// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const ColorIdToColor = [
  "#2f3233",
  "#84949c",
  "#8e775e",
  "#f1e7d0",
  "#646f75",
  "#6a5a48",
  "#c9bfa9",
  "#7b8771",
  "#8a5b3b",
  "#6d585f",
  "#612526",
  "#5c6e6f",
  "#b3a65c",
  "#666666",
  "#8c8c8c",
  "#b3b3b3",
  "#cccccc",
  "#e6e6e6",
  "#a4b495",
  "#a0afb7",
  "#af9981",
  "#fbf3e3",
  "#b9caac",
  "#d8976b",
  "#b0939d",
  "#ac595a",
  "#97b1b2",
  "#ffeec0",
  "#ba774a",
  "#ff69b4",
  "#92747e",
  "#832f30",
  "#799395",
  "#f2f2ed",
  "#f2df77",
  "#b2a9a4",
  "#edece6",
  "#121617",
  "#eeecda",
  "#55544e",
  "#e8d9ba",
  "#f7f5e9",
  "#d1c0aa",
  "#050505",
  "#515255",
  "#615c50",
  "#f8fdff",
  "#2f2f30",
  "#676869",
  "#b9b8b2",
  "#53575e",
  "#e3e5e3",
  "#2f2f30",
  "#363535",
  "#585654",
  "#bc6646",
  "#c8d6e5",
  "#bad2db",
  "#e8e5da",
  "#e4dacd",
  "#a0a09e",
  "#605157",
  "#444c57",
  "#86837b",
  "#676869",
  "#b9b8b2",
  "#e9eae7",
  "#53575e",
  "#c8bfb5",
  "#c2c0bb",
  "#4b2929",
  "#303b39",
  "#403330",
  "#c2b6b6",
  "#756761",
  "#5e6259",
  "#727c7f",
  "#596368",
  "#23383f",
  "#bec1c3",
  "#2f2f30",
  "#313031",
  "#373a3a",
  "#e7e2da",
  "#edeae5",
  "#edece6",
  "#e3ded0",
  "#ccc9c0",
  "#4f4842",
  "#ccc5bd",
  "#867a6f",
  "#887b6c",
  "#d1c7b8",
  "#c0b2a2",
  "#beb5a9",
  "#6b645b",
  "#e0e0d9",
  "#a7a8a2",
  "#7f817e",
  "#636562",
  "#dcd2c3",
  "#60797d",
  "#657b83",
  "#b2ada4",
  "#9d9887",
  "#979fa5",
  "#939591",
  "#988f85",
  "#e3e5e3",
  "#2f2f30",
  "#676869",
  "#b9b8b2",
  "#53575e",
  "#e3e5e3",
  "#2f2f30",
  "#676869",
  "#949488",
  "#cfcbc2",
  "#f0eadc",
  "#eeefea",
  "#8aa3b1",
  "#626970",
  "#b9b8b2",
  "#cfcac7",
  "#978a7f",
  "#d9d7cb",
  "#cfbea9",
  "#bab9b6",
  "#e1d9c5",
  "#d8e0df",
  "#f5e1a6",
  "#d3ccc4",
  "#4f4d51",
  "#edece6",
  "#969eab",
  "#48423c",
  "#53575e",
  "#8e9698",
  "#d6dbd5",
  "#969d95",
  "#2f2f30",
  "#536872",
  "#e3e5e3",
  "#d1c0aa",
  "#2f2f30",
  "#676869",
  "#949488",
  "#cfcbc2",
  "#f0eadc",
  "#eeefea",
  "#8aa3b1",
  "#626970",
  "#b9b8b2",
  "#cfcac7",
  "#978a7f",
  "#d9d7cb",
  "#cfbea9",
  "#bab9b6",
  "#e1d9c5",
  "#d8e0df",
  "#f5e1a6",
  "#d3ccc4",
  "#4f4d51",
  "#edece6",
  "#969eab",
  "#48423c",
  "#53575e",
  "#666c78",
  "#bdc5b8",
  "#2f2f30",
  "#536872",
  "#e3e5e3",
  "#62615c",
  "#575b67",
  "#313031",
  "#78736e",
  "#887b6c",
  "#dfdeed",
  "#62615c",
  "#575b67",
  "#313031",
  "#78736e",
  "#887b6c",
  "#dfdeed",
  "#5c8797",
  "#2e292f",
  "#575853",
  "#e7e2da",
  "#e3e5e3",
  "#efefef",
  "#e9e2d0",
  "#9a8b79",
  "#78736e",
  "#727c7f",
  "#74685a",
  "#4f4e4a",
  "#edece6",
  "#867a6f",
  "#6b645b",
  "#7f817e",
  "#e4e5df",
  "#c1ae92",
  "#94908c",
  "#727c7f",
  "#596368",
  "#e7e2da",
  "#edece6",
  "#e4e5df",
  "#ebe8d8",
  "#beb5a9",
  "#988f7b",
  "#ada8a5",
  "#edece6",
  "#c0b2a2",
  "#636562",
  "#bcbfbf",
  "#d8d4bf",
  "#585654",
  "#e8e5da",
  "#444c57",
  "#edeae5",
  "#e0e0d9",
  "#939591",
  "#f1efe2",
  "#b4b296",
  "#78736e",
  "#74685a",
  "#e9eae7",
  "#867a6f",
  "#6b645b",
  "#7f817e",
  "#7e6f59",
  "#f1efe2",
  "#b4b296",
  "#c6bfb3",
  "#b2a9a4",
  "#edece6",
  "#373a3a",
  "#e7e2da",
  "#edece6",
  "#d1c7b8",
  "#b2ada4",
  "#2f2f30",
  "#c6bfad",
  "#e3e5e3",
  "#edeae5",
  "#b0b8b2",
  "#605a5d",
  "#798286",
  "#e2e0d6",
  "#596368",
  "#7f817e",
  "#484c49",
  "#9c8a79",
  "#b2b5af",
  "#5b6043",
  "#dbd0b9",
  "#616669",
  "#a39b7e",
  "#988977",
  "#cbbca5",
  "#c2bdb1",
  "#bebfb2",
  "#244653",
  "#e2ded8",
  "#bcb7ad",
  "#cec6bb",
  "#a8a093",
  "#7c7d75",
  "#bdbdb7",
  "#bbab95",
  "#e2ddd0",
  "#b2ac9c",
  "#b7b7b2",
  "#9b9893",
  "#585858",
  "#95978a",
  "#91999c",
  "#979083",
  "#4b3029",
  "#94766c",
  "#beac9f",
  "#c59f91",
  "#996c6e",
  "#6d595a",
  "#8b534e",
  "#ac7559",
  "#8d422f",
  "#c28e61",
  "#c19e80",
  "#cbb99b",
  "#c19f6e",
  "#aeb08f",
  "#8f8666",
  "#708672",
  "#45584d",
  "#8ca49c",
  "#627f7b",
  "#a0bbb8",
  "#739694",
  "#c0b6b4",
  "#7e696a",
  "#a39b90",
  "#cc8d84",
  "#e8b9ae",
  "#ecceb9",
  "#ecd0b1",
  "#cdcdb4",
  "#efc488",
  "#9aabab",
  "#546670",
  "#974f49",
  "#c08f80",
  "#eedac3",
  "#d9c3a6",
  "#ada193",
  "#7f7263",
  "#c4957a",
  "#a76251",
  "#3a4a3f",
  "#aca17d",
  "#ae905e",
  "#e9bf8c",
  "#946644",
  "#f3e5d1",
  "#6d817b",
  "#47626f",
  "#b8b2a2",
  "#f0eadc",
  "#f2e0c3",
  "#cbcec5",
  "#e9e0d5",
  "#d6bcaa",
  "#9e3e33",
  "#f1bfb1",
  "#cbd0c2",
  "#598c74",
  "#ab7878",
  "#c6b9b8",
  "#abd1c9",
  "#014e4c",
  "#4b5645",
  "#acb19f",
  "#f0cda0",
  "#c2ccc4",
  "#cd9c85",
  "#dec3b9",
  "#bc9c9e",
  "#623f45",
  "#e1d286",
  "#a489a0",
  "#8ac6bd",
  "#dab5b4",
  "#888782",
  "#f0d39d",
  "#c9aa98",
  "#cd717b",
  "#f6e3a1",
  "#f4e8b2",
  "#f2eac3",
  "#51323b",
  "#443735",
  "#3d4450",
  "#515763",
  "#4b2929",
  "#622f2d",
  "#975840",
  "#af8871",
  "#c3b09d",
  "#7f614a",
  "#6e5241",
  "#5f4d43",
  "#506a67",
  "#738478",
  "#979f7f",
  "#caab7d",
  "#a58258",
  "#97896a",
  "#565c4a",
  "#c08650",
  "#8b7d7b",
  "#777f86",
  "#887b67",
  "#a6a397",
  "#9a7e64",
  "#96724c",
  "#a39b7e",
  "#a7947c",
  "#d3b699",
  "#ece1cb",
  "#ebb875",
  "#b4b9b9",
  "#e8d9bd",
  "#e4c495",
  "#ae9278",
  "#85695b",
  "#6a4238",
  "#432722",
  "#7b3728",
  "#937f68",
  "#a79473",
  "#7a6a51",
  "#988f7b",
  "#575449",
  "#324038",
  "#616564",
  "#797978",
  "#b6b7b0",
  "#73705e",
  "#d9ad7f",
  "#be795e",
  "#9c8a79",
  "#61463a",
  "#eecf9e",
  "#d9a06a",
  "#dfc8b5",
  "#b3ae95",
  "#857c5d",
  "#89a4ad",
  "#f8d492",
  "#e0deda",
  "#bcb8b6",
  "#ada8a5",
  "#847b77",
  "#6d6562",
  "#e4dbd8",
  "#d4cdca",
  "#b1a3a1",
  "#867875",
  "#6e615f",
  "#4d3c3c",
  "#d1c5c4",
  "#c1b2b3",
  "#b3a3a5",
  "#8b7c7e",
  "#6f5c5f",
  "#4e3132",
  "#e3d9d5",
  "#d6c2be",
  "#c9b0ab",
  "#b89d9a",
  "#907676",
  "#76595d",
  "#5f3d3f",
  "#e5dcd6",
  "#d7c8c2",
  "#c3b1ac",
  "#b6a09a",
  "#8c706a",
  "#7a5f5a",
  "#5a3532",
  "#e3dbd4",
  "#d1c5be",
  "#bfb1aa",
  "#ac9e97",
  "#8c7e78",
  "#56433b",
  "#e5dad4",
  "#d6c8c0",
  "#c6b3a9",
  "#b8a196",
  "#947569",
  "#806257",
  "#5a382d",
  "#e7dbd3",
  "#dbc7bd",
  "#cfb4a8",
  "#c3a497",
  "#9c6e63",
  "#85594f",
  "#5d3831",
  "#e9ddd4",
  "#decabd",
  "#d1b7a8",
  "#c1a392",
  "#9d7868",
  "#896656",
  "#694336",
  "#e6ddd5",
  "#d9cdc3",
  "#cbb9ab",
  "#bba595",
  "#967a6a",
  "#715243",
  "#4f3426",
  "#e5e1d8",
  "#d4ccc3",
  "#c1b6ab",
  "#b7ab9f",
  "#8d7f75",
  "#756861",
  "#4d3930",
  "#e4dcd4",
  "#d3c8bd",
  "#c2b4a7",
  "#b5a597",
  "#907865",
  "#7a6455",
  "#5f4b3f",
  "#e6ddd4",
  "#d6c7b9",
  "#c5b1a2",
  "#b59f8f",
  "#8e725f",
  "#785b47",
  "#634533",
  "#e8ded3",
  "#dac8b8",
  "#cab3a0",
  "#bfa38d",
  "#957258",
  "#815d40",
  "#69482c",
  "#e5ddd0",
  "#d7c5b3",
  "#c9b29c",
  "#bca38b",
  "#947a62",
  "#7d644d",
  "#65503d",
  "#e6dccd",
  "#d7c5ae",
  "#c7b198",
  "#baa185",
  "#9e8163",
  "#8a6b4d",
  "#70573f",
  "#ebddcb",
  "#e4caad",
  "#d7b593",
  "#cca683",
  "#ba8c64",
  "#a57955",
  "#8d623d",
  "#e8dcc6",
  "#dbc7a8",
  "#cdb592",
  "#c5aa85",
  "#b39167",
  "#9c7a56",
  "#8a6645",
  "#e9dcc6",
  "#e4ceac",
  "#dcbd92",
  "#d2b084",
  "#c19763",
  "#ad8451",
  "#906a3a",
  "#eadfc9",
  "#e0cfb0",
  "#d0ba94",
  "#c6b08a",
  "#ac9571",
  "#9a815e",
  "#7f6743",
  "#e9decf",
  "#dacab2",
  "#ccb79b",
  "#c0a98b",
  "#947f65",
  "#867057",
  "#6e543c",
  "#eae2d4",
  "#d9cfba",
  "#c8bba3",
  "#b8a992",
  "#8e7f6a",
  "#786957",
  "#66543e",
  "#e8e2d4",
  "#dbd0b9",
  "#cdbda2",
  "#c1ae91",
  "#998970",
  "#7e6f59",
  "#5d513e",
  "#deddd1",
  "#d1ccb9",
  "#c1bca7",
  "#b2ac96",
  "#898473",
  "#6b6757",
  "#5e5949",
  "#e2e0d7",
  "#d1cdbf",
  "#bfb9aa",
  "#b0ab9c",
  "#8b8372",
  "#726b5b",
  "#424036",
  "#e2e2d1",
  "#cecebd",
  "#bbbca7",
  "#acad97",
  "#7f8266",
  "#65684c",
  "#4f523a",
  "#e3e2d9",
  "#d1d0c6",
  "#abac9f",
  "#7b8070",
  "#64695c",
  "#4e5147",
  "#dcdfd7",
  "#d1d3c7",
  "#bdc0b3",
  "#9fa694",
  "#7a8775",
  "#626e60",
  "#465448",
  "#ddddd6",
  "#c9c9c0",
  "#b6b5ab",
  "#a6a69b",
  "#7f7e72",
  "#6d6c62",
  "#64645a",
  "#e4e4dd",
  "#cdd2ca",
  "#bec3bb",
  "#aeb3a9",
  "#7a8076",
  "#44483d",
  "#d7dfd8",
  "#c2cdc5",
  "#adbbb2",
  "#9baaa2",
  "#7c8e87",
  "#5e706a",
  "#343b36",
  "#dae2e0",
  "#c2cfcf",
  "#abbebf",
  "#9bafb2",
  "#7a9192",
  "#5d7274",
  "#4a5d5f",
  "#bccbce",
  "#a4b7bd",
  "#96aab0",
  "#607d84",
  "#47626a",
  "#dee1df",
  "#cdd2d2",
  "#b8bebe",
  "#a9b0b1",
  "#23383f",
  "#dbdfe0",
  "#bfc9d0",
  "#aabac6",
  "#98a9b7",
  "#768b9a",
  "#5d6f7f",
  "#2f3d4c",
  "#dde2e0",
  "#cad0d2",
  "#b8c0c3",
  "#adb5b9",
  "#7a848d",
  "#606b75",
  "#586168",
  "#e3e4e1",
  "#d4d8d7",
  "#a8aeb1",
  "#7d848b",
  "#dddcdb",
  "#cbc9c9",
  "#b5b1b5",
  "#a6a3a9",
  "#736f78",
  "#5d5962",
  "#4a4653",
  "#cec9cc",
  "#bdb5b9",
  "#afa7ac",
  "#85777b",
  "#695c62",
  "#4e4247",
  "#cfc9c8",
  "#bdb8b8",
  "#aea9aa",
  "#7b787d",
  "#605e63",
  "#3a373e",
  "#dbcfd4",
  "#cbb8c0",
  "#aa8e9a",
  "#8b6878",
  "#7e5a6d",
  "#5f3f54",
  "#e0cdd1",
  "#d2b6be",
  "#b995a1",
  "#9e6d79",
  "#8d5869",
  "#6d344f",
  "#e8d4d5",
  "#dabdc1",
  "#c79ea2",
  "#9e6b75",
  "#895460",
  "#63333e",
  "#ebd1cf",
  "#dcb6b5",
  "#c39393",
  "#995d62",
  "#864c52",
  "#723941",
  "#edd3d2",
  "#e6bdbd",
  "#cf8a8d",
  "#ad5e65",
  "#974953",
  "#863a42",
  "#ebcecb",
  "#e3b7b1",
  "#cd8e89",
  "#b56966",
  "#a0524e",
  "#8e3738",
  "#f0e1d8",
  "#ebcfc3",
  "#e3b5a8",
  "#cd8e7f",
  "#b3675d",
  "#a0584f",
  "#7b3730",
  "#eeded5",
  "#eacdc1",
  "#e2b6a7",
  "#ce9382",
  "#a85e53",
  "#8f4438",
  "#83382a",
  "#efded1",
  "#edd2c0",
  "#e4b9a2",
  "#d9987c",
  "#c1785c",
  "#ad654c",
  "#994b35",
  "#efe1d2",
  "#eccfbb",
  "#e5b99b",
  "#db9c7b",
  "#c47b5b",
  "#b46848",
  "#a2583a",
  "#edddca",
  "#ebccb3",
  "#e0b392",
  "#d4966e",
  "#c38058",
  "#b46c42",
  "#a6613c",
  "#f0e1d0",
  "#edd0b6",
  "#e8be9b",
  "#d69969",
  "#cd8c5d",
  "#bb7748",
  "#b06c3e",
  "#f3e5d2",
  "#f3d9ba",
  "#f0cb97",
  "#e3ac72",
  "#d7995d",
  "#c6884a",
  "#b6743b",
  "#f2e3ca",
  "#f2d5b0",
  "#edc38e",
  "#e5ae6b",
  "#d59858",
  "#c78538",
  "#b67d3c",
  "#f3e6d4",
  "#f5debb",
  "#edc796",
  "#ddac6d",
  "#d69e59",
  "#cc9249",
  "#ba7f38",
  "#efddc1",
  "#e8c89e",
  "#d6ad78",
  "#cc9b5c",
  "#c09056",
  "#a4763c",
  "#ede0c5",
  "#e9d6b0",
  "#e1c28d",
  "#c99e53",
  "#bc934d",
  "#aa803a",
  "#996f32",
  "#e9e0c5",
  "#e4d0a5",
  "#d2ba83",
  "#c2a462",
  "#b89b59",
  "#9c7f41",
  "#95793d",
  "#e7dfc5",
  "#ddcda6",
  "#cbb584",
  "#b1975f",
  "#9d8344",
  "#8e773f",
  "#7a6841",
  "#e9e1ca",
  "#dfd4b0",
  "#cfc291",
  "#bba86a",
  "#9c9152",
  "#8d844d",
  "#655f2d",
  "#ecead5",
  "#e0ddbd",
  "#cbc99d",
  "#aeac7a",
  "#95945c",
  "#71713e",
  "#5f6033",
  "#e4e4ce",
  "#dbddbd",
  "#c7cda8",
  "#abb486",
  "#88915d",
  "#6d7645",
  "#576238",
  "#e4e8da",
  "#dae2cd",
  "#c5d1b2",
  "#a3b48c",
  "#788d60",
  "#60724f",
  "#475842",
  "#e0e7da",
  "#cfddc7",
  "#b3cbaa",
  "#8ba97f",
  "#5e7f57",
  "#42603c",
  "#405840",
  "#c8d8c4",
  "#acc2a8",
  "#98b092",
  "#6c8867",
  "#537150",
  "#205134",
  "#d8e2d8",
  "#c6d5c9",
  "#aac2b3",
  "#91af9d",
  "#61826c",
  "#4f6a56",
  "#3d5541",
  "#d7e4db",
  "#c4d9ce",
  "#accabc",
  "#94b5a6",
  "#6b927f",
  "#547867",
  "#2a4f43",
  "#bfd2c9",
  "#a8c1b7",
  "#7ea298",
  "#5f887d",
  "#476f65",
  "#124a42",
  "#e0e7e2",
  "#c3d7d3",
  "#b4ccc9",
  "#8caeab",
  "#518682",
  "#2e6864",
  "#01554f",
  "#bedbd8",
  "#9ec6c6",
  "#7bb1b2",
  "#5c9598",
  "#3c797d",
  "#016367",
  "#c7dfe0",
  "#b0d2d6",
  "#84b4be",
  "#5b96a2",
  "#217786",
  "#015a6b",
  "#d8e7e6",
  "#c5dce0",
  "#adccd3",
  "#83afbc",
  "#5b92a2",
  "#2f778b",
  "#015d75",
  "#dce7e8",
  "#c2dae0",
  "#a9c9d7",
  "#85b0c4",
  "#5389a1",
  "#22657f",
  "#01455e",
  "#e0e8e7",
  "#c5d8de",
  "#b3c9d3",
  "#97b4c3",
  "#6a8ea1",
  "#43718b",
  "#215772",
  "#ced9dd",
  "#b2c7d3",
  "#8ba7bb",
  "#6a8aa4",
  "#506b84",
  "#25476a",
  "#e1e6e6",
  "#cbd8e1",
  "#b2c8d8",
  "#8ea9c2",
  "#6b8ca9",
  "#4c6b8a",
  "#284a70",
  "#cbd5db",
  "#bbc7d2",
  "#99a7b8",
  "#6c7f9a",
  "#516582",
  "#3b496d",
  "#d6d9de",
  "#bdc3cd",
  "#99a0b2",
  "#757c91",
  "#5d657b",
  "#3b3c5a",
  "#dad6db",
  "#c5c0c9",
  "#a29baa",
  "#7e778e",
  "#645e77",
  "#3e385a",
  "#e0dadf",
  "#d1c6d2",
  "#b0a3b6",
  "#7a6b85",
  "#675a75",
  "#443757",
  "#ebd1db",
  "#e3c0cf",
  "#cb9aad",
  "#b87e93",
  "#92576f",
  "#7c3655",
  "#edd5dd",
  "#e8c0cf",
  "#d899b1",
  "#c47b95",
  "#a2566f",
  "#854158",
  "#f1d3da",
  "#efc0cb",
  "#e392a1",
  "#d47c8c",
  "#b04b63",
  "#99324e",
  "#f1d2d7",
  "#f0bcc9",
  "#eb92a3",
  "#dd7788",
  "#bd4c5f",
  "#a53a4e",
  "#f2d5d7",
  "#f0c1c6",
  "#ed939d",
  "#d66972",
  "#bb4b51",
  "#9d373c",
  "#f1c6c4",
  "#f0b3b2",
  "#ed9190",
  "#d76c6e",
  "#b74e4f",
  "#a43834",
  "#f2ccc5",
  "#f0afa8",
  "#ee9489",
  "#d9766c",
  "#b24743",
  "#a13b34",
  "#f2d1c3",
  "#f2b8a7",
  "#e79580",
  "#d87b6a",
  "#c76356",
  "#b85444",
  "#f0d1c3",
  "#f3c1ab",
  "#e49780",
  "#dd7861",
  "#c65f47",
  "#b44b34",
  "#f3d0bd",
  "#f2bda2",
  "#e2946f",
  "#d67c56",
  "#c4633e",
  "#b1533c",
  "#f3d3bf",
  "#f3c1a3",
  "#e89d6f",
  "#d57e52",
  "#c56639",
  "#bb613e",
  "#f4d3b3",
  "#f4c69f",
  "#f2ac78",
  "#e6955f",
  "#cb7841",
  "#c36f3e",
  "#f2e3ce",
  "#f4d4af",
  "#f5c894",
  "#efb57a",
  "#e69f5f",
  "#d88b4d",
  "#d28240",
  "#f3e3ca",
  "#f4d9b1",
  "#f5cf9b",
  "#efb97b",
  "#eaaa62",
  "#df984e",
  "#d28233",
  "#f3e2c9",
  "#f5d6a9",
  "#f6cd8e",
  "#f4bf77",
  "#ebad5e",
  "#df9938",
  "#d88f32",
  "#f3e6ce",
  "#f5deaf",
  "#f7d391",
  "#fbcb78",
  "#f7be5b",
  "#f2af46",
  "#e39a33",
  "#f4e3bc",
  "#f5e0b1",
  "#f6dda3",
  "#f6c973",
  "#f1ba55",
  "#eaae47",
  "#d69835",
  "#f5e5bc",
  "#f4e1ae",
  "#f5d68f",
  "#eec25f",
  "#e1b047",
  "#d6a02b",
  "#c48919",
  "#f3e8c2",
  "#f5e1ac",
  "#f7d78a",
  "#eac365",
  "#dbb04a",
  "#d1a436",
  "#c49832",
  "#f3eac6",
  "#eee3b2",
  "#e6d88e",
  "#d9c661",
  "#c4b146",
  "#ac9825",
  "#9c8b1f",
  "#e9e5b3",
  "#dad790",
  "#c4c476",
  "#b4b05a",
  "#989746",
  "#847e35",
  "#dce1b8",
  "#c5cd8f",
  "#afb96a",
  "#97a554",
  "#7a8833",
  "#6c7b30",
  "#d3dfc3",
  "#bdd0ab",
  "#9db682",
  "#85a16a",
  "#648149",
  "#58713f",
  "#d7e3ca",
  "#c0d2ad",
  "#99c285",
  "#7fac6e",
  "#4f854a",
  "#2f5f3a",
  "#cce2ca",
  "#aed2b0",
  "#8ec298",
  "#68a678",
  "#498555",
  "#245e36",
  "#d1e3d2",
  "#b7d7bf",
  "#8ac1a1",
  "#57aa80",
  "#348a5d",
  "#016844",
  "#d7ebe2",
  "#c0e3da",
  "#a1d4c8",
  "#70baa7",
  "#53a38f",
  "#368976",
  "#016c4f",
  "#c1e6df",
  "#a1d5cb",
  "#75b9ae",
  "#61a89d",
  "#3b8c80",
  "#016d60",
  "#c2e5e5",
  "#a7dcdc",
  "#6ec2c4",
  "#3aa9ae",
  "#01858b",
  "#017478",
  "#c2e0e3",
  "#a6d0d6",
  "#7dc1cb",
  "#4da6b2",
  "#08808e",
  "#01717e",
  "#c6e3e8",
  "#a6d4de",
  "#71b8c7",
  "#34a3b6",
  "#018498",
  "#016e85",
  "#d3e7e9",
  "#b4e0e7",
  "#8fd0dd",
  "#56b5ca",
  "#01a0b8",
  "#01819e",
  "#016081",
  "#b7dfe8",
  "#a2d5e7",
  "#5db3d4",
  "#289ec4",
  "#017ca7",
  "#015d87",
  "#d6e4e7",
  "#c3dfe8",
  "#b0d6e6",
  "#7db5d3",
  "#5a9ec0",
  "#2377a2",
  "#094c73",
  "#ccdbe5",
  "#b8cddd",
  "#97b3d0",
  "#7498be",
  "#4e739f",
  "#164576",
  "#d8dde6",
  "#c7d1e2",
  "#a7b2d4",
  "#8b98c4",
  "#6572a5",
  "#3e4371",
  "#dfd9e4",
  "#d1cbdf",
  "#bdb4d4",
  "#968db8",
  "#716998",
  "#4d426e",
  "#dfdce5",
  "#d2c8dd",
  "#c0afd0",
  "#a18ab7",
  "#7e6596",
  "#624977",
  "#e5dbe5",
  "#dac7da",
  "#c2a4c2",
  "#a785a7",
  "#7c5a7e",
  "#5d395f",
  "#b54d7f",
  "#953d68",
  "#92345b",
  "#ac4362",
  "#cc617f",
  "#c84f68",
  "#a42e41",
  "#ab3c51",
  "#a82e33",
  "#bf2d32",
  "#c33a36",
  "#ad2c34",
  "#f3d1c8",
  "#c04d35",
  "#c35530",
  "#d7552a",
  "#e16f3e",
  "#e47237",
  "#ec8430",
  "#f4a045",
  "#eb882c",
  "#f7dda1",
  "#fad97a",
  "#fdcc4e",
  "#ffc723",
  "#f8ac1d",
  "#fdb702",
  "#ffc801",
  "#f7e594",
  "#fed95d",
  "#fed340",
  "#fecb01",
  "#edd26f",
  "#ddb835",
  "#cba901",
  "#c6b836",
  "#b2c216",
  "#9aba25",
  "#3f8a24",
  "#358c3f",
  "#238652",
  "#017244",
  "#d4e7c3",
  "#87dcce",
  "#019187",
  "#019196",
  "#017680",
  "#01b0bb",
  "#7fc3e1",
  "#0192c6",
  "#016ea7",
  "#015f97",
  "#015086",
  "#225288",
  "#c2cbe0",
  "#3c4c80",
  "#cab2d2",
  "#795484",
  "#665385",
  "#514c7e",
  "#019d6e",
  "#3b373c",
  "#353337",
  "#323132",
  "#31363a",
  "#323639",
  "#f2ece6",
  "#eee9e0",
  "#efe8dd",
  "#e9ebe7",
  "#edeae0",
  "#e8e3d9",
  "#e5dfd2",
  "#efe8db",
  "#ece5d8",
  "#aca79e",
  "#908a83",
  "#dfd9d2",
  "#b9b2a9",
  "#aba39a",
  "#6f6459",
  "#564537",
  "#e3ded7",
  "#d1cbc1",
  "#bfb6aa",
  "#ada295",
  "#74685a",
  "#5c4d3c",
  "#e3ddd3",
  "#b1a290",
  "#8a7a6a",
  "#716354",
  "#564536",
  "#e6dfd3",
  "#817a6e",
  "#54504a",
  "#e2e0d6",
  "#cfcabd",
  "#bfb6a7",
  "#afa696",
  "#867e70",
  "#645a4b",
  "#554c3e",
  "#c8cbc4",
  "#b2b5af",
  "#a3a7a0",
  "#63655f",
  "#484c49",
  "#dedfdc",
  "#cbccc9",
  "#434341",
  "#dcdedc",
  "#c6caca",
  "#b0b5b5",
  "#a0a5a7",
  "#7f8486",
  "#616669",
  "#44484d",
  "#e2dedb",
  "#cfc9c8",
  "#bcb6b6",
  "#ada5a5",
  "#837d7f",
  "#676064",
  "#443e40",
  "#f3eee7",
  "#ede6db",
  "#f4efe5",
  "#f4efe4",
  "#f7efe3",
  "#f7efde",
  "#f8eedb",
  "#ac9a8a",
  "#a18d7d",
  "#a49689",
  "#9e9284",
  "#665d57",
  "#c4b7a5",
  "#b3a491",
  "#9c8a79",
  "#826f5e",
  "#5b4b44",
  "#cdbfb0",
  "#c5b6a4",
  "#a79582",
  "#827466",
  "#6e5f53",
  "#e0d6c8",
  "#dbcebd",
  "#c9b29c",
  "#af9781",
  "#6a5143",
  "#ad947c",
  "#9f8267",
  "#7c5c43",
  "#cabaa8",
  "#8a7362",
  "#dfd2bf",
  "#d0bfaa",
  "#c4b49c",
  "#d4c5ad",
  "#c4b39c",
  "#dcd1bf",
  "#cfc0ab",
  "#c0af97",
  "#b7a48b",
  "#a18e77",
  "#cbb49a",
  "#e3d2b8",
  "#c0a588",
  "#c1a98a",
  "#b09879",
  "#d8cfbe",
  "#cbc0ad",
  "#bcb099",
  "#ac9d83",
  "#63523d",
  "#b1a38e",
  "#cbbfad",
  "#ad9c85",
  "#907d66",
  "#f0ece2",
  "#e7dbcc",
  "#e7d7c6",
  "#ece1d1",
  "#e2d3bf",
  "#f4e8d2",
  "#f4e9d6",
  "#f3e9d7",
  "#f2e5cf",
  "#f4dec3",
  "#f5eacc",
  "#f6f0e2",
  "#eee8d7",
  "#e8dfca",
  "#dbd0bb",
  "#f3eee3",
  "#e2daca",
  "#dccfba",
  "#dfd9cf",
  "#ede1ce",
  "#e7d7c2",
  "#e9d9c0",
  "#e7d8be",
  "#e0d1b8",
  "#533640",
  "#72353d",
  "#81585b",
  "#573e3e",
  "#803532",
  "#7c3239",
  "#6e3637",
  "#692b2b",
  "#813235",
  "#9f4442",
  "#a42e37",
  "#b8473d",
  "#7c453d",
  "#753531",
  "#703229",
  "#6e423e",
  "#5d3736",
  "#e2d3c4",
  "#924e3c",
  "#93402f",
  "#903934",
  "#a0b3bc",
  "#3e5063",
  "#8095a0",
  "#596e79",
  "#35454e",
  "#6591a8",
  "#416d83",
  "#87aab9",
  "#5b8d9f",
  "#3e758a",
  "#7c9aa0",
  "#679199",
  "#9cb0b3",
  "#577c88",
  "#3e4b54",
  "#a0aeaf",
  "#376167",
  "#314d58",
  "#666d69",
  "#273e3e",
  "#606e74",
  "#3d484c",
  "#e6e1d9",
  "#e7e1d7",
  "#ded8cf",
  "#786e70",
  "#392b2d",
  "#dfdad1",
  "#d6cec3",
  "#ada090",
  "#aa9e95",
  "#e5e2da",
  "#c0b9a9",
  "#aea594",
  "#a7a094",
  "#c6c0b6",
  "#a0998f",
  "#57534c",
  "#dad9d4",
  "#d6d3cc",
  "#d0cec9",
  "#c2c0ba",
  "#aaa9a4",
  "#ccccc5",
  "#abb0ac",
  "#d1d2cb",
  "#cecec6",
  "#a0a09a",
  "#dee0de",
  "#c5c8c4",
  "#a5a9a8",
  "#969a96",
  "#d3d5d3",
  "#c9cccd",
  "#b8bcbb",
  "#90979b",
  "#656d73",
  "#dcddd8",
  "#cac9c6",
  "#959491",
  "#949392",
  "#d0cec8",
  "#c3c1bc",
  "#f2e0c4",
  "#eaba8a",
  "#eddbbd",
  "#d9ad7f",
  "#c09972",
  "#f8e4c2",
  "#eabf86",
  "#f1dfc1",
  "#edd6b1",
  "#e5c28b",
  "#f8ddb7",
  "#e7c7a0",
  "#e1cdae",
  "#d2bb9d",
  "#c3aa8c",
  "#e3c9a1",
  "#dcbc8e",
  "#cba97e",
  "#caad87",
  "#bd9c77",
  "#dcc6a6",
  "#ccb18b",
  "#dbc8a2",
  "#ba9a67",
  "#8f6c3e",
  "#ac6b53",
  "#b0785c",
  "#a85e39",
  "#d5b59b",
  "#976b53",
  "#c67b57",
  "#b16a37",
  "#a56c4a",
  "#e6d0bd",
  "#dfc8b5",
  "#ccb299",
  "#bfa287",
  "#aa866e",
  "#dbc5a7",
  "#d2b18f",
  "#bb8d6b",
  "#d8c4ae",
  "#c7a485",
  "#edd1b1",
  "#ecd3b3",
  "#ddc6ab",
  "#b7987b",
  "#ad896a",
  "#9d986f",
  "#b9b292",
  "#a29f80",
  "#827c5a",
  "#4d5346",
  "#a69474",
  "#c8bd98",
  "#b3a479",
  "#857c5d",
  "#635936",
  "#b1a584",
  "#8d8168",
  "#cdc4ae",
  "#a49b82",
  "#7d745e",
  "#aaad9c",
  "#8ea486",
  "#868578",
  "#99907e",
  "#5a5243",
  "#a19c8f",
  "#bdc0a0",
  "#9a9883",
  "#44493d",
  "#424c44",
  "#f7f7f1",
  "#f0ebe0",
  "#ae8087",
  "#a87376",
  "#ba7176",
  "#c37f7a",
  "#bf796e",
  "#b57466",
  "#f2b88c",
  "#f5c78e",
  "#cc896c",
  "#dba480",
  "#e3ab7b",
  "#e8b87f",
  "#eeb76b",
  "#fbd187",
  "#fbe4b3",
  "#fddfa0",
  "#fedf94",
  "#fbd682",
  "#fbd073",
  "#f4c454",
  "#f6d58f",
  "#f1cd7b",
  "#e1bd8e",
  "#cba576",
  "#ba9c75",
  "#d5b176",
  "#dcc797",
  "#bea775",
  "#c4b47d",
  "#cebc55",
  "#d2d083",
  "#9fac5c",
  "#abca99",
  "#a9c095",
  "#78b185",
  "#9fcdb1",
  "#bbb98a",
  "#9ba373",
  "#8fa277",
  "#75946b",
  "#7d9b89",
  "#81a595",
  "#89c6b7",
  "#8ac5ba",
  "#92d0d0",
  "#97cbd2",
  "#8bc4d1",
  "#73c0d2",
  "#89c6df",
  "#94b2a6",
  "#a3c0bd",
  "#90bdbd",
  "#9fc5cc",
  "#c7d8db",
  "#afc7cd",
  "#9fbbc3",
  "#88abb4",
  "#68909d",
  "#427584",
  "#175a6c",
  "#9bbfc9",
  "#6f9db3",
  "#9bc8de",
  "#7c9ab5",
  "#6487b0",
  "#bbc5de",
  "#afa5c7",
  "#b3a1c6",
  "#937496",
  "#83a2b4",
  "#7b99b0",
  "#8595aa",
  "#8990a3",
  "#908a9b",
  "#9a8ca2",
  "#9b7e8b",
  "#a38887",
  "#a08882",
  "#a2877d",
  "#a8857a",
  "#ae8e7e",
  "#a58c7b",
  "#9c8373",
  "#a08e7e",
  "#d5c7ba",
  "#c6b5a7",
  "#b9a796",
  "#a58f7b",
  "#917864",
  "#785f4c",
  "#604c3d",
  "#a3846c",
  "#a88e76",
  "#dcc7b3",
  "#d2b79e",
  "#c5a88d",
  "#b59778",
  "#89674a",
  "#725237",
  "#765138",
  "#dcc7ad",
  "#cfb597",
  "#c1a485",
  "#b99974",
  "#a78361",
  "#946e48",
  "#7b5838",
  "#a78c71",
  "#dfd3c3",
  "#c0ad96",
  "#af987f",
  "#a08568",
  "#8f7659",
  "#695239",
  "#ab9579",
  "#a4947e",
  "#b9a47e",
  "#ddd0b6",
  "#cdbb9c",
  "#c3b090",
  "#b19f80",
  "#9f8e71",
  "#877459",
  "#665439",
  "#9e9985",
  "#989a82",
  "#909886",
  "#969c92",
  "#8d9e97",
  "#8b9fa0",
  "#80969d",
  "#cbd4d4",
  "#b6c3c4",
  "#a6b2b5",
  "#90a0a6",
  "#6f848c",
  "#204652",
  "#c9d9e0",
  "#b7c9d1",
  "#9eb4c0",
  "#708d9e",
  "#4e7287",
  "#32586e",
  "#899caa",
  "#979fa5",
  "#949194",
  "#989192",
  "#8f8a91",
  "#9d9093",
  "#9d8d8e",
  "#9f9291",
  "#9e9089",
  "#959ba0",
  "#939899",
  "#92948d",
  "#d3cec4",
  "#dcd8d0",
  "#9e9793",
  "#a09287",
  "#9e9991",
  "#958d7f",
  "#c8bcab",
  "#a0907f",
  "#393437",
  "#2b4360",
  "#234058",
  "#283849",
  "#2b3441",
  "#e8decd",
  "#4b3029",
  "#4c3d31",
  "#454b40",
  "#2e5464",
  "#c29871",
  "#cec4b8",
  "#ebe0c3",
  "#3e3230",
  "#cec6b6",
  "#85867f",
  "#153b2f",
  "#b6aa9d",
  "#e5e5e5",
  "#f7f5e6",
  "#446964",
  "#faf6ed",
  "#412a1c",
  "#5a331c",
  "#cbc2b0",
  "#ada394",
  "#f2f7f7",
  "#dfdccb",
  "#4f4842",
  "#c1b899",
  "#30332d",
  "#46403d",
  "#ada297",
  "#fcfdff",
  "#4a4f52",
  "#a39785",
  "#6d6c65",
  "#ede7d2",
  "#82735e",
  "#abb4ab",
  "#444542",
  "#616258",
  "#6b7062",
  "#6d3e37",
  "#5f5349",
  "#ffffff",
  "#64747d",
  "#3f5e73",
  "#586162",
  "#c9c0ab",
  "#73796c",
  "#a89885",
  "#333d46",
  "#49453c",
  "#818582",
  "#928e82",
  "#252a2a",
  "#725e4d",
  "#5b5e61",
  "#c5c2ba",
  "#a4a490",
  "#a39f8c",
  "#b2b2ab",
  "#38556b",
  "#673e3c",
  "#cac5b9",
  "#c3c0ab",
  "#cfcece",
  "#727d82",
  "#9c907d",
  "#7a7362",
  "#79736e",
  "#f8f4e9",
  "#65182c",
  "#452a19",
  "#acb297",
  "#7d8284",
  "#13233a",
  "#151312",
  "#ba1f26",
  "#e6e9ee",
  "#19221f",
  "#e9ebee",
  "#b4b2a9",
  "#483c37",
  "#DCB6B5",
  "#D9987C",
  "#EDD0B6",
  "#E4C495",
  "#A58258",
  "#EECF9E",
  "#BEC3BB",
  "#6d6b58",
  "#405840",
  "#788b81",
  "#9EC6C6",
  "#B8CDDD",
  "#4C6B8A",
  "#6E543C",
  "#C0A98B",
  "#E2E0D6",
  "#B2B5AF",
  "#988F7B",
  "#74685A",
  "#727C7F",
  "#484C49",
  "#BEB5A9",
  "#596368",
  "#7E6F59",
  "#E8D9BD",
  "#DBD0B9",
  "#C1AE91",
  "#6A4238",
  "#7B3728",
  "#DEDDD1",
  "#deddd1",
  "#e2e0d6",
  "#7b3728",
  "#6a4238",
  "#dcb6b5",
  "#d9987c",
  "#edd0b6",
  "#a58258",
  "#eecf9e",
  "#e4c495",
  "#e8d9bd",
  "#c1ae91",
  "#a39b7e",
  "#6d6b58",
  "#405840",
  "#9ec6c6",
  "#b8cddd",
  "#4c6b8a",
  "#74685a",
  "#c0a98b",
  "#9c8a79",
  "#7e6f59",
  "#beb5a9",
  "#dbd0b9",
  "#6e543c",
  "#988f7b",
  "#bec3bb",
  "#b2b5af",
  "#788b81",
  "#596368",
  "#727c7f",
  "#484c49",
  "#EECF9E",
  "#B8CDDD",
  "#E8D9BD",
  "#C0A98B",
  "#A58258",
  "#EDD0B6",
  "#D9987C",
  "#6A4238",
  "#DCB6B5",
  "#9EC6C6",
  "#788b81",
  "#405840",
  "#9C8A79",
  "#E2E0D6",
  "#6E543C",
  "#727C7F",
  "#596368",
  "#484C49",
  "#BEC3BB",
  "#DEDDD1",
  "#6A4238",
  "#4E3132",
  "#D9987C",
  "#E6DDD5",
  "#BA8C64",
  "#E4C495",
  "#E8D9BD",
  "#A58258",
  "#A57955",
  "#727C7F",
  "#596368",
  "#ADA8A5",
  "#7F817E",
  "#616669",
  "#4E5147",
  "#788b81",
  "#DEDDD1",
  "#BEC3BB",
  "#E2E0D6",
  "#B2B5AF",
  "#7F817E",
  "#C1AE91",
  "#2F3D4C",
  "#78736E",
  "#4F4842",
  "#564536",
  "#4C6B8A",
  "#74685A",
  "#9C8A79",
  "#DBD0B9",
  "#7B3728",
  "#A39B7E",
  "#988F7B",
  "#6d6b58",
  "#EECF9E",
  "#B8CDDD",
  "#DCB6B5",
  "#9EC6C6",
  "#eecf9e",
  "#d9987c",
  "#e8d9bd",
  "#c0a98b",
  "#ba8c64",
  "#edd0b6",
  "#c1ae91",
  "#7e6f59",
  "#9ec6c6",
  "#e6ddd5",
  "#b8cddd",
  "#deddd1",
  "#dcb6b5",
  "#bec3bb",
  "#405840",
  "#4e5147",
  "#4c6b8a",
  "#2f3d4c",
  "#e4c495",
  "#a58258",
  "#6e543c",
  "#4e3132",
  "#7b3728",
  "#6a4238",
  "#a57955",
  "#7f817e",
  "#564536",
  "#6e543c",
  "#d9987c",
  "#dcb6b5",
  "#6a4238",
  "#e2e0d6",
  "#bec3bb",
  "#beb5a9",
  "#b2b5af",
  "#484c49",
  "#7b3728",
  "#9ec6c6",
  "#eecf9e",
  "#727c7f",
  "#596368",
  "#a39b7e",
  "#e8d9bd",
  "#c0a98b",
  "#b8cddd",
  "#deddd1",
  "#405840",
  "#4c6b8a",
  "#c1ae91",
  "#74685a",
  "#9c8a79",
  "#e4c495",
  "#edd0b6",
  "#dbd0b9",
  "#646753",
  "#68887b",
  "#B7AB9F",
  "#674721",
  "#d5c3ad",
  "#5c5753",
  "#423f40",
  "#f0ece3",
  "#dfdcd5",
  "#cac7c0",
  "#acaa9d",
  "#76716d",
  "#666c68",
  "#b0a08d",
  "#d1caba",
  "#f2f3ee",
  "#a3a59f",
  "#2f374a",
  "#5f4c42",
  "#191815",
  "#948d7d",
  "#74766b",
  "#3e3a37",
  "#fffefa",
  "#5f5345",
  "#e1ddc0",
  "#e0d1b4",
  "#c4bea2",
  "#b0ae9a",
  "#514d41",
  "#525658",
  "#fffef9",
  "#c8bca6",
  "#b4a49f",
  "#c2b89c",
  "#f0f7fa",
  "#2d4647",
  "#DBDBDB",
  "#161513",
  "#E7E8E2",
  "#ACA298",
  "#C3C2BD",
  "#8E8E8C",
  "#29303A",
  "#19363D",
  "#7D8E98",
  "#EDEDED",
  "#817765",
  "#0C0006",
  "#0C0006",
  "#A1A1A1",
  "#5B8095",
  "#3F3E41",
  "#554541",
  "#5D5E5B",
  "#7F7E7A",
  "#6A6965",
  "#4A545C",
  "#F0ECDB",
  "#ABA796",
  "#F9FAF5",
  "#CCB9B1",
  "#C2B89C",
  "#040707",
  "#332A22",
  "#B4A49F",
  "#2E2822",
  "#A6AEAD",
  "#CEC8B4",
  "#524535",
  "#E4E8CF",
  "#0F3F67",
  "#3D6C80",
  "#857F69",
  "#452727",
  "#464A49",
  "#9AA3AA",
  "#6D2B2D",
  "#4B392B",
  "#3C382F",
  "#A12034",
  "#365C45",
  "#37624F",
  "#38483E",
  "#5C7C6D",
  "#282B30",
  "#5C4B39",
  "#FDFEF9",
  "#D4D0C7",
  "#629881",
  "#004961",
  "#DCE0DF",
  "#A79C7E",
  "#3F776E",
  "#A64F3B",
  "#778083",
  "#D1C8B7",
  "#000000",
  "#716E69",
  "#48382C",
  "#C7BFA7",
  "#08402E",
  "#646263",
  "#969897",
  "#978B7E",
  "#FFFFFF",
  "#F4E8D6",
  "#9FA6AA",
  "#DFDCD3",
  "#65615D",
  "#53524F",
  "#A39584",
  "#81837B",
  "#85514D",
  "#F2F1EC",
  "#e5d8bd",
  "#695e50",
  "#38211d",
  "#302f30",
  "#434f51",
  "#bec0c0",
  "#e7e8e9",
  "#a99d8a",
  "#4F5455",
  "#C9BFB0",
  "#788387",
  "#7c7463",
  "#A2A298",
  "#B2AFAD",
  "#B6AB9F",
  "#4b4b4d",
  "#06060a",
  "#66211c",
  "#373229",
  "#f0dfb7",
  "#a49f90",
  "#a49f90",
  "#faf8f4",
  "#2f2a22",
  "#6d6158",
  "#385546",
  "#c3b9a3",
  "#06060a",
  "#4c4036",
  "#f1edd6",
  "#4f2e26",
  "#c3b9a3",
  "#a4a7a6",
  "#b2b8b4",
  "#665c52",
  "#fff9f0",
  "#f5f4ee",
  "#eaebe7",
  "#DED6C6",
  "#E3D3C8",
  "#D4CBB4",
  "#C8AF99",
  "#B79E86",
  "#242424",
  "#8E7C6C",
  "#B09B8B",
  "#9FA193",
  "#F0E5DC",
  "#9E9286",
  "#9E9686",
  "#9F684F",
  "#F3E9D2",
  "#6E4B50",
  "#F7EBD4",
  "#4C443E",
  "#858281",
  "#D2CBBB",
  "#707377",
  "#192A21",
  "#EFEFEF",
  "#939698",
  "#49544A",
  "#A89D8D",
  "#DAD1C7",
  "#55413E",
  "#F1E5D1",
  "#5E6C68",
  "#686261",
  "#D9CAB7",
  "#E0D7CA",
  "#EBEBEB",
  "#3B393A",
  "#554A47",
  "#1B2A41",
  "#A69790",
  "#959288",
  "#59626E",
  "#A0A09D",
  "#B7B4B3",
  "#CACED2",
  "#AFA797",
  "#4D4442",
  "#5C5653",
  "#CBBFB8",
  "#F3ECDF",
  "#BAAA9E",
  "#764A4A",
  "#A8ADB3",
  "#E9E4DD",
  "#F0F0EE",
  "#E7DFC6",
  "#696561",
  "#605D59",
  "#515154",
  "#C8B9A8",
  "#BCADA0",
  "#5F2D2C",
  "#3B4B46",
  "#F7F7F7",
  "#F6F5E4",
  "#DAD3C5",
  "#F1EDEC",
  "#F8EDD8",
  "#C3C3BE",
  "#DFCEC6",
  "#B8B3AC",
  "#D8C7A2",
  "#CEAE90",
  "#C8B8A1",
  "#BBBCB2",
  "#DBDED6",
  "#737373",
  "#928C83",
  "#E0DDD4",
  "#ACACAC",
  "#BBB3AA",
  "#BBB8AD",
  "#998F86",
  "#D6DADD",
  "#E7F0F2",
  "#DFE1D5",
  "#CDC8BC",
  "#E1DFD4",
  "#CABA9F",
  "#ACA291",
  "#D4C298",
  "#9C8462",
  "#A18B72",
  "#C8CAC9",
  "#D4A97D",
  "#D7B588",
  "#ECE7BC",
  "#F3F3E3",
  "#A59C88",
  "#D7B385",
  "#A59A7C",
  "#C6AF97",
  "#F4F4EB",
  "#E3C59B",
  "#E5D3B5",
  "#E1C39C",
  "#CEC4AE",
  "#D4BEAA",
  "#514A46",
  "#edf5f4",
  "#941318",
  "#231f20",
  "#4c191c",
  "#4c4d4f",
  "#636466",
  "#a9a089",
  "#62443d",
  "#ad6c32",
  "#004829",
  "#003663",
  "#f7edc9",
  "#7f6757",
  "#dedbc4",
  "#5d9a8b",
  "#be1228",
  "#bdbdb8",
  "#376b7c",
  "#d6bd9e",
  "#eeeeec",
  "#A89D8E",
  "#aea89c",
  "#d0cbc5",
  "#ffffff",
  "#2f3437",
  "#3d3429",
  "#b0a282",
  "#586151",
  "#593b26",
  "#47393d",
  "#371516",
  "#3a4545",
  "#8b8041",
  "#d5d8d7",
  "#bfc4c5",
  "#a9afb2",
  "#999fa3",
  "#838b91",
  "#6d747a",
  "#575c62",
  "#d4d4cd",
  "#c9cbc6",
  "#bbbcb6",
  "#a8aaa4",
  "#9c9f99",
  "#92958f",
  "#717572",
  "#e0dfdc",
  "#d2d1cd",
  "#c7c6c2",
  "#b9b8b5",
  "#9f9f9d",
  "#7b7a78",
  "#3c3d3d",
  "#ddddd9",
  "#cdccc9",
  "#a8a7a3",
  "#92928f",
  "#81807e",
  "#6f6f6e",
  "#5e5e5d",
  "#d0cfc9",
  "#c4c3bd",
  "#bbbab5",
  "#abaca6",
  "#969794",
  "#7b7c7a",
  "#575957",
  "#f2f0e7",
  "#bfbab0",
  "#afaba1",
  "#a19e97",
  "#949089",
  "#7e7a74",
  "#5c5752",
  "#dedbd2",
  "#c7c2b7",
  "#b2ada2",
  "#9a9387",
  "#8b8376",
  "#746e64",
  "#635f59",
  "#d1c9bc",
  "#c2b9ac",
  "#b1a89c",
  "#a19689",
  "#8e8274",
  "#7d7265",
  "#64584a",
  "#f2f2ee",
  "#e3e4e2",
  "#dadbdb",
  "#acadae",
  "#848585",
  "#5c5d5d",
  "#414040",
  "#edeae7",
  "#e6e3df",
  "#d4cfca",
  "#b9b4b1",
  "#918e8c",
  "#6f6a68",
  "#4b4441",
  "#e1dedd",
  "#d8d3d4",
  "#b8b4b6",
  "#a6a1a3",
  "#908b8e",
  "#69656a",
  "#49454b",
  "#dddada",
  "#d2cecc",
  "#c5bebc",
  "#b3aaaa",
  "#8b8283",
  "#655d5e",
  "#50484a",
  "#e5e2e0",
  "#d4d0ce",
  "#c4bfbc",
  "#b5adaa",
  "#8d847f",
  "#665e59",
  "#4f443f",
  "#eeede5",
  "#e1ded9",
  "#ccc8c1",
  "#b8b1aa",
  "#8c857d",
  "#7c736c",
  "#61574f",
  "#e8e6e1",
  "#d0cbc3",
  "#beb8ae",
  "#afaaa1",
  "#99938d",
  "#827c77",
  "#564d4b",
  "#e6e0d4",
  "#d1c9bd",
  "#b4aca3",
  "#a2978b",
  "#8d8478",
  "#766f67",
  "#615c58",
  "#e1e1dc",
  "#d3d4d0",
  "#c6c8c5",
  "#b9b8b5",
  "#8e908d",
  "#6b6a65",
  "#4e4f48",
  "#eae8e4",
  "#d7d6d2",
  "#bdbeba",
  "#a7a9a5",
  "#8a8b87",
  "#6f716e",
  "#585a5c",
  "#eae9e7",
  "#d2d6d6",
  "#b1b6b8",
  "#9aa0a5",
  "#6f7477",
  "#5c5e61",
  "#454443",
  "#e1e5e3",
  "#dce2e2",
  "#d2d9db",
  "#b8bfc2",
  "#8e9598",
  "#6e7579",
  "#434b4f",
  "#e7e7e6",
  "#dadbdd",
  "#c0c2c4",
  "#adb0b5",
  "#828388",
  "#575960",
  "#404149",
  "#ebe9e7",
  "#e6e3e4",
  "#e1ddde",
  "#c0b2b2",
  "#9c8e8e",
  "#746665",
  "#554747",
  "#f2ebe2",
  "#ede4dc",
  "#e6d7ce",
  "#cdb8b3",
  "#a59491",
  "#826f6b",
  "#5f4a47",
  "#eaded9",
  "#e6d5cf",
  "#ddc8c1",
  "#d2bbb3",
  "#b59b94",
  "#8f746c",
  "#674a41",
  "#ecdfda",
  "#d9cac5",
  "#c9bcb7",
  "#b8a9a3",
  "#8e7d78",
  "#786560",
  "#60504b",
  "#ded6d0",
  "#d5cbc6",
  "#b9b0a8",
  "#aa9f97",
  "#a1928b",
  "#80726b",
  "#5b4c44",
  "#ebe2d8",
  "#d7cbc0",
  "#c8bab1",
  "#aca199",
  "#93857c",
  "#82746c",
  "#645851",
  "#f2eee5",
  "#e3d8cc",
  "#cfc1b5",
  "#b6a393",
  "#a7978a",
  "#857567",
  "#65574c",
  "#e9e3dc",
  "#d2c7b9",
  "#c0b1a2",
  "#ab9a8b",
  "#8d7b6c",
  "#766759",
  "#5f5248",
  "#e7e0d7",
  "#d2c8be",
  "#bdb6ae",
  "#a3968c",
  "#9a8e83",
  "#746a5e",
  "#5d5043",
  "#e8e3d6",
  "#dad0c2",
  "#cabfb2",
  "#b7ac9e",
  "#9f9484",
  "#827566",
  "#594e40",
  "#e9e3d6",
  "#e2daca",
  "#dacfbf",
  "#d1c9bb",
  "#a89d8e",
  "#8b7d6b",
  "#5f5241",
  "#e7e9e7",
  "#dcd7cf",
  "#d2ccc3",
  "#b2aa9c",
  "#8c8475",
  "#7a6c5e",
  "#615544",
  "#e3d6bc",
  "#d7c7a7",
  "#c1b295",
  "#b4a284",
  "#a59171",
  "#927f63",
  "#766851",
  "#dfdbcd",
  "#d3cbb7",
  "#c1b8a2",
  "#afa78d",
  "#8f876b",
  "#7b6b53",
  "#5f563f",
  "#e7e6d6",
  "#d3d0bc",
  "#bbb8a5",
  "#a1a190",
  "#827e6e",
  "#776e5d",
  "#5c5644",
  "#e7e5dc",
  "#dbd8c9",
  "#cac8b6",
  "#aead96",
  "#928c7a",
  "#777162",
  "#676357",
  "#d4d3c2",
  "#c6c6b3",
  "#b5b7a3",
  "#9e9f87",
  "#928e74",
  "#78725d",
  "#6a6758",
  "#d0ccbc",
  "#c2c1b2",
  "#a8a897",
  "#969481",
  "#87836f",
  "#676455",
  "#5c594c",
  "#ceccbf",
  "#bfbbae",
  "#b0ab9b",
  "#999382",
  "#878170",
  "#716c5e",
  "#5f5a4d",
  "#e0e3d9",
  "#dbdcd2",
  "#c5c8bf",
  "#aaafa8",
  "#89928a",
  "#646c64",
  "#474e44",
  "#e4ece9",
  "#dfebea",
  "#d5e1e1",
  "#b4c7c9",
  "#8b9fa1",
  "#6a7e81",
  "#334448",
  "#d2e0df",
  "#c8d7d8",
  "#a4babd",
  "#8ca2a8",
  "#6d868b",
  "#5d7076",
  "#455257",
  "#e1e5e5",
  "#ccd3d3",
  "#adb7b8",
  "#93a0a2",
  "#7c8787",
  "#707b7d",
  "#585f60",
  "#d7dddd",
  "#cbd3d4",
  "#a8b4b8",
  "#92a2a9",
  "#67787e",
  "#525e63",
  "#464b4f",
  "#e4e9e8",
  "#dde3e4",
  "#d4dcdb",
  "#adb6ba",
  "#858f94",
  "#5e686d",
  "#3a484f",
  "#ced3d2",
  "#bcc1c1",
  "#aab1b3",
  "#919a9f",
  "#7d868a",
  "#666f73",
  "#445056",
  "#d0dce0",
  "#c1d0d8",
  "#b2c0c8",
  "#a1b1ba",
  "#8f9fa9",
  "#667884",
  "#515e69",
  "#eceded",
  "#e1e5eb",
  "#dadde3",
  "#bcc5cf",
  "#939fa9",
  "#6a7680",
  "#3f4c5a",
  "#e6e9ed",
  "#dfdac8",
  "#212424",
  "#212424",
  "#42372a",
  "#7c7d7c",
  "#c2bcae",
  "#6d6c61",
  "#dfdac8",
  "#004327",
  "#f1f1f1",
  "#42372a",
  "#d6d0c1",
  "#c2bcae",
  "#6d6c61",
  "#f1f1f1",
  "#9cb1bf",
  "#aca38b",
  "#513b36",
  "#8b9d89",
  "#a2a298",
  "#595c53",
  "#8f8d85",
  "#ada69a",
  "#255d79",
  "#3d4445",
  "#f5efe4",
  "#2c3c55",
  "#475662",
  "#a39382",
  "#7b2c06",
  "#646c6f",
  "#868683",
  "#d3cdbc",
  "#576c58",
  "#87a2a7",
  "#e3d4bb",
  "#ced0cb",
  "#838a91",
  "#968a76",
  "#969784",
  "#58554f",
  "#fff1cd",
  "#937d68",
  "#595c53",
  "#253739",
  "#f2f3ee",
  "#c6b9a0",
  "#425b65",
  "#677f86",
  "#738a8b",
  "#a1aeac",
  "#f0eae0",
  "#7d8681",
  "#ced0c6",
  "#bec6bf",
  "#47545d",
  "#3b4550",
  "#64707c",
  "#9fa5b3",
  "#a3adb2",
  "#aebbc0",
  "#bcc0bf",
  "#6a828c",
  "#bcc5d9",
  "#ccd0dd",
  "#71787f",
  "#919ea7",
  "#8092a3",
  "#657687",
  "#d4dae2",
  "#9eadbb",
  "#d4dcdb",
  "#cedde7",
  "#cfdbe0",
  "#a1b2bb",
  "#848982",
  "#bcc5b6",
  "#c4d0c6",
  "#2a4a6f",
  "#e3e6eb",
  "#d4dce3",
  "#adb4c4",
  "#828b9c",
  "#5c6576",
  "#404d62",
  "#e9e9ea",
  "#e2e1e2",
  "#dedfe2",
  "#b1b2be",
  "#8b8d98",
  "#656874",
  "#484b5a",
  "#f2ebea",
  "#ebdde1",
  "#e3c8d2",
  "#d7b3c0",
  "#c58ba1",
  "#a8647e",
  "#86455c",
  "#f1edeb",
  "#eee0e3",
  "#e4d0d5",
  "#d0aebb",
  "#b28692",
  "#9a6a79",
  "#6f4052",
  "#eae1e0",
  "#eadbe1",
  "#dac2ca",
  "#cbb7c0",
  "#a48b93",
  "#866c76",
  "#5d4450",
  "#efe7e4",
  "#e5d8d6",
  "#d6c5c2",
  "#d1c1c3",
  "#ac9b9c",
  "#877578",
  "#5b484b",
  "#f0eae7",
  "#f0dddf",
  "#e4c9ce",
  "#d5b6ba",
  "#aa8a8d",
  "#8e6c6f",
  "#624046",
  "#f2eeeb",
  "#f0dadd",
  "#d7b8bd",
  "#c9a1a9",
  "#ad7982",
  "#905c67",
  "#73424a",
  "#f3e6e7",
  "#ecced4",
  "#e3b9c2",
  "#d494a0",
  "#c47281",
  "#ad586c",
  "#9a3c55",
  "#f3ddd8",
  "#eec9ca",
  "#ebb3b4",
  "#dc9294",
  "#c67276",
  "#af545d",
  "#943e45",
  "#f0e0d7",
  "#f5e2dd",
  "#dfbeba",
  "#c59191",
  "#af7271",
  "#95555a",
  "#853e44",
  "#f2ede5",
  "#edd4d2",
  "#e5c7c6",
  "#d9b1b2",
  "#b78e8b",
  "#976a66",
  "#6e403e",
  "#f2e4dd",
  "#f2dcd8",
  "#e7cdca",
  "#dbbebc",
  "#b49997",
  "#90716e",
  "#694848",
  "#f3ebe7",
  "#f5dbd9",
  "#ddb9b6",
  "#c99d9b",
  "#ab7673",
  "#905959",
  "#7a4041",
  "#e9dad7",
  "#e4d2ce",
  "#dabcb7",
  "#cf9f9a",
  "#b87770",
  "#9e5b55",
  "#89423e",
  "#efe3dd",
  "#edd1cd",
  "#e8c1bb",
  "#e0a79f",
  "#ce7c74",
  "#b4635e",
  "#a53f3e",
  "#f2e0db",
  "#edcfc9",
  "#e9cac3",
  "#dfb1a8",
  "#ca887f",
  "#ae6056",
  "#a0413f",
  "#efded9",
  "#ead2cd",
  "#dcc0ba",
  "#caa6a1",
  "#af7e76",
  "#95625b",
  "#7d453e",
  "#edd8d0",
  "#e5d1cc",
  "#dfcac5",
  "#cfaea5",
  "#ac8880",
  "#8c5e55",
  "#6f4741",
  "#f0e7df",
  "#ebddd7",
  "#e3cbc2",
  "#c4a297",
  "#b6897d",
  "#996c61",
  "#715045",
  "#f0e3da",
  "#ecd6ce",
  "#e4cec6",
  "#d8b1a5",
  "#bc8675",
  "#9e6757",
  "#884f3e",
  "#f5e5dd",
  "#f2ded3",
  "#f4d1c4",
  "#efbdb0",
  "#d5917c",
  "#b06e5b",
  "#a2543e",
  "#f3e4de",
  "#f5ded9",
  "#f3d2c9",
  "#efbcb2",
  "#e19789",
  "#ca7363",
  "#a8483d",
  "#f2e2df",
  "#eed8d3",
  "#eacfc8",
  "#e4bcb3",
  "#cc9487",
  "#b16456",
  "#94493e",
  "#f2e6e0",
  "#f2ddd8",
  "#f3d3cb",
  "#dfbaab",
  "#bd8675",
  "#ae6f60",
  "#8f4f42",
  "#eedbd3",
  "#ead3c9",
  "#e9cac0",
  "#e2b5a4",
  "#b4715a",
  "#9d6454",
  "#924c3a",
  "#f0e4db",
  "#eddfd6",
  "#e4c9be",
  "#dbb19f",
  "#c08973",
  "#ab715a",
  "#945b41",
  "#f0dbce",
  "#edccb9",
  "#e7bca5",
  "#d5a084",
  "#be886a",
  "#a26949",
  "#965f43",
  "#f0dacc",
  "#eed5c7",
  "#e9c3ac",
  "#d6a284",
  "#c78d6a",
  "#a86e49",
  "#986544",
  "#ebdfd2",
  "#ebd5c7",
  "#e2c7b8",
  "#dbbbaa",
  "#bc947d",
  "#9a6e5c",
  "#805a48",
  "#f1e8e0",
  "#eadad2",
  "#d7bfb5",
  "#c4a79a",
  "#a4816f",
  "#8a6757",
  "#6e483a",
  "#f1e7d9",
  "#e9d9ce",
  "#e4d1c8",
  "#d1bbb0",
  "#a68f85",
  "#8b7265",
  "#64493e",
  "#eee6dc",
  "#ebdfd5",
  "#dbcbbf",
  "#bfa999",
  "#977d6f",
  "#6e554b",
  "#604b43",
  "#f0ebe4",
  "#ebe2d8",
  "#dfd4c9",
  "#beada4",
  "#978379",
  "#736157",
  "#604a3f",
  "#ebe3dc",
  "#e5ded5",
  "#d1c2b5",
  "#b19e90",
  "#9a8172",
  "#7d675c",
  "#64544a",
  "#f1e0d0",
  "#ecdac9",
  "#c6ad97",
  "#b29a86",
  "#9b806a",
  "#826a56",
  "#6c5a4d",
  "#efe9dd",
  "#e8e1d6",
  "#e4cdb9",
  "#c3a98f",
  "#ab886b",
  "#8e705a",
  "#775f4f",
  "#ece3d8",
  "#e9e0d8",
  "#dcc8b7",
  "#c4ab98",
  "#ac8f7b",
  "#8d6e54",
  "#76563d",
  "#eddac7",
  "#e6c6aa",
  "#d9b391",
  "#cba282",
  "#bc8d68",
  "#a57b5b",
  "#8e684b",
  "#f2e6d6",
  "#e8cfb8",
  "#e3c5a9",
  "#d5b092",
  "#ba8b69",
  "#a06f50",
  "#946448",
  "#efe2d6",
  "#ebd9cc",
  "#e5d0bf",
  "#e1c0a7",
  "#ca9b75",
  "#b47e50",
  "#9a653c",
  "#f1e8dd",
  "#f3e8db",
  "#f0d8c2",
  "#e8ceb5",
  "#d4ad87",
  "#b28a61",
  "#936c43",
  "#f0e8dd",
  "#ede2d4",
  "#decfbc",
  "#ceb69c",
  "#b29577",
  "#987b5d",
  "#77593d",
  "#ece5d8",
  "#e5d9c6",
  "#deccb6",
  "#c6b199",
  "#ac9379",
  "#90775d",
  "#7b624d",
  "#eeeade",
  "#ebe1d2",
  "#e2cfb2",
  "#d3bc9b",
  "#b99e78",
  "#a88767",
  "#987659",
  "#efe6db",
  "#f0e5d9",
  "#ebd8c2",
  "#e2ceb8",
  "#d2b088",
  "#ad865a",
  "#987043",
  "#f0e8da",
  "#f0ddc9",
  "#edd4b8",
  "#dbb78e",
  "#c89e73",
  "#af8159",
  "#9d7149",
  "#f6e7d2",
  "#f7e6cc",
  "#f0d6b7",
  "#e4c39d",
  "#ca9d6d",
  "#be9064",
  "#a2784e",
  "#f5e6d0",
  "#edcda5",
  "#deb583",
  "#d7aa77",
  "#c69b6a",
  "#b4865a",
  "#9e7247",
  "#f3ebd4",
  "#f2e9d0",
  "#f2dbba",
  "#e4c093",
  "#d3a771",
  "#b88d5a",
  "#a87a4b",
  "#f3eddf",
  "#f2ebd7",
  "#e9d0ae",
  "#d4b288",
  "#c3996b",
  "#b2885c",
  "#99744e",
  "#f5edd9",
  "#f0e1c3",
  "#e2c8a2",
  "#ceb28a",
  "#c2a379",
  "#b49167",
  "#a68053",
  "#e8dcc8",
  "#e5d1b6",
  "#dcc2a2",
  "#d8ba95",
  "#bc976c",
  "#b29169",
  "#8e6e4b",
  "#f2e8d8",
  "#f0e3d2",
  "#e6d3b9",
  "#d9c39f",
  "#c3a377",
  "#a88759",
  "#896a3f",
  "#eee6d5",
  "#ece2cc",
  "#dfc8aa",
  "#ceb697",
  "#b6936c",
  "#a1855c",
  "#816640",
  "#eae5d8",
  "#e4dfd1",
  "#dbcfba",
  "#cabba3",
  "#ad9a7e",
  "#8b795f",
  "#766245",
  "#efe9d9",
  "#e9ddc6",
  "#dfcfb3",
  "#ceba9a",
  "#ae9774",
  "#947b56",
  "#725d3d",
  "#ece4d4",
  "#e6ddc9",
  "#dfcdae",
  "#d3bc96",
  "#b29774",
  "#9f8766",
  "#897052",
  "#eed39b",
  "#eccf94",
  "#dbbe74",
  "#d2bc88",
  "#b79e6a",
  "#a28651",
  "#947f4e",
  "#71684c",
  "#dcd2a9",
  "#cecaa1",
  "#e9e6b8",
  "#bca96f",
  "#b2ae7f",
  "#9a9764",
  "#8a8646",
  "#777d54",
  "#9e8f72",
  "#b2a282",
  "#c3b498",
  "#aea995",
  "#d6d7bd",
  "#c6bda0",
  "#9e9f87",
  "#828678",
  "#676357",
  "#878263",
  "#d0c6a1",
  "#8d856a",
  "#b0a582",
  "#b5aa85",
  "#b2a57b",
  "#9e8f68",
  "#f3efe2",
  "#f3ebd9",
  "#ddc9ab",
  "#bca27b",
  "#ac926b",
  "#9e835f",
  "#8b6f4d",
  "#eae6d9",
  "#e5ddc8",
  "#d1c1a7",
  "#c0ab8f",
  "#af9778",
  "#887154",
  "#695c4c",
  "#ece7dc",
  "#e4ddcd",
  "#c7b9a2",
  "#b9ab90",
  "#a0906e",
  "#847551",
  "#665c46",
  "#f0eada",
  "#e6dbc5",
  "#d9cbad",
  "#c6b28c",
  "#a68e61",
  "#927747",
  "#77633a",
  "#efe9da",
  "#ece5d0",
  "#e9dac2",
  "#d5be9a",
  "#b3976b",
  "#91774f",
  "#866e4d",
  "#f1e9d7",
  "#f1e9d2",
  "#ead3ad",
  "#e2caa1",
  "#d0b486",
  "#be9c6b",
  "#aa8650",
  "#f7e8cc",
  "#f3d5a8",
  "#e9bf84",
  "#d5a463",
  "#daa863",
  "#c39458",
  "#b28243",
  "#f6edce",
  "#f9eac2",
  "#efdaa4",
  "#eed39b",
  "#e1ba75",
  "#cfa357",
  "#c49e43",
  "#f6eed4",
  "#f7eac8",
  "#f3e1b5",
  "#e9ce98",
  "#d5b373",
  "#bf9e62",
  "#b39150",
  "#f0e3be",
  "#ebdab0",
  "#e6cf9e",
  "#cea36e",
  "#cdac67",
  "#ba9c56",
  "#a68734",
  "#f1e3b5",
  "#e9d59e",
  "#d8c482",
  "#cdb668",
  "#ad9555",
  "#a48d49",
  "#917c3b",
  "#e9e6da",
  "#e5ddc6",
  "#d0c6a1",
  "#bcac7d",
  "#9c8f60",
  "#897747",
  "#75693d",
  "#ede6d9",
  "#e2dac9",
  "#d7ccb6",
  "#c9ba9d",
  "#b1a582",
  "#9e9067",
  "#726647",
  "#dfdac6",
  "#d4cdb5",
  "#c6bda0",
  "#b0a582",
  "#9c946f",
  "#7a744d",
  "#5e573e",
  "#e9e7d7",
  "#dedbc4",
  "#d1ccaa",
  "#bcb58b",
  "#a39d70",
  "#8c8752",
  "#797547",
  "#eaebdd",
  "#e7e5d5",
  "#dfdcc7",
  "#c8c5a5",
  "#a19d77",
  "#918c66",
  "#756f4d",
  "#edebd5",
  "#e4e2ca",
  "#e5dfc1",
  "#dcd2a9",
  "#bfac78",
  "#ab955d",
  "#927f4a",
  "#eeebc2",
  "#e9e7b3",
  "#dcdb94",
  "#c3c67e",
  "#b5b364",
  "#a1a057",
  "#8e8849",
  "#e9e5c6",
  "#dfdbb6",
  "#d3d0a3",
  "#c0bc8a",
  "#a8a268",
  "#908a4f",
  "#7d7943",
  "#ece7d1",
  "#e7e1c5",
  "#dfdab9",
  "#cec99f",
  "#bab381",
  "#a59f6c",
  "#8d8753",
  "#edeee0",
  "#e3ead9",
  "#dce4cb",
  "#ccd1ac",
  "#b6be96",
  "#99a374",
  "#717a4e",
  "#e3e8da",
  "#dae1d0",
  "#cfdbc4",
  "#bac6a4",
  "#98a77d",
  "#7d8e61",
  "#5d6d3c",
  "#e9e8d8",
  "#dfe3d0",
  "#cfd2b5",
  "#b8bd97",
  "#9da073",
  "#7f8353",
  "#6c7344",
  "#eeece1",
  "#ebe9dd",
  "#e2e0d3",
  "#cecab6",
  "#a9a484",
  "#8f8a6b",
  "#6f6b4d",
  "#e1e5d8",
  "#d8decf",
  "#c7cebf",
  "#b2b9a5",
  "#92987e",
  "#6c765b",
  "#566049",
  "#e2e0d6",
  "#d2d4c3",
  "#c8cab6",
  "#acaf96",
  "#909374",
  "#6d704f",
  "#57593f",
  "#eaebe0",
  "#e7e6d8",
  "#dedccd",
  "#c3c2af",
  "#a1a187",
  "#7c7c64",
  "#6a6b58",
  "#dfe5d9",
  "#dbddcd",
  "#d1d2c1",
  "#afb29f",
  "#85866f",
  "#656552",
  "#5f5e4b",
  "#dcddd4",
  "#d1d2c8",
  "#c8cac0",
  "#bec4b8",
  "#929a8a",
  "#727b6c",
  "#515746",
  "#dfe5db",
  "#cad5c8",
  "#d0d5c8",
  "#b8bfb0",
  "#929b89",
  "#798372",
  "#52584e",
  "#e1e8dc",
  "#dbe5d8",
  "#cfddcd",
  "#b9d1b6",
  "#8faf88",
  "#709068",
  "#4c663e",
  "#e3ede3",
  "#d1e5d3",
  "#cdddc4",
  "#aac5a3",
  "#93b087",
  "#6e8b63",
  "#5c724c",
  "#dae9df",
  "#c5decf",
  "#a8d0ba",
  "#83bb9e",
  "#60a182",
  "#438866",
  "#20654a",
  "#dde7df",
  "#c7dace",
  "#bcd0c3",
  "#9cb7a6",
  "#789583",
  "#54745f",
  "#3d5948",
  "#e6eae0",
  "#e2e8df",
  "#deeae0",
  "#b2c5b9",
  "#899a8c",
  "#697b6c",
  "#405241",
  "#e6e9e3",
  "#e0e4dd",
  "#d9e0d7",
  "#b6c4bb",
  "#87988c",
  "#758478",
  "#57645c",
  "#e0e9e4",
  "#dee8e3",
  "#d5e2de",
  "#b9cac5",
  "#90a49d",
  "#70837d",
  "#495a51",
  "#ecf1ec",
  "#e6efea",
  "#dcece7",
  "#acc7c0",
  "#809f97",
  "#627d74",
  "#375549",
  "#d7e5dd",
  "#c3d7d0",
  "#aec7c0",
  "#8aaea4",
  "#6b9085",
  "#447266",
  "#3b564e",
  "#d3e5dc",
  "#bed5c8",
  "#a1c2b1",
  "#7eaa96",
  "#608f7b",
  "#3b6c55",
  "#2e594b",
  "#d7e7e0",
  "#badad1",
  "#9fcdc0",
  "#7cb5a5",
  "#559c8a",
  "#277a67",
  "#006852",
  "#d7e7e1",
  "#c2dcd6",
  "#acd0ca",
  "#87b9b2",
  "#5d9c92",
  "#42857c",
  "#106157",
  "#d5e7e4",
  "#cde2df",
  "#bbd6d5",
  "#99c1be",
  "#6fa39f",
  "#4a8582",
  "#0f5f5c",
  "#e1ebe5",
  "#c7d6d2",
  "#b6ccc8",
  "#92b1a9",
  "#73978f",
  "#4a726b",
  "#2d5951",
  "#d0dbd8",
  "#cad9d7",
  "#becfcd",
  "#a1b7b5",
  "#7b9793",
  "#547370",
  "#355856",
  "#e8eee8",
  "#d9e6e4",
  "#d6e5e3",
  "#a7bbba",
  "#7f9392",
  "#566b6b",
  "#3b4f4f",
  "#dce6e4",
  "#d3e0df",
  "#c7dada",
  "#9fbfbf",
  "#6b9a9b",
  "#467a7b",
  "#155d61",
  "#dbe6e5",
  "#cfe2e1",
  "#bbdbdb",
  "#8ac2c3",
  "#53a0a1",
  "#1f7d82",
  "#00666f",
  "#d4e3e3",
  "#d5e1e1",
  "#cad9db",
  "#a0bcc0",
  "#79989c",
  "#497279",
  "#2a535c",
  "#dbe4e5",
  "#cedee3",
  "#c2d3d7",
  "#95afb7",
  "#6f8d96",
  "#496772",
  "#2c5261",
  "#d2e4e6",
  "#cde0e4",
  "#b6d7de",
  "#8dbbc4",
  "#4b99a9",
  "#167b8f",
  "#00687d",
  "#d9e3e6",
  "#cbdee2",
  "#b3d0d9",
  "#86b5c4",
  "#5c96a9",
  "#31778c",
  "#02617b",
  "#dae3e6",
  "#d1dee4",
  "#a8c0ce",
  "#7e9daf",
  "#618396",
  "#355c74",
  "#2b516b",
  "#e9eeed",
  "#e3eaea",
  "#d7dfe2",
  "#acbfc9",
  "#7b8f99",
  "#516772",
  "#334a59",
  "#ecefeb",
  "#d4e2e6",
  "#cddce3",
  "#adc6d3",
  "#7f9daa",
  "#5c7a89",
  "#2c5268",
  "#e1e9ec",
  "#dfeaef",
  "#cedde7",
  "#bbcddc",
  "#8da7b9",
  "#5f7b8e",
  "#2d5069",
  "#dee6e8",
  "#c9d7de",
  "#a1b9cb",
  "#7494ac",
  "#52778f",
  "#2b5876",
  "#2c4c6a",
  "#d7e1e5",
  "#c5d8e3",
  "#aac8d8",
  "#81acc4",
  "#5491b2",
  "#32759a",
  "#005d89",
  "#d8e4e8",
  "#c3d8e4",
  "#a3c3d7",
  "#77a6c3",
  "#508aab",
  "#266c94",
  "#175788",
  "#dfe7e9",
  "#c4d2dd",
  "#a3bbce",
  "#779bb6",
  "#4f7b9a",
  "#1a5b84",
  "#255269",
  "#dae1e4",
  "#c1ceda",
  "#aabed0",
  "#8ca8bf",
  "#587f9e",
  "#395e7d",
  "#2a4a6f",
  "#dae3e8",
  "#bdd0e1",
  "#a1bed9",
  "#719cc3",
  "#4d83af",
  "#266393",
  "#224d88",
  "#d8e0e8",
  "#c7d3e0",
  "#adbfd6",
  "#7d9dc3",
  "#5b83b2",
  "#2f6295",
  "#304a77",
  "#dde3e8",
  "#c7d1dc",
  "#b6c3d2",
  "#9dafc2",
  "#6b8096",
  "#4b6077",
  "#2e5268",
  "#e9ecef",
  "#dae4ee",
  "#d6dfe8",
  "#adbad0",
  "#8290a6",
  "#627188",
  "#384966",
  "#e0e2e5",
  "#d1d6df",
  "#c0c6d4",
  "#a5afc4",
  "#7c8ba8",
  "#566682",
  "#3a3f5b",
  "#dee1e6",
  "#d4dae2",
  "#bcc5d9",
  "#9aa9c8",
  "#6c86b7",
  "#4e6897",
  "#364875",
  "#e3e5e8",
  "#dcdfe6",
  "#ccd0dd",
  "#a7b0cc",
  "#818db3",
  "#617099",
  "#455383",
  "#e6e6e8",
  "#dadbdf",
  "#c7ccd9",
  "#a4abbf",
  "#838ba4",
  "#606a88",
  "#3c486d",
  "#e4e3e5",
  "#dcdbe2",
  "#d1d2dc",
  "#afb2c4",
  "#898ca3",
  "#6b6d85",
  "#454b6a",
  "#e2e3ec",
  "#dee0ea",
  "#d1d3e1",
  "#b1b2cb",
  "#8f90b4",
  "#686b93",
  "#4c517f",
  "#e5e7e9",
  "#e5e6ea",
  "#dadde6",
  "#b8b9cb",
  "#9090a2",
  "#6e6f82",
  "#464960",
  "#efedeb",
  "#ebe8ec",
  "#d6d2d9",
  "#bab3bf",
  "#928a98",
  "#6b6472",
  "#4a4353",
  "#dfdee5",
  "#e0dde3",
  "#d4d1dc",
  "#bfbbc9",
  "#9c95a9",
  "#79738b",
  "#544f66",
  "#e5e1e5",
  "#dbd6df",
  "#cec8d2",
  "#bab3c2",
  "#9c8fa6",
  "#736a86",
  "#4e4360",
  "#e6e2e7",
  "#dfdbe5",
  "#d3d0dd",
  "#bfb8ce",
  "#998eb4",
  "#736993",
  "#534b77",
  "#e7dee6",
  "#e6dde7",
  "#d6cbdb",
  "#c3b1c8",
  "#a487ac",
  "#896792",
  "#6a4877",
  "#e7e3e7",
  "#e1d8e0",
  "#d7c7d6",
  "#c3aec3",
  "#a689a3",
  "#7f667f",
  "#604560",
  "#e8dfe4",
  "#e6d8e1",
  "#ddcad8",
  "#d0b7ca",
  "#b08ea5",
  "#88657e",
  "#674160",
  "#e8e1e3",
  "#e2d9dc",
  "#dbccd3",
  "#cfbac4",
  "#b695a4",
  "#906277",
  "#623f52",
  "#e6dae2",
  "#e7d8e3",
  "#e7cede",
  "#dab7cf",
  "#c291b2",
  "#a36c93",
  "#824874",
  "#f4dfe4",
  "#f5d8e0",
  "#f6c8d5",
  "#f2a8bf",
  "#ea85a4",
  "#e06c90",
  "#cb567c",
  "#f0e1e5",
  "#f1d6dd",
  "#f0c8d3",
  "#e6a4b8",
  "#da859f",
  "#cb6787",
  "#b0446a",
  "#f2dee1",
  "#f3d3d9",
  "#eebfc9",
  "#ea9dac",
  "#d5768b",
  "#cc607a",
  "#b13e5e",
  "#f5e4e5",
  "#f7cdd2",
  "#f8b3bc",
  "#f892a0",
  "#e76b81",
  "#da5770",
  "#d04a64",
  "#f5dbd9",
  "#f9cccd",
  "#f9b5b6",
  "#f8949b",
  "#eb6a76",
  "#e05164",
  "#cb384b",
  "#f3dbdb",
  "#f5cacb",
  "#f4b3b7",
  "#ea8e96",
  "#d56d76",
  "#c04f5b",
  "#ad3d4c",
  "#f4d9d7",
  "#f5d2cf",
  "#f4c1c0",
  "#f09b9d",
  "#dc7678",
  "#c8585c",
  "#b1393e",
  "#f5e3e0",
  "#f7d8d7",
  "#fac2bf",
  "#faa09d",
  "#f27777",
  "#e75f64",
  "#cb484c",
  "#f6e2de",
  "#f7dcd3",
  "#facac2",
  "#fbb1a6",
  "#f3867c",
  "#d7584c",
  "#b94940",
  "#f4e0db",
  "#f4dbd6",
  "#f6c8c3",
  "#eeaaa2",
  "#df8079",
  "#c76157",
  "#ae413a",
  "#f4ece7",
  "#f3e3dd",
  "#f1c5bb",
  "#e8a091",
  "#db8675",
  "#c06f60",
  "#b35941",
  "#f4e4dc",
  "#f5e0d8",
  "#f2d1c8",
  "#f2c2b6",
  "#e79c86",
  "#dc8267",
  "#c35b3c",
  "#f4e8e1",
  "#f7e2d8",
  "#f8dfd7",
  "#f4c8be",
  "#fda48d",
  "#e4745b",
  "#cf533a",
  "#f5e8e1",
  "#f6e4dc",
  "#f5ded4",
  "#eeb9ab",
  "#e68f75",
  "#e57757",
  "#c15339",
  "#f3eae2",
  "#f6e2d5",
  "#f3d4c5",
  "#f3b598",
  "#f6a37c",
  "#ec8a5b",
  "#dd6f3b",
  "#f4ddcd",
  "#f5d9c9",
  "#f7d5c2",
  "#f8be9d",
  "#fba270",
  "#f49056",
  "#ea874f",
  "#f3e9df",
  "#f3e1d2",
  "#f8d8be",
  "#fac6a0",
  "#feac71",
  "#fa9a54",
  "#f39349",
  "#f5decc",
  "#f5d4bf",
  "#f5c6a7",
  "#f0ab80",
  "#e08d59",
  "#d27638",
  "#c66b35",
  "#f5e2d6",
  "#f5dfd4",
  "#efc7b6",
  "#e7b095",
  "#d28d6c",
  "#c77c5a",
  "#b05f3a",
  "#d6bc8e",
  "#f2dabb",
  "#e8ba6c",
  "#d9b280",
  "#f6e4c0",
  "#e2bc8b",
  "#efd1a7",
  "#e9b072",
  "#f3e6cf",
  "#ceb9a5",
  "#c4a47f",
  "#dcbf98",
  "#eadbc6",
  "#d4b288",
  "#e2c8a2",
  "#c3aa87",
  "#f0d2a4",
  "#e1c193",
  "#c2a379",
  "#ccb38b",
  "#e2caa1",
  "#d0b486",
  "#efdaa4",
  "#ac8955",
  "#f6e2c8",
  "#e0ccaf",
  "#f0e1c3",
  "#e7d5b6",
  "#e1cba9",
  "#cfb695",
  "#ecd7ba",
  "#ebd6ba",
  "#f4e4d5",
  "#f6d9c6",
  "#f2c3a7",
  "#e9a580",
  "#d2885e",
  "#c47444",
  "#b96a3c",
  "#f2e4d7",
  "#f0dcca",
  "#f1cdb4",
  "#eab794",
  "#d89466",
  "#cf8149",
  "#bf7037",
  "#f2e9dd",
  "#f5e3d1",
  "#f4dcc6",
  "#f0c9aa",
  "#e4ac78",
  "#d29358",
  "#c58038",
  "#f3ecdd",
  "#f6e8d6",
  "#f5debf",
  "#fbd19f",
  "#fcbc7d",
  "#f5ae61",
  "#f09c43",
  "#f4eedd",
  "#f4ead3",
  "#fbe4c2",
  "#fdd9aa",
  "#fcc584",
  "#fabb72",
  "#fbb153",
  "#f4f0de",
  "#f7eed6",
  "#fae6c4",
  "#ffdba5",
  "#ffd892",
  "#ffc963",
  "#ffbd32",
  "#f6efda",
  "#f8eece",
  "#f8eccb",
  "#fce5af",
  "#ffda77",
  "#ffd25a",
  "#ffc72f",
  "#f2ede1",
  "#f5e7d2",
  "#f4e2c6",
  "#f0cea0",
  "#e3b270",
  "#ce974d",
  "#bb8132",
  "#f2eee2",
  "#f4e9cf",
  "#f4dfb7",
  "#edc482",
  "#e1ad59",
  "#cf9943",
  "#bd862e",
  "#f3edd9",
  "#f5e5c6",
  "#f6deaf",
  "#f4c775",
  "#eeb955",
  "#e2a94b",
  "#c99233",
  "#f6ead3",
  "#f8e2bb",
  "#f8dcab",
  "#f9cf8e",
  "#eeb865",
  "#e5ac4f",
  "#d8a431",
  "#f6eed7",
  "#f7edcf",
  "#fbe7b7",
  "#ffe19c",
  "#fed27d",
  "#ffc85e",
  "#ffc047",
  "#f2efd7",
  "#f5efc3",
  "#f5edb2",
  "#f7eca1",
  "#feeb83",
  "#ffdf37",
  "#ffcb3b",
  "#f0efe1",
  "#f3efcd",
  "#f5eeba",
  "#f6edae",
  "#f9eb97",
  "#fcd361",
  "#f6c545",
  "#f2ecdb",
  "#f2ead2",
  "#f9e5ba",
  "#f5e3a7",
  "#f8d86e",
  "#e5c14c",
  "#d9ad38",
  "#f3f0e6",
  "#f0edd2",
  "#f0e7a9",
  "#f0df75",
  "#e3c74e",
  "#cfb128",
  "#b8a029",
  "#efefd6",
  "#eaeece",
  "#e9edbd",
  "#ececa7",
  "#ede777",
  "#e6da42",
  "#e0be36",
  "#f1edd3",
  "#efe8bb",
  "#ebe3a9",
  "#e0e2a9",
  "#d8d68e",
  "#d6ce81",
  "#d4c44b",
  "#f0eac6",
  "#f1e7b5",
  "#e7d890",
  "#ddc76a",
  "#c6b156",
  "#ae9c3f",
  "#a3923e",
  "#eeeed7",
  "#e9e7af",
  "#e1e0a0",
  "#d5d17b",
  "#c9c664",
  "#bab242",
  "#99a32a",
  "#eeefdc",
  "#f0edcc",
  "#eae9b8",
  "#e4e5ab",
  "#d9e29a",
  "#cace66",
  "#b7c04e",
  "#ecf1e2",
  "#ebedd1",
  "#e2e9bf",
  "#dde7ad",
  "#ccd98a",
  "#b3c667",
  "#a7b53c",
  "#e6ebd7",
  "#e6eccc",
  "#dbe5ba",
  "#cddda2",
  "#adc571",
  "#95af54",
  "#78973b",
  "#e2ede1",
  "#ddead9",
  "#d2e3cd",
  "#b8d7ae",
  "#93bf84",
  "#73a55b",
  "#558c3b",
  "#ecf0e5",
  "#e8f0e2",
  "#e4efdf",
  "#d6eccd",
  "#bde4b1",
  "#9bd687",
  "#74be58",
  "#e3efe2",
  "#dbeedb",
  "#cceace",
  "#bce5be",
  "#8fd49a",
  "#65c171",
  "#37a84f",
  "#dae9dd",
  "#d0e6d6",
  "#b7dcc4",
  "#97cda9",
  "#64b082",
  "#4c9d6f",
  "#007845",
  "#daeee1",
  "#c2ead6",
  "#a4e0c3",
  "#74cfa8",
  "#3eb989",
  "#25a975",
  "#00935f",
  "#dceee2",
  "#bfe5d6",
  "#a0d4be",
  "#7cc4aa",
  "#4ca787",
  "#1f8f6e",
  "#007859",
  "#d4ede3",
  "#bbe7d9",
  "#95dcc6",
  "#57c9b0",
  "#04b296",
  "#00a285",
  "#00896f",
  "#d8eae5",
  "#bce1d9",
  "#a3d8ce",
  "#73c2b5",
  "#40a696",
  "#089080",
  "#007c6d",
  "#e2ebe5",
  "#c4e5e3",
  "#b3deda",
  "#8cccc8",
  "#5ab1ac",
  "#239692",
  "#007a77",
  "#e1ede6",
  "#d3ece7",
  "#a9e3df",
  "#7cd5d1",
  "#3abdb7",
  "#00a29d",
  "#00918d",
  "#deeeed",
  "#d1ebeb",
  "#c2e7e9",
  "#b3e3e5",
  "#6ccacf",
  "#38b8be",
  "#0099a0",
  "#e5f1ef",
  "#d3e7e6",
  "#bededf",
  "#8cced1",
  "#4ab2b4",
  "#0e9498",
  "#007681",
  "#e8efed",
  "#d2e5e9",
  "#c3dde3",
  "#92c7d3",
  "#52a5b7",
  "#168da2",
  "#007893",
  "#deeced",
  "#d3e8ec",
  "#c5e3eb",
  "#9ad4e2",
  "#56b8cd",
  "#1fa3bc",
  "#008ea9",
  "#e4edee",
  "#cee4ee",
  "#add6eb",
  "#7ec0e3",
  "#44a6d1",
  "#1091c0",
  "#007bae",
  "#dae6ea",
  "#d0e1e8",
  "#accfe0",
  "#7cb5d0",
  "#5096b7",
  "#1e80a9",
  "#006994",
  "#d6e1e4",
  "#ccdfe9",
  "#9ec8e5",
  "#63a8d3",
  "#3a8ebc",
  "#1877ac",
  "#00609e",
  "#d3e5ec",
  "#cbe3ef",
  "#a2d0ec",
  "#67b3e1",
  "#2e96d0",
  "#1389ca",
  "#0071b6",
  "#d9e6ee",
  "#c7ddee",
  "#9ac6eb",
  "#5fa4e0",
  "#388dd1",
  "#177fc8",
  "#0262af",
  "#dae3ea",
  "#c2d7ea",
  "#96bde2",
  "#71a3d0",
  "#3984be",
  "#166eae",
  "#175799",
  "#e1e8ed",
  "#d3e0ed",
  "#aac9ea",
  "#7bade2",
  "#4e8ed2",
  "#3879c2",
  "#2463ad",
  "#e0e6eb",
  "#d0dbe9",
  "#a2bcdb",
  "#7da2d2",
  "#5287c0",
  "#326ead",
  "#18569a",
  "#dde0e9",
  "#dadee9",
  "#cbd1e1",
  "#abb6d8",
  "#8293c5",
  "#6174ab",
  "#415397",
  "#dfe2ec",
  "#d7ddec",
  "#cad1ea",
  "#adb9e3",
  "#8496d2",
  "#7287c6",
  "#5668ae",
  "#e9e5e9",
  "#e5e1ea",
  "#dcd7e4",
  "#c7bedd",
  "#a698c7",
  "#8378ad",
  "#5a4e87",
  "#edeced",
  "#e9e5ed",
  "#e4dfed",
  "#d1c8e6",
  "#9898bc",
  "#7b7da7",
  "#5d5d88",
  "#eae1e9",
  "#e5d6e5",
  "#ddcae0",
  "#caafd0",
  "#aa85b5",
  "#9769a2",
  "#7a5188",
  "#ecdfea",
  "#e9ddea",
  "#e0cae5",
  "#d1b1d8",
  "#b68bc2",
  "#a675b1",
  "#855994",
  "#ece2e8",
  "#ebe0e8",
  "#ead2e3",
  "#e3bed9",
  "#cf94be",
  "#b06ea0",
  "#935284",
  "#eee5e8",
  "#efe1ec",
  "#efdae8",
  "#eac2de",
  "#dea3cd",
  "#c67cb2",
  "#a05a8e",
  "#8e575d",
  "#79413a",
  "#6e403e",
  "#753e45",
  "#8b585d",
  "#5f4345",
  "#614142",
  "#6a4f61",
  "#a04848",
  "#6d1d14",
  "#983d4d",
  "#8b4548",
  "#72271e",
  "#a84f5c",
  "#a04f45",
  "#a23d3f",
  "#575561",
  "#5f5358",
  "#7a6c74",
  "#715d79",
  "#4a4353",
  "#6b6472",
  "#9e9fa8",
  "#807d85",
  "#364875",
  "#2d5069",
  "#295167",
  "#196a76",
  "#1c3c2d",
  "#3b5a54",
  "#52634f",
  "#526a4d",
  "#8c817b",
  "#7b675a",
  "#e1ded9",
  "#b9b0a8",
  "#3d4646",
  "#7e756b",
  "#e1dacd",
  "#eeeade",
  "#c0ab8f",
  "#d8cab2",
  "#d5d1c0",
  "#cbc1be",
  "#a1917e",
  "#c8b8a4",
  "#ebe3d6",
  "#f0ece2",
  "#d7c5ae",
  "#d2b89c",
  "#e4d2b9",
  "#eee6d7",
  "#e0d4c4",
  "#cbbab0",
  "#efe7da",
  "#eae6de",
  "#d5d0bf",
  "#c8bea8",
  "#b9ac97",
  "#aaa190",
  "#d1c9bb",
  "#dbd1c6",
  "#e6e1d8",
  "#cec7b8",
  "#bb987b",
  "#9b6f45",
  "#b08661",
  "#c7a78b",
  "#efebde",
  "#e7dbca",
  "#bc9f85",
  "#a58056",
  "#baa286",
  "#ae9273",
  "#c8a987",
  "#c3a98f",
  "#705746",
  "#5e3f1e",
  "#b29577",
  "#c6b199",
  "#8d847f",
  "#6d5f53",
  "#a39080",
  "#87796c",
  "#766759",
  "#635141",
  "#462406",
  "#381b04",
  "#c9bcac",
  "#dbcfba",
  "#f7f0e2",
  "#cabfb2",
  "#b6a393",
  "#9c8a7a",
  "#a38e72",
  "#8d7868",
  "#d3ac9a",
  "#a38064",
  "#c88f68",
  "#b58365",
  "#ba8a74",
  "#a16f52",
  "#9f6f59",
  "#7a4d42",
  "#ccb9ad",
  "#ddba87",
  "#c5944f",
  "#af7800",
  "#ae814e",
  "#ce9859",
  "#ae7b44",
  "#aa7f5e",
  "#977652",
  "#cea886",
  "#c88b5a",
  "#b1703a",
  "#b27547",
  "#a96c3f",
  "#855842",
  "#574542",
  "#eacbb4",
  "#d6a284",
  "#bd8675",
  "#b06e5b",
  "#96534a",
  "#743618",
  "#772f0f",
  "#692300",
  "#92b3dc",
  "#4d7cb2",
  "#345578",
  "#6c86b7",
  "#5668ae",
  "#7a8ab7",
  "#826d95",
  "#b18aae",
  "#cc6e94",
  "#c65a87",
  "#aa4875",
  "#9e4749",
  "#cb484c",
  "#eb6a76",
  "#e4745b",
  "#de624e",
  "#ffce6a",
  "#f3c16d",
  "#edad57",
  "#e2ac71",
  "#fba971",
  "#ec8e3f",
  "#ce7b51",
  "#da7953",
  "#ddcb6b",
  "#a9ac31",
  "#aaa44c",
  "#7a8e68",
  "#94d3c1",
  "#bae6d2",
  "#8dc9c0",
  "#00948b",
  "#f3f0e7",
  "#d7cbc1",
  "#c9b6a9",
  "#c4bab9",
  "#b99d99",
  "#c69b9e",
  "#ad929f",
  "#9f898c",
  "#ece8de",
  "#f1e7d9",
  "#f3ebe4",
  "#f5e4da",
  "#efdacf",
  "#e1c4b9",
  "#e3b9ab",
  "#c59688",
  "#ede2e4",
  "#ebd7d9",
  "#dbb7bc",
  "#b98290",
  "#a67479",
  "#9d686c",
  "#9f6071",
  "#7f3f55",
  "#cfbeb7",
  "#e4caba",
  "#e5c0a9",
  "#dfbaab",
  "#ca7976",
  "#c1727c",
  "#b0676d",
  "#af5959",
  "#545049",
  "#c2b8ac",
  "#eddcc9",
  "#1a1917",
  "#000000",
  "#ffffff",
  "#eaeace",
  "#bfbfb6",
  "#e8e8e8",
  "#373025",
  "#a1a191",
  "#383838",
  "#354c3b",
  "#6b3d31",
  "#96683b",
  "#51524d",
  "#aa988a",
  "#757d82",
  "#8f9da8",
  "#3c4a53",
  "#4f4135",
  "#2b2b2b",
  "#524b3e",
  "#002e45",
  "#da2122",
  "#ebebeb",
  "#112e57",
  "#cccfbe",
  "#959595",
  "#4f6e7d",
  "#848484",
  "#9d4e2f",
  "#9aa1a3",
  "#BEB5A9",
  "#C8BCAB",
  "#EDECE6",
  "#bbb2a3",
  "#efece3",
  "#e3dbcd",
  "#2a3037",
  "#313233",
  "#433f34",
  "#E7e7e9",
  "#f6f5fa",
  "#6b5d50",
  "#d4d3ce",
  "#778375",
  "#afb2a3",
  "#b8bab2",
  "#31353a",
  "#323234",
  "#757257",
  "#5c5c4f",
  "#c5baa5",
  "#ccc8c0",
  "#90948b",
  "#c5c2b8",
  "#b3b0a6",
  "#54523b",
  "#8b8370",
  "#d8d5cf",
  "#1a181a",
  "#4d412f",
  "#e2ded4",
  "#b2ad98",
  "#f4f6f2",
  "#aaa69a",
  "#2f2f30",
  "#303d4d",
  "#4d3d30",
  "#797979",
  "#870000",
  "#edece7",
  "#d7d7d1",
  "#143d1e",
  "#040708",
  "#ffffff",
  "#4a3321",
  "#361721",
  "#35352d",
  "#4e4d48",
  "#6a7a55",
  "#8a5121",
  "#928e34",
  "#d7d7d2",
  "#bf2726",
  "#840a2d",
  "#4a3321",
  "#830b0d",
  "#8b8776",
  "#133f1f",
  "#053752",
  "#979292",
  "#4e4d48",
  "#999492",
  "#b7ac97",
  "#1e4922",
  "#d3ccab",
  "#bdb68f",
  "#bdb790",
  "#999492",
  "#4d4d47",
  "#315d74",
  "#221f1f",
  "#999492",
  "#edefeb",
  "#a22320",
  "#7a2a28",
  "#49331f",
  "#bdb68f",
  "#9f8777",
  "#221f1f",
  "#bc9369",
  "#9f8776",
  "#040708",
  "#23302c",
  "#63707c",
  "#4e413a",
  "#322c2d",
  "#304654",
  "#2a3d3a",
  "#6c6f6a",
  "#3b564b",
  "#e7e2cb",
  "#5c6461",
  "#a58966",
  "#726158",
  "#a09b9a",
  "#8d877c",
  "#dcc28f",
  "#4b504c",
  "#8b8e8c",
  "#9aa098",
  "#4f5f67",
  "#466279",
  "#5f767a",
  "#78484a",
  "#927564",
  "#475960",
  "#958b75",
  "#c3cbb8",
  "#e0d0b4",
  "#ccd0c7",
  "#986953",
  "#7b7162",
  "#bbc2aa",
  "#9e7960",
  "#c9bca7",
  "#aaa891",
  "#24211f",
  "#734136",
  "#f1edcf",
  "#606659",
  "#999b93",
  "#3a4650",
  "#46443c",
  "#5b3e2f",
  "#673440",
  "#7a7265",
  "#5d3e41",
  "#514e47",
  "#d3c6b4",
  "#f7f1cc",
  "#acaeb2",
  "#cbd0c9",
  "#fff7e3",
  "#a0aa9a",
  "#f0ead6",
  "#d2cab6",
  "#e0d0b4",
  "#a6c1c9",
  "#d8d4bf",
  "#a1ab8b",
  "#bbc2aa",
  "#8f5937",
  "#73645b",
  "#7a7474",
  "#3f4748",
  "#585c67",
  "#8c898c",
  "#dfd5c3",
  "#5f6a62",
  "#c9af8c",
  "#9d9ba1",
  "#908171",
  "#333932",
  "#999a92",
  "#ac9988",
  "#485061",
  "#5c5e63",
  "#6b6866",
  "#c9c0b8",
  "#867f7d",
  "#4d3b33",
  "#c0b19d",
  "#6e767f",
  "#614e42",
  "#a67c64",
  "#7f4642",
  "#9d8071",
  "#877563",
  "#cabbaa",
  "#9f9584",
  "#978b7e",
  "#55554f",
  "#f8f8f7",
  "#a8967c",
  "#84786d",
  "#eddcc9",
  "#1a1917",
  "#423124",
  "#a9a092",
  "#847362",
  "#ede0c9",
  "#224a4f",
  "#a5a6aa",
  "#fbf9f4",
  "#f0ebd1",
  "#f7f5f5",
  "#2f2e2e",
  "#756346",
  "#5c4d29",
  "#40311c",
  "#e0d8c5",
  "#6e6968",
  "#c4b591",
  "#928b7c",
  "#949594",
  "#8e988c",
  "#7c7463",
  "#59534c",
  "#79888e",
  "#988977",
  "#e8b9ae",
  "#946644",
  "#47626f",
  "#e9e0d5",
  "#598c74",
  "#c2ccc4",
  "#92576f",
  "#b87e93",
  "#cb9aad",
  "#e3c0cf",
  "#ebd1db",
  "#7c3655",
  "#854158",
  "#a2566f",
  "#c47b95",
  "#d899b1",
  "#99324e",
  "#b04b63",
  "#d47c8c",
  "#e392a1",
  "#efc0cb",
  "#f1d3da",
  "#f0bcc9",
  "#f1d2d7",
  "#a42e37",
  "#bb4b51",
  "#d66972",
  "#ed939d",
  "#f0c1c6",
  "#f2d5d7",
  "#813235",
  "#a43834",
  "#d76c6e",
  "#ed9190",
  "#f0b3b2",
  "#f1c6c4",
  "#903934",
  "#a13b34",
  "#d9766c",
  "#ee9489",
  "#f0afa8",
  "#f2ccc5",
  "#b8473d",
  "#b85444",
  "#d87b6a",
  "#e79580",
  "#f2b8a7",
  "#f2d1c3",
  "#b44b34",
  "#c65f47",
  "#dd7861",
  "#e49780",
  "#f3c1ab",
  "#f0d1c3",
  "#c4633e",
  "#d67c56",
  "#e2946f",
  "#c35530",
  "#f3c1a3",
  "#f3d3bf",
  "#c36f3e",
  "#cb7841",
  "#e6955f",
  "#f2b88c",
  "#f4c69f",
  "#f4d3b3",
  "#e69f5f",
  "#efb57a",
  "#f5c894",
  "#f4d4af",
  "#df9938",
  "#ebad5e",
  "#eeb76b",
  "#f4bf77",
  "#f5d6a9",
  "#e39a33",
  "#f2af46",
  "#f7be5b",
  "#fbcb78",
  "#fbd187",
  "#f5deaf",
  "#ffc723",
  "#f4c454",
  "#fbd073",
  "#fbd682",
  "#fedf94",
  "#f5e5bc",
  "#fecb01",
  "#fed340",
  "#ffd566",
  "#fad97a",
  "#f5e1a6",
  "#f3e8c2",
  "#f1ead8",
  "#f6dda3",
  "#f5e0b1",
  "#c48919",
  "#d6a02b",
  "#eec25f",
  "#f5d68f",
  "#c49832",
  "#d1a436",
  "#dbb04a",
  "#eac365",
  "#f7d78a",
  "#f5e1ac",
  "#cba901",
  "#ddb835",
  "#edd26f",
  "#f7e594",
  "#f2eac3",
  "#9c8b1f",
  "#ac9825",
  "#c4b146",
  "#d9c661",
  "#e6d88e",
  "#eee3b2",
  "#847e35",
  "#b4b05a",
  "#c4c476",
  "#d2d083",
  "#dad790",
  "#e9e5b3",
  "#2f5f3a",
  "#4f854a",
  "#7fac6e",
  "#99c285",
  "#abca99",
  "#c0d2ad",
  "#245e36",
  "#68a678",
  "#78b185",
  "#8ec298",
  "#aed2b0",
  "#cce2ca",
  "#016844",
  "#57aa80",
  "#8ac1a1",
  "#9fcdb1",
  "#b7d7bf",
  "#d1e3d2",
  "#368976",
  "#53a38f",
  "#70baa7",
  "#89c6b7",
  "#a1d4c8",
  "#c0e3da",
  "#3b8c80",
  "#75b9ae",
  "#8ac5ba",
  "#a1d5cb",
  "#c1e6df",
  "#017478",
  "#01858b",
  "#3aa9ae",
  "#6ec2c4",
  "#92d0d0",
  "#a7dcdc",
  "#c2e5e5",
  "#01717e",
  "#08808e",
  "#4da6b2",
  "#7dc1cb",
  "#97cbd2",
  "#a6d0d6",
  "#016e85",
  "#34a3b6",
  "#71b8c7",
  "#8bc4d1",
  "#a6d4de",
  "#c6e3e8",
  "#016081",
  "#01819e",
  "#01a0b8",
  "#56b5ca",
  "#8fd0dd",
  "#b4e0e7",
  "#015d87",
  "#017ca7",
  "#289ec4",
  "#5db3d4",
  "#89c6df",
  "#a2d5e7",
  "#b7dfe8",
  "#2377a2",
  "#5a9ec0",
  "#7db5d3",
  "#b0d6e6",
  "#c3dfe8",
  "#4c6b8a",
  "#6b8ca9",
  "#8ea9c2",
  "#b2c8d8",
  "#cbd8e1",
  "#164576",
  "#4e739f",
  "#7498be",
  "#97b3d0",
  "#b8cddd",
  "#ccdbe5",
  "#3e4371",
  "#6572a5",
  "#8b98c4",
  "#a7b2d4",
  "#bbc5de",
  "#d8dde6",
  "#4d426e",
  "#716998",
  "#968db8",
  "#bdb4d4",
  "#d1cbdf",
  "#dfd9e4",
  "#624977",
  "#7e6596",
  "#a18ab7",
  "#c0afd0",
  "#d2c8dd",
  "#dfdce5",
  "#5d395f",
  "#7c5a7e",
  "#a785a7",
  "#c2a4c2",
  "#dac7da",
  "#e5dbe5",
  "#2f2f30",
  "#7d848b",
  "#a8aeb1",
  "#bec1c3",
  "#d4d8d7",
  "#656d73",
  "#90979b",
  "#b8bcbb",
  "#d3d5d3",
  "#dbdfe0",
  "#44484d",
  "#616669",
  "#7f8486",
  "#939899",
  "#a0a5a7",
  "#b0b5b5",
  "#c6caca",
  "#606e74",
  "#969a96",
  "#abb0ac",
  "#a5a9a8",
  "#c5c8c4",
  "#dad9d4",
  "#434341",
  "#636562",
  "#7f817e",
  "#939591",
  "#a7a8a2",
  "#bdbdb7",
  "#cbccc9",
  "#585858",
  "#7f7b73",
  "#b2ada4",
  "#beb9b0",
  "#cbc7bf",
  "#484c49",
  "#63655f",
  "#7c7d75",
  "#92948d",
  "#a3a7a0",
  "#b2b5af",
  "#c8cbc4",
  "#f2eac3",
  "#9e6b75",
  "#ae8087",
  "#c79ea2",
  "#dabdc1",
  "#e8d4d5",
  "#864c52",
  "#995d62",
  "#a87376",
  "#c39393",
  "#dcb6b5",
  "#ebd1cf",
  "#974953",
  "#ad5e65",
  "#ba7176",
  "#cf8a8d",
  "#e6bdbd",
  "#edd3d2",
  "#8e3738",
  "#b56966",
  "#c37f7a",
  "#cd8e89",
  "#ebcecb",
  "#7b3730",
  "#a0584f",
  "#bf796e",
  "#cd8e7f",
  "#e3b5a8",
  "#ebcfc3",
  "#83382a",
  "#a85e53",
  "#b57466",
  "#ce9382",
  "#e2b6a7",
  "#eacdc1",
  "#994b35",
  "#c1785c",
  "#d9987c",
  "#e4b9a2",
  "#edd2c0",
  "#a2583a",
  "#b46848",
  "#c47b5b",
  "#db9c7b",
  "#e5b99b",
  "#eccfbb",
  "#a6613c",
  "#c38058",
  "#d4966e",
  "#dba480",
  "#e0b392",
  "#ebccb3",
  "#cd8c5d",
  "#d69969",
  "#e3ab7b",
  "#e8be9b",
  "#edd0b6",
  "#b16a37",
  "#f0cb97",
  "#f3d9ba",
  "#b67d3c",
  "#c78538",
  "#d59858",
  "#e8b87f",
  "#edc38e",
  "#f2d5b0",
  "#ba7f38",
  "#cc9249",
  "#d69e59",
  "#ddac6d",
  "#edc796",
  "#a57955",
  "#ba8c64",
  "#cca683",
  "#e4caad",
  "#a4763c",
  "#c09056",
  "#efddc1",
  "#906a3a",
  "#ad8451",
  "#c19763",
  "#cba576",
  "#d2b084",
  "#dcbd92",
  "#e4ceac",
  "#9c7a56",
  "#b39167",
  "#ba9c75",
  "#c5aa85",
  "#cdb592",
  "#dbc7a8",
  "#996f32",
  "#aa803a",
  "#c99e53",
  "#d5b176",
  "#e1c28d",
  "#e9d6b0",
  "#9c7f41",
  "#b89b59",
  "#c2a462",
  "#d2ba83",
  "#dcc797",
  "#e4d0a5",
  "#7a6841",
  "#9d8344",
  "#b1975f",
  "#bea775",
  "#cbb584",
  "#ddcda6",
  "#655f2d",
  "#8d844d",
  "#9c9152",
  "#c4b47d",
  "#cfc291",
  "#dfd4b0",
  "#71713e",
  "#95945c",
  "#aeac7a",
  "#bbb98a",
  "#cbc99d",
  "#e0ddbd",
  "#576238",
  "#6d7645",
  "#88915d",
  "#9ba373",
  "#dbddbd",
  "#475842",
  "#60724f",
  "#8fa277",
  "#a3b48c",
  "#c5d1b2",
  "#dae2cd",
  "#42603c",
  "#5e7f57",
  "#75946b",
  "#8ba97f",
  "#b3cbaa",
  "#cfddc7",
  "#205134",
  "#537150",
  "#6c8867",
  "#98b092",
  "#acc2a8",
  "#c8d8c4",
  "#3d5541",
  "#61826c",
  "#7d9b89",
  "#91af9d",
  "#aac2b3",
  "#c6d5c9",
  "#2a4f43",
  "#547867",
  "#94b5a6",
  "#accabc",
  "#c4d9ce",
  "#124a42",
  "#476f65",
  "#7ea298",
  "#94b2a6",
  "#a8c1b7",
  "#bfd2c9",
  "#01554f",
  "#2e6864",
  "#518682",
  "#8caeab",
  "#a3c0bd",
  "#b4ccc9",
  "#c3d7d3",
  "#016367",
  "#3c797d",
  "#5c9598",
  "#7bb1b2",
  "#bedbd8",
  "#015a6b",
  "#217786",
  "#5b96a2",
  "#84b4be",
  "#b0d2d6",
  "#c7dfe0",
  "#175a6c",
  "#427584",
  "#68909d",
  "#88abb4",
  "#9fbbc3",
  "#c7d8db",
  "#015d75",
  "#2f778b",
  "#5b92a2",
  "#83afbc",
  "#9bbfc9",
  "#c5dce0",
  "#01455e",
  "#22657f",
  "#5389a1",
  "#85b0c4",
  "#a9c9d7",
  "#c2dae0",
  "#215772",
  "#43718b",
  "#6a8ea1",
  "#97b4c3",
  "#b3c9d3",
  "#506b84",
  "#6a8aa4",
  "#8ba7bb",
  "#b2c7d3",
  "#ced9dd",
  "#3b496d",
  "#6c7f9a",
  "#8595aa",
  "#99a7b8",
  "#cbd5db",
  "#3b3c5a",
  "#5d657b",
  "#757c91",
  "#99a0b2",
  "#bdc3cd",
  "#d6d9de",
  "#3e385a",
  "#645e77",
  "#7e778e",
  "#a29baa",
  "#c5c0c9",
  "#dad6db",
  "#7a6b85",
  "#9a8ca2",
  "#b0a3b6",
  "#d1c6d2",
  "#e0dadf",
  "#5f3f54",
  "#7e5a6d",
  "#8b6878",
  "#aa8e9a",
  "#cbb8c0",
  "#dbcfd4",
  "#665d57",
  "#6d6562",
  "#847b77",
  "#9e9793",
  "#ada8a5",
  "#cfcac7",
  "#48423c",
  "#dcd8d0",
  "#564537",
  "#6f6459",
  "#867a6f",
  "#aba39a",
  "#b9b2a9",
  "#ccc5bd",
  "#756861",
  "#a09287",
  "#b7ab9f",
  "#c1b6ab",
  "#d4ccc3",
  "#564536",
  "#716354",
  "#8a7a6a",
  "#a0907f",
  "#b1a290",
  "#c0b2a2",
  "#d1c7b8",
  "#4d3930",
  "#826f5e",
  "#917c6a",
  "#c5b6a4",
  "#cdbfb0",
  "#dbcebd",
  "#443735",
  "#755c48",
  "#a48d77",
  "#d8c4ae",
  "#443735",
  "#5f3d3f",
  "#76595d",
  "#907676",
  "#b89d9a",
  "#c9b0ab",
  "#d6c2be",
  "#5a3532",
  "#7a5f5a",
  "#a08882",
  "#b6a09a",
  "#c3b1ac",
  "#d7c8c2",
  "#5a382d",
  "#806257",
  "#a2877d",
  "#b8a196",
  "#c6b3a9",
  "#d6c8c0",
  "#5d3831",
  "#9c6e63",
  "#a8857a",
  "#cfb4a8",
  "#dbc7bd",
  "#694336",
  "#896656",
  "#ae8e7e",
  "#c1a392",
  "#d1b7a8",
  "#decabd",
  "#4f3426",
  "#715243",
  "#967a6a",
  "#a58c7b",
  "#bba595",
  "#cbb9ab",
  "#634533",
  "#785b47",
  "#8e725f",
  "#9c8373",
  "#b59f8f",
  "#d6c7b9",
  "#403330",
  "#7a6455",
  "#907865",
  "#a08e7e",
  "#b5a597",
  "#c2b4a7",
  "#d3c8bd",
  "#604c3d",
  "#785f4c",
  "#917864",
  "#a58f7b",
  "#b9a796",
  "#c6b5a7",
  "#d5c7ba",
  "#69482c",
  "#815d40",
  "#a3846c",
  "#bfa38d",
  "#cab3a0",
  "#dac8b8",
  "#65503d",
  "#947a62",
  "#bca38b",
  "#c9b29c",
  "#d7c5b3",
  "#765138",
  "#c5a88d",
  "#dcc7b3",
  "#b99974",
  "#cfb597",
  "#dcc7ad",
  "#70573f",
  "#9e8163",
  "#a78c71",
  "#baa185",
  "#c7b198",
  "#d7c5ae",
  "#695239",
  "#8f7659",
  "#a08568",
  "#c0ad96",
  "#cfbea9",
  "#dfd3c3",
  "#855d42",
  "#ab8b6e",
  "#caad87",
  "#dabe9e",
  "#e1cdae",
  "#f1dbbd",
  "#6e543c",
  "#867057",
  "#947f65",
  "#ccb79b",
  "#dacab2",
  "#786957",
  "#8e7f6a",
  "#a4947e",
  "#b8a992",
  "#c8bba3",
  "#d9cfba",
  "#9a815e",
  "#ac9571",
  "#b9a47e",
  "#c6b08a",
  "#d0ba94",
  "#e0cfb0",
  "#665439",
  "#877459",
  "#9f8e71",
  "#b19f80",
  "#cdbb9c",
  "#ddd0b6",
  "#5d513e",
  "#7e6f59",
  "#998970",
  "#ac9d83",
  "#c1ae91",
  "#cdbda2",
  "#5a5243",
  "#726b5b",
  "#b0ab9c",
  "#bfb9aa",
  "#d1cdbf",
  "#5e5949",
  "#898473",
  "#b2ac96",
  "#d1ccb9",
  "#4f523a",
  "#65684c",
  "#7f8266",
  "#acad97",
  "#bbbca7",
  "#cecebd",
  "#465448",
  "#626e60",
  "#7a8775",
  "#9fa694",
  "#bdc0b3",
  "#d1d3c7",
  "#4e5147",
  "#7b8070",
  "#95978a",
  "#abac9f",
  "#bebfb2",
  "#d1d0c6",
  "#64645a",
  "#7f7e72",
  "#949488",
  "#a6a69b",
  "#b6b5ab",
  "#c9c9c0",
  "#5e6259",
  "#7a8076",
  "#969c92",
  "#bec3bb",
  "#cdd2ca",
  "#343b36",
  "#5e706a",
  "#7c8e87",
  "#8d9e97",
  "#9baaa2",
  "#adbbb2",
  "#4a5d5f",
  "#5d7274",
  "#7a9192",
  "#8b9fa0",
  "#9bafb2",
  "#abbebf",
  "#c2cfcf",
  "#244653",
  "#607d84",
  "#80969d",
  "#96aab0",
  "#a4b7bd",
  "#bccbce",
  "#204652",
  "#536872",
  "#6f848c",
  "#90a0a6",
  "#a6b2b5",
  "#b6c3c4",
  "#cbd4d4",
  "#23383f",
  "#596368",
  "#91999c",
  "#a9b0b1",
  "#b8bebe",
  "#cdd2d2",
  "#32586e",
  "#4e7287",
  "#708d9e",
  "#8aa3b1",
  "#9eb4c0",
  "#b7c9d1",
  "#c9d9e0",
  "#2f3d4c",
  "#5d6f7f",
  "#768b9a",
  "#98a9b7",
  "#aabac6",
  "#bfc9d0",
  "#606b75",
  "#7a848d",
  "#979fa5",
  "#adb5b9",
  "#b8c0c3",
  "#cad0d2",
  "#605e63",
  "#7b787d",
  "#949194",
  "#bdb8b8",
  "#cfc9c8",
  "#443e40",
  "#676064",
  "#837d7f",
  "#989192",
  "#ada5a5",
  "#4a4653",
  "#5d5962",
  "#736f78",
  "#8f8a91",
  "#a6a3a9",
  "#b5b1b5",
  "#cbc9c9",
  "#4e4247",
  "#695c62",
  "#9d9093",
  "#afa7ac",
  "#bdb5b9",
  "#cec9cc",
  "#4e3132",
  "#6f5c5f",
  "#8b7c7e",
  "#b3a3a5",
  "#c1b2b3",
  "#d1c5c4",
  "#4d3c3c",
  "#6e615f",
  "#867875",
  "#9f9291",
  "#b1a3a1",
  "#c2b6b6",
  "#56433b",
  "#756761",
  "#8c7e78",
  "#ac9e97",
  "#bfb1aa",
  "#d1c5be",
  "#827466",
  "#9c8a79",
  "#a79582",
  "#b3a491",
  "#c4b7a5",
  "#5f4b3f",
  "#907d66",
  "#b7a48b",
  "#c0af97",
  "#dfd2bf",
  "#74685a",
  "#9e9284",
  "#ada295",
  "#bfb6aa",
  "#d1cbc1",
  "#4f4842",
  "#78736e",
  "#908a83",
  "#aca79e",
  "#bcb7ad",
  "#ccc9c0",
  "#54504a",
  "#6b645b",
  "#817a6e",
  "#979083",
  "#a8a093",
  "#cec6bb",
  "#645a4b",
  "#867e70",
  "#958d7f",
  "#cfcabd",
  "#7d745e",
  "#bcb099",
  "#cbc0ad",
  "#dbd0bb",
  "#f7f7f1",
  "#f5f2e9",
  "#f3eee3",
  "#eeece3",
  "#eeefea",
  "#edece6",
  "#e5e2da",
  "#e3ddd3",
  "#e3ded0",
  "#e5dfd2",
  "#e6dfd3",
  "#e2daca",
  "#dcd1bf",
  "#dcd2c3",
  "#dfd9cf",
  "#e3ded7",
  "#e2ded8",
  "#e7e2da",
  "#eeefeb",
  "#ecece7",
  "#f6f0e2",
  "#f0ece2",
  "#edeae0",
  "#f0eadc",
  "#efe8db",
  "#e8e2d4",
  "#e8dfca",
  "#f4e8d2",
  "#f2e3ca",
  "#f2e5cf",
  "#ede1ce",
  "#dccfba",
  "#e6dccd",
  "#e9decf",
  "#e9dcc6",
  "#e8dcc6",
  "#eadfc9",
  "#e2d3bf",
  "#e7d7c2",
  "#e9ebe7",
  "#f1eee6",
  "#f4efe5",
  "#f7efe3",
  "#f0ebe0",
  "#e3e4e1",
  "#dedfdc",
  "#d8e0df",
  "#e3e2d9",
  "#e2e0d6",
  "#e8e3d9",
  "#edeae5",
  "#eee9e0",
  "#e6ddd5",
  "#f2ece6",
  "#e7dbd3",
  "#edddca",
  "#f0e1d0",
  "#f3e9d7",
  "#efe8dd",
  "#cfcac7",
  "#ada8a5",
  "#847b77",
  "#6d6562",
  "#403330",
  "#c2b6b6",
  "#b1a3a1",
  "#867875",
  "#6e615f",
  "#4d3c3c",
  "#d1c5c4",
  "#c1b2b3",
  "#b3a3a5",
  "#8b7c7e",
  "#6f5c5f",
  "#4e3132",
  "#d6c2be",
  "#c9b0ab",
  "#b89d9a",
  "#907676",
  "#76595d",
  "#5f3d3f",
  "#d7c8c2",
  "#c3b1ac",
  "#b6a09a",
  "#7a5f5a",
  "#5a3532",
  "#d1c5be",
  "#bfb1aa",
  "#ac9e97",
  "#8c7e78",
  "#756761",
  "#56433b",
  "#d6c8c0",
  "#c6b3a9",
  "#b8a196",
  "#806257",
  "#5a382d",
  "#e7dbd3",
  "#dbc7bd",
  "#cfb4a8",
  "#9c6e63",
  "#5d3831",
  "#decabd",
  "#d1b7a8",
  "#c1a392",
  "#896656",
  "#694336",
  "#e6ddd5",
  "#cbb9ab",
  "#bba595",
  "#967a6a",
  "#715243",
  "#4f3426",
  "#d4ccc3",
  "#c1b6ab",
  "#b7ab9f",
  "#756861",
  "#4d3930",
  "#d3c8bd",
  "#c2b4a7",
  "#b5a597",
  "#907865",
  "#7a6455",
  "#5f4b3f",
  "#d6c7b9",
  "#b59f8f",
  "#8e725f",
  "#785b47",
  "#634533",
  "#dac8b8",
  "#cab3a0",
  "#bfa38d",
  "#815d40",
  "#69482c",
  "#d7c5b3",
  "#c9b29c",
  "#bca38b",
  "#947a62",
  "#65503d",
  "#e6dccd",
  "#d7c5ae",
  "#c7b198",
  "#baa185",
  "#9e8163",
  "#70573f",
  "#e4caad",
  "#cca683",
  "#ba8c64",
  "#a57955",
  "#e8dcc6",
  "#dbc7a8",
  "#cdb592",
  "#c5aa85",
  "#b39167",
  "#9c7a56",
  "#e9dcc6",
  "#e4ceac",
  "#dcbd92",
  "#d2b084",
  "#c19763",
  "#ad8451",
  "#906a3a",
  "#eadfc9",
  "#e0cfb0",
  "#d0ba94",
  "#c6b08a",
  "#ac9571",
  "#9a815e",
  "#e9decf",
  "#dacab2",
  "#ccb79b",
  "#947f65",
  "#867057",
  "#6e543c",
  "#d9cfba",
  "#c8bba3",
  "#b8a992",
  "#8e7f6a",
  "#786957",
  "#e8e2d4",
  "#cdbda2",
  "#c1ae91",
  "#998970",
  "#7e6f59",
  "#5d513e",
  "#d1ccb9",
  "#b2ac96",
  "#898473",
  "#5e5949",
  "#d1cdbf",
  "#bfb9aa",
  "#b0ab9c",
  "#726b5b",
  "#cecebd",
  "#bbbca7",
  "#acad97",
  "#7f8266",
  "#65684c",
  "#4f523a",
  "#e3e2d9",
  "#d1d0c6",
  "#bebfb2",
  "#abac9f",
  "#7b8070",
  "#4e5147",
  "#d1d3c7",
  "#bdc0b3",
  "#9fa694",
  "#7a8775",
  "#626e60",
  "#465448",
  "#c9c9c0",
  "#b6b5ab",
  "#a6a69b",
  "#7f7e72",
  "#64645a",
  "#cdd2ca",
  "#bec3bb",
  "#7a8076",
  "#5e6259",
  "#adbbb2",
  "#9baaa2",
  "#7c8e87",
  "#5e706a",
  "#343b36",
  "#c2cfcf",
  "#abbebf",
  "#9bafb2",
  "#7a9192",
  "#5d7274",
  "#4a5d5f",
  "#d8e0df",
  "#bccbce",
  "#a4b7bd",
  "#96aab0",
  "#607d84",
  "#244653",
  "#cdd2d2",
  "#b8bebe",
  "#a9b0b1",
  "#596368",
  "#23383f",
  "#dbdfe0",
  "#bfc9d0",
  "#aabac6",
  "#98a9b7",
  "#768b9a",
  "#5d6f7f",
  "#2f3d4c",
  "#cad0d2",
  "#b8c0c3",
  "#adb5b9",
  "#7a848d",
  "#606b75",
  "#e3e4e1",
  "#d4d8d7",
  "#bec1c3",
  "#a8aeb1",
  "#7d848b",
  "#2f2f30",
  "#cbc9c9",
  "#b5b1b5",
  "#a6a3a9",
  "#736f78",
  "#5d5962",
  "#4a4653",
  "#cec9cc",
  "#bdb5b9",
  "#afa7ac",
  "#695c62",
  "#4e4247",
  "#cfc9c8",
  "#bdb8b8",
  "#7b787d",
  "#605e63",
  "#dbcfd4",
  "#cbb8c0",
  "#aa8e9a",
  "#8b6878",
  "#7e5a6d",
  "#5f3f54",
  "#e8d4d5",
  "#dabdc1",
  "#c79ea2",
  "#9e6b75",
  "#ebd1cf",
  "#dcb6b5",
  "#c39393",
  "#995d62",
  "#864c52",
  "#edd3d2",
  "#e6bdbd",
  "#cf8a8d",
  "#ad5e65",
  "#974953",
  "#ebcecb",
  "#cd8e89",
  "#b56966",
  "#8e3738",
  "#ebcfc3",
  "#e3b5a8",
  "#cd8e7f",
  "#a0584f",
  "#7b3730",
  "#eacdc1",
  "#e2b6a7",
  "#ce9382",
  "#a85e53",
  "#83382a",
  "#edd2c0",
  "#e4b9a2",
  "#d9987c",
  "#c1785c",
  "#994b35",
  "#eccfbb",
  "#e5b99b",
  "#db9c7b",
  "#c47b5b",
  "#b46848",
  "#a2583a",
  "#edddca",
  "#ebccb3",
  "#e0b392",
  "#d4966e",
  "#c38058",
  "#a6613c",
  "#f0e1d0",
  "#edd0b6",
  "#e8be9b",
  "#d69969",
  "#cd8c5d",
  "#f3d9ba",
  "#f0cb97",
  "#f2e3ca",
  "#f2d5b0",
  "#edc38e",
  "#d59858",
  "#c78538",
  "#b67d3c",
  "#edc796",
  "#ddac6d",
  "#d69e59",
  "#cc9249",
  "#ba7f38",
  "#f0eadc",
  "#efddc1",
  "#c09056",
  "#a4763c",
  "#e9d6b0",
  "#e1c28d",
  "#c99e53",
  "#aa803a",
  "#996f32",
  "#e4d0a5",
  "#d2ba83",
  "#c2a462",
  "#b89b59",
  "#9c7f41",
  "#ddcda6",
  "#cbb584",
  "#b1975f",
  "#9d8344",
  "#7a6841",
  "#dfd4b0",
  "#cfc291",
  "#9c9152",
  "#8d844d",
  "#655f2d",
  "#e0ddbd",
  "#cbc99d",
  "#aeac7a",
  "#95945c",
  "#71713e",
  "#dbddbd",
  "#88915d",
  "#6d7645",
  "#576238",
  "#dae2cd",
  "#c5d1b2",
  "#a3b48c",
  "#60724f",
  "#475842",
  "#cfddc7",
  "#b3cbaa",
  "#8ba97f",
  "#5e7f57",
  "#42603c",
  "#c8d8c4",
  "#acc2a8",
  "#98b092",
  "#6c8867",
  "#537150",
  "#205134",
  "#c6d5c9",
  "#aac2b3",
  "#91af9d",
  "#61826c",
  "#3d5541",
  "#c4d9ce",
  "#accabc",
  "#94b5a6",
  "#547867",
  "#2a4f43",
  "#bfd2c9",
  "#a8c1b7",
  "#7ea298",
  "#476f65",
  "#124a42",
  "#c3d7d3",
  "#b4ccc9",
  "#8caeab",
  "#518682",
  "#2e6864",
  "#01554f",
  "#bedbd8",
  "#7bb1b2",
  "#5c9598",
  "#3c797d",
  "#016367",
  "#c7dfe0",
  "#b0d2d6",
  "#84b4be",
  "#5b96a2",
  "#217786",
  "#015a6b",
  "#c5dce0",
  "#83afbc",
  "#5b92a2",
  "#2f778b",
  "#015d75",
  "#c2dae0",
  "#a9c9d7",
  "#85b0c4",
  "#5389a1",
  "#22657f",
  "#01455e",
  "#b3c9d3",
  "#97b4c3",
  "#6a8ea1",
  "#43718b",
  "#215772",
  "#ced9dd",
  "#b2c7d3",
  "#8ba7bb",
  "#6a8aa4",
  "#506b84",
  "#cbd8e1",
  "#b2c8d8",
  "#8ea9c2",
  "#6b8ca9",
  "#4c6b8a",
  "#cbd5db",
  "#99a7b8",
  "#6c7f9a",
  "#3b496d",
  "#d6d9de",
  "#bdc3cd",
  "#99a0b2",
  "#757c91",
  "#5d657b",
  "#3b3c5a",
  "#dad6db",
  "#c5c0c9",
  "#a29baa",
  "#7e778e",
  "#645e77",
  "#3e385a",
  "#e0dadf",
  "#d1c6d2",
  "#b0a3b6",
  "#7a6b85",
  "#ebd1db",
  "#e3c0cf",
  "#cb9aad",
  "#b87e93",
  "#92576f",
  "#7c3655",
  "#d899b1",
  "#c47b95",
  "#a2566f",
  "#854158",
  "#f1d3da",
  "#efc0cb",
  "#e392a1",
  "#d47c8c",
  "#b04b63",
  "#99324e",
  "#f1d2d7",
  "#f0bcc9",
  "#f2d5d7",
  "#f0c1c6",
  "#ed939d",
  "#d66972",
  "#bb4b51",
  "#f1c6c4",
  "#f0b3b2",
  "#ed9190",
  "#d76c6e",
  "#a43834",
  "#f2ccc5",
  "#f0afa8",
  "#ee9489",
  "#d9766c",
  "#a13b34",
  "#f2d1c3",
  "#f2b8a7",
  "#e79580",
  "#d87b6a",
  "#b85444",
  "#f0d1c3",
  "#f3c1ab",
  "#e49780",
  "#dd7861",
  "#c65f47",
  "#b44b34",
  "#e2946f",
  "#d67c56",
  "#c4633e",
  "#f3d3bf",
  "#f3c1a3",
  "#f4d3b3",
  "#f4c69f",
  "#e6955f",
  "#cb7841",
  "#c36f3e",
  "#f4d4af",
  "#f5c894",
  "#efb57a",
  "#e69f5f",
  "#f5d6a9",
  "#f4bf77",
  "#ebad5e",
  "#df9938",
  "#f5deaf",
  "#fbcb78",
  "#f7be5b",
  "#f2af46",
  "#e39a33",
  "#f5e0b1",
  "#f6dda3",
  "#f5e5bc",
  "#f5d68f",
  "#eec25f",
  "#d6a02b",
  "#c48919",
  "#f3e8c2",
  "#f5e1ac",
  "#f7d78a",
  "#eac365",
  "#dbb04a",
  "#d1a436",
  "#c49832",
  "#eee3b2",
  "#e6d88e",
  "#d9c661",
  "#c4b146",
  "#ac9825",
  "#9c8b1f",
  "#e9e5b3",
  "#dad790",
  "#c4c476",
  "#b4b05a",
  "#847e35",
  "#c0d2ad",
  "#99c285",
  "#7fac6e",
  "#4f854a",
  "#2f5f3a",
  "#cce2ca",
  "#aed2b0",
  "#8ec298",
  "#68a678",
  "#245e36",
  "#d1e3d2",
  "#b7d7bf",
  "#8ac1a1",
  "#57aa80",
  "#016844",
  "#c0e3da",
  "#a1d4c8",
  "#70baa7",
  "#53a38f",
  "#368976",
  "#c1e6df",
  "#a1d5cb",
  "#75b9ae",
  "#3b8c80",
  "#c2e5e5",
  "#a7dcdc",
  "#6ec2c4",
  "#3aa9ae",
  "#01858b",
  "#017478",
  "#a6d0d6",
  "#7dc1cb",
  "#4da6b2",
  "#08808e",
  "#01717e",
  "#c6e3e8",
  "#a6d4de",
  "#71b8c7",
  "#34a3b6",
  "#016e85",
  "#b4e0e7",
  "#8fd0dd",
  "#56b5ca",
  "#01a0b8",
  "#01819e",
  "#016081",
  "#b7dfe8",
  "#a2d5e7",
  "#5db3d4",
  "#289ec4",
  "#017ca7",
  "#015d87",
  "#c3dfe8",
  "#b0d6e6",
  "#7db5d3",
  "#5a9ec0",
  "#2377a2",
  "#ccdbe5",
  "#b8cddd",
  "#97b3d0",
  "#7498be",
  "#4e739f",
  "#164576",
  "#d8dde6",
  "#a7b2d4",
  "#8b98c4",
  "#6572a5",
  "#3e4371",
  "#dfd9e4",
  "#d1cbdf",
  "#bdb4d4",
  "#968db8",
  "#716998",
  "#4d426e",
  "#dfdce5",
  "#d2c8dd",
  "#c0afd0",
  "#a18ab7",
  "#7e6596",
  "#624977",
  "#e5dbe5",
  "#dac7da",
  "#c2a4c2",
  "#a785a7",
  "#7c5a7e",
  "#5d395f",
  "#c35530",
  "#f5e1a6",
  "#fad97a",
  "#ffc723",
  "#f7e594",
  "#fed340",
  "#fecb01",
  "#edd26f",
  "#ddb835",
  "#cba901",
  "#3b373c",
  "#313031",
  "#f2ece6",
  "#eee9e0",
  "#efe8dd",
  "#e7e2da",
  "#edeae5",
  "#edece6",
  "#eeefea",
  "#e9ebe7",
  "#edeae0",
  "#e8e3d9",
  "#e5dfd2",
  "#e3ded0",
  "#efe8db",
  "#e2ded8",
  "#ccc9c0",
  "#bcb7ad",
  "#aca79e",
  "#908a83",
  "#78736e",
  "#4f4842",
  "#ccc5bd",
  "#b9b2a9",
  "#aba39a",
  "#867a6f",
  "#6f6459",
  "#564537",
  "#e3ded7",
  "#d1cbc1",
  "#bfb6aa",
  "#ada295",
  "#74685a",
  "#e3ddd3",
  "#d1c7b8",
  "#c0b2a2",
  "#b1a290",
  "#8a7a6a",
  "#716354",
  "#564536",
  "#e6dfd3",
  "#cec6bb",
  "#a8a093",
  "#817a6e",
  "#6b645b",
  "#54504a",
  "#e2e0d6",
  "#cfcabd",
  "#867e70",
  "#645a4b",
  "#c8cbc4",
  "#b2b5af",
  "#a3a7a0",
  "#7c7d75",
  "#63655f",
  "#484c49",
  "#dedfdc",
  "#cbccc9",
  "#bdbdb7",
  "#a7a8a2",
  "#7f817e",
  "#636562",
  "#434341",
  "#c6caca",
  "#b0b5b5",
  "#a0a5a7",
  "#7f8486",
  "#616669",
  "#44484d",
  "#ada5a5",
  "#837d7f",
  "#676064",
  "#443e40",
  "#f4efe5",
  "#f7efe3",
  "#9e9284",
  "#665d57",
  "#c4b7a5",
  "#b3a491",
  "#9c8a79",
  "#826f5e",
  "#cdbfb0",
  "#c5b6a4",
  "#a79582",
  "#827466",
  "#6e5f53",
  "#dbcebd",
  "#dfd2bf",
  "#d4c5ad",
  "#dcd1bf",
  "#c0af97",
  "#b7a48b",
  "#cbc0ad",
  "#bcb099",
  "#ac9d83",
  "#63523d",
  "#907d66",
  "#f0ece2",
  "#e2d3bf",
  "#f4e8d2",
  "#f3e9d7",
  "#f2e5cf",
  "#f6f0e2",
  "#e8dfca",
  "#dbd0bb",
  "#f3eee3",
  "#dcd2c3",
  "#e2daca",
  "#dccfba",
  "#dfd9cf",
  "#ede1ce",
  "#e7d7c2",
  "#72353d",
  "#813235",
  "#a42e37",
  "#b8473d",
  "#7c453d",
  "#903934",
  "#3e5063",
  "#b0b8b2",
  "#606e74",
  "#e5e2da",
  "#c0b9a9",
  "#aea594",
  "#c6c0b6",
  "#b2ada4",
  "#dad9d4",
  "#abb0ac",
  "#c5c8c4",
  "#a5a9a8",
  "#969a96",
  "#d3d5d3",
  "#b8bcbb",
  "#90979b",
  "#656d73",
  "#585858",
  "#48423c",
  "#e1cdae",
  "#cba97e",
  "#caad87",
  "#ac6b53",
  "#b0785c",
  "#b16a37",
  "#d8c4ae",
  "#b9b292",
  "#857c5d",
  "#7d745e",
  "#5a5243",
  "#bdc0a0",
  "#f7f7f1",
  "#ae8087",
  "#a87376",
  "#ba7176",
  "#c37f7a",
  "#bf796e",
  "#b57466",
  "#f2b88c",
  "#dba480",
  "#e3ab7b",
  "#e8b87f",
  "#eeb76b",
  "#fbd187",
  "#fedf94",
  "#fbd682",
  "#fbd073",
  "#f4c454",
  "#cba576",
  "#ba9c75",
  "#d5b176",
  "#dcc797",
  "#bea775",
  "#c4b47d",
  "#d2d083",
  "#abca99",
  "#78b185",
  "#9fcdb1",
  "#bbb98a",
  "#9ba373",
  "#8fa277",
  "#75946b",
  "#7d9b89",
  "#89c6b7",
  "#8ac5ba",
  "#92d0d0",
  "#97cbd2",
  "#8bc4d1",
  "#89c6df",
  "#94b2a6",
  "#a3c0bd",
  "#c7d8db",
  "#9fbbc3",
  "#88abb4",
  "#68909d",
  "#427584",
  "#175a6c",
  "#9bbfc9",
  "#bbc5de",
  "#8595aa",
  "#9a8ca2",
  "#a08882",
  "#a2877d",
  "#a8857a",
  "#ae8e7e",
  "#a58c7b",
  "#9c8373",
  "#a08e7e",
  "#d5c7ba",
  "#c6b5a7",
  "#b9a796",
  "#a58f7b",
  "#917864",
  "#785f4c",
  "#604c3d",
  "#a3846c",
  "#dcc7b3",
  "#c5a88d",
  "#765138",
  "#dcc7ad",
  "#cfb597",
  "#b99974",
  "#a78c71",
  "#dfd3c3",
  "#cfbea9",
  "#c0ad96",
  "#a08568",
  "#8f7659",
  "#695239",
  "#a4947e",
  "#b9a47e",
  "#ddd0b6",
  "#cdbb9c",
  "#b19f80",
  "#9f8e71",
  "#877459",
  "#665439",
  "#95978a",
  "#949488",
  "#969c92",
  "#8d9e97",
  "#8b9fa0",
  "#80969d",
  "#cbd4d4",
  "#b6c3c4",
  "#a6b2b5",
  "#90a0a6",
  "#6f848c",
  "#536872",
  "#204652",
  "#91999c",
  "#c9d9e0",
  "#b7c9d1",
  "#9eb4c0",
  "#8aa3b1",
  "#708d9e",
  "#4e7287",
  "#32586e",
  "#979fa5",
  "#949194",
  "#989192",
  "#8f8a91",
  "#9d9093",
  "#9f9291",
  "#939899",
  "#939591",
  "#92948d",
  "#dcd8d0",
  "#9e9793",
  "#a09287",
  "#979083",
  "#958d7f",
  "#a0907f",
  "#2b4360",
  "#234058",
  "#cbc6b7",
  "#aaa28b",
  "#dbd6b9",
  "#ffffff",
  "#292929",
  "#46423a",
  "#c6c2be",
  "#c4b499",
  "#f3f3f3",
  "#dccebe",
  "#3e3d40",
  "#5f251f",
  "#514432",
  "#eeece8",
  "#b1a698",
  "#00412d",
  "#454b4d",
  "#7b685a",
  "#9c8e7e",
  "#ededec",
  "#a8a6a2",
  "#c2b4a0",
  "#c2b4a0",
  "#554f49",
  "#030303",
  "#a59989",
  "#fefffc",
  "#3e2d0f",
  "#776154",
  "#7e8285",
  "#ffffff",
  "#40190a",
  "#a09174",
  "#c9c6b5",
  "#fcecd2",
  "#e8dccd",
  "#d5c8b0",
  "#2c2b2a",
  "#593033",
  "#f4f6f7",
  "#743d36",
  "#d3cdbd",
  "#2c4452",
  "#9d9388",
  "#beae99",
  "#a1917f",
  "#a49789",
  "#fdf1d4",
  "#e2cca9",
  "#513c35",
  "#3c574b",
  "#cabb9f",
  "#bdbebf",
  "#e5e3d2",
  "#16363f",
  "#254035",
  "#3b3837",
  "#d1d2d4",
  "#f7f3e4",
  "#d3c5ad",
  "#fff6e4",
  "#e0c5a1",
  "#c6b09a",
  "#4c4846",
  "#587278",
  "#f5f5f4",
  "#f5faf2",
  "#c1ae9a",
  "#602c30",
  "#f5eace",
  "#212121",
  "#4b392f",
  "#e0d6bd",
  "#2d4e43",
  "#bbac97",
  "#656158",
  "#f8fcff",
  "#63574c",
  "#8d9093",
  "#5e6567",
  "#925f42",
  "#cccec8",
  "#a5a8a3",
  "#f6f1e6",
  "#c0c7bc",
  "#efe9e0",
  "#fff3d1",
  "#a7aa9e",
  "#a4aaad",
  "#5a5850",
  "#a59c87",
  "#63554f",
  "#b5a091",
  "#8d9484",
  "#948671",
  "#798689",
  "#e2e3e4",
  "#9aa29b",
  "#567d96",
  "#c2b59b",
  "#9ab5c6",
  "#4f5736",
  "#a99573",
  "#343c44",
  "#baaf9b",
  "#534f4e",
  "#98afc1",
  "#c06050",
  "#edeee6",
  "#51605b",
  "#c6b89e",
  "#74676e",
  "#747c65",
  "#616161",
  "#e98b43",
  "#a1965c",
  "#dccaa2",
  "#736f66",
  "#7e6958",
  "#3d5847",
  "#f5cf46",
  "#9f978c",
  "#c3914c",
  "#8d473d",
  "#aca39c",
  "#a1a29d",
  "#41504d",
  "#8f6b51",
  "#6a7780",
  "#ebe2d3",
  "#675e59",
  "#4a494e",
  "#544645",
  "#e5e5e3",
  "#9c8a74",
  "#98887b",
  "#6f4b4b",
  "#e1dbcb",
  "#a79b8d",
  "#ac393e",
  "#70403e",
  "#e6e6de",
  "#00639c",
  "#e9c66c",
  "#3e3e3e",
  "#455f6e",
  "#c6bdac",
  "#0b8a93",
  "#414f69",
  "#f3dfc6",
  "#12221d",
  "#60605e",
  "#422b19",
  "#a29788",
  "#66685e",
  "#f0efee",
  "#ada590",
  "#52504d",
  "#567d96",
  "#934f45",
  "#6b7669",
  "#616c64",
  "#36393A",
  "#E6E7D8",
  "#832930",
  "#B23643",
  "#AA5154",
  "#C23F4B",
  "#D86165",
  "#4D3F33",
  "#52463B",
  "#6A4E36",
  "#70563E",
  "#7F5832",
  "#956133",
  "#986735",
  "#906A46",
  "#A96B2B",
  "#C07722",
  "#C27B2E",
  "#CE8121",
  "#D88A30",
  "#E09851",
  "#E6A96F",
  "#C5B5A7",
  "#DFC6B0",
  "#D8CBC0",
  "#ECDBCD",
  "#F0E8DF",
  "#EFE5DC",
  "#EFE4DA",
  "#F1E4D7",
  "#F4E5D7",
  "#B4CBD9",
  "#005E63",
  "#2D3D33",
  "#97D5B1",
  "#9D4F84",
  "#603231",
  "#86252B",
  "#EB8621",
  "#F2ECE5",
  "#E1E7EA",
  "#008C5D",
  "#BDBBDA",
  "#D185B7",
  "#862A2E",
  "#DCA29E",
  "#7C2829",
  "#D4C5B6",
  "#DFD0C2",
  "#E1CFBE",
  "#F2E6DB",
  "#67A0C1",
  "#A1C9E3",
  "#BEE1E2",
  "#EEEFE8",
  "#DBD8E7",
  "#867E7D",
  "#B97A77",
  "#EAE8E5",
  "#D9974C",
  "#E3901A",
  "#AACCE3",
  "#9390BE",
  "#722F2E",
  "#B83944",
  "#F3951B",
  "#FEA93A",
  "#F9D1AA",
  "#83A8C1",
  "#C7D9E3",
  "#E2E5E6",
  "#086845",
  "#008356",
  "#A6272F",
  "#8A7662",
  "#FFA405",
  "#B2D1E7",
  "#19563E",
  "#3C3A48",
  "#BF7AA4",
  "#99282C",
  "#BE5B59",
  "#98B6CB",
  "#D9DAD8",
  "#717366",
  "#838A65",
  "#94968A",
  "#9AA07D",
  "#DBD7D5",
  "#D4BEA8",
  "#E6D9CC",
  "#EDE1D5",
  "#F6E5D4",
  "#FAE7D3",
  "#585568",
  "#84747C",
  "#6B3136",
  "#A1876A",
  "#DDA667",
  "#FFAF3E",
  "#EEBF8B",
  "#25485C",
  "#005476",
  "#006392",
  "#006B9B",
  "#6C97B3",
  "#95A7B4",
  "#B8C4CC",
  "#A9CCE6",
  "#D7DDE1",
  "#E8EAE9",
  "#E8EAE9",
  "#386A6D",
  "#308A91",
  "#699093",
  "#88ABAD",
  "#6AB1B6",
  "#63B3B9",
  "#98B9BB",
  "#90CCD0",
  "#89CED2",
  "#ACD6D8",
  "#9FD8DB",
  "#C6E1E1",
  "#DCEDEC",
  "#207856",
  "#41795F",
  "#757E78",
  "#009461",
  "#41AA7D",
  "#1CAD78",
  "#9DA5A0",
  "#8CAC9B",
  "#5FC094",
  "#83C7A5",
  "#A5C1B2",
  "#8AD3AF",
  "#C0D7C8",
  "#D5DAD5",
  "#B4E5CA",
  "#C7E8D4",
  "#E6EAE4",
  "#DDEBDF",
  "#D2EDDB",
  "#63664F",
  "#72813A",
  "#8D9275",
  "#A3AC74",
  "#98B33E",
  "#AFC657",
  "#B7C292",
  "#D9DCB8",
  "#D6E0A0",
  "#DFE6B7",
  "#E8E9DC",
  "#E7E7D1",
  "#EAF0D3",
  "#444258",
  "#534F74",
  "#66656D",
  "#6F6C81",
  "#6C698D",
  "#81808B",
  "#8C8B95",
  "#9C98B6",
  "#BEBACF",
  "#D1D1D6",
  "#D4D1DF",
  "#DDDBDC",
  "#E9E8E8",
  "#54414C",
  "#82516F",
  "#7D596E",
  "#A25A85",
  "#A8658C",
  "#977287",
  "#C1669D",
  "#B195A4",
  "#C29AAF",
  "#CB94B3",
  "#CDB9C3",
  "#C8C1C4",
  "#D6BBC9",
  "#D5CECF",
  "#DED1D5",
  "#E1D1D7",
  "#DFDBDA",
  "#E2DCDC",
  "#EAE8E5",
  "#EEE8E8",
  "#783C3A",
  "#8F6360",
  "#DE8E89",
  "#D59B96",
  "#CEB2AF",
  "#C9BFBD",
  "#ECCCC8",
  "#ECE7E3",
  "#54473B",
  "#6B5137",
  "#6D5539",
  "#825E39",
  "#6E6256",
  "#7C6A55",
  "#B0752D",
  "#9C7851",
  "#AB804F",
  "#C88326",
  "#C88626",
  "#AB9279",
  "#D19038",
  "#C59967",
  "#E39931",
  "#C9A887",
  "#BAB3AC",
  "#E8A553",
  "#C2B6A9",
  "#EBAE62",
  "#CCB9A4",
  "#C5BFB9",
  "#D7BEA3",
  "#E9BD8E",
  "#F2C89B",
  "#E3D1BF",
  "#E8D3BD",
  "#F1D6BA",
  "#F5D6B5",
  "#E7DBD0",
  "#F6D8B8",
  "#EBDCCC",
  "#F3DEC8",
  "#F9DBBD",
  "#EFE9E1",
  "#F4E8DA",
  "#006B9F",
  "#57A3D1",
  "#64907A",
  "#575A4C",
  "#ECEDE7",
  "#9A8B92",
  "#B4AAAE",
  "#BA9A77",
  "#E19000",
  "#F6CEA2",
  "#FFCF95",
  "#F6E0C9",
  "#FAE0C3",
  "#F2EBE3",
  "#9A9EA0",
  "#E0EAEF",
  "#D6E8E8",
  "#025E42",
  "#4F5342",
  "#A3A793",
  "#6F68A4",
  "#BCB7D5",
  "#603250",
  "#C1ACA9",
  "#C9AE91",
  "#FDBA61",
  "#B9E3E5",
  "#B9BFA7",
  "#E1E2DD",
  "#9693A1",
  "#5E354C",
  "#744962",
  "#EDD3DF",
  "#EDE4E2",
  "#FBBD71",
  "#6CABD6",
  "#B0C4D3",
  "#A8DEE2",
  "#565C43",
  "#DDE3CB",
  "#B2AFBB",
  "#7D3761",
  "#863B67",
  "#E1A5C3",
  "#91302C",
  "#FBB758",
  "#EFC89B",
  "#F5EEE5",
  "#106086",
  "#457697",
  "#AFC3B9",
  "#8B81BA",
  "#D4CFE3",
  "#AE7995",
  "#BF9B6E",
  "#D8B081",
  "#D7C1A8",
  "#E1D4C6",
  "#007CB6",
  "#858585",
  "#7E8D99",
  "#0096A2",
  "#0098A4",
  "#809158",
  "#A2CA48",
  "#D0D4C3",
  "#625894",
  "#A79DC8",
  "#D8D5E0",
  "#DDDAE4",
  "#5F5654",
  "#B02826",
  "#C33A38",
  "#F5DFDB",
  "#F8DCBB",
  "#EAE4DB",
  "#314655",
  "#9AC2E2",
  "#CFDBE5",
  "#E0E4E8",
  "#004C52",
  "#20ADB8",
  "#8CD5DC",
  "#94ACA0",
  "#858A77",
  "#D4D4D2",
  "#915D79",
  "#A23530",
  "#D8C5C1",
  "#6C6965",
  "#EDD0AE",
  "#F1E1CF",
  "#63707B",
  "#58748B",
  "#B3CADE",
  "#687152",
  "#95A969",
  "#493F6C",
  "#453432",
  "#E18479",
  "#F7ACA1",
  "#F3DEDA",
  "#F3E7E4",
  "#53BFCB",
  "#96D6DD",
  "#CED4BE",
  "#F1DEE6",
  "#AF332E",
  "#BD2F2C",
  "#DFCFCC",
  "#6F614F",
  "#FEAB13",
  "#D2CABF",
  "#FDD29B",
  "#3D454D",
  "#86AD3D",
  "#8EAF54",
  "#634F35",
  "#765935",
  "#8B7A66",
  "#987B54",
  "#B37F28",
  "#978064",
  "#B5812E",
  "#AF8136",
  "#C88A28",
  "#998C7C",
  "#A09180",
  "#AA906F",
  "#C38D38",
  "#D79413",
  "#AB9E8E",
  "#BD9F7B",
  "#B3A18C",
  "#DD9C2C",
  "#C5AA88",
  "#BCAD9A",
  "#E5AA53",
  "#DCB481",
  "#CDBBA6",
  "#D9C1A2",
  "#D1C5B7",
  "#D6C7B5",
  "#DAC8B2",
  "#E5CDAF",
  "#EFC898",
  "#DBCFC0",
  "#EED0AC",
  "#E0D1BF",
  "#E4D2BC",
  "#E8D4BC",
  "#E4DBD0",
  "#EFDFCB",
  "#F5DFC4",
  "#EFE8DF",
  "#F1E8DC",
  "#4E5B66",
  "#A1C0DC",
  "#B0B0AF",
  "#269D78",
  "#728C42",
  "#749639",
  "#B34F83",
  "#D486AC",
  "#973E34",
  "#E3CFCB",
  "#F6D6CF",
  "#786D60",
  "#B0A290",
  "#D7A762",
  "#FCBB58",
  "#EFE7DC",
  "#FAE8D1",
  "#234760",
  "#D2DCBF",
  "#B9483C",
  "#EEA197",
  "#A79278",
  "#FFBA35",
  "#FEE1BC",
  "#C7D8E6",
  "#83C5CE",
  "#605088",
  "#E1DFE4",
  "#6F3B33",
  "#7E3C33",
  "#DCA440",
  "#EAB45D",
  "#FFBA1F",
  "#F7EBDC",
  "#87B1D5",
  "#E9EED7",
  "#D3D0D6",
  "#AC833F",
  "#C39E67",
  "#F6E5D0",
  "#37919D",
  "#164B3C",
  "#CB983B",
  "#C5AF92",
  "#F8AF1C",
  "#F1AA4A",
  "#CEBEA8",
  "#F3BA6F",
  "#F1C184",
  "#FFD090",
  "#EDE1D0",
  "#FBDCAE",
  "#F5E1BE",
  "#F5E6D1",
  "#F4E7CE",
  "#4F5050",
  "#59796C",
  "#C5DE9E",
  "#92486C",
  "#E3DBDC",
  "#B05446",
  "#E16F5F",
  "#DFB778",
  "#E5DFD7",
  "#FADBAF",
  "#105444",
  "#7D7D7C",
  "#DEEBE5",
  "#CC6552",
  "#E16553",
  "#F5CAC1",
  "#E8E3DC",
  "#274C68",
  "#184C6E",
  "#004E76",
  "#005B8E",
  "#1D567C",
  "#3A698D",
  "#57718A",
  "#4883B0",
  "#6790B3",
  "#90969C",
  "#769DC2",
  "#9BB6D1",
  "#BDBFC0",
  "#B2C2D5",
  "#CBCDCC",
  "#C3CFDA",
  "#C2D0DF",
  "#D6DDE5",
  "#E9E9E9",
  "#E8EAEB",
  "#00565F",
  "#39595F",
  "#006E7B",
  "#007585",
  "#4B7278",
  "#008897",
  "#62868B",
  "#49A7B5",
  "#85A6AB",
  "#ADC9CC",
  "#BDD1D3",
  "#B3D7DB",
  "#D6DAD7",
  "#D1DEDF",
  "#C9DDDD",
  "#C4E1E4",
  "#C8E6E9",
  "#47524D",
  "#1C5C4A",
  "#517367",
  "#007C5C",
  "#008763",
  "#008466",
  "#008E6B",
  "#669887",
  "#5DA78F",
  "#31B592",
  "#65B59A",
  "#8CBCAB",
  "#8BC2AE",
  "#B8BBB9",
  "#80D2B6",
  "#95CFBA",
  "#A9D0C1",
  "#ABD5C5",
  "#D7D9D6",
  "#ACE3CD",
  "#C9E1D5",
  "#C4E3D6",
  "#C4E6D7",
  "#E5EAE5",
  "#DBEEE5",
  "#D9EDE3",
  "#D2EBDE",
  "#465439",
  "#53594C",
  "#506436",
  "#5B6C42",
  "#5B7638",
  "#647D43",
  "#648637",
  "#75845D",
  "#8B9973",
  "#919F72",
  "#A4A7A1",
  "#86B34F",
  "#A2AE8E",
  "#AFBE9B",
  "#AAC089",
  "#C1C2BD",
  "#B2CF89",
  "#BFD1A3",
  "#C4CFB0",
  "#B9D594",
  "#D2E0BB",
  "#DBDDD2",
  "#D9E1CC",
  "#D4E6B6",
  "#E0E1DC",
  "#E6EADD",
  "#E5EBD5",
  "#E3ECCE",
  "#5A4D70",
  "#5F507A",
  "#655A7B",
  "#70677F",
  "#7D6D99",
  "#83769B",
  "#8A8692",
  "#9A95A6",
  "#A398B4",
  "#A09DA7",
  "#B8B5BC",
  "#BEB9C5",
  "#C3BACE",
  "#C4C1C6",
  "#D1CFD3",
  "#D8D2E0",
  "#DCDBDB",
  "#DEDBDE",
  "#E0DDE1",
  "#6A4253",
  "#7D395A",
  "#834662",
  "#A14C72",
  "#856772",
  "#A86D86",
  "#BB7191",
  "#A48C95",
  "#B88599",
  "#CB9DB0",
  "#D8B6C3",
  "#E9B9CA",
  "#E5CED4",
  "#E8DADD",
  "#EBE5E5",
  "#5E3B34",
  "#7C3B31",
  "#713E34",
  "#823F33",
  "#79493F",
  "#71554E",
  "#8B4C3F",
  "#7C625C",
  "#B54131",
  "#88625A",
  "#93645B",
  "#CF4D3D",
  "#CA5B4A",
  "#A78A84",
  "#B18B83",
  "#DE8F7F",
  "#B4A4A0",
  "#E19B8D",
  "#C4B1AC",
  "#E3B3A8",
  "#D4CCC9",
  "#D8CCC8",
  "#E9CCC5",
  "#EECCC4",
  "#E6DAD6",
  "#EDE6E2",
  "#EFE7E2",
  "#F2E6E2",
  "#3F3934",
  "#52483B",
  "#645239",
  "#745D36",
  "#7F6948",
  "#7D7974",
  "#8A7455",
  "#9E782E",
  "#967D54",
  "#948062",
  "#9F8662",
  "#9D8B70",
  "#C89319",
  "#B4986D",
  "#B29C7D",
  "#BBA17B",
  "#DBA000",
  "#BCAE9A",
  "#B7B3AC",
  "#E2AC39",
  "#C3B198",
  "#C6BAA8",
  "#CCBDA6",
  "#CEC5B6",
  "#D9C3A4",
  "#D3C6B4",
  "#DACAB3",
  "#E6CAA1",
  "#DFCCB1",
  "#F0CB90",
  "#E4CFB1",
  "#DDD7CD",
  "#EFD5AE",
  "#FFCE7D",
  "#E2D8C9",
  "#E9D8BE",
  "#DEDCD7",
  "#F0DEC2",
  "#F4DDBE",
  "#E6E1D8",
  "#EDE3D5",
  "#F0E3D2",
  "#F3E5CE",
  "#EDE8DF",
  "#ECE9E2",
  "#446A8B",
  "#005765",
  "#878888",
  "#BE5385",
  "#EDA798",
  "#F7E7E3",
  "#005482",
  "#8699AD",
  "#BEE2E7",
  "#A1C777",
  "#E6A7BE",
  "#E58A77",
  "#B4CEEB",
  "#6BB7C4",
  "#F1D5DD",
  "#BEB4B1",
  "#FFCF6E",
  "#FFD997",
  "#D8E7E9",
  "#D7EBE3",
  "#A19B98",
  "#B68D2C",
  "#F5B700",
  "#F9C13B",
  "#FBD388",
  "#F2DEBE",
  "#FBE3BD",
  "#38B9CD",
  "#F1BC59",
  "#EFC076",
  "#ECDFCA",
  "#FADEAA",
  "#F5EFE5",
  "#91B5D8",
  "#E7F1EC",
  "#616160",
  "#F5D8E1",
  "#DBC399",
  "#0095AC",
  "#C99C1D",
  "#C39E4B",
  "#FFC100",
  "#FADAA1",
  "#ECE2D1",
  "#CBD8E6",
  "#00A1B8",
  "#61933A",
  "#675F6D",
  "#676162",
  "#AE5138",
  "#D89683",
  "#E9DBC5",
  "#FADEAE",
  "#F6EBD8",
  "#E4E8EC",
  "#00879E",
  "#D6E8C6",
  "#41393B",
  "#874531",
  "#E7B523",
  "#C4BDB0",
  "#FAD587",
  "#EDDAB9",
  "#EAE0CD",
  "#F4E9D6",
  "#EDE8DD",
  "#F5E5C7",
  "#E7E9EB",
  "#517933",
  "#AD94C2",
  "#BCA5CC",
  "#CDC2C4",
  "#F4D9D0",
  "#AFA490",
  "#B7A78C",
  "#CEA127",
  "#DAA937",
  "#DEB349",
  "#EBBD51",
  "#FFC700",
  "#DDD3C2",
  "#E4D0AB",
  "#E2D5C0",
  "#FFD04A",
  "#E6D7BD",
  "#E3DDD2",
  "#F3DCB4",
  "#F9DFAD",
  "#EBE8E1",
  "#EFE9DF",
  "#F4E9D7",
  "#F5E8D2",
  "#F6E7CD",
  "#F7E6CA",
  "#B1DCCF",
  "#85689E",
  "#9477AC",
  "#A185B7",
  "#E7E0D3",
  "#EFE8D9",
  "#4181BA",
  "#005345",
  "#435736",
  "#74568C",
  "#7F7685",
  "#C8B7D6",
  "#D6C8DE",
  "#A77987",
  "#F39578",
  "#F7C631",
  "#F4E9D4",
  "#F5EBD9",
  "#D5E1E2",
  "#569532",
  "#523B64",
  "#4E4653",
  "#B8537B",
  "#FBCB3B",
  "#F8CD6A",
  "#FED56A",
  "#F7DA99",
  "#EBE6DA",
  "#B2C1D7",
  "#BBCEE3",
  "#384340",
  "#006755",
  "#937B3C",
  "#CECCC3",
  "#DDD6C9",
  "#E3D5BB",
  "#F5E9D4",
  "#EEE9DE",
  "#F6EBD3",
  "#3573AB",
  "#7CA4D3",
  "#E0E6E1",
  "#E7EAE4",
  "#DDEED2",
  "#794532",
  "#F6E3DB",
  "#847558",
  "#E6C780",
  "#F7C500",
  "#E8CC8D",
  "#FACA35",
  "#F6CF6C",
  "#F8D483",
  "#FFD571",
  "#FFDC8C",
  "#F1E7D3",
  "#F3E8D4",
  "#F6E8CF",
  "#F8E8C9",
  "#FCE5B4",
  "#9FD5E2",
  "#00AA8F",
  "#518439",
  "#864833",
  "#F8CEC0",
  "#C3BDB0",
  "#DACCB0",
  "#D4DEEE",
  "#A0D6E3",
  "#8ED3C2",
  "#54494B",
  "#D97A99",
  "#E3B6C2",
  "#806C65",
  "#D6C9AD",
  "#F2EDE3",
  "#8599B4",
  "#B2C5DF",
  "#7FCADB",
  "#007F6E",
  "#4E3A34",
  "#57453E",
  "#D06740",
  "#625841",
  "#665936",
  "#FFD967",
  "#FEE39F",
  "#60666C",
  "#5C7291",
  "#A3BADA",
  "#C9CFD8",
  "#BCBDBB",
  "#DEE2E0",
  "#AE486D",
  "#C199A3",
  "#E7A8BA",
  "#E16233",
  "#F1BCA9",
  "#C4AE73",
  "#D1BE8E",
  "#F2D486",
  "#E9DDC4",
  "#1C3753",
  "#1C4B75",
  "#626F83",
  "#4D73A1",
  "#718EB4",
  "#8FA6C6",
  "#9DB1D0",
  "#B9C1CD",
  "#D7DBE1",
  "#E9E9E7",
  "#245D6A",
  "#3A5E67",
  "#00839D",
  "#547C87",
  "#338193",
  "#519BAD",
  "#009FBE",
  "#7F9DA5",
  "#49B6CE",
  "#9AB4BA",
  "#83B8C5",
  "#B0D3DB",
  "#C9D1D2",
  "#D9DEDF",
  "#C1E3EA",
  "#DBE1E1",
  "#D0E4E8",
  "#2D3D39",
  "#1F564C",
  "#4B9C8C",
  "#AAD4C8",
  "#C6D1CD",
  "#B9DED3",
  "#B2E5D8",
  "#D5DDD8",
  "#CAE3DB",
  "#CFEDE3",
  "#E7EAE6",
  "#E5E9E4",
  "#E2ECE6",
  "#3E4E39",
  "#527143",
  "#497839",
  "#65775B",
  "#6C895B",
  "#7C8D74",
  "#87AC72",
  "#74B559",
  "#A5B29C",
  "#9BB68C",
  "#93C87B",
  "#A5C295",
  "#B3CAA6",
  "#C9D3C3",
  "#C8D6C1",
  "#C6DEBB",
  "#C1E1B2",
  "#DADBD6",
  "#D7DFD1",
  "#D5E2CB",
  "#D2E7C3",
  "#E5E9DF",
  "#E3EBDD",
  "#55455E",
  "#624B6E",
  "#675C6D",
  "#867091",
  "#A493AC",
  "#A29BA6",
  "#BCB6BD",
  "#C6B9CA",
  "#D8D0D9",
  "#DDD2DF",
  "#DFDBDD",
  "#E0DDE0",
  "#E9E7E6",
  "#734150",
  "#8A3F59",
  "#AA516F",
  "#976876",
  "#CC6487",
  "#9F9899",
  "#C68597",
  "#DBA9B6",
  "#D0B5BB",
  "#C4C0C0",
  "#E3C1C9",
  "#DECDD0",
  "#DDDAD8",
  "#E7DADB",
  "#ECE9E7",
  "#EFE6E5",
  "#F0E7E7",
  "#5E3E32",
  "#724232",
  "#994C33",
  "#9A5238",
  "#7F6359",
  "#857873",
  "#B86C51",
  "#DD7B59",
  "#BEB1AB",
  "#E5B4A3",
  "#CDCBC9",
  "#DBCCC6",
  "#E3CCC3",
  "#EACDC2",
  "#DED9D5",
  "#E5D9D4",
  "#F4D8CE",
  "#EFD8CF",
  "#F0E0D9",
  "#EAE8E5",
  "#EDE8E4",
  "#EEE6E2",
  "#EFE7E3",
  "#F0E5DE",
  "#BC9E36",
  "#E0BA25",
  "#EBC65D",
  "#E2CB8F",
  "#EFD077",
  "#F2DCAA",
  "#F0E1BF",
  "#F8E1B2",
  "#EBE7DE",
  "#F3E7CE",
  "#F6E5C3",
  "#1C5789",
  "#628CC0",
  "#3C6158",
  "#C9B1A8",
  "#F3E3DA",
  "#EFC900",
  "#E3DDCF",
  "#FEE089",
  "#EDE6D8",
  "#F4EAD1",
  "#37465C",
  "#39AFC9",
  "#A55E43",
  "#CA5322",
  "#CBC0A7",
  "#FDD84F",
  "#F9E8BC",
  "#F7ECD5",
  "#9E9F9E",
  "#50C7B3",
  "#EFE7E7",
  "#B25431",
  "#968550",
  "#E7E1D4",
  "#F2E7CC",
  "#FDE39F",
  "#9CA5B6",
  "#CBD3E2",
  "#87CEE2",
  "#646967",
  "#A9B7B3",
  "#E6E2E6",
  "#743347",
  "#ECA8B9",
  "#675750",
  "#AE684A",
  "#7F7B73",
  "#B7B2A4",
  "#D3CDBE",
  "#F8D02E",
  "#C3E1E9",
  "#78BEB1",
  "#942D52",
  "#F2D6DA",
  "#F37C4B",
  "#EDE4DE",
  "#233F61",
  "#008DAC",
  "#E2E7E7",
  "#90DDCD",
  "#BEE9DE",
  "#63406E",
  "#F0EDE4",
  "#6D9464",
  "#EFBFC9",
  "#AF7F6B",
  "#B48D7C",
  "#F3EDDD",
  "#165F9C",
  "#F4A481",
  "#E1DAC7",
  "#F7E9C5",
  "#368631",
  "#DBB6A6",
  "#F4D1C1",
  "#007C9A",
  "#48877D",
  "#D8E8E3",
  "#3F3E3E",
  "#DEC7CB",
  "#503E37",
  "#674332",
  "#AE562D",
  "#BE6B44",
  "#A18C82",
  "#A09591",
  "#D8967B",
  "#E5906A",
  "#B5A49D",
  "#EFB499",
  "#F2CEBE",
  "#EDDAD1",
  "#EDEAE6",
  "#EDE8E3",
  "#EFE8E2",
  "#F0E7E1",
  "#F2E2D9",
  "#9F8B33",
  "#9E967E",
  "#B0993F",
  "#C4A91B",
  "#CBB132",
  "#D9B500",
  "#ECC722",
  "#F3D15B",
  "#EFD886",
  "#E8D8AC",
  "#F3DE9C",
  "#F7DF96",
  "#F6E2A9",
  "#F4E7C8",
  "#F4E6C0",
  "#6D8DBE",
  "#CBD7DA",
  "#1C4741",
  "#4F514D",
  "#496343",
  "#F6B99D",
  "#F3C0A9",
  "#B7A44B",
  "#F6ECCC",
  "#F4F0E4",
  "#F6EDD1",
  "#52774D",
  "#4D4A4A",
  "#7C503A",
  "#A75B34",
  "#857A74",
  "#978953",
  "#FCE99C",
  "#E6E9E3",
  "#B5506B",
  "#E0899C",
  "#D4692E",
  "#EEA986",
  "#D5BF19",
  "#F1E4B8",
  "#E7E4D9",
  "#9CB2DF",
  "#D7E5EA",
  "#BC93C1",
  "#D5BAD8",
  "#9D3352",
  "#4F4E49",
  "#B3A236",
  "#AAA48F",
  "#D5D1C2",
  "#ECE9DC",
  "#F4EAC6",
  "#00779B",
  "#DCC5DD",
  "#6C4E3E",
  "#F17831",
  "#9A8B30",
  "#ECD461",
  "#ECD96A",
  "#ECDB8B",
  "#EBE4CC",
  "#EFEAD6",
  "#F0EEE5",
  "#F6F1DE",
  "#F6F2E5",
  "#B4DCEA",
  "#E6CED0",
  "#C2886B",
  "#F7EAB3",
  "#F7EBBD",
  "#F5EFD7",
  "#4E6185",
  "#E3DEE2",
  "#CDC0B9",
  "#EFDCD2",
  "#CCBC37",
  "#F2EFE5",
  "#F7EED4",
  "#A9C4BF",
  "#E56E27",
  "#6F6845",
  "#F7EAA5",
  "#677DAD",
  "#D3E5E9",
  "#83C385",
  "#E68D5A",
  "#354E76",
  "#707992",
  "#898D9B",
  "#8998BC",
  "#979FB2",
  "#A3A7B1",
  "#A6AFC8",
  "#B1B6C4",
  "#BEC2C9",
  "#CCCED3",
  "#CED1D9",
  "#CED3E3",
  "#DADBDC",
  "#DBDDE0",
  "#DBDCE1",
  "#E8E8EB",
  "#2F454D",
  "#0C5C70",
  "#006B88",
  "#0A6C84",
  "#008FB5",
  "#829096",
  "#20A1C3",
  "#599FB7",
  "#9DAAAE",
  "#5DB2CF",
  "#94B5C2",
  "#8DBDCF",
  "#9AC5D5",
  "#B0CED9",
  "#B5D7E2",
  "#C1DDE7",
  "#BBDDE9",
  "#005D56",
  "#90A8A4",
  "#55B7AC",
  "#8BD6CC",
  "#D1DDD9",
  "#E4EBE7",
  "#495A47",
  "#346437",
  "#266A34",
  "#3C6E3E",
  "#536C51",
  "#7C927A",
  "#779B74",
  "#7EB17E",
  "#A1C09F",
  "#C4D2C0",
  "#BDD7BB",
  "#BAD9B8",
  "#D7DAD5",
  "#D3DECF",
  "#CFE2CD",
  "#CCE3C9",
  "#C8E3C6",
  "#E2ECE0",
  "#E0ECDD",
  "#DEEDD9",
  "#7D5F7F",
  "#7D6D7E",
  "#9A729C",
  "#9E919F",
  "#BFB6BF",
  "#D5CFD4",
  "#DCD1D9",
  "#EBE8E9",
  "#EDE8EA",
  "#6B4A50",
  "#7E434E",
  "#864F5A",
  "#984356",
  "#816469",
  "#966870",
  "#977F82",
  "#C16D7E",
  "#B18E93",
  "#D0929C",
  "#C1A4A9",
  "#D6B5B8",
  "#D3BFC1",
  "#E2CECF",
  "#E3DAD8",
  "#E9DAD9",
  "#F1E5E4",
  "#4E3D34",
  "#654330",
  "#5B4A41",
  "#66554D",
  "#765B4D",
  "#8F6C58",
  "#AE6335",
  "#AA8E7F",
  "#D9A387",
  "#BEAFA6",
  "#E1B7A3",
  "#DBCEC6",
  "#EACEC0",
  "#EDE7E1",
  "#F0E8E2",
  "#5A5335",
  "#787256",
  "#867B3D",
  "#918A70",
  "#A49B7A",
  "#AEA26B",
  "#B8B192",
  "#C9B96D",
  "#CFBF3B",
  "#CDC387",
  "#D4CFBC",
  "#D9D2B8",
  "#DED29C",
  "#E8D36D",
  "#E2D8AE",
  "#EDDDA2",
  "#E6DEC4",
  "#F4E291",
  "#ECE9E0",
  "#F2E8C9",
  "#3F4F72",
  "#004641",
  "#A1D3A2",
  "#ABDDAC",
  "#ECB8BE",
  "#F3EEDC",
  "#224373",
  "#5F373D",
  "#8A4B56",
  "#EFDFDF",
  "#546894",
  "#B6D4E0",
  "#A5CEA7",
  "#603960",
  "#A1948C",
  "#C2C7D6",
  "#9FD3E7",
  "#D4DEE1",
  "#BCCCC9",
  "#616760",
  "#442529",
  "#D86C80",
  "#E5DFDE",
  "#E1D2CA",
  "#F2D4C2",
  "#76908D",
  "#D2E6E2",
  "#E6E7E4",
  "#A25D2C",
  "#C77338",
  "#E1CBBE",
  "#CCC45A",
  "#F5EDCF",
  "#C4E0EB",
  "#DD939C",
  "#CD6F27",
  "#908B2C",
  "#ACA90C",
  "#448CA7",
  "#8DCCE7",
  "#90B9B5",
  "#DEEBE8",
  "#8F988F",
  "#46AC5F",
  "#CDD8CD",
  "#AB4357",
  "#F3C4C9",
  "#8A5631",
  "#BB7546",
  "#787336",
  "#BCB928",
  "#C6C13B",
  "#EEEDE5",
  "#555C5E",
  "#4E6C69",
  "#4B7B78",
  "#00837D",
  "#008C86",
  "#BAE3DF",
  "#CBEBE6",
  "#573B55",
  "#F0A9B1",
  "#F5CED1",
  "#ED8B45",
  "#F8D7C3",
  "#ECEADF",
  "#0097C4",
  "#BDD7E3",
  "#009B96",
  "#A0C6C2",
  "#C1E6E2",
  "#91A392",
  "#B5CAB6",
  "#C5C7C3",
  "#EBDEE8",
  "#826F63",
  "#EBDED4",
  "#8D8964",
  "#324169",
  "#38B1DB",
  "#154946",
  "#10514E",
  "#22625F",
  "#2A7C79",
  "#6DB0AC",
  "#A1D8D4",
  "#CBD5D3",
  "#3A5F42",
  "#33643E",
  "#B5BBB5",
  "#68303A",
  "#853643",
  "#F2DCDC",
  "#6C5141",
  "#8F5833",
  "#826A5C",
  "#A4673C",
  "#B4662F",
  "#8C7567",
  "#A08573",
  "#D77E44",
  "#D38043",
  "#DA8953",
  "#D08E61",
  "#EC9F6C",
  "#D6A78A",
  "#EAB696",
  "#E1BCA7",
  "#F0C8B0",
  "#E1CFC3",
  "#E5DAD3",
  "#E9DCD3",
  "#EFDDD1",
  "#EEE7E1",
  "#E8E38C",
  "#6C7AAB",
  "#848DB5",
  "#00546E",
  "#1B7694",
  "#B0CFDD",
  "#BDD9D6",
  "#496E51",
  "#E8DAE5",
  "#ED9AA3",
  "#C9B7B7",
  "#343333",
  "#B59F91",
  "#E5E0DC",
  "#EBEAE8",
  "#DEDDD3",
  "#E8E7E3",
  "#D6E5EB",
  "#006663",
  "#5D7861",
  "#D0E4D2",
  "#D2B6CC",
  "#5F4546",
  "#85686A",
  "#F6D8DA",
  "#D8BCAA",
  "#F7E2D3",
  "#D6D5CB",
  "#E4E184",
  "#343E61",
  "#7586C6",
  "#AFC5D0",
  "#7E9E84",
  "#7C4E75",
  "#963747",
  "#F19754",
  "#F6B180",
  "#EEC4A9",
  "#B2B1A5",
  "#F1F0E8",
  "#F2F1E5",
  "#B8BCD4",
  "#537686",
  "#CDD3D5",
  "#E0C0DA",
  "#E5D1E0",
  "#482E32",
  "#E8A06C",
  "#CCB19F",
  "#BBC9D0",
  "#D7E3E0",
  "#32583D",
  "#DDB1D4",
  "#E5DCDC",
  "#AF907B",
  "#F18517",
  "#FABC90",
  "#DEDEDA",
  "#F1EFCC",
  "#F3F2DA",
  "#5A638D",
  "#57B7DD",
  "#D6A4CC",
  "#F5A265",
  "#EED3C1",
  "#E8E3A8",
  "#E4E5EA",
  "#6B5253",
  "#5B5A58",
  "#F3CCB0",
  "#5D5D32",
  "#EEEDD5",
  "#0C4C62",
  "#00A4A6",
  "#C98EBD",
  "#B94657",
  "#D8D87C",
  "#E0DD90",
  "#C1DAE6",
  "#D0DDE3",
  "#EBD3E2",
  "#EAE2E6",
  "#D2D36F",
  "#E8E5AE",
  "#E7E6DD",
  "#454C6C",
  "#6E718E",
  "#68709F",
  "#71779E",
  "#8085AE",
  "#9194AB",
  "#9799B8",
  "#AEB0C8",
  "#BCBED5",
  "#C8CAE4",
  "#DBDBDD",
  "#E9E8E8",
  "#ECEAED",
  "#394A53",
  "#005F7D",
  "#007096",
  "#587381",
  "#1883A7",
  "#5E93AD",
  "#84939C",
  "#7D98A6",
  "#8F9EA5",
  "#99AFBC",
  "#A7B1B6",
  "#ADC8D7",
  "#C7D0D4",
  "#CBDEE8",
  "#C9DEE9",
  "#007A7A",
  "#6C9393",
  "#609C9B",
  "#64B1AF",
  "#8CADAC",
  "#44BFBE",
  "#88C8C6",
  "#A1CCCA",
  "#C8E2DF",
  "#C3E3DF",
  "#E6E9E6",
  "#DDEDEA",
  "#D9EDEA",
  "#32523D",
  "#57725E",
  "#34794D",
  "#238E52",
  "#5B9A70",
  "#7F9584",
  "#57A972",
  "#7AA888",
  "#51B074",
  "#A9B4AB",
  "#80C194",
  "#93C1A1",
  "#8BCEA0",
  "#C5D4C8",
  "#A6DEB7",
  "#BEDAC4",
  "#B7E2C3",
  "#D5DED6",
  "#D2DED4",
  "#C8E6CE",
  "#E3E9E1",
  "#E5EBE4",
  "#DAEDDC",
  "#D8EFDC",
  "#533F4F",
  "#734D6C",
  "#9E7594",
  "#B897AF",
  "#E1D1DC",
  "#E5DBE0",
  "#EDEAEB",
  "#EEE9EB",
  "#EEE9EB",
  "#EEE8EA",
  "#84474B",
  "#9E555C",
  "#AC4B57",
  "#B87C7E",
  "#A78E8E",
  "#DB7680",
  "#A99898",
  "#DB9599",
  "#EAB0B2",
  "#DDB8B8",
  "#EBBABB",
  "#E6C4C5",
  "#D5CECD",
  "#ECD0CF",
  "#E3DBD8",
  "#EEDCDA",
  "#ECE8E5",
  "#ECE7E4",
  "#EEE7E5",
  "#F0E7E5",
  "#363635",
  "#664D3B",
  "#AE6830",
  "#9E8472",
  "#D77E29",
  "#B1937D",
  "#A8998E",
  "#D48B4C",
  "#DD883A",
  "#C1A28B",
  "#E29859",
  "#BAA79A",
  "#E0A678",
  "#CCB7A8",
  "#D3BAA7",
  "#F4AC71",
  "#E7B794",
  "#F0BC94",
  "#D9C4B6",
  "#D6CEC7",
  "#E9C9B2",
  "#E1D0C3",
  "#F3D4BD",
  "#E8DCD2",
  "#F4DDCC",
  "#F0E4DB",
  "#F0E8E0",
  "#F4E5D9",
  "#484737",
  "#6C6B3E",
  "#747264",
  "#7E7F3A",
  "#A09E64",
  "#BBB786",
  "#B9BB58",
  "#C2C28F",
  "#C9CC75",
  "#D7D4BB",
  "#DDDA87",
  "#E1DBAE",
  "#EDE9D3",
  "#EDECCD",
  "#EDE9C5",
  "#333D6B",
  "#F4A6A8",
  "#5A4A3D",
  "#7D8234",
  "#A2AF1D",
  "#EAEBBA",
  "#F0F0E0",
  "#3D4448",
  "#89D6D5",
  "#AFBB34",
  "#BAC348",
  "#C5CF5A",
  "#D7DC88",
  "#64727A",
  "#7F847F",
  "#B973A8",
  "#F9CECD",
  "#A17247",
  "#ECE5DF",
  "#F2ECE6",
  "#B9C546",
  "#F1F1ED",
  "#E6BDD9",
  "#DD646D",
  "#C49F80",
  "#E9EAD9",
  "#767F84",
  "#B2B8BA",
  "#D4E4E1",
  "#E4B6D6",
  "#EBD2E2",
  "#6B2C31",
  "#E48286",
  "#A4A967",
  "#AE639A",
  "#514C47",
  "#BDB1A6",
  "#F79A38",
  "#BEC198",
  "#D3D3CB",
  "#385142",
  "#EEDBE5",
  "#B5A08F",
  "#FCAE63",
  "#E9EAD7",
  "#7FB7D6",
  "#AA7E54",
  "#DDB694",
  "#E8E0D8",
  "#0087BD",
  "#B1D2E6",
  "#AF7026",
  "#E7C4A6",
  "#F3C49B",
  "#F3E6D9",
  "#F4E6DA",
  "#E2E3D2",
  "#E8EAD0",
  "#F0DCC9",
  "#F7F5EE",
  "#705F68",
  "#8D6E5A",
  "#DC7525",
  "#645636",
  "#DFD3C5",
  "#F0ECDF",
  "#9A5C38",
  "#E2CD9E",
  "#EFE7DA",
  "#3C3E3E",
  "#E7DCD5",
  "#D8E5D4",
  "#EAE7C1",
  "#D6EAE2",
  "#B9C9E1",
  "#83A89A",
  "#F8EDE1",
  "#B6AB9D",
  "#CCBDA6",
  "#F0EDDF",
  "#B6AB9D",
  "#F0E8E1",
  "#A29182",
  "#F3E7CD",
  "#E9EAD9",
  "#FEB572",
  "#F9D1B5",
  "#F2E3D2",
  "#F1D4D5",
  "#5D3F36",
  "#A0C6C2",
  "#CAC0B8",
  "#BDBFC0",
  "#A6908B",
  "#D8CBC0",
  "#D49C9B",
  "#E4E1DB",
  "#B5D3D2",
  "#CDDBE0",
  "#5F5569",
  "#A85958",
  "#C16130",
  "#C3CACD",
  "#E56F5C",
  "#F0BD00",
  "#514961",
  "#E1DACA",
  "#E7CBC7",
  "#E8D3B7",
  "#D2A36C",
  "#A2AE8E",
  "#FFCF73",
  "#EDE3CD",
  "#32628C",
  "#494D52",
  "#E9D8BE",
  "#8E5637",
  "#28A2B7",
  "#06A5AE",
  "#C9CBC9",
  "#DEDCC1",
  "#D4BFA5",
  "#658185",
  "#746357",
  "#991B25",
  "#C16D7E",
  "#AE5367",
  "#D37998",
  "#F4D3CB",
  "#D2DDE1",
  "#9F9899",
  "#D5C4B7",
  "#6A4D33",
  "#2D2D2D",
  "#282829",
  "#3B343F",
  "#524F63",
  "#2C3241",
  "#2E4A58",
  "#6A4A3E",
  "#BFD1E4",
  "#C57463",
  "#E5DBD7",
  "#EEE2DF",
  "#5E7C86",
  "#92B8DC",
  "#005B8E",
  "#1C3C43",
  "#567EBE",
  "#413048",
  "#D8E0E9",
  "#99BDD0",
  "#D1DDE3",
  "#005476",
  "#7F8A9C",
  "#B5CBDA",
  "#154367",
  "#737B84",
  "#457697",
  "#88B7BF",
  "#E1DBD2",
  "#E6D8D1",
  "#7093AB",
  "#F3A9A4",
  "#D5E9E9",
  "#D1DDE3",
  "#9E713E",
  "#9DB19E",
  "#6D5E4D",
  "#735237",
  "#A48561",
  "#9D8E7E",
  "#B0C4D3",
  "#A96E4D",
  "#CCCCCB",
  "#C19659",
  "#E1C09D",
  "#F7B260",
  "#7D623B",
  "#9A5238",
  "#F7DA99",
  "#FFD17D",
  "#FEDFA1",
  "#F0DFBC",
  "#EBC68E",
  "#594B3F",
  "#F58B52",
  "#FFD17D",
  "#F4C272",
  "#E8E8E5",
  "#A49B7A",
  "#E4BE9B",
  "#E0A767",
  "#EDE3D5",
  "#F8E8DC",
  "#ECD9CA",
  "#505354",
  "#87846E",
  "#C498AC",
  "#C9A02E",
  "#D7A762",
  "#C5AA9B",
  "#D7C6B4",
  "#C4B591",
  "#DBCAA4",
  "#CBC890",
  "#C26430",
  "#E6E7A3",
  "#8FA6C6",
  "#E6E9E9",
  "#E6E9E9",
  "#F2D7B4",
  "#F9E3C1",
  "#C19659",
  "#D3BAA7",
  "#5D3E3F",
  "#DDB5BA",
  "#453432",
  "#BABAB9",
  "#DFE2E7",
  "#9B3D3F",
  "#DFDCD5",
  "#EEEFEA",
  "#C6D6B2",
  "#452B33",
  "#646350",
  "#8A7662",
  "#7A4D3A",
  "#C87F3C",
  "#AD6C55",
  "#724232",
  "#A8D4D7",
  "#D0C738",
  "#FFB54F",
  "#FBEDBA",
  "#DAB955",
  "#63655D",
  "#D5E1E2",
  "#F3F2EC",
  "#EBEAE4",
  "#9DAAAE",
  "#A8DAE5",
  "#ECEDE7",
  "#B3D6DC",
  "#F8EAD5",
  "#B8C7CC",
  "#AFC3CC",
  "#005184",
  "#343639",
  "#E6D9B7",
  "#FBDCB1",
  "#B28D80",
  "#676162",
  "#908874",
  "#BCC7B5",
  "#9D9E9D",
  "#F3E7DE",
  "#37423B",
  "#BEA18E",
  "#AFB1B3",
  "#C4DBE4",
  "#79433D",
  "#CC907B",
  "#7D362A",
  "#C2886B",
  "#ECDED4",
  "#C27470",
  "#D16965",
  "#F7E6E4",
  "#C27470",
  "#D66B76",
  "#E19B8D",
  "#59A4D1",
  "#7CA8BF",
  "#DCE1DF",
  "#E2DDCB",
  "#C9B9C9",
  "#ECE9D9",
  "#DFE5F0",
  "#F0E8E1",
  "#F7F0DF",
  "#63584C",
  "#E2CCAB",
  "#B8C7CC",
  "#896A46",
  "#E8CDA5",
  "#EFEBD1",
  "#C7BDB6",
  "#A32E39",
  "#EFDAB9",
  "#F8EFD8",
  "#FAEBD1",
  "#899596",
  "#C1BEA2",
  "#BF7567",
  "#BDE0A9",
  "#FAD9AF",
  "#B7AFA4",
  "#00533F",
  "#F6EBCD",
  "#6E6867",
  "#A05155",
  "#CBD7E3",
  "#5A3732",
  "#3B343F",
  "#5D3944",
  "#503E37",
  "#3E2A27",
  "#674332",
  "#C3AD94",
  "#F6F5D9",
  "#ECD461",
  "#46383E",
  "#4A5A88",
  "#8F908F",
  "#833733",
  "#7F4C3C",
  "#295078",
  "#82C8E3",
  "#5C9BCC",
  "#EAE6E1",
  "#7C8D95",
  "#938564",
  "#F9F1E4",
  "#A7B9A5",
  "#C79E9C",
  "#87846E",
  "#728D73",
  "#5F708A",
  "#F5EBD7",
  "#3A4357",
  "#D0D7C7",
  "#68695B",
  "#ECD1AD",
  "#F2E8CE",
  "#4A423A",
  "#C3DEE7",
  "#2C5663",
  "#E8CCBD",
  "#C3C4C8",
  "#E3E2D9",
  "#388597",
  "#D3D9D9",
  "#915165",
  "#A29F7F",
  "#DBE0E0",
  "#CDB288",
  "#B2CCC5",
  "#8D3926",
  "#4D2F27",
  "#A3652D",
  "#3D2923",
  "#553F2F",
  "#372B27",
  "#833622",
  "#39332F",
  "#7F4F27",
  "#9C6D39",
  "#6A2B24",
  "#CB8C39",
  "#62372A",
  "#C98122",
  "#6A2B24",
  "#59382A",
  "#5F3828",
  "#7D3D23",
  "#502C26",
  "#A94C1C",
  "#5A3423",
  "#CABB9E",
  "#90969C",
  "#C3B3B8",
  "#A99898",
  "#6E8799",
  "#CD4A38",
  "#A0A9AE",
  "#C33F28",
  "#AD588F",
  "#2D2D2D",
  "#E8E8E4",
  "#D8D1C5",
  "#642A33",
  "#FADEAE",
  "#E8DCC6",
  "#0081B8",
  "#706D74",
  "#2F7769",
  "#6E8A7F",
  "#4B9C8C",
  "#A57B76",
  "#7A655D",
  "#BEA488",
  "#B66E59",
  "#304B38",
  "#932F55",
  "#CBB3AD",
  "#D8CFCD",
  "#5E717B",
  "#E0D9AF",
  "#DBCFD0",
  "#B0C4D3",
  "#DDEDD3",
  "#C6B3AA",
  "#819BB4",
  "#F8A476",
  "#97A1CF",
  "#E5E9DF",
  "#336C72",
  "#F6F2E5",
  "#503137",
  "#009E82",
  "#AE684A",
  "#9A7259",
  "#3E4334",
  "#AFD2E5",
  "#CFD0C2",
  "#A45D6A",
  "#7B90A0",
  "#C8C6BD",
  "#E18D93",
  "#E3D7C4",
  "#E3DDD2",
  "#7D7F80",
  "#949488",
  "#D6C0BE",
  "#6B2230",
  "#987623",
  "#976856",
  "#A16C79",
  "#D4DADD",
  "#03664F",
  "#646967",
  "#A09591",
  "#878A83",
  "#57624D",
  "#6289A3",
  "#F6CE62",
  "#007067",
  "#DEDACB",
  "#B6B4A9",
  "#EEE7DF",
  "#C7C9D5",
  "#A3A78D",
  "#D6D9E7",
  "#E0B7A4",
  "#1B80B8",
  "#915B24",
  "#847B72",
  "#E3F0DD",
  "#C1BEA2",
  "#E5EADE",
  "#EBE9BA",
  "#F5EBD9",
  "#98A9A4",
  "#D0CD98",
  "#23693B",
  "#DAB6AB",
  "#BCC7B5",
  "#DCCE8D",
  "#D3EDEF",
  "#F7F6EE",
  "#CCCCCB",
  "#AF98B0",
  "#CD8161",
  "#D6DCE0",
  "#B8BFBA",
  "#F1E8D4",
  "#5DAB70",
  "#4D7A79",
  "#D9CEC4",
  "#CDCCE1",
  "#D8D4CE",
  "#D09D6E",
  "#D4D4D2",
  "#CADEE1",
  "#F29F00",
  "#CF966E",
  "#D1BE8E",
  "#FDC582",
  "#EBCA9C",
  "#DDC9B0",
  "#D7B468",
  "#C9CBC9",
  "#AEAEAB",
  "#95C268",
  "#EEE9DE",
  "#EAE2CC",
  "#D4CFBC",
  "#E1D5BB",
  "#AAC089",
  "#C7D2CE",
  "#C8CDC7",
  "#525353",
  "#737B84",
  "#9C968B",
  "#DADAD9",
  "#AA8E7F",
  "#777B5B",
  "#E7DFD3",
  "#F9E4AE",
  "#D4B773",
  "#D7B468",
  "#B4B3B9",
  "#B68D2C",
  "#9B8987",
  "#777899",
  "#B6A5A6",
  "#B6A379",
  "#C4CCC9",
  "#A2AE8E",
  "#9DA298",
  "#DAB955",
  "#B0CFDE",
  "#28373A",
  "#3C5949",
  "#17407D",
  "#FBEAD6",
  "#8B7267",
  "#C7582E",
  "#F4EEDB",
  "#E6AF47",
  "#D6BB82",
  "#F2DEC2",
  "#D2C6A8",
  "#D7DDE1",
  "#F8B8A1",
  "#A99A8C",
  "#F2DCDC",
  "#F3F2EC",
  "#EEE0E2",
  "#CD8161",
  "#D8C7B2",
  "#E8E8E5",
  "#315368",
  "#567195",
  "#364A55",
  "#617482",
  "#34435C",
  "#5270A7",
  "#444038",
  "#E8D6BB",
  "#F7EDDA",
  "#384A33",
  "#DFEBE6",
  "#D1D4E6",
  "#E8E4E0",
  "#F8ECE6",
  "#F2EFE5",
  "#575253",
  "#A09180",
  "#ECDFA3",
  "#A3AC74",
  "#D5D6B5",
  "#C1BEA2",
  "#3E6256",
  "#3E3E34",
  "#E0DAD5",
  "#D7C2B6",
  "#BDD176",
  "#475538",
  "#CBC4B8",
  "#594B3F",
  "#EDC9CC",
  "#CBF0E8",
  "#F5E4DA",
  "#EDE1D0",
  "#32A5BB",
  "#5E555F",
  "#CFD7E3",
  "#E5E2E5",
  "#EBE5F0",
  "#C6CEDB",
  "#B8B9C8",
  "#C9CBE5",
  "#7D7D7C",
  "#D9DCDD",
  "#97CD87",
  "#9B6D54",
  "#ECD96A",
  "#FFC032",
  "#FFE087",
  "#EECD40",
  "#F8D483",
  "#F8F3C2",
  "#F4E6C0",
  "#F9E09C",
  "#FFD562",
  "#E1E2DD",
  "#00918B",
  "#9EB4CB",
  "#D6DCE0",
  "#A3C0CB",
  "#EFEFF1",
  "#BCB6BD",
  "#D1B098",
  "#A79DC8",
  "#C8AEC0",
  "#DCDFE4",
  "#BCB6BD",
  "#E6EBB9",
  "#DEECAA",
  "#EAECD4",
  "#30673F",
  "#F3F2DA",
  "#FCE2AF",
  "#9FAE36",
  "#EDE8E2",
  "#EBE9E0",
  "#A2967F",
  "#4F3841",
  "#C15A57",
  "#7BADAB",
  "#E4E1DB",
  "#7C6655",
  "#FCDE93",
  "#F9F4DA",
  "#C0C1B5",
  "#C7CA56",
  "#2E8F3D",
  "#905636",
  "#F4E7D4",
  "#006872",
  "#2D3D39",
  "#CFC1CB",
  "#EAE8E5",
  "#D1C2B9",
  "#D2CFC6",
  "#BA977C",
  "#C2794F",
  "#D08E61",
  "#EAE9EA",
  "#FFBE7A",
  "#8BD6D3",
  "#699093",
  "#FFAE62",
  "#BB565C",
  "#9C7851",
  "#B6B4A9",
  "#423B64",
  "#D1D2DC",
  "#807A7C",
  "#ECE8C6",
  "#55B7AC",
  "#29524D",
  "#D7CCC7",
  "#D9DCB8",
  "#D0CD98",
  "#60696C",
  "#29394C",
  "#6D837D",
  "#373635",
  "#223A53",
  "#445A66",
  "#B69F90",
  "#4E5B66",
  "#E4DABF",
  "#C3D8E3",
  "#999997",
  "#646967",
  "#B9D3D1",
  "#F2F3E2",
  "#FACAAB",
  "#84939C",
  "#A29F7F",
  "#C8CED4",
  "#B7C3C5",
  "#E5B600",
  "#833532",
  "#D7DDE1",
  "#F6F7EE",
  "#98977B",
  "#D1DFDD",
  "#F8F2E4",
  "#CECCC3",
  "#E36811",
  "#CBC5B1",
  "#F5E3CD",
  "#ECF1E2",
  "#968A3B",
  "#7B8178",
  "#BEA99D",
  "#817B73",
  "#654657",
  "#B89441",
  "#E3B383",
  "#D5CBC6",
  "#B0A498",
  "#BFBFA8",
  "#445A66",
  "#3B4966",
  "#768299",
  "#B0AAA0",
  "#202C3A",
  "#ECE2D2",
  "#E1D5C6",
  "#909396",
  "#C5BBAB",
  "#EDE0D1",
  "#DC9C86",
  "#B8632A",
  "#627775",
  "#F0ECDF",
  "#D6D3E0",
  "#3A5267",
  "#4D4F52",
  "#6C6B3E",
  "#B8C4CC",
  "#7DB0C2",
  "#EBF5E4",
  "#C2794F",
  "#BCAE9A",
  "#E3DCD4",
  "#DECEBE",
  "#DCF3EE",
  "#32759A",
  "#99AFBC",
  "#CF7B1C",
  "#CA9A51",
  "#C39E4B",
  "#ECE6D8",
  "#5C5A47",
  "#9E967E",
  "#615B3C",
  "#9E967E",
  "#9F9288",
  "#AAA48F",
  "#EDC687",
  "#E2712B",
  "#525234",
  "#F4E9D4",
  "#528580",
  "#B1AC96",
  "#B9A99F",
  "#4F4C80",
  "#E5C586",
  "#E9E6DA",
  "#E3DCD4",
  "#CFCFAC",
  "#E5EEE4",
  "#E7DDDE",
  "#D2CDC6",
  "#D8D0D9",
  "#D4CABD",
  "#384137",
  "#E8EAE4",
  "#DFDAD5",
  "#CCBDA5",
  "#71A63F",
  "#D699B9",
  "#865C7D",
  "#DAE2E8",
  "#E6DDE6",
  "#F1DAD2",
  "#FED6AB",
  "#F4E8DA",
  "#BF8E63",
  "#DFCCB1",
  "#E0D2CD",
  "#A2AE8E",
  "#BAB3AC",
  "#D2CFC6",
  "#AFB4AC",
  "#024A7F",
  "#CEDFDD",
  "#BDE8DA",
  "#B33E3F",
  "#C5BEBA",
  "#F5DAD0",
  "#DAD2D8",
  "#AEB5D4",
  "#9D9E9D",
  "#F1EDE0",
  "#96B0B7",
  "#EFD886",
  "#4A413E",
  "#D2E5E0",
  "#2A493F",
  "#E2D4CB",
  "#D48594",
  "#CEA9AA",
  "#CBB3AD",
  "#C79CA3",
  "#C49F9A",
  "#EFE7E0",
  "#E2BEC0",
  "#D5D6B5",
  "#72404F",
  "#484253",
  "#8D84B5",
  "#877678",
  "#E6B580",
  "#D4C9B5",
  "#9E3147",
  "#72B671",
  "#D8D8D7",
  "#E7D098",
  "#CFAD78",
  "#B6CCD8",
  "#BE3B30",
  "#D6CCCA",
  "#F4DCCF",
  "#D4D2CB",
  "#DFCECB",
  "#A09591",
  "#D9B7AF",
  "#E9DCD3",
  "#D9DCC0",
  "#847B72",
  "#5B4A41",
  "#546386",
  "#BC9795",
  "#C0B4AB",
  "#E4D2E2",
  "#F3ECD1",
  "#C6C0D9",
  "#3F8685",
  "#93383F",
  "#C9BDB7",
  "#D4CBC8",
  "#867091",
  "#594786",
  "#8C8B95",
  "#BF7567",
  "#D5D0C7",
  "#E4E7E9",
  "#888C29",
  "#B9CACE",
  "#482E32",
  "#53504D",
  "#CCBA87",
  "#CFB084",
  "#D1AA6D",
  "#F7A800",
  "#E29E00",
  "#CA8F00",
  "#E09000",
  "#E78C00",
  "#AF8152",
  "#DCAF2F",
  "#E1D8C4",
  "#DBC399",
  "#E4D1B4",
  "#EFDC3B",
  "#F3A852",
  "#F8CA3A",
  "#A48F79",
  "#A18F65",
  "#F4B600",
  "#F5B500",
  "#B98F4E",
  "#A78020",
  "#FF9C00",
  "#E0A312",
  "#F69824",
  "#E99C54",
  "#EE920A",
  "#D96F0B",
  "#B94A24",
  "#BE3C28",
  "#F3782E",
  "#E05313",
  "#EB6C2A",
  "#DB5417",
  "#CE5D2A",
  "#E17021",
  "#D3654D",
  "#A52F28",
  "#9B2A2A",
  "#9A2928",
  "#852227",
  "#6E252B",
  "#5C252A",
  "#43292A",
  "#6F3A33",
  "#7A2D2C",
  "#C5866E",
  "#97332B",
  "#CA7475",
  "#D6A0A5",
  "#A74236",
  "#CA565D",
  "#C5424D",
  "#B9271F",
  "#CE6A55",
  "#AA2C40",
  "#A6393D",
  "#836384",
  "#8D414E",
  "#C3638C",
  "#67263D",
  "#786A9A",
  "#913A75",
  "#4D2D41",
  "#864F82",
  "#9E8691",
  "#BC4579",
  "#33516F",
  "#194E65",
  "#0C3E7D",
  "#1C3753",
  "#232830",
  "#005688",
  "#3B6C8C",
  "#303E47",
  "#225E77",
  "#00527D",
  "#223241",
  "#0789B4",
  "#223656",
  "#637C94",
  "#007DAF",
  "#005D8C",
  "#158C8B",
  "#006083",
  "#00474F",
  "#007777",
  "#2F355E",
  "#466B8D",
  "#6193AB",
  "#407561",
  "#3A6939",
  "#385D31",
  "#535640",
  "#174947",
  "#194536",
  "#413F36",
  "#33392B",
  "#3B392F",
  "#2C3A2F",
  "#50703C",
  "#6E7E5C",
  "#313F3C",
  "#7D775C",
  "#4C4539",
  "#41413A",
  "#006B4E",
  "#5B8041",
  "#62993D",
  "#B8CCAA",
  "#3D4736",
  "#8B9A78",
  "#423C31",
  "#058554",
  "#607041",
  "#006150",
  "#7CB8B2",
  "#365746",
  "#007141",
  "#2A8054",
  "#498880",
  "#7BADAB",
  "#7B898E",
  "#8C969B",
  "#837A66",
  "#7B786A",
  "#9A9B9B",
  "#6E706D",
  "#786C5F",
  "#766141",
  "#5E6158",
  "#5B5E58",
  "#555C5E",
  "#5B6162",
  "#5A5347",
  "#53575C",
  "#3D4448",
  "#36393A",
  "#504E49",
  "#818177",
  "#494D52",
  "#3D484A",
  "#928F85",
  "#5F6B6F",
  "#B5B0A0",
  "#808374",
  "#938870",
  "#C5C7C3",
  "#989492",
  "#7D7E7C",
  "#AFB1A8",
  "#6D6961",
  "#989FA1",
  "#8F9391",
  "#525654",
  "#B7B3A8",
  "#8E9495",
  "#7E8589",
  "#C7C7C5",
  "#8B6C44",
  "#9D6432",
  "#7B5142",
  "#804F2F",
  "#8E4E38",
  "#724A32",
  "#744F2F",
  "#5D3D2E",
  "#693A33",
  "#4E3C30",
  "#61362E",
  "#51332B",
  "#483530",
  "#433C3B",
  "#2A2524",
  "#A55B33",
  "#7A543D",
  "#765B4B",
  "#544033",
  "#E7E0D1",
  "#D6D5CA",
  "#EAEAE6",
  "#323233",
  "#202021",
  "#EEEBE1",
  "#2D2F31",
  "#EEEEE7",
  "#2C2A29",
  "#C8CBC4",
  "#8F353A",
  "#BF4F5C",
  "#B27782",
  "#C95D73",
  "#A86D86",
  "#333A3E",
  "#343639",
  "#D4C9B5",
  "#CC9089",
  "#672529",
  "#974951",
  "#97534D",
  "#B84B1B",
  "#89242B",
  "#B47761",
  "#614466",
  "#423B64",
  "#006AA8",
  "#007499",
  "#AAB2B9",
  "#65635E",
  "#D57471",
  "#693838",
  "#2C2B2B",
  "#25313D",
  "#7F6948",
  "#54494B",
  "#605F5E",
  "#C1B8A8",
  "#5D4C30",
  "#E0CDD1",
  "#7C7C7A",
  "#9AB4BA",
  "#7C625C",
  "#AB4C4C",
  "#D35338",
  "#906A46",
  "#B7B3AC",
  "#E9EAE9",
  "#B87C7E",
  "#DBCFBB",
  "#CDC2C4",
  "#EDE8E2",
  "#DEDCD7",
  "#E4CAA7",
  "#CBC0A7",
  "#7B6364",
  "#D6C0BE",
  "#98A9A4",
  "#EADDD4",
  "#D9A397",
  "#A56A61",
  "#F2E7DB",
  "#492D35",
  "#4D73A1",
  "#6C645F",
  "#782E34",
  "#8F969B",
  "#A4726D",
  "#70482F",
  "#5B4941",
  "#B3A897",
  "#E2AD72",
  "#E48320",
  "#375754",
  "#9EAD9E",
  "#CD6555",
  "#D8C7B2",
  "#BBA17B",
  "#DDCEC4",
  "#324965",
  "#3B424C",
  "#B6D1E2",
  "#8B5545",
  "#DE6546",
  "#B9A08B",
  "#C5A762",
  "#005A56",
  "#4C4E48",
  "#E5E2CD",
  "#829E96",
  "#39595F",
  "#8A8B54",
  "#C2D0DF",
  "#4D3F38",
  "#B0C7D4",
  "#B7C3C5",
  "#AFA490",
  "#817B72",
  "#E7BBB0",
  "#E7EAE0",
  "#69662F",
  "#DCD1C0",
  "#C9CBC9",
  "#D7CFBC",
  "#DFCD45",
  "#A68E86",
  "#ABA18D",
  "#BEC2C2",
  "#717376",
  "#D2D0C6",
  "#DCDFD8",
  "#AFB3A5",
  "#BAB9B5",
  "#DCDFD8",
  "#BEBCBA",
  "#DFDBDA",
  "#93BEC0",
  "#599FB7",
  "#83A8C1",
  "#32523D",
  "#E9E9E7",
  "#CCB7A8",
  "#C6BDBD",
  "#626976",
  "#CEAF96",
  "#807A7C",
  "#DAE0E2",
  "#E2E5E4",
  "#E9E8E9",
  "#EDF2E9",
  "#A3C0DA",
  "#E3DAD6",
  "#E6EACB",
  "#FBECDE",
  "#E4E1DB",
  "#F6D9BE",
  "#97B1DA",
  "#D6C2B7",
  "#B9A99F",
  "#44483D",
  "#F2EAC0",
  "#A38061",
  "#A43E2D",
  "#DDDCD3",
  "#E3E7DE",
  "#4E4A45",
  "#F7F1EF",
  "#7C8BAE",
  "#DFEBC1",
  "#C3CDE1",
  "#949235",
  "#F3E7EF",
  "#D6C387",
  "#D6D5CB",
  "#48433F",
  "#C5E4E9",
  "#AD6368",
  "#B6B4A9",
  "#6794A5",
  "#8F9391",
  "#838C86",
  "#9CBFD7",
  "#ECD5AF",
  "#10A1CF",
  "#E8E8E8",
  "#FCE462",
  "#DDC9B0",
  "#57363F",
  "#BEC1D6",
  "#E88683",
  "#EAE3D7",
  "#983660",
  "#E0B595",
  "#FFBB93",
  "#FBB847",
  "#B0B655",
  "#DC9C86",
  "#FBCAAA",
  "#CBCCCB",
  "#E2E2DB",
  "#E7EAEB",
  "#626F83",
  "#88625A",
  "#D9C15B",
  "#D6CCCA",
  "#E8BDD3",
  "#E4C5C1",
  "#E1C5CB",
  "#E8C4DB",
  "#D9D8DA",
  "#C76090",
  "#E8E1CB",
  "#F08948",
  "#A14A45",
  "#5F5A4C",
  "#136777",
  "#00939F",
  "#0F4C4B",
  "#5A8487",
  "#D7C3B9",
  "#EAEBBA",
  "#5A3732",
  "#873A2B",
  "#9A4C3C",
  "#A09591",
  "#E1DADF",
  "#676A6B",
  "#909998",
  "#F0EDE4",
  "#B8C2C3",
  "#E4D8CE",
  "#E7D4BC",
  "#C6BAA8",
  "#1D577E",
  "#5C615A",
  "#BDC3B9",
  "#62A3AD",
  "#E8E7E3",
  "#9E7043",
  "#CD8161",
  "#DDDAD8",
  "#3F3934",
  "#C6D0C8",
  "#9BA99A",
  "#00836E",
  "#6F6550",
  "#D7D9D6",
  "#EFBFA1",
  "#808080",
  "#41464B",
  "#8A8376",
  "#4C413A",
  "#F4ECD6",
  "#FBE5AD",
  "#F0E8DA",
  "#F6F2DE",
  "#606573",
  "#6E3936",
  "#6B3C50",
  "#A4A93A",
  "#B8B192",
  "#229064",
  "#7A6B81",
  "#F3EED9",
  "#62859D",
  "#7EA28F",
  "#D59883",
  "#3B6035",
  "#796C61",
  "#C49F9A",
  "#66605C",
  "#A493AC",
  "#BFB6BF",
  "#DFDDE2",
  "#7090C9",
  "#D3D0D6",
  "#898D9B",
  "#B4B3B9",
  "#DEDCE6",
  "#ECDFCA",
  "#9B8987",
  "#BDA68A",
  "#AFA490",
  "#817B73",
  "#A2A5A5",
  "#D6C9AD",
  "#D7DDDD",
  "#25313D",
  "#7B8178",
  "#D5CCC4",
  "#57B5A2",
  "#CDD4CE",
  "#818278",
  "#DBEDCF",
  "#E4DDCE",
  "#AAA8AE",
  "#F1F1E8",
  "#EEEFEA",
  "#EEEFEB",
  "#E3E7DE",
  "#E8E8E4",
  "#EDECE7",
  "#C4B591",
  "#4E4653",
  "#636040",
  "#8D9275",
  "#68655D",
  "#C9464F",
  "#F4E3B8",
  "#6F7A70",
  "#C4B591",
  "#CAC8A8",
  "#C9D7C4",
  "#6C645F",
  "#EAE9E7",
  "#EEE9E4",
  "#DFDBD8",
  "#B3C5D1",
  "#D06740",
  "#E1E7EA",
  "#7D98A6",
  "#4E5A60",
  "#85A6AB",
  "#AFB1B3",
  "#E8E7E3",
  "#ABBCDC",
  "#3A7D9A",
  "#98958D",
  "#807A7C",
  "#6C645F",
  "#A09591",
  "#BBC3BB",
  "#9D948B",
  "#BEB1AB",
  "#9E9890",
  "#8B7267",
  "#494538",
  "#CCD9CA",
  "#E7D9C7",
  "#F5BC5D",
  "#CED06A",
  "#64533d",
  "#716d65",
  "#292a27",
  "#5d2d1e",
  "#babbbb",
  "#b04923",
  "#dce1d6",
  "#171b1c",
  "#e3dbce",
  "#c7c2bc",
  "#DACBAF",
  "#756048",
  "#655E49",
  "#655e49",
  "#B2B4AC",
  "#CBCFCA",
  "#404B4E",
  "#A19E93",
  "#B1B6B2",
  "#B1B6B2",
  "#ACB2AF",
  "#AEB1AB",
  "#494A44",
  "#F0EDDD",
  "#303533",
  "#5D5748",
  "#BAC0C0",
  "#898887",
  "#898887",
  "#4F4B47",
  "#3A4145",
  "#3A4145",
  "#423933",
  "#E1DAC7",
  "#AFB0B0",
  "#4D5352",
  "#2B2B2C",
  "#ACADAC",
  "#ACADAC",
  "#B9BEBC",
  "#ACADAC",
  "#A9A092",
  "#F0F4EF",
  "#E0E7EB",
  "#E0E8ED",
  "#5B5C54",
  "#575851",
  "#5B5C54",
  "#586D90",
  "#2D3231",
  "#525659",
  "#4D5153",
  "#ACA598",
  "#0B1574",
  "#D7C8B3",
  "#E5DBC4",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#666D6B",
  "#F2C137",
  "#E5ECE7",
  "#C9BCA3",
  "#4F5257",
  "#4F5257",
  "#D16C37",
  "#2D2E2E",
  "#2D2E2E",
  "#2A2A2B",
  "#2C2D2D",
  "#333937",
  "#3B3C3C",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2C2D2E",
  "#404645",
  "#404645",
  "#323334",
  "#303031",
  "#006AB2",
  "#006AB2",
  "#0083BE",
  "#162159",
  "#294A62",
  "#4F606B",
  "#4B5D69",
  "#566C76",
  "#566C76",
  "#67767D",
  "#bb9b82",
  "#968D72",
  "#3083C1",
  "#3083C1",
  "#57453C",
  "#4B2B48",
  "#491217",
  "#60595B",
  "#B6BCBB",
  "#A1A3A4",
  "#E1E9F0",
  "#E1E9F0",
  "#EFFBFF",
  "#F5DF3D",
  "#F5DF3D",
  "#4C433D",
  "#7A163C",
  "#564D39",
  "#4D4738",
  "#976E61",
  "#8A8680",
  "#7C7873",
  "#5D4B47",
  "#EAC066",
  "#48403C",
  "#8B8D7E",
  "#8B8D7E",
  "#756048",
  "#7c453e",
  "#F3E7C8",
  "#452430",
  "#CBC8BD",
  "#CBC8BD",
  "#838469",
  "#EFEAD9",
  "#EFEAD9",
  "#A19E99",
  "#9D978E",
  "#9D978E",
  "#8C8478",
  "#B2B4AC",
  "#B2B4AC",
  "#BDB8A7",
  "#373B3E",
  "#373B3E",
  "#373B3E",
  "#3A3D40",
  "#232725",
  "#3D4546",
  "#3C4143",
  "#3D4546",
  "#404041",
  "#444743",
  "#3F423F",
  "#3F3F3D",
  "#A6ABAE",
  "#B4BCBD",
  "#B4B8B4",
  "#D6CF72",
  "#533939",
  "#E3D2B0",
  "#E3D2B0",
  "#E3D2B0",
  "#EFE2C0",
  "#EFE2C0",
  "#2D4338",
  "#F2F5F1",
  "#F2F5F1",
  "#A3A7A9",
  "#936548",
  "#b17861",
  "#936548",
  "#888075",
  "#92867C",
  "#92867C",
  "#29382F",
  "#926346",
  "#8F6244",
  "#2F3433",
  "#323735",
  "#4E6263",
  "#365045",
  "#365045",
  "#365045",
  "#455E50",
  "#455E50",
  "#90886F",
  "#90886F",
  "#9E987E",
  "#4AA590",
  "#313634",
  "#2C312F",
  "#524C40",
  "#4D453F",
  "#513A70",
  "#4A4846",
  "#2F3D36",
  "#2F3D36",
  "#32443C",
  "#3D4954",
  "#3D4954",
  "#3D4954",
  "#45565F",
  "#45565F",
  "#4A5862",
  "#009390",
  "#C6905A",
  "#aa8578",
  "#E5E7E5",
  "#C3AA80",
  "#CEB78E",
  "#DED0AF",
  "#D0D5D2",
  "#AAA398",
  "#AAA398",
  "#AAA398",
  "#B8B4A8",
  "#B8B4A8",
  "#3D3D3D",
  "#313433",
  "#325053",
  "#64635C",
  "#2F487C",
  "#A1A29E",
  "#595449",
  "#959C99",
  "#524A3E",
  "#524A3E",
  "#A8ABA8",
  "#A8ABA8",
  "#373637",
  "#373637",
  "#ACB0B3",
  "#ACB0B3",
  "#DEDBCF",
  "#DEDBCF",
  "#A59E92",
  "#A59E92",
  "#7C8181",
  "#7C8181",
  "#979A9C",
  "#979A9C",
  "#9C9F9F",
  "#595B58",
  "#595B58",
  "#BCB7A3",
  "#BDB7A3",
  "#BCB7A3",
  "#CDC9B5",
  "#CDC9B5",
  "#98292C",
  "#A33733",
  "#BA4432",
  "#ECF0ED",
  "#2E53A1",
  "#3665AD",
  "#A4A9AB",
  "#8A795E",
  "#DFB465",
  "#AB8F5F",
  "#A78B5D",
  "#998053",
  "#9B7F51",
  "#545454",
  "#6EA743",
  "#606964",
  "#6E7173",
  "#BEB9A5",
  "#756F64",
  "#756F64",
  "#837F71",
  "#3D3C3C",
  "#565551",
  "#514842",
  "#483C39",
  "#3B7AAB",
  "#BFA981",
  "#324B3C",
  "#915241",
  "#915241",
  "#34453C",
  "#EAD590",
  "#EFEEE5",
  "#2B302F",
  "#424A4B",
  "#B3BCBD",
  "#FBFFFC",
  "#0D5E86",
  "#0D5E86",
  "#8B392E",
  "#8B392E",
  "#26603E",
  "#26603E",
  "#B42C29",
  "#B42C29",
  "#4B8941",
  "#4B8941",
  "#EECF41",
  "#EECF41",
  "#2769B8",
  "#2769B8",
  "#2A334F",
  "#2A334F",
  "#E65A23",
  "#E7AB36",
  "#E7AB36",
  "#576D69",
  "#4A4E55",
  "#4A4E55",
  "#4A4E55",
  "#525A5E",
  "#525A5E",
  "#F0EDDD",
  "#60503F",
  "#675C51",
  "#675C51",
  "#675C51",
  "#736C5F",
  "#736C5F",
  "#736C5F",
  "#1B6193",
  "#1B6193",
  "#3C3E41",
  "#9e7269",
  "#C5C0B2",
  "#416947",
  "#F1D650",
  "#FEDF47",
  "#C5BEAD",
  "#C1BAA5",
  "#C8DED1",
  "#A5382D",
  "#A6392D",
  "#A5382D",
  "#544F4C",
  "#544F4C",
  "#ADA899",
  "#ADA490",
  "#C8D954",
  "#C8D954",
  "#5E5548",
  "#2F2925",
  "#DBCEB2",
  "#E4DCC0",
  "#676756",
  "#646554",
  "#717662",
  "#2D2E2F",
  "#9C9E9A",
  "#C4BFB5",
  "#F0F2ED",
  "#693832",
  "#693832",
  "#693832",
  "#676D60",
  "#676D60",
  "#764841",
  "#303634",
  "#DFB465",
  "#7E6B52",
  "#675D50",
  "#C1C8C7",
  "#7b4844",
  "#3C3F3E",
  "#4A4745",
  "#A5ABAE",
  "#5D5F5D",
  "#546069",
  "#0D6938",
  "#0D6938",
  "#A6987E",
  "#424343",
  "#424343",
  "#424343",
  "#2A2B2B",
  "#3E3B38",
  "#424343",
  "#424343",
  "#424343",
  "#424343",
  "#424343",
  "#3E3B38",
  "#3E3B38",
  "#3E3B38",
  "#3E3B38",
  "#BDB6AB",
  "#E4DFD6",
  "#514F4D",
  "#A1A29E",
  "#58462C",
  "#A6A9A7",
  "#2D3B50",
  "#354B5E",
  "#A9A092",
  "#303533",
  "#303533",
  "#9AA09C",
  "#959593",
  "#9AA09C",
  "#5E6265",
  "#5E6265",
  "#6A7273",
  "#5C6063",
  "#959C9C",
  "#D9D9CD",
  "#D9D9CD",
  "#E7E9DF",
  "#6A6D70",
  "#6A6D70",
  "#787F80",
  "#7A7D80",
  "#3D3E40",
  "#E2672A",
  "#E2672A",
  "#88473C",
  "#BEC0B9",
  "#BEC0B9",
  "#D4DAD4",
  "#A8BFC8",
  "#78816A",
  "#78816A",
  "#868F78",
  "#868F78",
  "#DADAD7",
  "#939894",
  "#C7E2E3",
  "#9CA0A1",
  "#12273A",
  "#C2B198",
  "#C2B198",
  "#C2B198",
  "#D1C5AD",
  "#D1C5AD",
  "#727C6F",
  "#836F4A",
  "#EFF3F2",
  "#EFF3F2",
  "#F9FFFF",
  "#F9FFFF",
  "#F4F7F5",
  "#F7F8F4",
  "#F9FFFF",
  "#797D7D",
  "#898F8D",
  "#AAB269",
  "#D9DBD8",
  "#A19E98",
  "#1F4E81",
  "#9C8B70",
  "#B9AD97",
  "#877F72",
  "#434138",
  "#85775C",
  "#575042",
  "#BABEBD",
  "#303533",
  "#434138",
  "#BABEBD",
  "#708185",
  "#A98D5F",
  "#7A7363",
  "#696D6E",
  "#EDDBB5",
  "#EDDBB5",
  "#F8E9C2",
  "#F8E9C2",
  "#ECD8B0",
  "#554737",
  "#b9a499",
  "#E6E7DF",
  "#D4A892",
  "#E5BE01",
  "#E98C1A",
  "#E3D9C6",
  "#E3BBA6",
  "#ECC6C1",
  "#FBC651",
  "#AF8C88",
  "#F3B300",
  "#FAD201",
  "#6A5D4D",
  "#DC6F32",
  "#C53940",
  "#F97748",
  "#ED6A40",
  "#B12D42",
  "#A52019",
  "#A72842",
  "#952842",
  "#6F3545",
  "#7B4248",
  "#781F19",
  "#C1876B",
  "#CC0605",
  "#D72D6D",
  "#8673A1",
  "#40428B",
  "#434569",
  "#1E2D6E",
  "#32508D",
  "#4D80C1",
  "#434267",
  "#3A73BA",
  "#063971",
  "#3A5D92",
  "#1D334A",
  "#29748B",
  "#4D644A",
  "#424632",
  "#3D504F",
  "#464748",
  "#35682D",
  "#7B7F6C",
  "#5D4E4C",
  "#709A57",
  "#308446",
  "#9E91A9",
  "#969992",
  "#80737E",
  "#6D6552",
  "#696170",
  "#6E6472",
  "#665C6D",
  "#534E5A",
  "#4F4751",
  "#62565C",
  "#5E5463",
  "#9F8A92",
  "#726C7E",
  "#C2AAAE",
  "#C2AAAE",
  "#D1BBCE",
  "#D1BBCE",
  "#A58F9F",
  "#8E7E8C",
  "#BBA7B3",
  "#7D6C72",
  "#9DA1AA",
  "#8D948D",
  "#4E5452",
  "#CAC4B0",
  "#909090",
  "#82898F",
  "#D0D0D0",
  "#898176",
  "#99524C",
  "#5E4748",
  "#5D4248",
  "#57474F",
  "#4E3B31",
  "#FAF4E3",
  "#E0C6D5",
  "#F4F4F4",
  "#282828",
  "#433C42",
  "#A5A5A5",
  "#A1A1A0",
  "#8F8F8F",
  "#F7D9ED",
  "#463C45",
  "#F6F6F6",
  "#F6F6F6",
  "#D7D7D7",
  "#828282",
  "#493D3B",
  "#634037",
  "#583838",
  "#B3B8B5",
  "#313735",
  "#323735",
  "#595D5A",
  "#C0C5BF",
  "#D0C9B1",
  "#8F9990",
  "#636C6D",
  "#CED5D2",
  "#E7EBDA",
  "#FBFFFF",
  "#E97237",
  "#E5DFCE",
  "#D9CEBE",
  "#9F8E7D",
  "#9F8E7D",
  "#9C9282",
  "#8E573D",
  "#8E573D",
  "#586063",
  "#6C5853",
  "#B9BEBC",
  "#565750",
  "#565750",
  "#4D5453",
  "#4D5453",
  "#353A38",
  "#626663",
  "#626663",
  "#5F483A",
  "#5F483A",
  "#8D9450",
  "#D5D5CA",
  "#D5D5CA",
  "#545040",
  "#545040",
  "#40554C",
  "#AAB1AC",
  "#AAB1AC",
  "#F1A121",
  "#F1A121",
  "#F8AC32",
  "#6C8472",
  "#768A81",
  "#C3B18C",
  "#C3B18C",
  "#E6EAEA",
  "#898C87",
  "#DB9A5D",
  "#4F5C62",
  "#766E63",
  "#B9AD9C",
  "#FFDBD4",
  "#48544F",
  "#DE6A31",
  "#DE6A31",
  "#B3B5AF",
  "#B3B5AF",
  "#B3B5AF",
  "#C2C5BF",
  "#C2C5BF",
  "#476E40",
  "#476E40",
  "#9FA2A2",
  "#91887D",
  "#E2DDD4",
  "#E2DDD4",
  "#F4F4E9",
  "#AE372C",
  "#AE372C",
  "#A94035",
  "#B7B6B2",
  "#919597",
  "#B6BCBB",
  "#969A99",
  "#B1B6B2",
  "#A5ACA8",
  "#ABB2B0",
  "#909190",
  "#E1A98C",
  "#91B0B6",
  "#1B2228",
  "#A48D6A",
  "#3C3B3B",
  "#F5F5EB",
  "#363B4E",
  "#DAC18B",
  "#2C3972",
  "#2C4674",
  "#593435",
  "#F4F4F8",
  "#EAF2F3",
  "#B1ACA3",
  "#454647",
  "#575C5D",
  "#4E5052",
  "#C4BFB9",
  "#909293",
  "#946B3A",
  "#C2AA8D",
  "#CCBCA0",
  "#C5B29B",
  "#908E8A",
  "#908E8A",
  "#616660",
  "#94A19A",
  "#7C8983",
  "#A0A5A7",
  "#618682",
  "#ADC0CA",
  "#DAC9A0",
  "#85898A",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D6D4C9",
  "#E6E9E0",
  "#E6E9E0",
  "#D6DAD4",
  "#91A79A",
  "#55585B",
  "#E5E2D8",
  "#E5E2D8",
  "#504139",
  "#644133",
  "#644133",
  "#6A4C3B",
  "#45565F",
  "#B8B4A8",
  "#525A5E",
  "#736C5F",
  "#3E3B38",
  "#D1C5AD",
  "#F8E9C2",
  "#2E3332",
  "#9EA09E",
  "#E6E9E0",
  "#5C6059",
  "#616560",
  "#616560",
  "#DADAD6",
  "#E1E4E3",
  "#7D8A85",
  "#909D95",
  "#999F9E",
  "#999F9E",
  "#7C8083",
  "#44767C",
  "#9d6355",
  "#595A57",
  "#303535",
  "#AEB7B9",
  "#A5A9AB",
  "#2F4239",
  "#7B7D7E",
  "#68A842",
  "#68A842",
  "#6D6B67",
  "#6D6B67",
  "#767872",
  "#51493F",
  "#56331E",
  "#5A7990",
  "#6386A0",
  "#43553B",
  "#F3F5F1",
  "#F3F5F1",
  "#E7E8DF",
  "#F3F2EA",
  "#F6F8F5",
  "#F4F4EE",
  "#A1A8A7",
  "#FAFFFD",
  "#F9ECD6",
  "#F5ECD8",
  "#FFFDE7",
  "#F8EED8",
  "#FBF5E0",
  "#53595F",
  "#F5F8F3",
  "#627062",
  "#6E7E6E",
  "#DFB465",
  "#6E7E6E",
  "#7E8481",
  "#7E8481",
  "#7E8481",
  "#8D9592",
  "#8D9592",
  "#6E555A",
  "#516A71",
  "#52524D",
  "#52524D",
  "#52524D",
  "#52524E",
  "#5C6059",
  "#5C6059",
  "#E47433",
  "#2A2A2B",
  "#A19E99",
  "#3A3D40",
  "#A3A7A9",
  "#919597",
  "#E7E8DF",
  "#F6A713",
  "#F6A713",
  "#FFB51C",
  "#2C2C2D",
  "#2C2C2D",
  "#3C3F43",
  "#3C3F43",
  "#3B4044",
  "#3B4044",
  "#6C6F72",
  "#6C6F72",
  "#2D2D2E",
  "#2D2D2E",
  "#E3E1D8",
  "#E3E1D8",
  "#ADB1B2",
  "#ABAFB1",
  "#545450",
  "#545450",
  "#F0F4F2",
  "#F0F4F2",
  "#9d958c",
  "#d1cdca",
  "#dfded3",
  "#d4d0ca",
  "#9e968b",
  "#4d423d",
  "#484343",
  "#fcecc5",
  "#6d6c65",
  "#ede8d1",
  "#000000",
  "#c3b9a8",
  "#81725e",
  "#aab4ab",
  "#434542",
  "#616158",
  "#8f9489",
  "#594d3e",
  "#6b6f62",
  "#6d3e36",
  "#5e5348",
  "#ffffff",
  "#63737d",
  "#9ea08a",
  "#3e5d73",
  "#dcceb0",
  "#576161",
  "#c9bfaa",
  "#73796b",
  "#514138",
  "#8299a3",
  "#e7e5d5",
  "#d1cec3",
  "#333c45",
  "#48453c",
  "#808481",
  "#928e82",
  "#a39685",
  "#c3b7a0",
  "#d0c6b4",
  "#aca0a0",
  "#dedfd8",
  "#e0dde8",
  "#891a20",
  "#a3927d",
  "#504541",
  "#605b5d",
  "#2f483b",
  "#25446a",
  "#4f3936",
  "#6b3933",
  "#aa7350",
  "#494d55",
  "#9f9181",
  "#314a40",
  "#abbcc3",
  "#1c4b60",
  "#486c83",
  "#eae3ed",
  "#1a4339",
  "#c8b6aa",
  "#534940",
  "#1f2021",
  "#3e3a38",
  "#385a6b",
  "#cfcfdc",
  "#863e39",
  "#b59380",
  "#a02223",
  "#777570",
  "#cdd0d2",
  "#505255",
  "#100f0f",
  "#979695",
  "#d0c9cc",
  "#4e2c2f",
  "#010005",
  "#393335",
  "#583b35",
  "#948d87",
  "#eae6cd",
  "#4c2f27",
  "#33362d",
  "#c3c3c1",
  "#2e453f",
  "#463f39",
  "#a52a23",
  "#9a9a98",
  "#bbb1a7",
  "#fbfaf8",
  "#876a4f",
  "#51514f",
  "#968e83",
  "#95928e",
  "#696a67",
  "#4c535b",
  "#a3816d",
  "#8d5937",
  "#7d6e5d",
  "#403c39",
  "#925437",
  "#bf9e75",
  "#5b6d76",
  "#a37c59",
  "#564033",
  "#ccc5b7",
  "#d9d9d9",
  "#83654f",
  "#ffffff",
  "#e4e2d8",
  "#aa9a88",
  "#dcd0b5",
  "#cdc8c2",
  "#9a948c",
  "#cbbeb3",
  "#93999c",
  "#f0e9d1",
  "#8397a5",
  "#c1b49e",
  "#e0cbae",
  "#fff1cf",
  "#d2cdbb",
  "#e1e1dd",
  "#5f474b",
  "#686057",
  "#575a5c",
  "#a6a9a8",
  "#4e4c49",
  "#754944",
  "#514b46",
  "#6e6d6d",
  "#4e6157",
  "#4c677b",
  "#4f5c58",
  "#574b47",
  "#424344",
  "#a2a29c",
  "#8f6a45",
  "#afbec3",
  "#818c77",
  "#9a3e43",
  "#c1c2b4",
  "#a99a88",
  "#638391",
  "#84817f",
  "#d2d8d6",
  "#9c5b4f",
  "#595954",
  "#e5dccb",
  "#040707",
  "#751b16",
  "#332c28",
  "#9b8c78",
  "#afb6b5",
  "#183f2e",
  "#726659",
  "#ffffff",
  "#393b3a",
  "#4c3e2f",
  "#997d62",
  "#8b694c",
  "#69493a",
  "#8a4f3c",
  "#242f2d",
  "#4a4739",
  "#d0d0c3",
  "#979a9b",
  "#FFFFFF",
  "#f9ead3",
  "#decfb0",
  "#100c0b",
  "#695e58",
  "#49281f",
  "#64142d",
  "#3e2c14",
  "#7f6661",
  "#c8ba9f",
  "#b5b9bc",
  "#0c452f",
  "#153149",
  "#5d7486",
  "#6b1d11",
  "#afa292",
  "#8f6d4a",
  "#fbf6f2",
  "#eeeef0",
  "#968a76",
  "#868683",
  "#838a91",
  "#857e75",
  "#3d4445",
  "#655541",
  "#585747",
  "#2c3c55",
  "#804039",
  "#58554f",
  "#5a6c7c",
  "#5c6468",
  "#5f6860",
  "#797979",
  "#e5ddcd",
  "#edeadf",
  "#c0cecd",
  "#cfd2c3",
  "#39311e",
  "#e8e5d1",
  "#363332",
  "#000000",
  "#f5f4ed",
  "#7b7562",
  "#5b3738",
  "#4b4940",
  "#485b65",
  "#99a6a7",
  "#863826",
  "#3f351a",
  "#2a4b37",
  "#2f5b48",
  "#474742",
  "#1d584d",
  "#51736f",
  "#004677",
  "#3f4442",
  "#4b2d02",
  "#675b43",
  "#373432",
  "#3f7898",
  "#737577",
  "#282c2d",
  "#3f7897",
  "#398c73",
  "#eef7f5",
  "#e1dbca",
  "#e7e4d1",
  "#99a6a7",
  "#e7e6de",
  "#00676c",
  "#b45414",
  "#ae9076",
  "#54372f",
  "#98887c",
  "#313132",
  "#313132",
  "#313132",
  "#d3cab7",
  "#010101",
  "#a2978a",
  "#ffffff",
  "#90623d",
  "#6e786f",
  "#000000",
  "#f3f3eb",
  "#475b65",
  "#3f351a",
  "#dbdee1",
  "#e7e6dd",
  "#ada18e",
  "#ebe8dc",
  "#949587",
  "#d4d1c7",
  "#fdfdf8",
  "#555551",
  "#4f4535",
  "#253d37",
  "#292817",
  "#6d503d",
  "#514a3d",
  "#454543",
  "#1a1b1c",
  "#3c4233",
  "#6f695d",
  "#5d6060",
  "#76332d",
  "#2b322e",
  "#38484f",
  "#565656",
  "#3a423f",
  "#60757a",
  "#adb8c0",
  "#1a363f",
  "#8f8f7e",
  "#924a36",
  "#633d30",
  "#928b82",
  "#7f5944",
  "#7f807d",
  "#f5f4f0",
  "#a3a284",
  "#4d555e",
  "#dfd5ba",
  "#8b857f",
  "#5f5248",
  "#727f83",
  "#596356",
  "#998475",
  "#9e998f",
  "#b1aea6",
  "#fbefd5",
  "#dfdbce",
  "#77382f",
  "#4d5765",
  "#c9a983",
  "#b3a798",
  "#697453",
  "#a8b4bb",
  "#5e6972",
  "#6e5e54",
  "#6e5e50",
  "#ece9de",
  "#ccbea2",
  "#9fa095",
  "#504f4d",
  "#636058",
  "#7a766c",
  "#757c5f",
  "#c0bfbb",
  "#2f2b2a",
  "#9c908c",
  "#887771",
  "#6a858c",
  "#efefef",
  "#2a2625",
  "#05030b",
  "#39342a",
  "#a59e90",
  "#c1b7a2",
  "#fff6ee",
  "#a18062",
  "#424e53",
  "#615b5d",
  "#26262a",
  "#d0d3dc",
  "#F7F6EF",
  "#e2ddd3",
  "#b8b4a8",
  "#2f2e31",
  "#443a35",
  "#a1a09b",
  "#737373",
  "#625852",
  "#737373",
  "#66676a",
  "#cdc5a5",
  "#262325",
  "#39312c",
  "#b9b09b",
  "#f8f8f8",
  "#000000",
  "#aea590",
  "#dcd1ba",
  "#ffffff",
  "#9d6844",
  "#d9c9af",
  "#f5faf4",
  "#e7d7b3",
  "#1e1e1e",
  "#45403c",
  "#c0b6a5",
  "#384e47",
  "#928986",
  "#9b927f",
  "#858078",
  "#e6e0de",
  "#000000",
  "#6e634d",
  "#602a2a",
  "#36251b",
  "#154535",
  "#f2e8cd",
  "#000000",
  "#65838e",
  "#436585",
  "#9d836b",
  "#4e4a48",
  "#521c01",
  "#403929",
  "#0f3c2b",
  "#2f4e38",
  "#000000",
  "#373530",
  "#717c7b",
  "#a9a897",
  "#9b8d6e",
  "#2b4164",
  "#f1f5f8",
  "#797f65",
  "#b39c85",
  "#444c4d",
  "#235272",
  "#7c402e",
  "#746f66",
  "#695c49",
  "#423e22",
  "#666662",
  "#dcd4bf",
  "#0c0c0e",
  "#19221f",
  "#c6bfad",
  "#f1faf7",
  "#242424",
  "#29231b",
  "#f4f4f2",
  "#736d63",
  "#d7cdb9",
  "#646561",
  "#682e2a",
  "#61544c",
  "#683418",
  "#545e67",
  "#864f29",
  "#a09b8f",
  "#53514e",
  "#725147",
  "#6f6154",
  "#746349",
  "#595755",
  "#4b3828",
  "#555b57",
  "#9a8771",
  "#b6afa7",
  "#a28a75",
  "#555554",
  "#976824",
  "#8d847a",
  "#bbbab3",
  "#434c57",
  "#6d7b82",
  "#80806a",
  "#434446",
  "#a99d8d",
  "#888986",
  "#b9aa92",
  "#796e5f",
  "#626564",
  "#736f66",
  "#574841",
  "#e1e1da",
  "#a6a39a",
  "#543546",
  "#000000",
  "#982721",
  "#3f3928",
  "#5f5e5b",
  "#9c927c",
  "#344f41",
  "#1f4963",
  "#4a6e7d",
  "#1a4535",
  "#ded0b3",
  "#5f453a",
  "#c3bba3",
  "#8c5d2c",
  "#f1f2f0",
  "#7f2f13",
  "#af9778",
  "#5a6265",
  "#fff5c9",
  "#717f65",
  "#accccb",
  "#bd6e50",
  "#3f382e",
  "#5e7270",
  "#e7b26e",
  "#060503",
  "#434746",
  "#212526",
  "#9d9483",
  "#323433",
  "#f9eed8",
  "#493f3d",
  "#274b41",
  "#afa397",
  "#776a61",
  "#ebebe9",
  "#c8c3af",
  "#7e745b",
  "#5f4736",
  "#352b21",
  "#6e3623",
  "#8b8e8c",
  "#6c748c",
  "#141211",
  "#ad9b7a",
  "#55534b",
  "#083931",
  "#5b5d5d",
  "#e6ddcb",
  "#4e2f21",
  "#e1d3b6",
  "#675d43",
  "#ffffff",
  "#54473b",
  "#242021",
  "#2b312f",
  "#b6b3a5",
  "#e8dcc7",
  "#f2f1f7",
  "#0a0203",
  "#837b68",
  "#ede7db",
  "#140b01",
  "#f8f0df",
  "#000000",
  "#48473a",
  "#d7d3cb",
  "#7e8083",
  "#28291f",
  "#b7b09b",
  "#433b35",
  "#0a3210",
  "#9a948c",
  "#3d4445",
  "#f5efe4",
  "#f5efe4",
  "#7f5432",
  "#757561",
  "#a39382",
  "#d3cdbc",
  "#9e8e76",
  "#766340",
  "#572700",
  "#ffffff",
  "#c6b9a0",
  "#dad6d8",
  "#ddbf9c",
  "#7d695d",
  "#9d805f",
  "#633c28",
  "#d2ab7b",
  "#3c434b",
  "#bd8b68",
  "#aa7a47",
  "#774820",
  "#83715b",
  "#93663b",
  "#23211f",
  "#5a4b44",
  "#e8e8e8",
  "#98896f",
  "#9b7c4a",
  "#633b29",
  "#9d8d82",
  "#1e1a15",
  "#8e5c2f",
  "#67402e",
  "#cca778",
  "#97673a",
  "#40392e",
  "#b37f45",
  "#b6aa9c",
  "#8f837b",
  "#232323",
  "#5d5956",
  "#c46623",
  "#66331a",
  "#443730",
  "#1c2317",
  "#000000",
  "#a9a18f",
  "#181717",
  "#e1dbc4",
  "#f9f7f7",
  "#463829",
  "#e1d4c2",
  "#030505",
  "#bebebe",
  "#f5f5f5",
  "#000000",
  "#eef0f0",
  "#7e7f84",
  "#5e4330",
  "#e4d4c1",
  "#ffffff",
  "#4a1711",
  "#4d4b40",
  "#694414",
  "#C97F31",
  "#B1871C",
  "#8A4C11",
  "#9C5634",
  "#2E2927",
  "#786256",
  "#5A5652",
  "#A56F4B",
  "#693424",
  "#5C3B28",
  "#BB8342",
  "#5D3D2E",
  "#242223",
  "#442E26",
  "#593328",
  "#3A3C47",
  "#7A7777",
  "#CDB9B2",
  "#1A1617",
  "#841000",
  "#534B40",
  "#8E867B",
  "#562D01",
  "#B3BAC0",
  "#004833",
  "#D2C9B6",
  "#70665A",
  "#FFFFFF",
  "#55514a",
  "#c4baaa",
  "#efeee5",
  "#ddd9ce",
  "#eeece1",
  "#504A46",
  "#A59484",
  "#888782",
  "#8A5A4C",
  "#E6E0DB",
  "#684f46",
  "#aeaa9d",
  "#313132",
  "#41433C",
  "#ACA7A1",
  "#563638",
  "#554C46",
  "#575C60",
  "#743733",
  "#413D3E",
  "#A7A9A9",
  "#40574C",
  "#394542",
  "#6B7972",
  "#4C3C38",
  "#27292D",
  "#5F544B",
  "#828A75",
  "#1F5371",
  "#A23032",
  "#E8ECEE",
  "#D1CABC",
  "#AD9883",
  "#537C8D",
  "#7E7B77",
  "#E8E7DC",
  "#D8DBDA",
  "#B8A28D",
  "#A34C38",
  "#3B3833",
  "#CABAA0",
  "#010005",
  "#454A4D",
  "#9B8E7E",
  "#F4F1E8",
  "#D9C8AD",
  "#1D181D",
  "#D5D1C9",
  "#BCAE9F",
  "#736242",
  "#423B28",
  "#4C4139",
  "#BAAB96",
  "#424244",
  "#4A443A",
  "#36393B",
  "#DDD9D3",
  "#E7E0CC",
  "#1A1517",
  "#524B3E",
  "#752716",
  "#094536",
  "#C5CDD7",
  "#F7F8F8",
  "#987856",
  "#704F46",
  "#c1bfba",
  "#494a4b",
  "#a59a8d",
  "#695B52",
  "#514946",
  "#B0A89C",
  "#2B2726",
  "#87898C",
  "#494542",
  "#363621",
  "#757A6C",
  "#425966",
  "#e8e4d9",
  "#473933",
  "#6e5a49",
  "#60554c",
  "#5b4f41",
  "#c0b5a0",
  "#c5baa6",
  "#6b6a5b",
  "#acb4ac",
  "#99a098",
  "#67716e",
  "#4e5856",
  "#435454",
  "#3c4d51",
  "#2a2b2c",
  "#7f878a",
  "#626869",
  "#423f3b",
  "#463e3b",
  "#81796f",
  "#72695e",
  "#c0bbae",
  "#4d483d",
  "#d9d9d1",
  "#3d5463",
  "#f2f2eb",
  "#797979",
  "#867d6e",
  "#6e726a",
  "#f2f4f1",
  "#676662",
  "#e3e2da",
  "#f4f6f1",
  "#030303",
  "#f8f0ca",
  "#4c4e4a",
  "#cecece",
  "#ffffff",
  "#3b3020",
  "#98a0ac",
  "#a0917e",
  "#6e3831",
  "#365f76",
  "#8f8c78",
  "#403f41",
  "#a2a298",
  "#695b52",
  "#595c53",
  "#8f8780",
  "#a6998f",
  "#265d79",
  "#2c3c55",
  "#203c51",
  "#475662",
  "#514946",
  "#cecccb",
  "#fafafa",
  "#7b2c06",
  "#636a6d",
  "#777a74",
  "#576c58",
  "#919599",
  "#d5c1a7",
  "#cfd0cc",
  "#6c7275",
  "#5b6163",
  "#746759",
  "#8f5a40",
  "#979784",
  "#494542",
  "#58554f",
  "#f8e4c4",
  "#907460",
  "#595c53",
  "#253739",
  "#79343c",
  "#b57c45",
  "#976645",
  "#a67c4b",
  "#debe98",
  "#6f5241",
  "#ebdfce",
  "#ebe9e0",
  "#eae9e0",
  "#e8e7df",
  "#ad9785",
  "#e5dfd4",
  "#837363",
  "#615447",
  "#bfb5a9",
  "#60544b",
  "#dbd3c6",
  "#d6c3a8",
  "#f3f1e7",
  "#c0beaf",
  "#9ca18d",
  "#868b81",
  "#c2c9bd",
  "#92a098",
  "#7c9392",
  "#596e6b",
  "#617475",
  "#455454",
  "#9dabab",
  "#4b4042",
  "#3f4445",
  "#dae5df",
  "#b3c7c8",
  "#7f9a9f",
  "#5d6d76",
  "#c7cbce",
  "#aab1b6",
  "#555c64",
  "#2a2b2c",
  "#e5e4de",
  "#b7bbba",
  "#7f878a",
  "#3a3b3b",
  "#d5d4d0",
  "#c6c3c0",
  "#b3b1ae",
  "#828080",
  "#c6c7c5",
  "#efece1",
  "#d5cabd",
  "#948c83",
  "#eae5dc",
  "#d5d1c6",
  "#a6a39a",
  "#d9d8d1",
  "#b7b7af",
  "#838682",
  "#61635e",
  "#4b4b45",
  "#235083",
  "#ecefec",
  "#557280",
  "#6b877a",
  "#fedc98",
  "#de9777",
  "#a55b3f",
  "#3f373e",
  "#c3b39a",
  "#13171c",
  "#e9e4da",
  "#bdc4c5",
  "#eadfc8",
  "#f3f3f0",
  "#efedea",
  "#efefec",
  "#e6e3da",
  "#eeeee7",
  "#e7e4dd",
  "#424242",
  "#84837d",
  "#5e5b56",
  "#6f645c",
  "#5d5651",
  "#938c7c",
  "#dac988",
  "#bbc0a9",
  "#c8cbc5",
  "#9ca19a",
  "#979f9b",
  "#767a72",
  "#4e5351",
  "#cccfcd",
  "#8da09f",
  "#698587",
  "#42676f",
  "#425862",
  "#b5c2c5",
  "#81959d",
  "#64737a",
  "#424547",
  "#a7aeb0",
  "#5c6568",
  "#565f6b",
  "#515b63",
  "#4e535c",
  "#5e5b5d",
  "#4b4042",
  "#5f444a",
  "#624c4d",
  "#9fa8ac",
  "#a6a19a",
  "#dedede",
  "#e2dcc0",
  "#aeae9a",
  "#f7f1cc",
  "#cbd0c9",
  "#d8d4bf",
  "#bbc2aa",
  "#f0ead6",
  "#c5bea2",
  "#fbf9f9",
  "#343032",
  "#5b433b",
  "#584d45",
  "#a29d8a",
  "#ffffff",
  "#bcb6a1",
  "#4a494a",
  "#ffffff",
  "#cec6ba",
  "#74655a",
  "#46413c",
  "#c4b6a2",
  "#bcb6b1",
  "#615347",
  "#605951",
  "#8b8882",
  "#222944",
  "#7d4037",
  "#777a74",
  "#c0b6a7",
  "#8a8f92",
  "#838a92",
  "#e4d7c6",
  "#778d99",
  "#4e606d",
  "#b1a693",
  "#d3bea1",
  "#515557",
  "#857e75",
  "#5f6860",
  "#79797a",
  "#efdab3",
  "#000000",
  "#4e4539",
  "#9b917f",
  "#d1bf9f",
  "#ffffff",
  "#141414",
  "#39311d",
  "#69735a",
  "#e9e8d3",
  "#363432",
  "#004583",
  "#231f20",
  "#f6f5f1",
  "#7c7562",
  "#5b3838",
  "#b93232",
  "#ccc4af",
  "#485b65",
  "#9aa7a9",
  "#943c29",
  "#c6701b",
  "#3f351a",
  "#2e5c48",
  "#6b7b84",
  "#b3ada5",
  "#1b584e",
  "#537878",
  "#004678",
  "#404543",
  "#4b2d05",
  "#675b44",
  "#1d1c0f",
  "#3f7998",
  "#747577",
  "#366889",
  "#378c73",
  "#e2dccb",
  "#c6b291",
  "#8e8f92",
  "#919392",
  "#e8e8e1",
  "#00686d",
  "#b55513",
  "#7b868e",
  "#000000",
  "#414141",
  "#314d43",
  "#f9feff",
  "#483c22",
  "#e5dbc7",
  "#d5c4b6",
  "#aba79f",
  "#efede9",
  "#f4f4f7",
  "#48292f",
  "#463f32",
  "#545657",
  "#a1a4a2",
  "#2e4f39",
  "#692a2c",
  "#524f4e",
  "#474647",
  "#273d1e",
  "#6e7e77",
  "#422c1f",
  "#544b3a",
  "#6c6d6d",
  "#9a9990",
  "#921a2c",
  "#335369",
  "#c8c4b6",
  "#c9b9a2",
  "#6a8f9e",
  "#84817d",
  "#dfddd5",
  "#3e6a62",
  "#a6592c",
  "#83a684",
  "#dad6b4",
  "#9e9687",
  "#a72225",
  "#030203",
  "#eaecda",
  "#194726",
  "#6c2b11",
  "#181b15",
  "#969b93",
  "#0e291b",
  "#3d241c",
  "#5b4f30",
  "#4e463a",
  "#6b7f56",
  "#e1e8e3",
  "#15335f",
  "#cdcdb5",
  "#a99474",
  "#4f7483",
  "#686355",
  "#f4f4e6",
  "#dae1da",
  "#a84729",
  "#928d8a",
  "#828486",
  "#79563f",
  "#8d8581",
  "#956e4f",
  "#bbb3af",
  "#906d4b",
  "#978b81",
  "#514946",
  "#6e3831",
  "#375348",
  "#cecccb",
  "#365f76",
  "#79343c",
  "#203c51",
  "#695b52",
  "#8f5a40",
  "#87898c",
  "#664f40",
  "#626869",
  "#71706d",
  "#3f3a34",
  "#ffffff",
  "#ded9c9",
  "#dfe1de",
  "#aeafac",
  "#5e6367",
  "#1d4933",
  "#30291f",
  "#a9abac",
  "#000013",
  "#5e4f2a",
  "#dfe1de",
  "#ded9ca",
  "#827870",
  "#a5978b",
  "#130600",
  "#831002",
  "#524c3f",
  "#b1a89c",
  "#562e04",
  "#b5bbc0",
  "#004833",
  "#d3ccb9",
  "#71675b",
  "#57493e",
  "#d8b689",
  "#50433b",
  "#e8e8e8",
  "#e8d5b7",
  "#d2d9d5",
  "#000000",
  "#babcb4",
  "#c9a585",
  "#ca2c38",
  "#d3dedc",
  "#9a7c61",
  "#4c1b1b",
  "#d4d5cf",
  "#ded2c3",
  "#665f5a",
  "#574139",
  "#3b3533",
  "#282a2a",
  "#233835",
  "#a9242f",
  "#007a6e",
  "#007864",
  "#cfa269",
  "#004e62",
  "#3a4040",
  "#004063",
  "#004b34",
  "#5f4d47",
  "#93ac92",
  "#2f8777",
  "#a99b8c",
  "#e3dfd8",
  "#919898",
  "#0078a5",
  "#6a7960",
  "#00a7b8",
  "#1b797f",
  "#006c4a",
  "#a9a29a",
  "#bfbcb7",
  "#ad9b7c",
  "#b2352b",
  "#009484",
  "#cac8c4",
  "#c8b79f",
  "#6e4729",
  "#73392f",
  "#4e2b1b",
  "#362218",
  "#b07540",
  "#d09041",
  "#d39c57",
  "#b96e3a",
  "#892c23",
  "#9d6134",
  "#9b3b26",
  "#000000",
  "#351900",
  "#aea295",
  "#bcaf9f",
  "#5b5b59",
  "#8d3428",
  "#000000",
  "#ffffff",
  "#573d2b",
  "#4f2a30",
  "#383a2c",
  "#565656",
  "#ada48a",
  "#a87548",
  "#851c23",
  "#215134",
  "#1a4766",
  "#a1a8a5",
  "#2a6e88",
  "#e2ebe6",
  "#d8d3b6",
  "#c3a67f",
  "#6b7289",
  "#231f20",
  "#aa9977",
  "#545149",
  "#003830",
  "#595b5b",
  "#e5dbc9",
  "#4c2d21",
  "#e0d1b5",
  "#665b42",
  "#ffffff",
  "#b58c6a",
  "#57341e",
  "#666955",
  "#d1c8b6",
  "#9b2026",
  "#dcded8",
  "#523136",
  "#9f673d",
  "#a7a6a5",
  "#8f8176",
  "#5d5a59",
  "#3b5040",
  "#6d3832",
  "#3e3937",
  "#9ea09f",
  "#2f2c2e",
  "#2e3f39",
  "#443632",
  "#2e3132",
  "#5c5246",
  "#7e846f",
  "#747270",
  "#124c64",
  "#dcdedb",
  "#c6bfae",
  "#a18d7b",
  "#aba6a6",
  "#466f81",
  "#7a7675",
  "#d2d4d1",
  "#0c645d",
  "#9b4d3c",
  "#202225",
  "#171d1b",
  "#eeeee9",
  "#5a5c5d",
  "#584c42",
  "#979da9",
  "#a0917e",
  "#7e7e80",
  "#8e8c76",
  "#3e403f",
  "#98948b",
  "#645b52",
  "#6f6151",
  "#8f867f",
  "#a79990",
  "#46606f",
  "#484540",
  "#e5ddd2",
  "#40444d",
  "#585d60",
  "#53504d",
  "#9b8975",
  "#7d473b",
  "#646c6f",
  "#787a75",
  "#f7f7f7",
  "#7e7979",
  "#c1b4a2",
  "#443c3c",
  "#616557",
  "#92959a",
  "#e0d3b3",
  "#d6e3d9",
  "#73726e",
  "#6e7376",
  "#746757",
  "#78786c",
  "#524a3f",
  "#f8e0c2",
  "#8c7766",
  "#65655d",
  "#3f4749",
  "#b2a690",
  "#ffd5cb",
  "#fbbeb2",
  "#f1d4c0",
  "#6f6151",
  "#65594a",
  "#e2d8cf",
  "#dcd3ca",
  "#d2c8bd",
  "#c3b8ae",
  "#a99a8d",
  "#968777",
  "#806d60",
  "#e8dcd1",
  "#f0ceb6",
  "#d3c4ba",
  "#ccb9ad",
  "#b49c8d",
  "#977d6c",
  "#8c6d5e",
  "#7e6355",
  "#e7ddcf",
  "#ded0c0",
  "#cab9a8",
  "#b49f8b",
  "#dcaa86",
  "#9d8774",
  "#887361",
  "#836f5d",
  "#e5dbce",
  "#dfd2c4",
  "#d1c0af",
  "#b8a18c",
  "#9c806d",
  "#8f7662",
  "#775e4b",
  "#da9b72",
  "#e2d4c2",
  "#dccebb",
  "#cfbca4",
  "#bca68c",
  "#a58d72",
  "#8a735b",
  "#826c54",
  "#e1d6c1",
  "#dcccb3",
  "#cfba9c",
  "#bd7750",
  "#bca47e",
  "#a98e69",
  "#997c57",
  "#826849",
  "#e7d9be",
  "#dfceae",
  "#d3c09d",
  "#c1a77d",
  "#a7885b",
  "#8d6e43",
  "#9c6040",
  "#856846",
  "#e8dcc8",
  "#e1cfb5",
  "#cdb99f",
  "#b8a183",
  "#a68c6c",
  "#987c5d",
  "#8b7355",
  "#e6d6bc",
  "#dfceb3",
  "#f6e0c8",
  "#d3be9e",
  "#c2a680",
  "#b6976c",
  "#aa855b",
  "#987248",
  "#eee4d0",
  "#e9ddc5",
  "#e2ceaf",
  "#dac4a3",
  "#c9ac86",
  "#f1d5b7",
  "#c19d73",
  "#a77f57",
  "#eadac2",
  "#e7d8be",
  "#ddc9ac",
  "#c9b394",
  "#c0a787",
  "#b0987a",
  "#a08461",
  "#e5d5c3",
  "#f1caa7",
  "#dfcdbb",
  "#d7c2ad",
  "#c9af98",
  "#b4967a",
  "#957459",
  "#8e7056",
  "#f1e2ce",
  "#ead6bd",
  "#e5caac",
  "#d3b28e",
  "#e7b388",
  "#c39b74",
  "#ae8157",
  "#a97b54",
  "#eadfc9",
  "#e8dac1",
  "#dacaac",
  "#c9ae84",
  "#c2a579",
  "#b39666",
  "#a8875b",
  "#f7a292",
  "#dea173",
  "#ead4b0",
  "#e3c79d",
  "#d5b387",
  "#cda674",
  "#bf9364",
  "#b88d60",
  "#ac8255",
  "#ead6b6",
  "#ead2b1",
  "#e6c8a3",
  "#d49262",
  "#d4b385",
  "#caa472",
  "#bf9765",
  "#a47c4f",
  "#eedcbe",
  "#e8d0ae",
  "#dabd98",
  "#caa77a",
  "#b79163",
  "#9b7149",
  "#ca8354",
  "#8f6541",
  "#dfccb6",
  "#dac5ac",
  "#c8ac8e",
  "#b99978",
  "#977555",
  "#927254",
  "#d8c4ab",
  "#c8ab8b",
  "#f7e8ce",
  "#c5a485",
  "#b6906b",
  "#a3795a",
  "#956e56",
  "#825e46",
  "#f2e3d0",
  "#ead3bb",
  "#e3c3a6",
  "#d2ab88",
  "#ba8d65",
  "#f6debf",
  "#9c6e49",
  "#8f6748",
  "#ebd7bf",
  "#e4ccb1",
  "#e2c19c",
  "#d5ae83",
  "#cc9764",
  "#be8759",
  "#b68253",
  "#efdfcc",
  "#f7d6b1",
  "#e9d4c0",
  "#e0c3ad",
  "#d9bca5",
  "#cda688",
  "#c49676",
  "#a87857",
  "#f0e2d2",
  "#e8d7c6",
  "#e0c8b6",
  "#d0b19b",
  "#f0c9a1",
  "#b59077",
  "#a47b64",
  "#99745d",
  "#eddbcd",
  "#e7d1c2",
  "#dcc0af",
  "#d8baa5",
  "#c4a289",
  "#bd9174",
  "#9c7059",
  "#e6b789",
  "#f0e2d4",
  "#ebdacc",
  "#e2c8ba",
  "#d6b3a3",
  "#d0ae9f",
  "#bc917f",
  "#9c725f",
  "#e6cfc5",
  "#e0c4b8",
  "#cfaea0",
  "#dd9d65",
  "#bf9789",
  "#b98d7d",
  "#a67768",
  "#8d5d50",
  "#f2e3d7",
  "#f0dbd2",
  "#e5c8bf",
  "#d9b3a6",
  "#ca9c8e",
  "#bb8877",
  "#d0864e",
  "#985949",
  "#f2d9cc",
  "#e8c5b8",
  "#d2a08e",
  "#c18872",
  "#b67861",
  "#9e624d",
  "#905b47",
  "#f2c8b5",
  "#e4b5a6",
  "#ef8c7d",
  "#fae0c1",
  "#d49b8a",
  "#c1796a",
  "#b36957",
  "#a5594e",
  "#8e5049",
  "#e2c1ab",
  "#dcb79f",
  "#cfa68d",
  "#bc8b6e",
  "#a26e57",
  "#fbd8ae",
  "#9b6752",
  "#875e4c",
  "#f6e4d6",
  "#f1d9c6",
  "#e8c6b0",
  "#deb59d",
  "#b67d5e",
  "#9c664b",
  "#dab8a1",
  "#fed1a5",
  "#caa286",
  "#b98766",
  "#b17d60",
  "#a07259",
  "#8e6552",
  "#825a49",
  "#d8bdad",
  "#c39d87",
  "#b78c75",
  "#a77964",
  "#f4c08b",
  "#86604f",
  "#7c5b4e",
  "#cdb5aa",
  "#b5988a",
  "#997968",
  "#8e6e5f",
  "#725748",
  "#645145",
  "#5f5047",
  "#eda768",
  "#e8d9d4",
  "#e0cec9",
  "#cfb7b1",
  "#bfa4a0",
  "#a58785",
  "#866963",
  "#6a544c",
  "#eae1de",
  "#dfd1d0",
  "#cdb9bb",
  "#efa361",
  "#bda7a8",
  "#a2898b",
  "#7f6868",
  "#5f4e4b",
  "#e1c6c5",
  "#d8b4b5",
  "#c89896",
  "#9a6d6b",
  "#8c5956",
  "#774d4a",
  "#d78a4b",
  "#634543",
  "#e8d7d5",
  "#e0cacb",
  "#d2b4b3",
  "#be999a",
  "#996e6f",
  "#85595d",
  "#6d4243",
  "#f6dfe0",
  "#f2cccf",
  "#f8ebd2",
  "#e5b6bf",
  "#d89fa8",
  "#c68691",
  "#ae6c75",
  "#914d4e",
  "#f4d7d5",
  "#ebc7c9",
  "#e4b2b5",
  "#d29a9c",
  "#c7868c",
  "#f9e3c6",
  "#b17376",
  "#905455",
  "#f3d3d1",
  "#e9b2b4",
  "#df979c",
  "#dd9091",
  "#c36b6e",
  "#ab5f5e",
  "#9b4b49",
  "#f2d7d0",
  "#fed9af",
  "#efc8c5",
  "#e4b2ae",
  "#d99a94",
  "#bc746b",
  "#ae675e",
  "#89504e",
  "#e69a95",
  "#cc7469",
  "#b66156",
  "#ed7b6c",
  "#fdce9e",
  "#a64c43",
  "#984841",
  "#fec1bf",
  "#ef8b84",
  "#e66f68",
  "#d2564a",
  "#c14c45",
  "#b84945",
  "#a84342",
  "#f9bb80",
  "#f9c6cc",
  "#f7b4be",
  "#e7838d",
  "#d85c66",
  "#cb4746",
  "#bd3a42",
  "#a54048",
  "#f5dcd9",
  "#f6c1c6",
  "#ee989e",
  "#fdb06d",
  "#e76f75",
  "#c24c4d",
  "#b03e43",
  "#a03d41",
  "#fac6d1",
  "#fab6c5",
  "#f7a2b4",
  "#eb8496",
  "#dd6779",
  "#bb4254",
  "#f79547",
  "#a5414d",
  "#f7d9d7",
  "#f9d0d1",
  "#f5b1bb",
  "#ef949d",
  "#e86674",
  "#bc4550",
  "#b04253",
  "#f6d6d6",
  "#f0b4c1",
  "#fae6ce",
  "#e59aa8",
  "#d5788b",
  "#b9596a",
  "#ad364e",
  "#963f50",
  "#f5c5dc",
  "#e898bf",
  "#dd7aa5",
  "#c9527f",
  "#b24668",
  "#f8ddc0",
  "#af405b",
  "#9d3c53",
  "#f3d6da",
  "#f3d1db",
  "#e3afc5",
  "#c77a9a",
  "#9e5774",
  "#7d485a",
  "#674a4e",
  "#f2dcde",
  "#fcd2ab",
  "#e9cdd6",
  "#ddb2c6",
  "#c997af",
  "#ba7699",
  "#924e6a",
  "#6c4551",
  "#eee0e2",
  "#eed5df",
  "#e2c4d5",
  "#d8b2ca",
  "#fec79b",
  "#bd90ae",
  "#8f6483",
  "#755172",
  "#eee2de",
  "#e4d3d6",
  "#d6bfce",
  "#ccaec5",
  "#bb95ae",
  "#8d6782",
  "#6d4a61",
  "#fdb580",
  "#e1d4dd",
  "#d4c7d6",
  "#cdbfd1",
  "#aa98ad",
  "#9a83a0",
  "#7d6685",
  "#5b435d",
  "#e3dddd",
  "#dccddd",
  "#cbb7d0",
  "#fca367",
  "#b498bd",
  "#9f7ca5",
  "#76597f",
  "#544556",
  "#e3dce8",
  "#d4c7e2",
  "#bdadd5",
  "#ab97c8",
  "#9379b0",
  "#6c598d",
  "#dc624d",
  "#f58c40",
  "#635083",
  "#e0e1e8",
  "#d3d1e0",
  "#c7c3d9",
  "#b2aac8",
  "#9c94bb",
  "#897eaa",
  "#5e5384",
  "#e9ebe6",
  "#d9dbe2",
  "#f9e8c4",
  "#d2d2dc",
  "#c3c2d0",
  "#a6a6bd",
  "#827f92",
  "#514c5a",
  "#daddea",
  "#d5dae6",
  "#c8d0e3",
  "#b4bdd9",
  "#929bc2",
  "#fae0b2",
  "#8085b4",
  "#53588a",
  "#d6d8df",
  "#c5c8d4",
  "#acb3ca",
  "#9aa1b9",
  "#7c819d",
  "#696d86",
  "#504c5b",
  "#d0d5e3",
  "#fddca8",
  "#c5ccdf",
  "#bdc5dc",
  "#a7b1cc",
  "#93a0bd",
  "#747d92",
  "#5c6274",
  "#dee2e3",
  "#c9d0d8",
  "#b3b9c7",
  "#a0a6b6",
  "#fccf8e",
  "#84899a",
  "#6e7182",
  "#49484c",
  "#e4ddde",
  "#d6ced1",
  "#c4bcc0",
  "#b4a9af",
  "#a39499",
  "#928187",
  "#765f61",
  "#fbbc6b",
  "#e5e0dd",
  "#d3cfd0",
  "#c1b9bd",
  "#afa8ae",
  "#988b90",
  "#7a6f74",
  "#675c5f",
  "#e5e0db",
  "#dcd9d5",
  "#cacac8",
  "#f8ac57",
  "#b3b1b0",
  "#a09e9d",
  "#797271",
  "#60544f",
  "#dbd8ce",
  "#cfccc4",
  "#b4b2ae",
  "#a29d96",
  "#8b847c",
  "#f99d48",
  "#726a62",
  "#c7c7c2",
  "#b6b4ac",
  "#adaba2",
  "#99958c",
  "#8d887a",
  "#6b655b",
  "#dfe1db",
  "#d4d7d2",
  "#fcebc8",
  "#cbcfc9",
  "#bbbeb8",
  "#a4a79e",
  "#898c83",
  "#565851",
  "#c8c6b9",
  "#c1bfb1",
  "#aeaa9a",
  "#95917f",
  "#7b7665",
  "#fee3b1",
  "#6e6958",
  "#5d594c",
  "#e7e7dd",
  "#dddccd",
  "#c7c8b7",
  "#9a9c87",
  "#878872",
  "#626451",
  "#e3e2d5",
  "#f7dbcf",
  "#fde0af",
  "#d4d3c3",
  "#c4c2b0",
  "#afab93",
  "#a39f87",
  "#87846b",
  "#696753",
  "#e1dfcf",
  "#dad9c9",
  "#d2d1bf",
  "#c5c3ae",
  "#ffd99f",
  "#aea98f",
  "#999275",
  "#81795e",
  "#edebdd",
  "#e5e3d4",
  "#dedbc7",
  "#cdcab2",
  "#b9b396",
  "#a29675",
  "#877c5e",
  "#fdc983",
  "#e2decf",
  "#dad5c6",
  "#cdc7b3",
  "#b8ae95",
  "#aca182",
  "#8e8163",
  "#6f664e",
  "#e0ded1",
  "#dbd8c9",
  "#cecbba",
  "#fec478",
  "#c0bba9",
  "#a8a189",
  "#8f866b",
  "#7d735d",
  "#d0cdc2",
  "#bab5a7",
  "#a09a89",
  "#918a78",
  "#7f7766",
  "#ffa84e",
  "#6c6453",
  "#ccc7bd",
  "#beb8ae",
  "#b6afa3",
  "#a59a8d",
  "#8b8274",
  "#7c7567",
  "#e3e0d7",
  "#dad6cc",
  "#f5e8ce",
  "#c5c1b8",
  "#b8b4ac",
  "#a69f93",
  "#908878",
  "#726859",
  "#ddddd3",
  "#cfd0c5",
  "#c2c3b9",
  "#b0b0a5",
  "#9a9a8e",
  "#fde0b5",
  "#8b8a7b",
  "#696757",
  "#d5dbd2",
  "#c7cfc8",
  "#b3beb9",
  "#a3b0ae",
  "#8b9490",
  "#7a847f",
  "#616964",
  "#cfd3c8",
  "#fedbae",
  "#bfc6bb",
  "#b0b9b2",
  "#a7b3aa",
  "#a2ada5",
  "#8b978e",
  "#646b61",
  "#d3d9d2",
  "#c9cfc9",
  "#9da8a1",
  "#fad4a4",
  "#818981",
  "#6a716a",
  "#d6ddd5",
  "#c9d3d0",
  "#b9c5c3",
  "#a7b2b0",
  "#8f9999",
  "#788181",
  "#646b68",
  "#f5c382",
  "#e0e2dc",
  "#ced2ce",
  "#b4bbbc",
  "#a0a8a8",
  "#83898a",
  "#6c7171",
  "#4b4e4e",
  "#c8cdcd",
  "#c0c6c5",
  "#adb3b3",
  "#fed6ca",
  "#f0ba77",
  "#9a9f9e",
  "#888d8f",
  "#6a6f70",
  "#444647",
  "#cfd4d1",
  "#b9bfbe",
  "#9ea5a5",
  "#7f8487",
  "#696d72",
  "#54585c",
  "#e39a50",
  "#4c4f52",
  "#d8d9d8",
  "#c6cbcc",
  "#b0b4b7",
  "#9a9fa2",
  "#7f8386",
  "#626568",
  "#4b4d4f",
  "#dae0e3",
  "#c8d2d6",
  "#f6eaca",
  "#b1bfc7",
  "#9eadb7",
  "#81909b",
  "#67737c",
  "#4e5357",
  "#d0d8d9",
  "#c0cacd",
  "#acb7c0",
  "#97a2ae",
  "#758391",
  "#f7e3bf",
  "#5f666c",
  "#464748",
  "#d4dedd",
  "#c3d0d2",
  "#a2b4ba",
  "#86989e",
  "#66797f",
  "#607077",
  "#494e52",
  "#c8d8d9",
  "#f5dbb0",
  "#bdd1d4",
  "#b1c7cb",
  "#a1bac0",
  "#84a0ab",
  "#6e8791",
  "#5e7480",
  "#dae3e2",
  "#bfd0d4",
  "#9bb1bb",
  "#7c939e",
  "#f3cf9c",
  "#627885",
  "#445962",
  "#435155",
  "#c8dee2",
  "#b9d3da",
  "#aecbd4",
  "#95b9c6",
  "#769eb0",
  "#618697",
  "#4e646f",
  "#ebbc7f",
  "#d4e2e4",
  "#c3d7dd",
  "#a4c1cd",
  "#8fafbf",
  "#7092a3",
  "#537284",
  "#415663",
  "#cbdcdf",
  "#b0c9d0",
  "#93b1bc",
  "#e1a863",
  "#7f9dac",
  "#6b8895",
  "#67818f",
  "#4c636e",
  "#cbdde2",
  "#bcd4dd",
  "#a0bece",
  "#81a2b6",
  "#63879f",
  "#4e738c",
  "#c58240",
  "#3f5266",
  "#f7e7c5",
  "#f9c4b3",
  "#f6e1aa",
  "#fcdb94",
  "#fcce73",
  "#ffc963",
  "#f5b54f",
  "#dfa34a",
  "#f6e9c4",
  "#f4e2b5",
  "#f1dbaa",
  "#f6d797",
  "#f5a48c",
  "#f1ca7f",
  "#ecb35d",
  "#d59d4e",
  "#f6ecd3",
  "#f2e6c8",
  "#f1dcb5",
  "#eacfa0",
  "#e5c48b",
  "#e3b26f",
  "#d0a05b",
  "#f19378",
  "#f7edd5",
  "#f4e2c0",
  "#edd5ac",
  "#e1c28b",
  "#d5af70",
  "#bf9652",
  "#b08749",
  "#f5e9c2",
  "#f2e1b4",
  "#edd7a4",
  "#ffc1b6",
  "#ef7a5f",
  "#e7cd8d",
  "#c92e2e",
  "#d33a41",
  "#e04c5b",
  "#f57f94",
  "#fdacbd",
  "#ffcdd8",
  "#fce2e6",
  "#ca2c2c",
  "#d5393f",
  "#e14b5a",
  "#f57e92",
  "#feacbd",
  "#ffcdd8",
  "#fee2e7",
  "#cf312b",
  "#d93e3c",
  "#e65458",
  "#f88791",
  "#ffb3bd",
  "#ffd3d8",
  "#fde7e8",
  "#b5332c",
  "#c33d3d",
  "#d44c57",
  "#ed7e8e",
  "#f9abba",
  "#fecdd6",
  "#fde2e6",
  "#a0372f",
  "#b14040",
  "#ca4f5a",
  "#e47f90",
  "#f5acbc",
  "#fcccd6",
  "#fce3e7",
  "#8a453e",
  "#9c5251",
  "#c78086",
  "#e1adb3",
  "#f0cdd1",
  "#f7e4e4",
  "#9d3d2d",
  "#a54337",
  "#b14c45",
  "#d37878",
  "#eaa6a9",
  "#f6c8ca",
  "#fae0e0",
  "#a33a2d",
  "#ae4138",
  "#be4e4e",
  "#de7c83",
  "#f2aab3",
  "#facbd0",
  "#fce1e3",
  "#bd4638",
  "#c94f43",
  "#d75f56",
  "#f0908d",
  "#fbb9b9",
  "#fed6d5",
  "#fde8e6",
  "#d33b2b",
  "#dc4739",
  "#e75a50",
  "#f88a87",
  "#ffb6b6",
  "#ffd4d3",
  "#fde7e4",
  "#e1c478",
  "#d7402b",
  "#df4c37",
  "#e95f4d",
  "#f98f83",
  "#ffb9b3",
  "#ffd7d1",
  "#fde9e3",
  "#e0412b",
  "#e7513b",
  "#f06450",
  "#fd988e",
  "#ffbeb8",
  "#ffd9d4",
  "#fdeae6",
  "#e04227",
  "#e75136",
  "#f16750",
  "#fe9989",
  "#ffc0b7",
  "#ffdbd4",
  "#fdebe5",
  "#e34c28",
  "#ea5933",
  "#f46f4b",
  "#ff9e84",
  "#ffc5b5",
  "#ffded3",
  "#fdede5",
  "#e95823",
  "#ef6530",
  "#f77946",
  "#ffa67e",
  "#ffcab0",
  "#ffe1cf",
  "#fdefe2",
  "#f0701a",
  "#f57c28",
  "#fb8b3c",
  "#ffb577",
  "#ffd4aa",
  "#ffe7cb",
  "#fcf2e1",
  "#f47c1b",
  "#f78523",
  "#fc9537",
  "#ffba71",
  "#ffd8a6",
  "#ffeac9",
  "#fcf3de",
  "#f98a0c",
  "#fc931e",
  "#ffa134",
  "#ffc36f",
  "#ffdda6",
  "#ffecc7",
  "#fcf4de",
  "#ff9f00",
  "#ffa706",
  "#ffb229",
  "#ffcf6b",
  "#ffe4a1",
  "#fef0c6",
  "#fbf6dd",
  "#ffaf00",
  "#ffb700",
  "#ffc21b",
  "#ffd766",
  "#ffe89f",
  "#fef2c3",
  "#fbf6db",
  "#deb866",
  "#ffb000",
  "#ffb600",
  "#ffc31e",
  "#ffd867",
  "#ffe99f",
  "#fff3c4",
  "#fbf7dd",
  "#ffbd00",
  "#ffc400",
  "#ffce0b",
  "#ffde64",
  "#ffec9e",
  "#fef4c3",
  "#fbf7db",
  "#ffd400",
  "#ffd600",
  "#ffdb00",
  "#ffe765",
  "#fff19f",
  "#fdf5c4",
  "#faf7dc",
  "#ecc900",
  "#f0cd00",
  "#f8d60a",
  "#fae466",
  "#fef0a1",
  "#fcf5c4",
  "#fbf8dd",
  "#c1b400",
  "#ccbb0e",
  "#d7c52e",
  "#ecdc71",
  "#f6eca9",
  "#faf4c8",
  "#faf8e0",
  "#b4ca00",
  "#c3cf00",
  "#d2d612",
  "#e1e465",
  "#f0f09f",
  "#f7f6c3",
  "#f7f8db",
  "#97c100",
  "#a4c700",
  "#bdd120",
  "#d2e169",
  "#e7efa0",
  "#f3f5c5",
  "#f7f8dc",
  "#99b009",
  "#abb915",
  "#bfc428",
  "#d5d869",
  "#e8e99f",
  "#f2f2c3",
  "#f5f6db",
  "#79a21e",
  "#88aa27",
  "#a6ba32",
  "#c3d16f",
  "#dde5a3",
  "#edf1c7",
  "#f4f6dd",
  "#569128",
  "#669a30",
  "#7ba640",
  "#acc774",
  "#cddfa7",
  "#e4eec8",
  "#f0f5de",
  "#c99b42",
  "#33a122",
  "#48ab2c",
  "#61b83e",
  "#97d477",
  "#bfe8aa",
  "#dbf3cb",
  "#ecf7e0",
  "#50ab18",
  "#62b424",
  "#78bf38",
  "#a7d873",
  "#cbeaa7",
  "#e1f3c9",
  "#eff8df",
  "#169928",
  "#32a431",
  "#4eb245",
  "#88d17e",
  "#b6e6af",
  "#d5f2ce",
  "#e7f6e1",
  "#008a31",
  "#00983c",
  "#31aa50",
  "#72cc88",
  "#a6e3b5",
  "#cbf0d2",
  "#e3f6e5",
  "#207337",
  "#2f7d3f",
  "#448c4e",
  "#7fb37f",
  "#aed2b0",
  "#cfe6ce",
  "#e5f1e2",
  "#136938",
  "#227442",
  "#348354",
  "#71ad87",
  "#a3cdb5",
  "#c8e3d2",
  "#e1f0e4",
  "#2f6f46",
  "#347e50",
  "#429565",
  "#75c099",
  "#a4dcc1",
  "#c9ecda",
  "#e2f5e9",
  "#00703a",
  "#00874a",
  "#00a162",
  "#53c799",
  "#94e1c2",
  "#c0efdb",
  "#dcf6e9",
  "#0c6546",
  "#007c56",
  "#0a976d",
  "#5bc2a2",
  "#95ddc7",
  "#bfedde",
  "#dcf6eb",
  "#006242",
  "#008158",
  "#009e75",
  "#35c6a8",
  "#85dfcb",
  "#b8eee0",
  "#d8f6ec",
  "#f3ebd4",
  "#105a3c",
  "#0a6548",
  "#17775c",
  "#5ca492",
  "#bfe0d7",
  "#d9ede7",
  "#2a453d",
  "#296253",
  "#34816f",
  "#65b4a5",
  "#9ad5cb",
  "#c2e8e0",
  "#def4ed",
  "#006047",
  "#007e5d",
  "#009d7b",
  "#3dc6ab",
  "#86decd",
  "#b8eee1",
  "#d8f5ec",
  "#055143",
  "#00745d",
  "#00967a",
  "#45c1ac",
  "#89dccd",
  "#b8ebe1",
  "#d7f4ec",
  "#006149",
  "#008363",
  "#009f7e",
  "#25c7af",
  "#7edecd",
  "#b3ede1",
  "#d3f4eb",
  "#005949",
  "#007c61",
  "#009c7d",
  "#24c5ae",
  "#7fddcf",
  "#b3ede2",
  "#d4f4ed",
  "#005a48",
  "#007a63",
  "#009a7f",
  "#22c3af",
  "#81ddd0",
  "#b4ece3",
  "#d5f4ed",
  "#174a43",
  "#006b5b",
  "#00907a",
  "#4bbcab",
  "#8bd8cd",
  "#baeae2",
  "#d8f3ec",
  "#004e4a",
  "#006d66",
  "#008b84",
  "#1fb9b4",
  "#7ed5d4",
  "#b3e8e6",
  "#d3f1ee",
  "#274043",
  "#225a5d",
  "#29777b",
  "#61acae",
  "#98ced0",
  "#c0e3e3",
  "#dcf0ed",
  "#f1e6cb",
  "#2f3e3e",
  "#325654",
  "#3e7371",
  "#6da9a7",
  "#9dcdcb",
  "#c4e3e1",
  "#ddf0ec",
  "#2f534f",
  "#2d5d5a",
  "#306e6d",
  "#629fa0",
  "#94c2c5",
  "#bedcdd",
  "#d8ebe9",
  "#1c4e42",
  "#0a5a52",
  "#00706c",
  "#499ea1",
  "#85c1c8",
  "#b3dbde",
  "#d5ebea",
  "#294e4f",
  "#255a5e",
  "#236d73",
  "#569ca5",
  "#8dc1ca",
  "#b8dae0",
  "#d6eaec",
  "#1d4543",
  "#0a565a",
  "#006b76",
  "#409cac",
  "#80c0cf",
  "#b0dae3",
  "#d2eaec",
  "#144552",
  "#005f6f",
  "#007b8e",
  "#12abbe",
  "#78cbda",
  "#aee1ea",
  "#d1eff1",
  "#0b464e",
  "#00636c",
  "#00808b",
  "#18afbb",
  "#7acfd9",
  "#afe3e9",
  "#d3f0f0",
  "#254952",
  "#1f5763",
  "#136b7b",
  "#4d9cae",
  "#87c0d1",
  "#b5dae4",
  "#d5ebee",
  "#254455",
  "#18546a",
  "#006985",
  "#419ab7",
  "#80bfd7",
  "#b0d9e8",
  "#d2eaf0",
  "#1d3e59",
  "#00567c",
  "#00719c",
  "#17a1c8",
  "#76c4e2",
  "#aadcee",
  "#cfecf2",
  "#eedfb7",
  "#203b5d",
  "#005381",
  "#006ea1",
  "#199fcc",
  "#73c1e4",
  "#a9dbef",
  "#ceebf3",
  "#2f394b",
  "#264864",
  "#185d82",
  "#3e90b8",
  "#7cb7d6",
  "#acd5e9",
  "#cde7f1",
  "#323a43",
  "#304656",
  "#2d5970",
  "#548da7",
  "#87b5cb",
  "#b3d3e1",
  "#d3e7ed",
  "#2e3549",
  "#254669",
  "#1a5e89",
  "#4a93be",
  "#84bbdc",
  "#b1d6ea",
  "#d3e8f1",
  "#2b3558",
  "#184a7c",
  "#0062a0",
  "#3195ca",
  "#74bae3",
  "#a8d5ef",
  "#cce8f3",
  "#2b3762",
  "#144b86",
  "#0063a6",
  "#1c94d0",
  "#6eb8e5",
  "#a3d4f0",
  "#c8e6f3",
  "#233872",
  "#004e93",
  "#0066b1",
  "#0f97d8",
  "#6cbaea",
  "#a3d6f2",
  "#cae8f3",
  "#333356",
  "#334076",
  "#365496",
  "#6289c6",
  "#92b3e0",
  "#bcd2ed",
  "#d7e5f2",
  "#3a3450",
  "#413d6d",
  "#4e4e8c",
  "#7f84be",
  "#aab0db",
  "#cbcfea",
  "#e2e5f1",
  "#3c3845",
  "#48445e",
  "#5c5a7c",
  "#8e8fb0",
  "#b8b9d2",
  "#d6d5e5",
  "#e8e8ef",
  "#e8d3a1",
  "#3b3339",
  "#453c50",
  "#544d6d",
  "#8782a6",
  "#afafcb",
  "#cfcfe0",
  "#e5e5ed",
  "#43334d",
  "#523c68",
  "#664b86",
  "#9a80b9",
  "#bfadd7",
  "#dbcee8",
  "#eae3f0",
  "#40363c",
  "#4d3d4b",
  "#604b62",
  "#957e99",
  "#bdabc2",
  "#d9ccdb",
  "#ebe3ea",
  "#4b3540",
  "#5d3d54",
  "#764b6e",
  "#aa7fa5",
  "#ccacca",
  "#e3cce0",
  "#f0e3ec",
  "#62334a",
  "#7b3c63",
  "#9b4a80",
  "#c280b4",
  "#dcacd3",
  "#edcde6",
  "#f5e3ef",
  "#663347",
  "#7f3b5f",
  "#9f487d",
  "#c67daf",
  "#dfaad1",
  "#edcce4",
  "#f6e3ef",
  "#8d2d48",
  "#a0365f",
  "#b4447b",
  "#d67cb0",
  "#e8a9d0",
  "#f3cae3",
  "#f7e2ed",
  "#9c284b",
  "#ab3162",
  "#bc427f",
  "#db7bb4",
  "#eba8d3",
  "#f4cbe5",
  "#f8e2ee",
  "#9d3448",
  "#ac3d58",
  "#bd5070",
  "#dc85a6",
  "#ecb0ca",
  "#f5d0e1",
  "#f8e5ec",
  "#aa253c",
  "#b83153",
  "#c84470",
  "#e47da7",
  "#f2abcb",
  "#f8cde1",
  "#fae2ec",
  "#e0c787",
  "#923538",
  "#9e3b45",
  "#ad485b",
  "#d07991",
  "#e6a7bc",
  "#f3c9d7",
  "#f8e1e7",
  "#a14048",
  "#ae4853",
  "#be5a67",
  "#dc8c9b",
  "#edb6c3",
  "#f5d4dc",
  "#f8e7ea",
  "#703e3c",
  "#7c4547",
  "#8c5059",
  "#b77f8c",
  "#d6acb8",
  "#e9ccd4",
  "#f3e2e6",
  "#73383f",
  "#833f4d",
  "#974c64",
  "#c27e9a",
  "#dcaac1",
  "#eccbda",
  "#f5e3ea",
  "#793b31",
  "#914443",
  "#b2525d",
  "#d48295",
  "#eaaebe",
  "#f6cfd9",
  "#fae4e8",
  "#6e3731",
  "#853f44",
  "#a64e5d",
  "#cb7e95",
  "#e4acc0",
  "#efcdd9",
  "#f8e3e8",
  "#b32735",
  "#c0324a",
  "#cf4566",
  "#e97b9d",
  "#f5abc5",
  "#facddd",
  "#fbe3ea",
  "#b82d33",
  "#c53d46",
  "#d35361",
  "#eb8a99",
  "#f6b6c3",
  "#fad4db",
  "#fae7e9",
  "#964333",
  "#9a4637",
  "#9f4b3d",
  "#bd6d64",
  "#d99992",
  "#ecbdb7",
  "#f6d9d4",
  "#a95445",
  "#b55e4f",
  "#c26c60",
  "#df9b91",
  "#eec0ba",
  "#f6dbd6",
  "#f9ece7",
  "#d6bb74",
  "#974434",
  "#9b4837",
  "#a14c3e",
  "#bf7065",
  "#da9b94",
  "#edc0b9",
  "#f7dad5",
  "#894334",
  "#8e4738",
  "#974c3e",
  "#b36f67",
  "#d19a95",
  "#e7bfba",
  "#f3dad5",
  "#7b4233",
  "#804638",
  "#864b40",
  "#a97169",
  "#cb9e99",
  "#e3c1bd",
  "#f0dbd7",
  "#754331",
  "#8b5042",
  "#ae6557",
  "#ce958e",
  "#e5bebb",
  "#f2dad7",
  "#f5eae7",
  "#7b4532",
  "#864d3b",
  "#975c4b",
  "#c18c80",
  "#ddb6ae",
  "#eed4ce",
  "#f6e8e2",
  "#6f4b3b",
  "#754f3f",
  "#7e5849",
  "#a48073",
  "#c6aaa0",
  "#dfcbc2",
  "#eee2db",
  "#714d39",
  "#78523f",
  "#825b48",
  "#a98573",
  "#caafa1",
  "#e2cfc4",
  "#f0e4dc",
  "#6b4a3c",
  "#704e40",
  "#7a5749",
  "#9f7f73",
  "#c3aaa1",
  "#ddcbc3",
  "#ede2dc",
  "#67473a",
  "#6d4c3f",
  "#785548",
  "#9b7d73",
  "#c0a9a1",
  "#dbcac3",
  "#ece2dc",
  "#6e493a",
  "#734d3e",
  "#7c5547",
  "#a17d71",
  "#c5a99f",
  "#decac2",
  "#ede1da",
  "#e26d4a",
  "#c29e54",
  "#6e4939",
  "#754e3f",
  "#7d5648",
  "#a47f73",
  "#c6aaa0",
  "#e0cbc3",
  "#eee1db",
  "#6f483b",
  "#744d40",
  "#7e554a",
  "#a57f75",
  "#c8aaa3",
  "#e0cbc5",
  "#efe2dd",
  "#6f473b",
  "#754c40",
  "#7f554b",
  "#a77f78",
  "#caaba6",
  "#e1cbc7",
  "#efe2de",
  "#684034",
  "#6d4338",
  "#754b41",
  "#9a726d",
  "#bf9f9c",
  "#dbc3c0",
  "#ecddda",
  "#714235",
  "#744539",
  "#7c4b42",
  "#9e726d",
  "#c19e9b",
  "#ddc3c0",
  "#ecdcd9",
  "#6c493a",
  "#724e3f",
  "#7a5648",
  "#a07e71",
  "#c3a99f",
  "#ddc9c1",
  "#ece1da",
  "#67493a",
  "#6d4e3f",
  "#755749",
  "#9c8174",
  "#c1aca2",
  "#dccdc5",
  "#ece3dc",
  "#614a3b",
  "#664f40",
  "#6f594b",
  "#978477",
  "#bdafa6",
  "#d8cfc7",
  "#eae4de",
  "#5d4b3d",
  "#604e40",
  "#695a4c",
  "#918578",
  "#b8b1a7",
  "#d3cfc7",
  "#e8e5df",
  "#58453b",
  "#604d44",
  "#68554d",
  "#8e7f79",
  "#b5aba7",
  "#d3ccc7",
  "#e6e2de",
  "#f5edd0",
  "#5a4430",
  "#6e5440",
  "#886a59",
  "#b59d94",
  "#d3c3bd",
  "#e8ddd8",
  "#f2ede8",
  "#594334",
  "#5f4b3c",
  "#68574a",
  "#8c847a",
  "#b4afa8",
  "#d3d0c9",
  "#e6e4df",
  "#52443c",
  "#564942",
  "#5f544e",
  "#86807e",
  "#aeabaa",
  "#cdccca",
  "#e4e3e0",
  "#5b3f36",
  "#5f433c",
  "#664b47",
  "#897475",
  "#b1a2a4",
  "#d0c5c5",
  "#e4dedd",
  "#433731",
  "#52433e",
  "#685553",
  "#9c8989",
  "#c2b5b7",
  "#dcd4d3",
  "#ece7e5",
  "#493a33",
  "#584744",
  "#6f5b5c",
  "#a19195",
  "#c4bbc0",
  "#ded8da",
  "#ece9e8",
  "#443a36",
  "#544649",
  "#6b5a64",
  "#9b8e9c",
  "#c1b9c4",
  "#dcd6dd",
  "#ebe9ea",
  "#383537",
  "#413d44",
  "#514a58",
  "#857d8f",
  "#b0acbb",
  "#d0cdd6",
  "#e5e3e7",
  "#353435",
  "#3c3b40",
  "#4a4a53",
  "#7b7c88",
  "#a9abb6",
  "#caccd3",
  "#e1e2e5",
  "#333334",
  "#3a3b3f",
  "#464a50",
  "#757b83",
  "#a2a9b1",
  "#c6cbcf",
  "#dfe2e3",
  "#f4e8c4",
  "#333334",
  "#3a3c3e",
  "#46494f",
  "#757b82",
  "#a3aab0",
  "#c6cbcf",
  "#dfe3e3",
  "#585858",
  "#787b7d",
  "#979c9f",
  "#c3c8cb",
  "#dce1e1",
  "#ecefec",
  "#f4f6f1",
  "#4b5756",
  "#6e7c7d",
  "#8f9d9e",
  "#bac8c9",
  "#d6e0e0",
  "#e9efed",
  "#f1f5f1",
  "#465956",
  "#627c7a",
  "#889e9e",
  "#b3c8c8",
  "#d3e1e1",
  "#e7efec",
  "#f1f4f1",
  "#696d70",
  "#8b9094",
  "#b8bdc0",
  "#d6dbdc",
  "#e8ebea",
  "#3d3f40",
  "#52565a",
  "#6d7378",
  "#a2a9ae",
  "#c7cdd1",
  "#e0e4e4",
  "#eef0ee",
  "#38393a",
  "#464a4d",
  "#5c6167",
  "#92999e",
  "#bac1c6",
  "#d7dcde",
  "#eaedeb",
  "#343435",
  "#373a3d",
  "#444a50",
  "#727c83",
  "#a0aab1",
  "#c4cbd0",
  "#dde2e3",
  "#393736",
  "#42444b",
  "#515a67",
  "#8290a0",
  "#acbac8",
  "#cdd7de",
  "#e3e9eb",
  "#323436",
  "#373c41",
  "#404b54",
  "#6d7e89",
  "#9cadb7",
  "#c1cdd3",
  "#dbe3e5",
  "#453c39",
  "#494242",
  "#4f4e53",
  "#717c86",
  "#9ca8b3",
  "#c1cad1",
  "#dce1e4",
  "#313435",
  "#373d3f",
  "#434e52",
  "#a1b0b4",
  "#c4cfd2",
  "#dde5e5",
  "#383a3c",
  "#44484d",
  "#717980",
  "#9ea7ad",
  "#c3c9cd",
  "#dde1e1",
  "#3d3d3e",
  "#4b4b4f",
  "#7c7f84",
  "#aaaeb3",
  "#cbced0",
  "#e2e4e3",
  "#4b433d",
  "#504a45",
  "#7e8283",
  "#a7aeb0",
  "#c9cece",
  "#e1e4e3",
  "#393d3c",
  "#434c4f",
  "#829ba1",
  "#adc3c8",
  "#cedddf",
  "#e4edeb",
  "#303536",
  "#364042",
  "#415457",
  "#6f898b",
  "#9eb5b8",
  "#c3d4d4",
  "#dce7e6",
  "#544839",
  "#5a4f40",
  "#645d4e",
  "#8d8c7f",
  "#b3b5ab",
  "#d3d4cc",
  "#e6e8e1",
  "#4f493b",
  "#555042",
  "#5f5e50",
  "#858d81",
  "#b0b8ae",
  "#cfd5cd",
  "#e4e8e2",
  "#464233",
  "#565344",
  "#6d6c5e",
  "#99a196",
  "#c0c8c1",
  "#dae0da",
  "#eaeee9",
  "#ead99d",
  "#4b4b3f",
  "#545447",
  "#616253",
  "#919284",
  "#b9bbb1",
  "#d6d8cf",
  "#e7e9e2",
  "#535140",
  "#5c5a47",
  "#6a6855",
  "#9a9885",
  "#bfc0b1",
  "#dadbcf",
  "#ecece3",
  "#5e5a42",
  "#696449",
  "#757055",
  "#a39f84",
  "#c8c5b2",
  "#e0ded0",
  "#edede3",
  "#766c4b",
  "#8d835e",
  "#a59c79",
  "#cbc7b0",
  "#e2e0d1",
  "#efeee3",
  "#f6f6ed",
  "#646742",
  "#83855e",
  "#c8cab2",
  "#e0e3d4",
  "#eeefe5",
  "#f6f7ee",
  "#6e743a",
  "#8b8c50",
  "#a6a56c",
  "#cccca3",
  "#e3e4ca",
  "#f0f0df",
  "#f5f6eb",
  "#83872e",
  "#9a983d",
  "#b1ad55",
  "#d3cf8f",
  "#e7e5bd",
  "#f2f1d7",
  "#f7f7e7",
  "#8c883f",
  "#949146",
  "#a19d52",
  "#c4c184",
  "#dddcb1",
  "#ececcf",
  "#f4f4e3",
  "#8b7744",
  "#9d8752",
  "#b19c68",
  "#d3c59d",
  "#f2eedd",
  "#f7f5eb",
  "#8b7d43",
  "#958649",
  "#ab9554",
  "#c6b984",
  "#ded6af",
  "#ede8cf",
  "#f5f3e3",
  "#e1ca84",
  "#9f8c3f",
  "#a89343",
  "#baa04f",
  "#d3c281",
  "#e7dcae",
  "#f2ebcd",
  "#f7f4e2",
  "#a08542",
  "#ac8d46",
  "#bb9951",
  "#d2ba7f",
  "#e8d8ad",
  "#f0e8cb",
  "#f5f2e1",
  "#ad863e",
  "#b89045",
  "#c59e55",
  "#e0c389",
  "#efddb5",
  "#f7ecd2",
  "#f9f5e5",
  "#96722e",
  "#a07a35",
  "#af8840",
  "#d1b071",
  "#e6cfa1",
  "#f2e4c5",
  "#f8f1dd",
  "#c58e38",
  "#cc953d",
  "#d5a14b",
  "#eac17c",
  "#f5daa9",
  "#faebcc",
  "#faf3e0",
  "#d68a1a",
  "#dc9222",
  "#eaa731",
  "#f4c36b",
  "#fbdc9f",
  "#fcebc3",
  "#fbf4dc",
  "#c57626",
  "#cc7f2d",
  "#d78c3b",
  "#ecb36d",
  "#f8d3a1",
  "#fbe7c5",
  "#fbf2dc",
  "#c57b3a",
  "#cd8341",
  "#d89050",
  "#eeb783",
  "#f9d5b0",
  "#fce7cf",
  "#fbf2e4",
  "#be7f3e",
  "#c68745",
  "#d19750",
  "#e8b981",
  "#f4d6ae",
  "#fae8ce",
  "#faf3e3",
  "#c4893a",
  "#cc9040",
  "#d69d4d",
  "#ecbf7f",
  "#f7daad",
  "#fbeacd",
  "#faf3e2",
  "#d9bf71",
  "#b2803d",
  "#ba8744",
  "#c9974f",
  "#e0b97f",
  "#f0d5ac",
  "#f8e8cc",
  "#f9f2e0",
  "#966b41",
  "#9f7247",
  "#ab7e51",
  "#cda87f",
  "#e3c9aa",
  "#f1e1cc",
  "#f7efe1",
  "#835e34",
  "#8c663b",
  "#997245",
  "#c09d73",
  "#dbc3a4",
  "#ecdcc5",
  "#f5ecdc",
  "#855c3f",
  "#8d6345",
  "#986e4f",
  "#be997c",
  "#dac0aa",
  "#ebdbca",
  "#f4ebdf",
  "#765138",
  "#7e583d",
  "#8a6348",
  "#b18e74",
  "#d1b7a3",
  "#e6d4c4",
  "#f2e8dd",
  "#a5763e",
  "#ae7e46",
  "#ba8b52",
  "#d8b281",
  "#ebd2ad",
  "#f5e5cc",
  "#f8f1e1",
  "#b5632c",
  "#bc6b32",
  "#c7773e",
  "#e1a16d",
  "#f1c5a0",
  "#f9dec3",
  "#faeddb",
  "#c76c37",
  "#d07640",
  "#db8450",
  "#f1ae84",
  "#fbcfb3",
  "#fde4d1",
  "#fcf1e4",
  "#c86638",
  "#d17042",
  "#dc8052",
  "#f2ab85",
  "#fbccb3",
  "#fde3d1",
  "#fcefe4",
  "#cc5a32",
  "#d4653e",
  "#e17751",
  "#f5a386",
  "#fdc8b6",
  "#ffe0d3",
  "#fdeee5",
  "#c29a4d",
  "#c35232",
  "#cb5e3d",
  "#d56e4e",
  "#ea9e82",
  "#f4c3b2",
  "#f9ddcf",
  "#faede3",
  "#ab4830",
  "#bd543d",
  "#d36651",
  "#ea9589",
  "#f8beb8",
  "#fddad5",
  "#fceae6",
  "#8e4332",
  "#924737",
  "#9a4b3d",
  "#b77067",
  "#d59a94",
  "#eabfb9",
  "#f4d9d5",
  "#804531",
  "#8d4e3a",
  "#9e5d4b",
  "#c88d81",
  "#e2b8b0",
  "#f0d5ce",
  "#f7e8e2",
  "#88442e",
  "#984f3b",
  "#ab604e",
  "#d29185",
  "#e8bbb4",
  "#f4d7d1",
  "#f9e9e4",
  "#a65330",
  "#ad5935",
  "#b66340",
  "#d48d6c",
  "#eab59d",
  "#f6d4c1",
  "#f9e7da",
  "#f2e7cb",
  "#edddb7",
  "#f7e4d4",
  "#e8d6ab",
  "#ddca9a",
  "#cdb379",
  "#b9995b",
  "#9e8249",
  "#ede5ce",
  "#e3d9bb",
  "#d5c8a6",
  "#cab88c",
  "#bca474",
  "#f5d8c7",
  "#a08b5f",
  "#7f6c46",
  "#ebe3cf",
  "#ded3bb",
  "#d1c5a8",
  "#a28d66",
  "#816f4e",
  "#7b6b4e",
  "#e4dcc4",
  "#f7c8b7",
  "#ddd3b7",
  "#d2c7a9",
  "#cec3a4",
  "#c1b697",
  "#ac9c7c",
  "#978466",
  "#f1e8cc",
  "#e8dcba",
  "#decea6",
  "#ceb985",
  "#f1b7a4",
  "#b99e64",
  "#a58b54",
  "#967e4e",
  "#eee5c7",
  "#e5d9b2",
  "#daca9c",
  "#c9b37a",
  "#c5b077",
  "#b19557",
  "#9d8246",
  "#e79e83",
  "#f4eaca",
  "#ece3c1",
  "#e1d5aa",
  "#dacea1",
  "#d1bb81",
  "#cab275",
  "#b09755",
  "#f3ebd6",
  "#ece3ca",
  "#e7dbbb",
  "#d88467",
  "#d9c9a1",
  "#c8b180",
  "#c1a977",
  "#b19b67",
  "#f3e4b6",
  "#eadba1",
  "#eada99",
  "#e1cc81",
  "#d2bd65",
  "#caab55",
  "#ce6c52",
  "#ab8f4e",
  "#f3edd1",
  "#f7f0ce",
  "#f7ecba",
  "#f3e4a0",
  "#e6d281",
  "#d6bd68",
  "#c6a447",
  "#f4edcc",
  "#f3e7be",
  "#f7dbd1",
  "#f1df9f",
  "#ebd689",
  "#ead180",
  "#e4c368",
  "#d0a647",
  "#faeec5",
  "#fde9b5",
  "#fae1a0",
  "#f3d27f",
  "#eec463",
  "#fcb0a3",
  "#eec2b7",
  "#efbc50",
  "#e2ad4a",
  "#faefce",
  "#fbebc1",
  "#fce6b0",
  "#f9d795",
  "#f5ca79",
  "#f7bc57",
  "#e4a039",
  "#f8eecc",
  "#e9a99a",
  "#fce9b6",
  "#fde7a5",
  "#fbdb90",
  "#facf70",
  "#fcc550",
  "#ffbd46",
  "#faf1c6",
  "#fdeeb2",
  "#ffeba2",
  "#fee181",
  "#e0907c",
  "#fdda66",
  "#ffcf30",
  "#feca25",
  "#faf1c5",
  "#fcf0b6",
  "#fceba2",
  "#f9e584",
  "#fde269",
  "#fbde61",
  "#ffd851",
  "#d37864",
  "#f8f3d5",
  "#f8f0c4",
  "#faf1b8",
  "#faea9e",
  "#f7e481",
  "#f8e165",
  "#ffdd39",
  "#f9f2ca",
  "#faf1bb",
  "#fceb9d",
  "#b6604f",
  "#f7e27d",
  "#fade60",
  "#f7d64f",
  "#f0c933",
  "#f7efd1",
  "#f9efc5",
  "#f4e8ae",
  "#f3e49c",
  "#f1da76",
  "#f1cc54",
  "#9e5545",
  "#e4bc3b",
  "#f8f3c5",
  "#f8eca9",
  "#f6e485",
  "#f3dd64",
  "#ecd559",
  "#edd24f",
  "#e2c839",
  "#f9f1b8",
  "#f8eda8",
  "#f0d3c9",
  "#f7e78f",
  "#f8e47b",
  "#f1da57",
  "#e8d24a",
  "#d2c13d",
  "#f7f0c5",
  "#f4ebb6",
  "#eee3a4",
  "#ecdf9b",
  "#e7d887",
  "#e9c9c1",
  "#e2d06d",
  "#cdbc47",
  "#f6efd1",
  "#f2e9c1",
  "#eae0b1",
  "#e6d89e",
  "#dbc988",
  "#d0bc68",
  "#bfa653",
  "#ece6c6",
  "#deb4aa",
  "#e6e0b9",
  "#dbd6a7",
  "#d5c589",
  "#c4b473",
  "#b3a358",
  "#ad9b4a",
  "#f5f0cd",
  "#f3edc1",
  "#eee7b0",
  "#e3da9b",
  "#d69b8e",
  "#d9cd7a",
  "#c7bc60",
  "#aea44a",
  "#f1f3ca",
  "#ecf0ba",
  "#e0e89b",
  "#d8de7b",
  "#d3d95d",
  "#cece4a",
  "#caca35",
  "#f89585",
  "#cb8574",
  "#e8f0c3",
  "#e2ecb4",
  "#d9e8a1",
  "#ccdb79",
  "#c5d25b",
  "#a7b554",
  "#95a54e",
  "#e5f1cf",
  "#e1efc2",
  "#dcedbb",
  "#b26b58",
  "#d1e8a5",
  "#cae392",
  "#a5c667",
  "#9bb95b",
  "#ebf3cb",
  "#e1f0ba",
  "#d4e898",
  "#bedd78",
  "#aad76a",
  "#95cb54",
  "#884d45",
  "#78b942",
  "#e2f1d1",
  "#d8edc4",
  "#cfe8b9",
  "#c4e0ac",
  "#add18a",
  "#9ec479",
  "#83ac58",
  "#dce8cf",
  "#d2dfbf",
  "#f1d5cb",
  "#bfcea8",
  "#a7b989",
  "#9baf7b",
  "#839462",
  "#627649",
  "#dce3d0",
  "#d4decb",
  "#cfdac4",
  "#c0cbb1",
  "#a9b595",
  "#ecc8be",
  "#889672",
  "#626d51",
  "#cbd8c6",
  "#bac9b4",
  "#aabba5",
  "#93a58c",
  "#70816b",
  "#5b6a5b",
  "#515d51",
  "#cdded3",
  "#e7b9ac",
  "#bfd1bf",
  "#aec1ad",
  "#9bad97",
  "#88977e",
  "#75866e",
  "#56664e",
  "#d5e0d5",
  "#ced9cc",
  "#bfcdc2",
  "#b3c2b5",
  "#daa492",
  "#97a493",
  "#737e6b",
  "#565d4f",
  "#e2e7dc",
  "#d2d9ca",
  "#bbc6b7",
  "#a7b4a2",
  "#8c9985",
  "#737f6a",
  "#586251",
  "#c18573",
  "#d1d7c7",
  "#c9d0bf",
  "#b9c0ad",
  "#a5aa92",
  "#939880",
  "#7b8068",
  "#dfe2c6",
  "#d5dbb9",
  "#cad2ad",
  "#975f57",
  "#b9c2a2",
  "#abb18e",
  "#969a72",
  "#80835c",
  "#e4e7d2",
  "#d4dabf",
  "#c7cdad",
  "#aeb68e",
  "#959d6e",
  "#777e55",
  "#87544b",
  "#6e7450",
  "#e2e3cc",
  "#dad9be",
  "#cbcbad",
  "#b9b790",
  "#a2a175",
  "#827f57",
  "#76754d",
  "#dde1ca",
  "#d6dabf",
  "#f37f6b",
  "#f2dacc",
  "#cccfae",
  "#c3c6a4",
  "#afb288",
  "#9d9e6f",
  "#8a885d",
  "#d2d4c4",
  "#c3c7b1",
  "#b8b8a1",
  "#a3a187",
  "#eecec1",
  "#858367",
  "#7d765a",
  "#e6e1cb",
  "#ded7be",
  "#cec7aa",
  "#b4a985",
  "#988b65",
  "#7b7251",
  "#6d684e",
  "#ebead6",
  "#e6bdac",
  "#e1e2cb",
  "#dbd8bc",
  "#cbc8a3",
  "#b4b085",
  "#9e9668",
  "#918659",
  "#e0e2be",
  "#d7daad",
  "#d1d2a1",
  "#c0c286",
  "#e2b5a5",
  "#a1a464",
  "#9c9a62",
  "#908d55",
  "#e8ecd2",
  "#e0e9ca",
  "#d3deba",
  "#cbd6a9",
  "#bcc58d",
  "#a6b376",
  "#8c965a",
  "#d89e87",
  "#d7e4c1",
  "#cfdeb5",
  "#bacda0",
  "#a6ba80",
  "#95ad6d",
  "#89a068",
  "#6e8454",
  "#e0efd2",
  "#c9e6c0",
  "#bfe0b8",
  "#d18c6c",
  "#a2d292",
  "#95c884",
  "#72a556",
  "#5f9253",
  "#ddf0cb",
  "#ceebb9",
  "#b7e3a0",
  "#a3d984",
  "#84cb6b",
  "#67b458",
  "#b86d52",
  "#51a448",
  "#c9e2c5",
  "#c0debf",
  "#aad0ac",
  "#8dba8e",
  "#7aac7a",
  "#5a8e5e",
  "#4d7256",
  "#d3edd1",
  "#c5e9c8",
  "#f6e3cf",
  "#b2e1b9",
  "#a9deb3",
  "#88c58e",
  "#67b273",
  "#288f50",
  "#bbecd6",
  "#abe6cd",
  "#a1dfc5",
  "#86d2b2",
  "#75c8a2",
  "#f7d5c1",
  "#5ab990",
  "#31976b",
  "#d7efe2",
  "#c7e9d8",
  "#b5e2ce",
  "#95d1b6",
  "#78be9c",
  "#51a07a",
  "#46926d",
  "#b1e7d4",
  "#f4cbb3",
  "#a1dfcb",
  "#89d6bd",
  "#66bfa0",
  "#3ba681",
  "#238966",
  "#306a57",
  "#d4ecde",
  "#cbe9de",
  "#b1decf",
  "#86c6b2",
  "#ea6d5a",
  "#f0c0a4",
  "#63a791",
  "#458a74",
  "#375c4f",
  "#c8ecdf",
  "#afe4d4",
  "#8ad7c5",
  "#5bc1a9",
  "#21a68c",
  "#00917a",
  "#2a806c",
  "#e5a883",
  "#c7ecdd",
  "#afe9d5",
  "#9fe3ce",
  "#83ddc5",
  "#50c9ac",
  "#00b998",
  "#009a7b",
  "#d3e9dc",
  "#c0e0d5",
  "#afd7cb",
  "#d8916d",
  "#97cbbb",
  "#7ebba6",
  "#599e84",
  "#367262",
  "#daeadd",
  "#c7ddcd",
  "#b1cfba",
  "#9cbea6",
  "#81a488",
  "#638469",
  "#c47752",
  "#c3d8cc",
  "#afcbbd",
  "#a1beaf",
  "#8aab98",
  "#75957d",
  "#64806c",
  "#56705f",
  "#c4ddcb",
  "#b4d1c1",
  "#f7dfcd",
  "#9cc1b2",
  "#83ac9d",
  "#588977",
  "#407465",
  "#3e5c53",
  "#cae9db",
  "#bce3d7",
  "#96cec0",
  "#6ab7a7",
  "#56a392",
  "#f6d8c4",
  "#3b7e6f",
  "#336155",
  "#cdf0e4",
  "#b7eae1",
  "#a2e4d8",
  "#79d5ca",
  "#4fc2b1",
  "#1db6a4",
  "#009181",
  "#c2e7dd",
  "#f6d0b7",
  "#ade1da",
  "#87d5d1",
  "#78cecc",
  "#43bbb6",
  "#00a6a1",
  "#008c87",
  "#c4e3db",
  "#b2ddd6",
  "#9cd1cd",
  "#87c5c2",
  "#f2c0a6",
  "#68b1ad",
  "#3f9793",
  "#2e7572",
  "#c6deda",
  "#b7d6d3",
  "#a6cbc9",
  "#8fbcba",
  "#689b99",
  "#517b77",
  "#3d585b",
  "#e8a481",
  "#d8e7de",
  "#c2dad3",
  "#abc8c0",
  "#94b8af",
  "#6c9187",
  "#55756c",
  "#445851",
  "#c1d2ce",
  "#bacdc8",
  "#a4bbb6",
  "#dd8963",
  "#8aa39c",
  "#748e88",
  "#5a7169",
  "#486055",
  "#ccd9cf",
  "#c2d1c6",
  "#b1c1b5",
  "#9cac9e",
  "#90a393",
  "#7d8d81",
  "#e1503c",
  "#606e63",
  "#c7d6cd",
  "#bdcec5",
  "#aabeb4",
  "#93a9a0",
  "#7f958e",
  "#4a5950",
  "#c8d8d1",
  "#b7ccc7",
  "#f6d8c4",
  "#9ab9b5",
  "#82a3a3",
  "#6f8f8e",
  "#4e6c6b",
  "#415451",
  "#dae5e2",
  "#c2d5d6",
  "#a9c3c6",
  "#97b2b7",
  "#75959a",
  "#f9c5ac",
  "#54747c",
  "#465a5d",
  "#bcdddd",
  "#acd3d7",
  "#88bdc8",
  "#6faab4",
  "#50939d",
  "#397a85",
  "#285e6b",
  "#c1e7e5",
  "#f5bba1",
  "#aae0df",
  "#87d1d2",
  "#68c1c3",
  "#3aa9a9",
  "#00898a",
  "#255456",
  "#b6e2e1",
  "#a1d9db",
  "#88cdd1",
  "#7bc7cb",
  "#f2a685",
  "#5cb5b9",
  "#2c9ba1",
  "#23777b",
  "#b9dce1",
  "#a1cfd7",
  "#95c8d2",
  "#86becb",
  "#71aebb",
  "#5598a9",
  "#33677b",
  "#e38e69",
  "#b7dfe2",
  "#a5d7dc",
  "#84c5ce",
  "#57abb7",
  "#3292a1",
  "#2c8392",
  "#226977",
  "#9ed9e2",
  "#8ad0db",
  "#6bc0ce",
  "#d0714a",
  "#45adbe",
  "#0493a7",
  "#008299",
  "#3c6c7a",
  "#c8e6ea",
  "#b7dfe5",
  "#a0d6e2",
  "#76c2d7",
  "#54b1c9",
  "#1fa0c1",
  "#b2573f",
  "#007594",
  "#c0dfe7",
  "#abd3e2",
  "#83b8d0",
  "#6aa4be",
  "#5394b4",
  "#3a6e8c",
  "#34586c",
  "#b4dbea",
  "#a9d4e7",
  "#f8e3d1",
  "#9bcee5",
  "#7dbcdb",
  "#5eabd1",
  "#4298c4",
  "#2474a3",
  "#b7ddeb",
  "#a4d4ec",
  "#94cce7",
  "#7bbde1",
  "#6db4dc",
  "#fcdcc7",
  "#3f9dd1",
  "#1369a7",
  "#cce3eb",
  "#b9d9e7",
  "#aed3e5",
  "#97c3df",
  "#6ba3d0",
  "#3d74ac",
  "#2f5688",
  "#b7d4e2",
  "#f7d7cc",
  "#fccfb9",
  "#a5c8dd",
  "#92bad4",
  "#79a7c5",
  "#5e8fb6",
  "#40729c",
  "#355473",
  "#c9dde5",
  "#c1d7e4",
  "#a1bfd5",
  "#81a5c0",
  "#f8ac89",
  "#6b8db3",
  "#396998",
  "#335183",
  "#d7e5eb",
  "#c0d7e8",
  "#a3c1e3",
  "#8dadd9",
  "#6e94cc",
  "#5b7eb7",
  "#41548c",
  "#f7946b",
  "#bacbdf",
  "#9db2d0",
  "#879ebf",
  "#6a82a8",
  "#414a62",
  "#c5d3df",
  "#b4c5d7",
  "#a5b7cd",
  "#f5855b",
  "#93a6be",
  "#7685a1",
  "#5c6a85",
  "#464956",
  "#c3d8e1",
  "#adc6d4",
  "#9ab4c7",
  "#85a0b6",
  "#6b89a3",
  "#f0764b",
  "#4b5a71",
  "#eaf0e9",
  "#d9e7df",
  "#d3e6dd",
  "#eef2eb",
  "#e3eee8",
  "#ddeae4",
  "#d6e7e2",
  "#d8ebe1",
  "#d9ede1",
  "#f7e6d3",
  "#d4ebda",
  "#eaefdf",
  "#e7edd9",
  "#e3ecd9",
  "#e1ebd5",
  "#e9e8e0",
  "#e3e2da",
  "#e0dfd7",
  "#ddd9ce",
  "#d3cec4",
  "#f9e1cb",
  "#ccc8be",
  "#c3bdb1",
  "#e5e6dc",
  "#dde1d8",
  "#d4d8d2",
  "#e4ebe4",
  "#dae4e2",
  "#d3dedc",
  "#d4dddc",
  "#f0f1ea",
  "#fad9bf",
  "#e5e7e4",
  "#dcdfde",
  "#eceeea",
  "#eaece8",
  "#e1e6e5",
  "#d9e0e1",
  "#f2efe8",
  "#f0ebe4",
  "#eee3de",
  "#f5f2ed",
  "#fecaa8",
  "#f4efea",
  "#f1ebe8",
  "#e9e7e8",
  "#f8eae3",
  "#f7e8e2",
  "#f5e4df",
  "#f8e9e0",
  "#f8e5dd",
  "#f8ddd8",
  "#f9dad3",
  "#fab689",
  "#f6f0e7",
  "#f6ecdf",
  "#f8e7da",
  "#f7e9dc",
  "#f5e2d5",
  "#f3deca",
  "#efd8c6",
  "#f8f0dc",
  "#f9e9d1",
  "#f7e1bf",
  "#f8c9c0",
  "#fca574",
  "#f7ebda",
  "#f7e7d4",
  "#f5e3cc",
  "#f5e0c8",
  "#f6f0e1",
  "#f7efdc",
  "#f4ead5",
  "#f3e6d3",
  "#f5ead6",
  "#f2e5d3",
  "#f78345",
  "#f0e0c9",
  "#f7eedb",
  "#f2ebda",
  "#f6ead2",
  "#f9ebd2",
  "#f2e7cf",
  "#f6e3c3",
  "#f2debc",
  "#f5eed8",
  "#f3ead0",
  "#f7e6d0",
  "#f1e4c4",
  "#f7ecd3",
  "#f6e8c9",
  "#f3e5c3",
  "#f4e3be",
  "#f2efdf",
  "#ece9d8",
  "#e9e5d0",
  "#f6efd6",
  "#f5edcd",
  "#fae2c8",
  "#f5ecc6",
  "#f4e9c0",
  "#f6f3dd",
  "#f4f1d8",
  "#f3eed0",
  "#eeecdb",
  "#e5e5d2",
  "#e6e4cf",
  "#ede8d5",
  "#fad9bc",
  "#e6e1cb",
  "#e2dbc2",
  "#f0ebd7",
  "#ebe6d2",
  "#eae4cd",
  "#e3dec7",
  "#f3e8d4",
  "#eee7d5",
  "#efe5d0",
  "#ede4d0",
  "#f8d0b2",
  "#e7deca",
  "#e7dbc3",
  "#e2d4bd",
  "#e6e0cf",
  "#e3dcc8",
  "#dbd2bc",
  "#eae0c8",
  "#e5d7b9",
  "#e2d2b3",
  "#dac9ab",
  "#f4c5a0",
  "#e9e6db",
  "#e3dfd2",
  "#e5dece",
  "#e0d8c6",
  "#d9cfbb",
  "#d7cdb7",
  "#f2f1e6",
  "#eceae0",
  "#e8e5d8",
  "#eeaf84",
  "#ebe6d7",
  "#e2ddd0",
  "#d9d3c4",
  "#cbc6b8",
  "#e5e0d0",
  "#dbd7c5",
  "#afa58f",
  "#9d917d",
  "#d07b51",
  "#dfdbcd",
  "#d7cebf",
  "#cdc4b5",
  "#ada290",
  "#998b75",
  "#84735e",
  "#ded3c6",
  "#cfc4b7",
  "#f6e0cc",
  "#cabdaf",
  "#b7a99c",
  "#9e8c7c",
  "#857466",
  "#7b6c5d",
  "#d3c9bd",
  "#c9beaf",
  "#b7aa9a",
  "#847562",
  "#f3f0e9",
  "#bbb2a1",
  "#978568",
  "#948065",
  "#7d664d",
  "#736046",
  "#b29678",
  "#c6b097",
  "#b8a28a",
  "#bdaa95",
  "#bfb198",
  "#f0efe6",
  "#b5a695",
  "#9f9282",
  "#8c6f5d",
  "#725641",
  "#5f4d43",
  "#58423a",
  "#3c2d2b",
  "#c4a996",
  "#dac2ae",
  "#ddbe9f",
  "#f8f7e8",
  "#d4b595",
  "#d9b091",
  "#d3a482",
  "#cb9976",
  "#a3673e",
  "#b87450",
  "#c37540",
  "#965a3a",
  "#804f31",
  "#c5a38c",
  "#efded2",
  "#f8ede3",
  "#e8d9d4",
  "#dbccc2",
  "#a06e68",
  "#7c3e2e",
  "#ab543f",
  "#b25c50",
  "#8a2728",
  "#8b383e",
  "#eeecdb",
  "#763637",
  "#f4e9ce",
  "#f2e7cf",
  "#f2debc",
  "#eddbbd",
  "#eed7b2",
  "#fce9bd",
  "#ead2a8",
  "#cfba92",
  "#d8ba87",
  "#efecdf",
  "#b99257",
  "#af8255",
  "#c49f78",
  "#d9c79a",
  "#c8ab6e",
  "#bba577",
  "#c2b393",
  "#cdbd95",
  "#c3b79d",
  "#aba38c",
  "#f5ecdc",
  "#b1ac8d",
  "#a1a07e",
  "#b4ae8e",
  "#c5c397",
  "#aca96e",
  "#c7b679",
  "#b4a85c",
  "#d5d3b8",
  "#979c78",
  "#f1eadc",
  "#a3b692",
  "#b2b69f",
  "#858a74",
  "#c7cab6",
  "#a3ac9e",
  "#738071",
  "#535f4e",
  "#c9d4c8",
  "#bbc3bb",
  "#89a098",
  "#eef1eb",
  "#e5e0d5",
  "#889d9a",
  "#6e888d",
  "#3d615e",
  "#9fb8c1",
  "#527687",
  "#4e7f92",
  "#3a647d",
  "#abc1cc",
  "#d5e1e3",
  "#a3aeb4",
  "#81949d",
  "#718087",
  "#565c5e",
  "#454b54",
  "#919da8",
  "#bac5d0",
  "#747d92",
  "#9c9ca6",
  "#7a767e",
  "#ac9eaa",
  "#e5dbce",
  "#958896",
  "#d6d2d5",
  "#ccb9b5",
  "#c4b7bb",
  "#b4a9af",
  "#94717d",
  "#6f505f",
  "#7c6a73",
  "#796c6f",
  "#56464e",
  "#e3ddce",
  "#453133",
  "#57504c",
  "#827d7b",
  "#d4cecb",
  "#b6b4b2",
  "#a5a2a0",
  "#cfcac2",
  "#bdb8ad",
  "#babdb8",
  "#bec2c2",
  "#e9e5d0",
  "#868583",
  "#888983",
  "#85837d",
  "#837c6e",
  "#dedfcd",
  "#d9d2be",
  "#e7dbc3",
  "#ddccb1",
  "#d4c9af",
  "#eceeec",
  "#f6f0e1",
  "#e1d6c1",
  "#cfba9c",
  "#8e5049",
  "#8e3f30",
  "#a5594e",
  "#b36957",
  "#f2efdf",
  "#e9ddc5",
  "#d3c09d",
  "#7e4a46",
  "#c18573",
  "#e6bdac",
  "#f2dacc",
  "#f5eed8",
  "#f1e4c4",
  "#edd7a4",
  "#bc8b6e",
  "#c18872",
  "#dcaa86",
  "#f0c9a1",
  "#eedfb7",
  "#583835",
  "#ebedea",
  "#e8d3a1",
  "#e1c28b",
  "#f9d795",
  "#fae1a0",
  "#fbebc1",
  "#fdeeb2",
  "#ede5ce",
  "#ddd3b7",
  "#cab88c",
  "#e5c48b",
  "#eacfa0",
  "#e3d9bb",
  "#e5d7b9",
  "#e2dbc2",
  "#d5c8a6",
  "#c1b697",
  "#9c6e49",
  "#caa472",
  "#dabd98",
  "#ead2b1",
  "#e7dbbb",
  "#d9c9a1",
  "#f0f1ea",
  "#ceb985",
  "#b99978",
  "#c9ac86",
  "#e2d2b3",
  "#dcccb3",
  "#ded0c0",
  "#693541",
  "#cfbca4",
  "#bca68c",
  "#a98e69",
  "#b0987a",
  "#b8a183",
  "#c9b394",
  "#5a3646",
  "#e8dcc8",
  "#e3c3a6",
  "#4f3b50",
  "#b98766",
  "#a58d72",
  "#b49f8b",
  "#c9af98",
  "#d7c2ad",
  "#e1cfb5",
  "#6f6578",
  "#d2ab88",
  "#9c6040",
  "#b49c8d",
  "#c3b8ae",
  "#cabdaf",
  "#cab9a8",
  "#5d4c54",
  "#f2f1e6",
  "#ead4b0",
  "#d5b387",
  "#b88d60",
  "#ccb9ad",
  "#d3c4ba",
  "#dcd3ca",
  "#e7ddcf",
  "#dfceb3",
  "#c0a787",
  "#997c57",
  "#9e8c7c",
  "#b7a99c",
  "#c9beaf",
  "#d3c9bd",
  "#cdc4b5",
  "#b7aa9a",
  "#9f8e7c",
  "#725748",
  "#86604f",
  "#b4967a",
  "#c8ac8e",
  "#c4baaa",
  "#ebe6d7",
  "#ada290",
  "#84735e",
  "#65594a",
  "#9d8774",
  "#968777",
  "#a29d96",
  "#cac4b0",
  "#afa58f",
  "#857a68",
  "#564e48",
  "#696867",
  "#8b847c",
  "#7f7d77",
  "#b6b8a5",
  "#9a9c87",
  "#626451",
  "#8b8274",
  "#8e816a",
  "#9e9079",
  "#d1c5a8",
  "#d6dabf",
  "#afb288",
  "#a2898b",
  "#e2d4c2",
  "#7b8068",
  "#a39f87",
  "#ab9e88",
  "#c5c3ae",
  "#e2e7dc",
  "#c9d0bf",
  "#783934",
  "#8c9985",
  "#586251",
  "#999275",
  "#aea98f",
  "#c4c2b0",
  "#dbd6a7",
  "#9f3e3e",
  "#c2d1c6",
  "#90a393",
  "#9c2e3b",
  "#5a7169",
  "#59523c",
  "#696753",
  "#606241",
  "#969a72",
  "#bfc6bb",
  "#a63841",
  "#a7b3aa",
  "#9da8a1",
  "#42483e",
  "#858367",
  "#95917f",
  "#b8b8a1",
  "#eceae0",
  "#c7cfc8",
  "#a3b0ae",
  "#7a847f",
  "#878872",
  "#939880",
  "#a5aa92",
  "#bbc6b7",
  "#b0c9d0",
  "#7f9dac",
  "#6b8895",
  "#30484a",
  "#4e6c6b",
  "#6f8f8e",
  "#9cac9e",
  "#a0bece",
  "#85a0b6",
  "#4b5a71",
  "#537284",
  "#83b8d0",
  "#97c3df",
  "#bcd4dd",
  "#cbdde2",
  "#bfa4a0",
  "#e3dfd2",
  "#63879f",
  "#3f5266",
  "#81a5c0",
  "#9ab4c7",
  "#b1bfc7",
  "#9bb1bb",
  "#b4c5d7",
  "#7685a1",
  "#5c6a85",
  "#10557d",
  "#40729c",
  "#5e8fb6",
  "#aed3e5",
  "#bacbdf",
  "#5b6d92",
  "#414a62",
  "#304c89",
  "#3862a3",
  "#6b8db3",
  "#a1bfd5",
  "#c9d0d8",
  "#93a0bd",
  "#d7cdb7",
  "#5c6274",
  "#5c79b3",
  "#8dadd9",
  "#9db2d0",
  "#a5b7cd",
  "#dee2e3",
  "#984841",
  "#a0a6b6",
  "#6e7182",
  "#2b3b4c",
  "#747d92",
  "#93a6be",
  "#c7d5e4",
  "#a64c43",
  "#acb3ca",
  "#7c819d",
  "#b86d52",
  "#696d86",
  "#3f4150",
  "#353963",
  "#40466d",
  "#3f457d",
  "#a6a6bd",
  "#bd6448",
  "#827f92",
  "#514c5a",
  "#999492",
  "#bbb6a9",
  "#c9bc96",
  "#bca87a",
  "#e2d0ac",
  "#cdbc96",
  "#b59f7c",
  "#efecd9",
  "#ded6bf",
  "#cac0a6",
  "#aa9d81",
  "#95836a",
  "#b1ada2",
  "#6c5d4a",
  "#f0e6d2",
  "#e3ceac",
  "#d6b28d",
  "#cc986b",
  "#ab7141",
  "#8b5c2b",
  "#e9caa6",
  "#daae85",
  "#bd8057",
  "#a09e97",
  "#bd713b",
  "#a55527",
  "#d17225",
  "#d1806d",
  "#b26b5d",
  "#905444",
  "#d69679",
  "#bd7a64",
  "#a95844",
  "#bf3f2d",
  "#827e78",
  "#ab3f30",
  "#a93434",
  "#be6f67",
  "#944544",
  "#773935",
  "#de8480",
  "#c86361",
  "#b0625c",
  "#b44d51",
  "#a02432",
  "#6a6967",
  "#9f233d",
  "#e1e0d1",
  "#cac7b4",
  "#968c76",
  "#aaa393",
  "#8e897c",
  "#6c6b6d",
  "#726e67",
  "#d5cfbf",
  "#bcb5a1",
  "#a39a88",
  "#c5bead",
  "#b2ab99",
  "#827b6d",
  "#e5e0d0",
  "#b1a591",
  "#867a6d",
  "#929392",
  "#aea497",
  "#938a7c",
  "#53473a",
  "#e8e0ce",
  "#d5cbb8",
  "#bfb5a3",
  "#b5a290",
  "#857567",
  "#4e433d",
  "#efeadb",
  "#848181",
  "#dfd3bd",
  "#b4a388",
  "#94836e",
  "#7f6c57",
  "#634f42",
  "#ded0b9",
  "#cbb79c",
  "#c6a883",
  "#a27f5d",
  "#886348",
  "#3b3230",
  "#6b4e3e",
  "#f9f6e7",
  "#e8decf",
  "#cec0ae",
  "#b99b82",
  "#906251",
  "#744634",
  "#eae1d0",
  "#ddccbd",
  "#d1b9a9",
  "#d4d0c3",
  "#b59c8d",
  "#8a6e62",
  "#5e3b2f",
  "#e3dfd5",
  "#d5d0c7",
  "#b5a99d",
  "#9f8e84",
  "#877e78",
  "#54423b",
  "#e3ded0",
  "#b0aca3",
  "#d5cbbe",
  "#c5b7ac",
  "#bba8a3",
  "#917876",
  "#6d5854",
  "#d6bbbb",
  "#ab696e",
  "#83434f",
  "#9e3f62",
  "#693a3c",
  "#848480",
  "#582f2f",
  "#8d8fa1",
  "#6f6177",
  "#4d3354",
  "#602e4e",
  "#6b5e6b",
  "#382930",
  "#e8e9e1",
  "#d6d2cd",
  "#c0bcbc",
  "#cbcdca",
  "#929591",
  "#d5d5d0",
  "#91898b",
  "#5f5960",
  "#cfd4d7",
  "#8ea3c5",
  "#53618f",
  "#8690a4",
  "#4b4a5c",
  "#403c3f",
  "#d0dde5",
  "#717571",
  "#9ab2c5",
  "#5f8ec2",
  "#4e719a",
  "#445772",
  "#404343",
  "#dcded8",
  "#c3c7c5",
  "#a8afb0",
  "#c9ced1",
  "#a2b0b7",
  "#626463",
  "#586471",
  "#8ca4ad",
  "#b7ced4",
  "#98c0cf",
  "#798e99",
  "#525a60",
  "#33383e",
  "#5ea3b1",
  "#3b98a2",
  "#26768e",
  "#c4baab",
  "#83a0ad",
  "#386b8c",
  "#004763",
  "#cbd3cc",
  "#9bafb1",
  "#82a1a7",
  "#56858c",
  "#44646d",
  "#023b4e",
  "#a7c7bc",
  "#afa79b",
  "#7eb6ac",
  "#759f9a",
  "#597d7d",
  "#496e73",
  "#1e4850",
  "#e8e6de",
  "#bbc3bb",
  "#919e97",
  "#b7c6be",
  "#8a9f9b",
  "#908980",
  "#707c79",
  "#cecec0",
  "#9fa194",
  "#767769",
  "#c2c8b8",
  "#a9b5a5",
  "#8a9e88",
  "#dbdfcc",
  "#c8d0b7",
  "#acae92",
  "#9d968c",
  "#87917a",
  "#697562",
  "#485241",
  "#dad9bc",
  "#c2be9f",
  "#949476",
  "#c8cb9f",
  "#b5b895",
  "#9ba375",
  "#e0dba9",
  "#878279",
  "#cfcb8c",
  "#bcb878",
  "#d1d256",
  "#b0bd4d",
  "#8dad61",
  "#ede9c9",
  "#d6d099",
  "#c9bf80",
  "#bab761",
  "#857d43",
  "#6a635d",
  "#5a5538",
  "#f2e7bd",
  "#f0dfa5",
  "#e1ca90",
  "#d6bd6f",
  "#bca346",
  "#957e37",
  "#efe8ca",
  "#f8e4b2",
  "#ecd093",
  "#d4cfc3",
  "#efd99a",
  "#e5c269",
  "#bb901e",
  "#efe6cb",
  "#dbc295",
  "#d5b781",
  "#bb9d61",
  "#987e55",
  "#866f4b",
  "#e9e0c0",
  "#f5f2e5",
  "#e8e1cc",
  "#eae0c4",
  "#f7ebcd",
  "#e2d3b3",
  "#d5c3a2",
  "#b8a387",
  "#b5a083",
  "#8e7559",
  "#d8cdb9",
  "#c8bca7",
  "#eeebd8",
  "#8a7a66",
  "#918578",
  "#695a4c",
  "#50382d",
  "#493830",
  "#4a403e",
  "#352d2b",
  "#ead6b8",
  "#ccaf92",
  "#a78668",
  "#e8e3cb",
  "#f1e7d4",
  "#e7ccb8",
  "#cea589",
  "#de9c8d",
  "#c58e79",
  "#c08e7f",
  "#c07060",
  "#a56559",
  "#906558",
  "#8f514c",
  "#d2c7a8",
  "#713128",
  "#783c36",
  "#6f4539",
  "#693d2d",
  "#64413d",
  "#f8e9c7",
  "#f2cd8f",
  "#e6b271",
  "#bd7d48",
  "#c87148",
  "#c5bca2",
  "#df745d",
  "#cc7469",
  "#af5c4a",
  "#bd4638",
  "#ab4830",
  "#985949",
  "#9e3f31",
  "#a6443d",
  "#ad433f",
  "#9f4552",
  "#9d9072",
  "#8c5059",
  "#734450",
  "#8e7f79",
  "#e4ca9f",
  "#e1c491",
  "#d6ae73",
  "#c79555",
  "#c29b63",
  "#b28a59",
  "#efd596",
  "#918a75",
  "#e8cd83",
  "#ddb558",
  "#efe5ba",
  "#dfce9d",
  "#d4bc7f",
  "#bb9951",
  "#b79f6d",
  "#ad9567",
  "#dad4b2",
  "#c1b88c",
  "#d2cbb9",
  "#a6a56c",
  "#e7e5bd",
  "#d3cf8f",
  "#b2b26a",
  "#6e743a",
  "#5f5d39",
  "#a7a787",
  "#babd99",
  "#c8ccad",
  "#a2ab87",
  "#edefe7",
  "#c5bead",
  "#75806a",
  "#484f32",
  "#363a32",
  "#a3b692",
  "#768c6e",
  "#597e5f",
  "#3e4f33",
  "#265d41",
  "#50996e",
  "#6e9486",
  "#b4ac99",
  "#2e8b7e",
  "#435851",
  "#bed6cd",
  "#96bfb8",
  "#558787",
  "#3d5459",
  "#6f8486",
  "#d0e2e0",
  "#7e9ea0",
  "#94c0c6",
  "#a29886",
  "#69a2ab",
  "#5d9fb6",
  "#6ca6c4",
  "#3c829f",
  "#4580a8",
  "#325a7d",
  "#304656",
  "#ced6d0",
  "#a7b0a9",
  "#768483",
  "#858374",
  "#c6d0d2",
  "#acc7d4",
  "#81929b",
  "#5a656c",
  "#517c8e",
  "#414f57",
  "#373839",
  "#57595a",
  "#5e6363",
  "#7e8181",
  "#847a67",
  "#a3a8a8",
  "#909698",
  "#d5d1c7",
  "#b9b8ae",
  "#7f807a",
  "#847d6f",
  "#827c6f",
  "#58584e",
  "#524f44",
  "#eae3d2",
  "#f2eddf",
  "#e2aa5f",
  "#82423a",
  "#674142",
  "#76403f",
  "#874b35",
  "#bd7d40",
  "#a9b5bc",
  "#e89b49",
  "#adb5a2",
  "#a27650",
  "#a2947f",
  "#5c463f",
  "#4a4442",
  "#9b6f40",
  "#4f423b",
  "#e5cba8",
  "#7f8786",
  "#d4cab9",
  "#dad3a1",
  "#deb866",
  "#7b7665",
  "#908972",
  "#b2a990",
  "#7f7766",
  "#918a78",
  "#a8a295",
  "#867f69",
  "#9a9684",
  "#aea897",
  "#807c64",
  "#e1c478",
  "#8f8d71",
  "#afab93",
  "#818066",
  "#9c9e87",
  "#b1b7a2",
  "#b9b790",
  "#cbcdae",
  "#d4dabf",
  "#a9b595",
  "#bfcbad",
  "#e7cd8d",
  "#cad7c0",
  "#586a54",
  "#798064",
  "#919d82",
  "#627067",
  "#687666",
  "#737f6a",
  "#638469",
  "#759a80",
  "#87ab93",
  "#b89c5b",
  "#64806c",
  "#75957d",
  "#8aab98",
  "#465a5d",
  "#415752",
  "#486055",
  "#6c9187",
  "#7da19a",
  "#93b5ac",
  "#b0baa4",
  "#c2aa6c",
  "#bec9b7",
  "#ccd4c4",
  "#93a9a0",
  "#aabeb4",
  "#c1d1c9",
  "#86989e",
  "#acbfbd",
  "#c1d0ca",
  "#82a0a6",
  "#9db6ba",
  "#cbba84",
  "#b5c8c9",
  "#618697",
  "#769eb0",
  "#95b9c6",
  "#465566",
  "#485b6e",
  "#435155",
  "#445962",
  "#627885",
  "#a08b5f",
  "#5e6c6c",
  "#778686",
  "#8a9696",
  "#7f867f",
  "#979f9b",
  "#aab2b0",
  "#757670",
  "#b8bab6",
  "#c1a873",
  "#cacbc5",
  "#d4d8d2",
  "#d9d3c4",
  "#e6e1cb",
  "#a09889",
  "#c9beaf",
  "#d9c6a6",
  "#646769",
  "#a8a9a3",
  "#daca9c",
  "#ccd0ca",
  "#990a14",
  "#69181a",
  "#762c23",
  "#662a25",
  "#4f3a30",
  "#745239",
  "#242e2c",
  "#27362e",
  "#0b412e",
  "#95805d",
  "#5f767f",
  "#e5dbab",
  "#a38f6a",
  "#baa887",
  "#bca470",
  "#c0b08c",
  "#ddcca7",
  "#bfae8c",
  "#dacaaa",
  "#e9e5d0",
  "#cbb58d",
  "#decea6",
  "#ece4c4",
  "#edddb7",
  "#ebdbb9",
  "#f4e2c0",
  "#ccb084",
  "#decca7",
  "#f3e5c3",
  "#a7885b",
  "#c1a77d",
  "#dac9ab",
  "#f5e1a4",
  "#9b7149",
  "#b79163",
  "#caa378",
  "#b1966f",
  "#c2ae8e",
  "#d1c2a7",
  "#aa896a",
  "#c0a689",
  "#d1bda4",
  "#9e624d",
  "#f2e5ba",
  "#985949",
  "#ae6b55",
  "#e7b388",
  "#f1caa7",
  "#f1d5b7",
  "#cda990",
  "#dfc1ab",
  "#d6b3a3",
  "#e2c8ba",
  "#f5e9c7",
  "#f1d9c6",
  "#754b4e",
  "#9a6d6b",
  "#d0ae9f",
  "#634543",
  "#774d4a",
  "#8c5956",
  "#65554a",
  "#69594d",
  "#7b6c5d",
  "#d5a65f",
  "#5f4f46",
  "#654c43",
  "#60514a",
  "#7f664e",
  "#927254",
  "#9d7756",
  "#8a7764",
  "#a3927c",
  "#d5cabb",
  "#bbab8e",
  "#ddb673",
  "#cdc0a8",
  "#dbd2bc",
  "#c2b59a",
  "#cec5b0",
  "#dbd3c3",
  "#7c7161",
  "#948674",
  "#978466",
  "#ac9c7c",
  "#ddbf86",
  "#cec3a4",
  "#bbab88",
  "#cebea0",
  "#a49a79",
  "#b8ae95",
  "#cec7aa",
  "#968d70",
  "#aca182",
  "#d6ceb1",
  "#e7deca",
  "#e0d8c6",
  "#eae0c8",
  "#f6ead2",
  "#f9ebd2",
  "#f7ecd3",
  "#f6e8c9",
  "#f5eed8",
  "#f5edcd",
  "#f8eecc",
  "#f3e7be",
  "#f6f3dd",
  "#d9cfbb",
  "#fbf6dd",
  "#f6eaca",
  "#f6e9c4",
  "#f5f2e1",
  "#faf8e0",
  "#f2f1d7",
  "#f2ebcd",
  "#f6f6ed",
  "#f6f7ee",
  "#eeefe5",
  "#e1d6c1",
  "#ece9d8",
  "#f7f5eb",
  "#f5f6eb",
  "#f7f7e7",
  "#f4f4e3",
  "#efeee3",
  "#f7f4e2",
  "#f5f3e3",
  "#f0f0df",
  "#f2efe8",
  "#e8e5d8",
  "#f2f1e6",
  "#ebe6d7",
  "#e9e5d0",
  "#eeecdb",
  "#eaead8",
  "#e5e5d2",
  "#e6e4cf",
  "#e7e7dd",
  "#e3e2d5",
  "#e1dfcf",
  "#dad5c6",
  "#dddccd",
  "#e7e4d9",
  "#e4dece",
  "#e7deca",
  "#e6e1cc",
  "#f2efe8",
  "#f2ebda",
  "#f2e7cf",
  "#f4e2c0",
  "#ebedea",
  "#d9d3c4",
  "#ebeee9",
  "#edeeeb",
  "#f1f2ee",
  "#d7cebf",
  "#e9e6db",
  "#e7e4d9",
  "#e7dbc3",
  "#e7e9e2",
  "#e6e4df",
  "#e3e0d7",
  "#dfdbcd",
  "#e9e8e0",
  "#dad6cc",
  "#d3cec4",
  "#edebdd",
  "#e8dcc8",
  "#e3dfd2",
  "#e2ddd0",
  "#dbd7c5",
  "#ede8d5",
  "#f0ebd7",
  "#ebe6d2",
  "#eae4cd",
  "#eceae0",
  "#f2efdf",
  "#f2eedd",
  "#e2d4c2",
  "#ebe3cf",
  "#e5e3d4",
  "#e2e0d1",
  "#dedbc7",
  "#e3dec7",
  "#e0ded1",
  "#dbd8c9",
  "#cecbba",
  "#dadbcf",
  "#e5dece",
  "#e0ded0",
  "#e0dfd7",
  "#d3d4cc",
  "#dfe1db",
  "#e6e8e1",
  "#e0e2dc",
  "#d6d8cf",
  "#f0f1ea",
  "#eaeee9",
  "#ecece3",
  "#e6e0cf",
  "#edede3",
  "#ecefec",
  "#eaece8",
  "#eceeea",
  "#e5e7e4",
  "#f1f5f1",
  "#f1f4f1",
  "#f2f4f1",
  "#f5f2ed",
  "#e3dcc8",
  "#f4efea",
  "#f0ebe4",
  "#f6f0e7",
  "#f6ecdf",
  "#f2e3d0",
  "#f0e2d2",
  "#e8d7c6",
  "#f7ebda",
  "#f7e7d4",
  "#f5e3cc",
  "#e4dcc4",
  "#f5e0c8",
  "#f3e6d3",
  "#f5ead6",
  "#f2e5d3",
  "#f0e0c9",
  "#f9f5e5",
  "#f6f0e1",
  "#f3e8d4",
  "#ede4d0",
  "#f8f1e1",
  "#e5e0d0",
  "#faf3e0",
  "#f8f1dd",
  "#f7ecd2",
  "#f9f2e0",
  "#f7efdc",
  "#eee7d5",
  "#e9ddc5",
  "#faf3e3",
  "#f7eedb",
  "#efe5d0",
  "#f1f2ee",
  "#27362e",
  "#27362e",
  "#242e2c",
  "#f2efe8",
  "#c9beaf",
  "#662a25",
  "#762c23",
  "#69181a",
  "#990a14",
  "#efeee5",
  "#edeeeb",
  "#e7e4d9",
  "#e4dece",
  "#f2e5d3",
  "#745239",
  "#4f3a30",
  "#f2e7cf",
  "#f4e2c0",
  "#d9c6a6",
  "#f2ebda",
  "#eee7d5",
  "#ebedea",
  "#e7deca",
  "#e6e1cc",
  "#a09889",
  "#ebeee9",
  "#ccd0ca",
  "#5f767f",
  "#a8a9a3",
  "#646769",
  "#2b2c2d",
  "#eee8dd",
  "#e9e5d8",
  "#f1ebe1",
  "#f0ebe1",
  "#f3ebdc",
  "#f4eedf",
  "#f3ecd9",
  "#f1ead8",
  "#eee4cf",
  "#f6f4ea",
  "#f4efe3",
  "#f1e7cc",
  "#efe7d3",
  "#f7f2e1",
  "#f7f0df",
  "#e3e0d7",
  "#e4e0d6",
  "#e1e2dd",
  "#dfdeda",
  "#ecf0e9",
  "#e9e7dd",
  "#dbd4c8",
  "#e7e3d9",
  "#e1e0d6",
  "#e5e2da",
  "#d7d7cd",
  "#e2dfd3",
  "#e8e9e1",
  "#f4e0cf",
  "#efd1bf",
  "#e8c4af",
  "#d9ac97",
  "#c99780",
  "#bc8069",
  "#a36952",
  "#f3e2d7",
  "#f1d8cd",
  "#e6c4b6",
  "#dcb2a2",
  "#c99d91",
  "#a57160",
  "#835246",
  "#f2d2c3",
  "#e6baa9",
  "#d7a697",
  "#cb9686",
  "#b47865",
  "#a76a58",
  "#8d5644",
  "#f7e8df",
  "#f7d7cd",
  "#f2beb4",
  "#d1867e",
  "#b86d64",
  "#8f584e",
  "#8c4944",
  "#eebebb",
  "#d79a99",
  "#c48281",
  "#b76d69",
  "#ae6660",
  "#924145",
  "#914849",
  "#f7dfd8",
  "#e6c6c3",
  "#dfbab7",
  "#d0a4a3",
  "#bb8a8a",
  "#9f6c69",
  "#7f534b",
  "#f7e7e4",
  "#e5c9c9",
  "#ddb9bd",
  "#caa1a6",
  "#bf8e92",
  "#99686b",
  "#784f4b",
  "#f2d6d6",
  "#ebcbce",
  "#e4bdc2",
  "#d7a5ad",
  "#c48a96",
  "#a76c76",
  "#824f52",
  "#eabcbf",
  "#d7a9b0",
  "#c89499",
  "#b07579",
  "#a66a6c",
  "#88585a",
  "#7c464a",
  "#f2e1de",
  "#e1c4c6",
  "#be9ca4",
  "#a68088",
  "#8e666a",
  "#7c484b",
  "#6d4643",
  "#dbbac1",
  "#d4b0b7",
  "#c49ea8",
  "#ae828d",
  "#93656b",
  "#7f4e59",
  "#67454a",
  "#ebc9ce",
  "#e3b9c0",
  "#cfa6b0",
  "#b78996",
  "#9f6f78",
  "#784552",
  "#7f444f",
  "#f0d7d2",
  "#e3c0bc",
  "#c99c99",
  "#aa756f",
  "#8b564f",
  "#865045",
  "#814d42",
  "#ede1d8",
  "#e1cbc3",
  "#d6bcb4",
  "#c1a199",
  "#ab8a82",
  "#926e64",
  "#76554a",
  "#eaddd4",
  "#dac4ba",
  "#baa198",
  "#a88f85",
  "#9a7e73",
  "#83675b",
  "#6b5145",
  "#d9c9c0",
  "#cdbcb4",
  "#b8a39a",
  "#a69086",
  "#7f6a60",
  "#6b584f",
  "#524641",
  "#eedfd5",
  "#e7d6cc",
  "#d2bbae",
  "#c8ab9b",
  "#b39383",
  "#977464",
  "#77584b",
  "#ecd9c6",
  "#e3cdb8",
  "#dcc2a9",
  "#cca88c",
  "#b58e73",
  "#a4785b",
  "#89644c",
  "#efe0d0",
  "#e8d0b9",
  "#dec0a8",
  "#cbae97",
  "#b0927a",
  "#a48268",
  "#98765b",
  "#f5e5d1",
  "#e5d0b8",
  "#dbc1a7",
  "#d0b092",
  "#bd9876",
  "#a17a5a",
  "#8a674c",
  "#e9ddcc",
  "#e1d1bc",
  "#c1ac92",
  "#b19a80",
  "#9f8468",
  "#8e755b",
  "#83684e",
  "#ebe0d3",
  "#dfd2c2",
  "#d8cab8",
  "#cabca9",
  "#baa893",
  "#8e7760",
  "#715f4e",
  "#ede2d4",
  "#ccbdad",
  "#bdad9a",
  "#907b68",
  "#776353",
  "#776350",
  "#dad3c8",
  "#cfc7b9",
  "#c1b8aa",
  "#aa9f8f",
  "#ebe8dc",
  "#ded6c9",
  "#d0c9bb",
  "#b9b0a3",
  "#a9a092",
  "#867c6c",
  "#675f53",
  "#ebe7dd",
  "#ddd6cd",
  "#cec8be",
  "#aa9f91",
  "#83796c",
  "#e6dfd3",
  "#ddd5c7",
  "#d0c7b7",
  "#aaa195",
  "#857b6d",
  "#746a5c",
  "#62584c",
  "#e4e0ce",
  "#e2dbc9",
  "#d8d0bc",
  "#c0b6a0",
  "#b1a793",
  "#8e826e",
  "#6e6352",
  "#e3ded3",
  "#d1cabc",
  "#c2bbac",
  "#aea391",
  "#8b7e6a",
  "#6c6150",
  "#e8d5bb",
  "#e1c9ac",
  "#d4b799",
  "#bea182",
  "#af8f6d",
  "#a07e5d",
  "#90704f",
  "#ead1ae",
  "#e3c59e",
  "#d3b188",
  "#caa577",
  "#bb9163",
  "#b68c63",
  "#aa815a",
  "#f4e7d0",
  "#efd8ba",
  "#e2c8a6",
  "#dec19c",
  "#d6b68b",
  "#c59e6f",
  "#a77c50",
  "#eadabf",
  "#e3cfb0",
  "#d2bc9f",
  "#bda281",
  "#b19671",
  "#a18560",
  "#90724e",
  "#e5d6bd",
  "#dfccad",
  "#d2bd9c",
  "#bfa57f",
  "#a98960",
  "#8f714a",
  "#856a4b",
  "#e9dfd0",
  "#ddd2be",
  "#d8ccb7",
  "#d1bea0",
  "#bba787",
  "#a58e6c",
  "#8a7454",
  "#e1d4bd",
  "#c6b698",
  "#bead8d",
  "#b6a17c",
  "#a28d69",
  "#7a6848",
  "#f0e6d4",
  "#e9dcc6",
  "#dfceb3",
  "#dcc9a5",
  "#c9b28d",
  "#a58d66",
  "#907855",
  "#f2ead7",
  "#e8d8bd",
  "#e1d0b2",
  "#d6c4a2",
  "#c9b38d",
  "#b29c75",
  "#8e764e",
  "#f2e9d6",
  "#eee3cb",
  "#e1d2b2",
  "#bba783",
  "#b29c73",
  "#a08a63",
  "#846f4b",
  "#f2ead6",
  "#f0e4ca",
  "#e0cfa8",
  "#cebc96",
  "#bba87e",
  "#af986b",
  "#907a50",
  "#ebe0c8",
  "#e4d8bd",
  "#dccdae",
  "#d6c7a3",
  "#c4b18a",
  "#ad976c",
  "#8c7952",
  "#ede5d1",
  "#e2d6b8",
  "#d9cca9",
  "#bbab82",
  "#ae9b6f",
  "#928159",
  "#82724e",
  "#ede3d0",
  "#dfd5ba",
  "#d6c9aa",
  "#cec19f",
  "#c1b58f",
  "#9f916b",
  "#7d704f",
  "#e6dfcf",
  "#e1d6c3",
  "#c5bba9",
  "#aea38e",
  "#a1937a",
  "#92856c",
  "#655a48",
  "#e6e1ce",
  "#d6ceba",
  "#cec6b1",
  "#c7bea5",
  "#b6ac91",
  "#978a6c",
  "#706750",
  "#dcd6c1",
  "#d0c8b1",
  "#c3baa2",
  "#a99d82",
  "#958c71",
  "#7e7254",
  "#786f51",
  "#edeade",
  "#dedccd",
  "#c8c2ac",
  "#a39a7a",
  "#8e8363",
  "#786f52",
  "#eee9da",
  "#e1dac5",
  "#cfc7ab",
  "#a3997b",
  "#938865",
  "#837a5b",
  "#7a7050",
  "#dcdacd",
  "#cac7b7",
  "#aea994",
  "#938f77",
  "#74705a",
  "#6a654b",
  "#e9e4d4",
  "#d3ceb8",
  "#c9c3ab",
  "#a29e87",
  "#918c72",
  "#847e64",
  "#756c4e",
  "#eee7cf",
  "#ece4ca",
  "#ddd2ac",
  "#d0c497",
  "#bcaf7a",
  "#afa16b",
  "#7c7147",
  "#eeead7",
  "#e7dfc2",
  "#ded6b3",
  "#cdc4a0",
  "#beb58c",
  "#b2a775",
  "#7e7546",
  "#edebd5",
  "#dfdab6",
  "#d3cda3",
  "#c4bd92",
  "#b2aa7c",
  "#99915f",
  "#877e4e",
  "#e4e5d0",
  "#dbddc4",
  "#d0d3b6",
  "#c2c5a4",
  "#b6b993",
  "#949569",
  "#6e6f4d",
  "#f3f2e9",
  "#eeede1",
  "#dfdfd1",
  "#c6c8b1",
  "#a1a282",
  "#858665",
  "#686b4b",
  "#ebe8dd",
  "#dad7c9",
  "#c4c0b0",
  "#aaab9e",
  "#97998b",
  "#707061",
  "#605e50",
  "#e1e2d2",
  "#d5d8c8",
  "#bbc3ad",
  "#959c81",
  "#7e856a",
  "#5f634f",
  "#4f5245",
  "#ededdf",
  "#d9decc",
  "#c2cbb3",
  "#878f77",
  "#767f67",
  "#616650",
  "#e2e5de",
  "#ced2cb",
  "#aeb5ad",
  "#666559",
  "#5d594d",
  "#575146",
  "#e9ece5",
  "#d9dcd6",
  "#bec4be",
  "#9ca299",
  "#737367",
  "#5e5c50",
  "#514d41",
  "#d6dcd1",
  "#ccd4c9",
  "#a9b6a8",
  "#97a697",
  "#758374",
  "#576256",
  "#dcdfd6",
  "#ced6cd",
  "#bec9bf",
  "#a8b5ac",
  "#6d7e75",
  "#525a53",
  "#e6eae3",
  "#d9e3dd",
  "#c1d3cd",
  "#afc3bf",
  "#3c5052",
  "#d6ddd5",
  "#cad2cd",
  "#bbc6bf",
  "#aeb8b3",
  "#929e9a",
  "#6e7673",
  "#59615e",
  "#dbe4dc",
  "#c9d6d1",
  "#b2c3c2",
  "#9eb1b0",
  "#899f9f",
  "#c5cecb",
  "#b9c5c2",
  "#707e7d",
  "#626f70",
  "#c1d2d1",
  "#96aeb2",
  "#60757a",
  "#485559",
  "#d7dcdd",
  "#bec9ce",
  "#a0b2bc",
  "#8e9ca7",
  "#768691",
  "#525356",
  "#e2e3e0",
  "#939ba4",
  "#6f767d",
  "#dddcdb",
  "#d1d0d1",
  "#b9b9be",
  "#a1a5ad",
  "#7f848f",
  "#71737c",
  "#48474b",
  "#cccecd",
  "#9da3a7",
  "#c9c8c4",
  "#b9b8b5",
  "#a2a3a2",
  "#848586",
  "#636463",
  "#4f4e4c",
  "#e1dfd9",
  "#d7d3ce",
  "#a0a09f",
  "#4c4946",
  "#e2dcd6",
  "#d9d6d3",
  "#b1aeae",
  "#9f9c9c",
  "#7a7473",
  "#655a56",
  "#cbc6c3",
  "#beb8b6",
  "#b5afab",
  "#9c9898",
  "#807c7d",
  "#67615f",
  "#524b48",
  "#ddd6cb",
  "#b0a89e",
  "#857e74",
  "#645b4e",
  "#cfc7bd",
  "#c6beb2",
  "#a7a198",
  "#867f73",
  "#756d63",
  "#5a554a",
  "#c2bcb0",
  "#8b8981",
  "#7a776c",
  "#737065",
  "#565148",
  "#c4c5bc",
  "#73766f",
  "#dde2e6",
  "#c4d1e0",
  "#aabbd3",
  "#8196b4",
  "#677b9b",
  "#617696",
  "#49536b",
  "#c6d3e5",
  "#b3c6e0",
  "#a7bcdc",
  "#99afd2",
  "#7c98c3",
  "#607cab",
  "#dbe3ec",
  "#c6d5ea",
  "#aac0e3",
  "#98aedb",
  "#5874b4",
  "#43487d",
  "#d5e1ed",
  "#bdd2ea",
  "#a0bde4",
  "#8faedc",
  "#7296cf",
  "#547dbd",
  "#41518e",
  "#c8d8e4",
  "#b6cbde",
  "#a1bdd7",
  "#87a4c0",
  "#7192b4",
  "#4f6e90",
  "#414b61",
  "#d3dddf",
  "#c7d3da",
  "#b7c8d3",
  "#9eb0c0",
  "#8b9eb3",
  "#64768b",
  "#4f5b6e",
  "#dee3e0",
  "#c8d4d8",
  "#b5c6cf",
  "#99afbc",
  "#859dad",
  "#4b5c6a",
  "#e1ebea",
  "#c6deec",
  "#aacfeb",
  "#8dbfe6",
  "#6ea7db",
  "#387ec2",
  "#335392",
  "#ccdce1",
  "#bcd2dd",
  "#adc6d6",
  "#91b3ce",
  "#7ba0c1",
  "#557ea2",
  "#425e79",
  "#d9e3e2",
  "#bfd7e1",
  "#adcedd",
  "#92bad1",
  "#73a3c2",
  "#4a7fa0",
  "#395e7a",
  "#dfeceb",
  "#c3e4eb",
  "#9ed6e7",
  "#7bc8e2",
  "#5bb4d5",
  "#37a5cb",
  "#0a5b7e",
  "#e8eeea",
  "#cfe3e4",
  "#bdd9de",
  "#92b9c4",
  "#6b9ca8",
  "#4e828d",
  "#3e5c64",
  "#dfeeeb",
  "#c3e7ea",
  "#9ad9e2",
  "#6cc4d3",
  "#2eadc2",
  "#0096ab",
  "#006381",
  "#cfeee8",
  "#bfe9e4",
  "#a5e3e0",
  "#7ed8d7",
  "#28b7b8",
  "#00a4a3",
  "#006d6e",
  "#e1eee7",
  "#d7e9e4",
  "#b8ddda",
  "#91c2c3",
  "#5f9e9d",
  "#488786",
  "#2d5c62",
  "#def1e9",
  "#bee9e0",
  "#90dacf",
  "#7bcbc1",
  "#50b5aa",
  "#289f90",
  "#206d63",
  "#e4ece1",
  "#c5d9d1",
  "#b8d1c7",
  "#a8c3b9",
  "#91afa4",
  "#546d61",
  "#d5ebe0",
  "#bae1d2",
  "#a8d7c6",
  "#96c6b6",
  "#72ac98",
  "#55927a",
  "#2d5c4f",
  "#daf1e2",
  "#c0e9d7",
  "#afe4cc",
  "#88cfaf",
  "#62b992",
  "#40a374",
  "#227654",
  "#e2efdf",
  "#d8ebd8",
  "#c8e5cd",
  "#abd6b4",
  "#7eb086",
  "#689b6c",
  "#578153",
  "#ebf1e3",
  "#daeed6",
  "#addeb3",
  "#9ecfa2",
  "#7fbb81",
  "#61a462",
  "#3d8145",
  "#dfecd9",
  "#c4dcc9",
  "#bed9c3",
  "#a3c6ac",
  "#8eb597",
  "#6e9675",
  "#4f6a4e",
  "#e1e6d3",
  "#cfd9c4",
  "#becdb6",
  "#b0c4a9",
  "#9baf91",
  "#809675",
  "#5d6c50",
  "#e9ebd8",
  "#d3dcc3",
  "#c7d1b5",
  "#bec8a6",
  "#aeba95",
  "#8c9a70",
  "#65704d",
  "#e9edd9",
  "#ceddbc",
  "#c3d6b2",
  "#bcd0a8",
  "#a5bd8e",
  "#8ba874",
  "#6d8553",
  "#e4efd8",
  "#d1e8c4",
  "#c0e0b3",
  "#b7d6a4",
  "#96c184",
  "#81ae66",
  "#639049",
  "#eff1dc",
  "#e4eec9",
  "#d6e8b5",
  "#c4db9c",
  "#afcd7f",
  "#99bd5f",
  "#7aa542",
  "#edeeca",
  "#e5eaba",
  "#e0e6af",
  "#d3da94",
  "#c5ce7f",
  "#aab85b",
  "#96a440",
  "#e8eace",
  "#d9ddb7",
  "#cfd4a6",
  "#bec48c",
  "#a7ab6b",
  "#949b59",
  "#7d8447",
  "#eae6c8",
  "#e0dfbb",
  "#d8d5a9",
  "#cac68c",
  "#bdb86c",
  "#aba857",
  "#8f9046",
  "#f4efd3",
  "#efe9c0",
  "#ede3af",
  "#e1d593",
  "#ccbd68",
  "#bcab51",
  "#a79a45",
  "#f8f2d3",
  "#f4e5b7",
  "#efdea4",
  "#e7d190",
  "#d8b966",
  "#ccad54",
  "#be9e43",
  "#f5eecf",
  "#f3e5b9",
  "#f2dfa8",
  "#ecd38b",
  "#ebcc76",
  "#e0be62",
  "#cfa541",
  "#f6f2da",
  "#f7f2d7",
  "#f9f0c7",
  "#f7d67a",
  "#f3c854",
  "#e8b229",
  "#f6f3d9",
  "#f8f2d2",
  "#faf0c2",
  "#faefbb",
  "#fce28e",
  "#f7cd58",
  "#f1b837",
  "#f8efcb",
  "#f8ecb0",
  "#f9e89e",
  "#fce589",
  "#f6d862",
  "#f3cd47",
  "#f0c32f",
  "#f8f4dc",
  "#fbf1c4",
  "#fdeea5",
  "#fae16a",
  "#f7d22d",
  "#f0ca14",
  "#edc80c",
  "#f7f4dd",
  "#f9f2c8",
  "#faf1b9",
  "#feee9a",
  "#ffea81",
  "#ffe04d",
  "#ffd328",
  "#f7f5e5",
  "#f8f2d6",
  "#fbefc5",
  "#ffe79d",
  "#ffdf7b",
  "#ffd046",
  "#ffc100",
  "#f8efd2",
  "#f9e8ba",
  "#f9e4a9",
  "#f7d98d",
  "#e9c062",
  "#dfb24f",
  "#d0a43f",
  "#f3ebd2",
  "#f1e4bf",
  "#eddaad",
  "#e0cb9b",
  "#c3a767",
  "#ba9d60",
  "#a88846",
  "#f8e7c9",
  "#f4e1be",
  "#f0ddba",
  "#dfc595",
  "#d0b179",
  "#c2a167",
  "#ac8950",
  "#f1e4c8",
  "#ead8b4",
  "#e8d4ab",
  "#dcc699",
  "#caae78",
  "#b5975d",
  "#9a804c",
  "#f0e4c9",
  "#e9dbc1",
  "#e8d6b0",
  "#d4b88b",
  "#c1a271",
  "#b39465",
  "#9a7c4d",
  "#f5ead1",
  "#f4e0bf",
  "#edd3ac",
  "#dfbe8b",
  "#d3ac73",
  "#bc9354",
  "#af864d",
  "#f6eeda",
  "#f5dfb9",
  "#f3d5a6",
  "#efd29d",
  "#e7c38a",
  "#d6aa64",
  "#b78944",
  "#f7f0dd",
  "#f9e6c1",
  "#f8dca9",
  "#efc689",
  "#e5b875",
  "#d7a458",
  "#c79244",
  "#f8ebd1",
  "#f8e7c9",
  "#f0d7ac",
  "#ebd2a8",
  "#e5c694",
  "#caa367",
  "#b5884d",
  "#f6eed8",
  "#fce4b6",
  "#f9daa3",
  "#f6d398",
  "#f0c985",
  "#e0b05d",
  "#c59442",
  "#f6f3e5",
  "#f6f0d9",
  "#faebc0",
  "#f8d898",
  "#eec377",
  "#e0b057",
  "#d09c3c",
  "#f9f2d9",
  "#fbf1d1",
  "#fee2a4",
  "#ffd98e",
  "#feca67",
  "#f9b945",
  "#eca72a",
  "#f9f0d0",
  "#fcedc2",
  "#fde9ae",
  "#ffe298",
  "#ffd269",
  "#ffc63c",
  "#ffb305",
  "#f7f2db",
  "#faefc2",
  "#fee59f",
  "#ffd368",
  "#ffc137",
  "#ffb428",
  "#fdab25",
  "#f8f2df",
  "#fbebc6",
  "#ffdea2",
  "#ffd185",
  "#ffc36a",
  "#ffb144",
  "#ff9a29",
  "#fbebcf",
  "#fce8c5",
  "#ffdbaa",
  "#ffd49f",
  "#ffb46e",
  "#ffa04f",
  "#f98433",
  "#f9e9d0",
  "#fcddb9",
  "#ffcfa1",
  "#febb83",
  "#faac6c",
  "#f99e59",
  "#ef8945",
  "#f8e5cb",
  "#fddfba",
  "#fdd4a9",
  "#f9c595",
  "#efaf78",
  "#e69c5a",
  "#d38643",
  "#f8f0e1",
  "#f8e5cc",
  "#f4d4ae",
  "#e8b984",
  "#d2985a",
  "#c4894f",
  "#bf8249",
  "#f5e3d0",
  "#f8ddc5",
  "#f4d3b7",
  "#e9c09a",
  "#d7a070",
  "#cf9561",
  "#b37c4a",
  "#f6e8d7",
  "#f4ddc4",
  "#f3d3b5",
  "#deb899",
  "#d6ab88",
  "#c08a64",
  "#aa724f",
  "#f2d8bf",
  "#f0ccaf",
  "#ecc6a6",
  "#dfb393",
  "#cd9875",
  "#b77c57",
  "#a06846",
  "#f7e6d3",
  "#f8dcc7",
  "#f5d4bd",
  "#eeb792",
  "#da966c",
  "#d08b60",
  "#b57248",
  "#f4f0e4",
  "#f9ebda",
  "#fcd9bd",
  "#fecfaf",
  "#f3a67d",
  "#e79060",
  "#cd6e44",
  "#f6f0e2",
  "#faead6",
  "#fde4cb",
  "#ffc299",
  "#ffa97a",
  "#fd9158",
  "#e77741",
  "#f7d1b7",
  "#f4c7ab",
  "#efb597",
  "#d17f58",
  "#9b5244",
  "#fbe8d8",
  "#ffdec9",
  "#ffd2ba",
  "#ffb99e",
  "#fca080",
  "#f88760",
  "#ed6641",
  "#f9e3d9",
  "#fad2c4",
  "#f7c7b6",
  "#efb3a0",
  "#dc8971",
  "#ac5844",
  "#a45849",
  "#f1e7de",
  "#f8e0d3",
  "#f2c8b6",
  "#e9ad99",
  "#db9b8a",
  "#c57f6d",
  "#8e4b3f",
  "#f9ebe2",
  "#fdd5c7",
  "#f6b4a5",
  "#ef9e8d",
  "#e2816a",
  "#c0594b",
  "#be5d4c",
  "#fae2d7",
  "#f9ddd5",
  "#f7cfc7",
  "#edb1a9",
  "#da8d80",
  "#cc796b",
  "#ac594b",
  "#f8ece6",
  "#fbe2de",
  "#ffcbc9",
  "#ffb1b0",
  "#f89596",
  "#de4f46",
  "#c24044",
  "#f8e8df",
  "#fbd7d3",
  "#fccbc9",
  "#f7a6a4",
  "#e9827f",
  "#df726d",
  "#bf4d47",
  "#f8dad6",
  "#f7cdcd",
  "#f2bcc0",
  "#eba3aa",
  "#da868c",
  "#b35250",
  "#a24e4d",
  "#f6c1c8",
  "#f3b0ba",
  "#e5848e",
  "#d56069",
  "#c74a4a",
  "#bc484e",
  "#a74c53",
  "#fbe4e6",
  "#ffd8e0",
  "#fec0ce",
  "#f891a9",
  "#f1758d",
  "#ce3a3e",
  "#b53f43",
  "#fae4e5",
  "#fcdce0",
  "#fccbd2",
  "#fcbbc5",
  "#ef91a0",
  "#c43944",
  "#a23d40",
  "#f7ebec",
  "#f7dbe3",
  "#f8d1e0",
  "#f5bdd4",
  "#f2adc9",
  "#dd6c96",
  "#9f3949",
  "#f7e2e6",
  "#f3ccd7",
  "#e5a4ba",
  "#d17c94",
  "#af5161",
  "#a8455e",
  "#aa446a",
  "#f5c6d2",
  "#f3bdcb",
  "#e8a1b5",
  "#ce798f",
  "#974851",
  "#9e4a52",
  "#984245",
  "#f6dde0",
  "#f5d2d7",
  "#f3c4cd",
  "#e2a0ae",
  "#d78c9b",
  "#be6471",
  "#a63b49",
  "#f5e8ea",
  "#f4dbe3",
  "#eeccdb",
  "#ecc1d5",
  "#dba9c4",
  "#b77494",
  "#894565",
  "#f5ecec",
  "#f4e1ea",
  "#f3cde5",
  "#f0bcdf",
  "#e59dcb",
  "#d772af",
  "#a33d65",
  "#f4e1eb",
  "#f2d8e8",
  "#edc7e1",
  "#d8a6ce",
  "#cc94c1",
  "#b471a5",
  "#70435a",
  "#eddce0",
  "#e0c6d6",
  "#dbb6cd",
  "#bd8cad",
  "#a8789c",
  "#966284",
  "#684b5b",
  "#f3ecea",
  "#f2dfe9",
  "#edcee5",
  "#e6bee0",
  "#c393c7",
  "#b078b1",
  "#6e496e",
  "#eedbe7",
  "#e7cfe4",
  "#debedd",
  "#cbaad0",
  "#b692be",
  "#a47dac",
  "#644466",
  "#eddcea",
  "#e6d0e7",
  "#ddc1e2",
  "#cbaed7",
  "#b493c8",
  "#9872af",
  "#694a73",
  "#ede3e7",
  "#e2cddc",
  "#d7bbd1",
  "#c3afc5",
  "#ae95b1",
  "#947795",
  "#614c5f",
  "#efdedf",
  "#e0c8d5",
  "#d8bbcd",
  "#b38fab",
  "#9f7b9b",
  "#8b6885",
  "#634e60",
  "#eadade",
  "#dec9d1",
  "#d3b9c5",
  "#bea5b5",
  "#a28698",
  "#846778",
  "#54454f",
  "#ede3df",
  "#e2d4d6",
  "#d6c7cc",
  "#c5afba",
  "#b69eab",
  "#8f7683",
  "#5e4a52",
  "#e9dfe5",
  "#d6c7d5",
  "#bca9c0",
  "#97819b",
  "#675569",
  "#564954",
  "#eee7e8",
  "#eae0e7",
  "#e2d6e4",
  "#d1c0dc",
  "#c0b0cf",
  "#a694bc",
  "#624d6c",
  "#ebe5eb",
  "#e4dbea",
  "#dacee7",
  "#cdbde2",
  "#b6a8d5",
  "#a797cb",
  "#604d7a",
  "#e2dfe7",
  "#d9d5e4",
  "#cac6df",
  "#a3a0c8",
  "#9593bd",
  "#78739f",
  "#574e70",
  "#d9d0e2",
  "#cfc3dc",
  "#b9b1ce",
  "#a49ec8",
  "#a098c5",
  "#8275ab",
  "#574c71",
  "#e3e3ea",
  "#dadaea",
  "#bfbfe4",
  "#a9aad7",
  "#9092ca",
  "#7173b3",
  "#555283",
  "#f1f0ed",
  "#e4e3eb",
  "#ccd0e6",
  "#bac0e4",
  "#8792cb",
  "#7179b8",
  "#4a4779",
  "#e9e8e5",
  "#ccd0e2",
  "#bec5de",
  "#abb2d7",
  "#98a0cc",
  "#717ab0",
  "#5b6196",
  "#e1dce3",
  "#d4cddb",
  "#bfb9cd",
  "#a6a4ba",
  "#9896ae",
  "#6d6983",
  "#514c5b",
  "#e8e2e5",
  "#cac2d0",
  "#b7b0c3",
  "#9e96ab",
  "#8e859b",
  "#81788d",
  "#5a505e",
  "#e1d9e3",
  "#dbd5df",
  "#d1c9d7",
  "#bcb4ca",
  "#aca2bd",
  "#857a9b",
  "#625165",
  "#ece3e2",
  "#e5dada",
  "#bdb1bc",
  "#a194a1",
  "#92838e",
  "#80717c",
  "#5b4a57",
  "#e6e1de",
  "#daced4",
  "#cdc0c9",
  "#bfb1bd",
  "#a89aaa",
  "#817180",
  "#594f58",
  "#d9d8da",
  "#cfced3",
  "#c0bfc7",
  "#b1b1bb",
  "#9b9daa",
  "#6f7280",
  "#5d5e6a",
  "#e4e3d9",
  "#e2ddcd",
  "#f5f4f1",
  "#eeebe1",
  "#f0ede3",
  "#e0dacf",
  "#c9c8cb",
  "#aeafb0",
  "#838487",
  "#747777",
  "#545554",
  "#c2c1bc",
  "#7c7974",
  "#50504f",
  "#d7d0c5",
  "#b9b2aa",
  "#aea89f",
  "#7e7467",
  "#534f4a",
  "#4b4745",
  "#e4dfd7",
  "#d1c7b9",
  "#bab0a5",
  "#62534d",
  "#e5dfd3",
  "#d6cdbc",
  "#a4927e",
  "#927d61",
  "#6f5d47",
  "#574c44",
  "#d0cac1",
  "#bcb8ae",
  "#908a76",
  "#787159",
  "#56523f",
  "#ddd9bb",
  "#bbac79",
  "#9d8b51",
  "#b89040",
  "#816e4b",
  "#b4b29d",
  "#a6a899",
  "#759171",
  "#788770",
  "#4d625a",
  "#babeaf",
  "#a2a690",
  "#8c896d",
  "#575c53",
  "#525850",
  "#bbc3b8",
  "#9fa398",
  "#3a596d",
  "#94a5ab",
  "#44535c",
  "#495b63",
  "#b8cbd4",
  "#9ec1cd",
  "#a0aeb8",
  "#5f7688",
  "#424b55",
  "#cad0d3",
  "#8e9a9f",
  "#91999c",
  "#525b61",
  "#b3bec5",
  "#77808a",
  "#626f7a",
  "#cbccd4",
  "#aaa7af",
  "#737379",
  "#49454b",
  "#4b4648",
  "#d4cbc6",
  "#b0a5a0",
  "#7e746c",
  "#766866",
  "#695b57",
  "#c1b4b8",
  "#9b8988",
  "#837272",
  "#7f686a",
  "#e7d1c4",
  "#cab2ac",
  "#7d4742",
  "#784042",
  "#6f4242",
  "#5b4846",
  "#f0e9d8",
  "#d9c9b3",
  "#bea996",
  "#9b775f",
  "#825945",
  "#5a4a43",
  "#3c3b3c",
  "#454444",
  "#515051",
  "#6c6b6c",
  "#79787a",
  "#868586",
  "#a3a2a3",
  "#c0bebf",
  "#cfced0",
  "#dddcdd",
  "#91353d",
  "#bd3c4b",
  "#54473d",
  "#6b543d",
  "#755d47",
  "#815f3c",
  "#886d52",
  "#95734f",
  "#9e7e5c",
  "#a78869",
  "#af9175",
  "#b89d83",
  "#c3a283",
  "#c2a891",
  "#c9ab8f",
  "#d2b69d",
  "#e3b687",
  "#d2bead",
  "#d9c0ab",
  "#dfc3a9",
  "#dac8ba",
  "#e4ccb7",
  "#f2caa2",
  "#d7d1ce",
  "#eed0b4",
  "#f3d2b2",
  "#f1d8c2",
  "#c9d9e9",
  "#c4badd",
  "#ffba6d",
  "#b3a7d3",
  "#d3cbe5",
  "#0081c2",
  "#aac9e8",
  "#dfd8ea",
  "#fbb158",
  "#c33e49",
  "#f4a027",
  "#fbd6af",
  "#e6e0ed",
  "#a9333d",
  "#fcbb69",
  "#9cbfe3",
  "#77393e",
  "#364c63",
  "#4d5e72",
  "#687788",
  "#768393",
  "#6a88a8",
  "#7796b8",
  "#909eaf",
  "#9fabba",
  "#97afc9",
  "#92b2d4",
  "#aeb7c5",
  "#a3bedc",
  "#bdc5d1",
  "#ccd1db",
  "#c5d5ea",
  "#dcdee3",
  "#dadee7",
  "#ecebee",
  "#eaebef",
  "#eaebf0",
  "#e8ebec",
  "#e1edef",
  "#bec4c1",
  "#ccd1cf",
  "#dadedc",
  "#9fa494",
  "#b9bcad",
  "#5e537a",
  "#6b637b",
  "#766f86",
  "#766b91",
  "#8478a0",
  "#8a8495",
  "#8c80a3",
  "#8d869a",
  "#9c90b7",
  "#a39dae",
  "#b0a5c6",
  "#b0abba",
  "#d0c7dc",
  "#9b587e",
  "#b16590",
  "#cb80a8",
  "#c688a9",
  "#d99fbe",
  "#deaac5",
  "#e7c0d4",
  "#d9c6d0",
  "#f0bfd8",
  "#e3d3da",
  "#eadee3",
  "#7f4644",
  "#8e4545",
  "#9c4745",
  "#a45351",
  "#b25352",
  "#a45e5b",
  "#c35352",
  "#bc605d",
  "#b86c68",
  "#cf6d6a",
  "#d96b6a",
  "#c87975",
  "#de7a76",
  "#d88682",
  "#e4928d",
  "#5b5044",
  "#665c50",
  "#725c42",
  "#73675d",
  "#866d4d",
  "#7f746a",
  "#9a8368",
  "#a29384",
  "#af9473",
  "#aea092",
  "#b99e80",
  "#baada0",
  "#c2aa8e",
  "#dca75c",
  "#e2af6b",
  "#cbb59e",
  "#c5b9ae",
  "#c9c2be",
  "#d9c1a8",
  "#cec4bb",
  "#f2c284",
  "#e6ceb4",
  "#e2d4c6",
  "#f2d4b2",
  "#ebd7c3",
  "#f8dcbe",
  "#eee0d3",
  "#f2e1d1",
  "#fadfc2",
  "#f6eae0",
  "#f8e9da",
  "#bdd1e8",
  "#6a3d58",
  "#7d4240",
  "#0071b4",
  "#883e67",
  "#eaa5c7",
  "#83addb",
  "#007d92",
  "#0090a6",
  "#089eb4",
  "#d14748",
  "#38acc0",
  "#94d3e1",
  "#a8dbe5",
  "#fdcd87",
  "#6ac1d2",
  "#9ad5e2",
  "#c9393b",
  "#fae8d1",
  "#847560",
  "#92784e",
  "#9c835b",
  "#9a866b",
  "#a39077",
  "#b29056",
  "#ae9265",
  "#a39686",
  "#ae9675",
  "#ac9b84",
  "#b7a183",
  "#c29e60",
  "#aea293",
  "#c0a171",
  "#b7a691",
  "#cea65d",
  "#c7ab80",
  "#b9aea2",
  "#c7af8e",
  "#cfae7b",
  "#ceb38b",
  "#dbb169",
  "#c8b79e",
  "#c5bbb0",
  "#cfba9d",
  "#d5b789",
  "#d0c0ac",
  "#dcc198",
  "#d6c3aa",
  "#dbc5a7",
  "#d9cbba",
  "#e1cfb6",
  "#eccea2",
  "#efd5b1",
  "#e7d7c4",
  "#f5e3ce",
  "#f8e4cc",
  "#f6eade",
  "#f7eada",
  "#de87b0",
  "#f8b7ae",
  "#6c9cd1",
  "#f5a69b",
  "#fdd79c",
  "#eceee8",
  "#f2988b",
  "#fac6bf",
  "#fad3ce",
  "#6394cb",
  "#ec7e6f",
  "#f3ca8c",
  "#fee2b8",
  "#fce0b4",
  "#e96d5a",
  "#f9ebda",
  "#fed372",
  "#fcdfaf",
  "#525966",
  "#62656b",
  "#606672",
  "#536784",
  "#6e7176",
  "#697283",
  "#62738f",
  "#797e89",
  "#718099",
  "#87898e",
  "#858c9a",
  "#7c8da9",
  "#768eb3",
  "#9399a6",
  "#8c9ab4",
  "#8a9bb8",
  "#869bbd",
  "#809cc6",
  "#9ba6bd",
  "#95a7c6",
  "#b0b4be",
  "#aab5cd",
  "#a3b5d7",
  "#bfc2cb",
  "#b4c3e0",
  "#cfced1",
  "#c9cfe0",
  "#c4d0e8",
  "#dedddf",
  "#ecebef",
  "#4d5a5e",
  "#425d65",
  "#626f74",
  "#6b797e",
  "#77858a",
  "#698891",
  "#4d8d9e",
  "#75939c",
  "#8f9b9f",
  "#68a2b2",
  "#99a5a9",
  "#8ba8b0",
  "#76adbc",
  "#a3afb3",
  "#b0bbbf",
  "#8fc1d0",
  "#bcc7cc",
  "#b3cbd3",
  "#a4ccd7",
  "#cbd4d7",
  "#c9d5d9",
  "#c4d5db",
  "#bbd6de",
  "#b7d7e0",
  "#dbdedf",
  "#d8dfe2",
  "#d0e0e5",
  "#c3e1eb",
  "#cce6ef",
  "#ecebeb",
  "#eaebec",
  "#e7ecea",
  "#4b4e47",
  "#636761",
  "#dde0d7",
  "#e3e2e1",
  "#ecebe8",
  "#f1f0ef",
  "#4b4551",
  "#52485a",
  "#5d5465",
  "#b6a5c1",
  "#cabcd2",
  "#dcd2e1",
  "#ded3e4",
  "#edeaed",
  "#59444c",
  "#724859",
  "#874161",
  "#7c5364",
  "#977783",
  "#c67295",
  "#aa8f9a",
  "#b59ca6",
  "#c0a9b2",
  "#bab4b7",
  "#c8b5bc",
  "#d3c2c9",
  "#d4cfd2",
  "#76463d",
  "#7f5248",
  "#905e54",
  "#ab6153",
  "#b26d5f",
  "#d75443",
  "#c5796b",
  "#e08576",
  "#d29185",
  "#4f4a45",
  "#585045",
  "#5b5752",
  "#655d52",
  "#6f675d",
  "#74706b",
  "#7b756b",
  "#817e7a",
  "#8d7b5d",
  "#878078",
  "#938d86",
  "#a18d68",
  "#9b9895",
  "#ab9876",
  "#a29c95",
  "#b69f73",
  "#b5a283",
  "#ada8a2",
  "#bea982",
  "#bead90",
  "#caad72",
  "#d6b053",
  "#bab6b1",
  "#d1b57f",
  "#c6b79e",
  "#ceb88e",
  "#c2b9ae",
  "#e4ba50",
  "#cebb9d",
  "#deba6f",
  "#d5c09c",
  "#e7be5f",
  "#cfc1ac",
  "#c7c3bf",
  "#ddc18a",
  "#e3c17c",
  "#e9c26d",
  "#dac8a9",
  "#d7cbba",
  "#e1cca8",
  "#d4d0cd",
  "#e7d0a7",
  "#f0d196",
  "#e6d4b6",
  "#e0d6c7",
  "#ebd6b4",
  "#e0d9d1",
  "#dfdddc",
  "#e1dedc",
  "#eddfcb",
  "#f1e2c8",
  "#f6e3c5",
  "#eae5df",
  "#f0e6db",
  "#f6e8d3",
  "#eeebea",
  "#5184bf",
  "#ad3439",
  "#faded9",
  "#719ace",
  "#f2c765",
  "#f0ca7f",
  "#fce6b2",
  "#9bb3dd",
  "#ffcf97",
  "#ebe4d2",
  "#f1ebe4",
  "#b895c7",
  "#c4a4cf",
  "#a33e66",
  "#9c917b",
  "#a69c88",
  "#b2a896",
  "#c6ac66",
  "#bbb2a2",
  "#d2ba7e",
  "#d8bc70",
  "#c6beb0",
  "#cdc3ae",
  "#eac550",
  "#e1c88a",
  "#edc95e",
  "#d6cdbb",
  "#efcd6b",
  "#e4ce97",
  "#dcd0b8",
  "#efd079",
  "#d6d2cc",
  "#e1d3b5",
  "#ecd394",
  "#f3d585",
  "#dfd6c7",
  "#e4d9c5",
  "#e8dbc2",
  "#f1ddae",
  "#f7dd9f",
  "#ecddbf",
  "#e2deda",
  "#eae1d3",
  "#eee3cf",
  "#f2e5cc",
  "#eeeae7",
  "#f3ebe0",
  "#f7ecd9",
  "#dce1e4",
  "#9068a2",
  "#9f77b0",
  "#ab85bb",
  "#d0b8da",
  "#fa9a7e",
  "#f7eddb",
  "#f9f0e1",
  "#5d426a",
  "#c6557f",
  "#f8d870",
  "#c4cde7",
  "#009986",
  "#f6ecd9",
  "#f8eed9",
  "#537db9",
  "#a89a75",
  "#b0a481",
  "#baae8d",
  "#ceb24c",
  "#bbb29e",
  "#c7beac",
  "#d1cab9",
  "#e7cf8a",
  "#e4d09a",
  "#ebd495",
  "#f9d646",
  "#e1d7c1",
  "#e9d7a7",
  "#f7db81",
  "#fedf6f",
  "#f0dfb4",
  "#f6de9d",
  "#ffe27c",
  "#e7e0d3",
  "#fae199",
  "#ffe387",
  "#ffe693",
  "#f4ebdb",
  "#fdebbc",
  "#fad0c3",
  "#faedce",
  "#3863a1",
  "#bac5e4",
  "#00b4a3",
  "#fcac91",
  "#b0bce0",
  "#e1e2e9",
  "#444d63",
  "#404d6b",
  "#52586d",
  "#4f5972",
  "#5f6478",
  "#5a6684",
  "#63729a",
  "#767e99",
  "#717ea4",
  "#858ca5",
  "#7e8bae",
  "#9399b0",
  "#8f99b9",
  "#9ca6c2",
  "#b0b4c7",
  "#acb2c8",
  "#acb3cd",
  "#bec1d2",
  "#bcc2d8",
  "#cdd0dd",
  "#cacfe5",
  "#dcdde6",
  "#dcdde7",
  "#ebeaef",
  "#ecebf0",
  "#45626e",
  "#7c8286",
  "#989da0",
  "#38a1c5",
  "#a4a9ac",
  "#59b3d4",
  "#b2b6b9",
  "#b1b9be",
  "#7bc2df",
  "#c0c4c6",
  "#a1ccde",
  "#ced0d3",
  "#ccd2d6",
  "#d5dce0",
  "#dcdde0",
  "#b8dff0",
  "#e0e3e6",
  "#dde4e7",
  "#d6e5ec",
  "#d1e5ef",
  "#ebebee",
  "#374442",
  "#3e5b56",
  "#58716d",
  "#5da79c",
  "#7dbab0",
  "#adbab9",
  "#8dc4bc",
  "#bbc8c6",
  "#abd6cf",
  "#c9d4d3",
  "#bbe0da",
  "#888e87",
  "#979c95",
  "#a3a8a3",
  "#76c26f",
  "#b3b7b2",
  "#b3bcb1",
  "#b2c4ae",
  "#8dce86",
  "#bfc3bf",
  "#c0c8be",
  "#97d590",
  "#a2db9c",
  "#cdd4cc",
  "#ccd6c9",
  "#cbd9c7",
  "#b9e6b2",
  "#dbe0d9",
  "#d9e2d7",
  "#c4ebbd",
  "#d1eccb",
  "#e9ece6",
  "#e6ede3",
  "#dcf1d6",
  "#6b5073",
  "#7b5d84",
  "#8f6b99",
  "#8f7395",
  "#957d9a",
  "#a493a9",
  "#afa0b3",
  "#b8a3bc",
  "#c1aec5",
  "#c4b7c7",
  "#cbbace",
  "#d5c6d8",
  "#e4dee4",
  "#efeaee",
  "#4f4245",
  "#594d50",
  "#65585c",
  "#8d4a5f",
  "#716569",
  "#955569",
  "#7d7275",
  "#968c90",
  "#a39a9d",
  "#aea6a9",
  "#c7c2c4",
  "#ecdce0",
  "#f1dce2",
  "#f3e9eb",
  "#f5e8eb",
  "#49413f",
  "#54443f",
  "#7a5e54",
  "#856a61",
  "#9e654f",
  "#90766e",
  "#be7459",
  "#e48262",
  "#ed7c56",
  "#e4a38d",
  "#ebbaab",
  "#f0bbaa",
  "#f0c7ba",
  "#5a5545",
  "#666050",
  "#726c5d",
  "#9b8d59",
  "#969085",
  "#a69766",
  "#a29d92",
  "#ada073",
  "#b6a97f",
  "#b8a870",
  "#afaaa0",
  "#c1b27d",
  "#bfb38c",
  "#bcb7af",
  "#cbb97b",
  "#c8bc99",
  "#d8c15d",
  "#c9c5bd",
  "#d2c6a6",
  "#e2c84d",
  "#e8cf66",
  "#dacfb3",
  "#dfd0a1",
  "#d5d1ca",
  "#dad3c7",
  "#efd77f",
  "#f4de98",
  "#e6e0d4",
  "#f4e3b3",
  "#f1e5c5",
  "#f8e6af",
  "#fee88f",
  "#f0ebe6",
  "#f2ece1",
  "#faecc7",
  "#f5bfce",
  "#f8e8e3",
  "#f0eadf",
  "#f08b64",
  "#56c9bc",
  "#d76a8c",
  "#feeca8",
  "#f6efe2",
  "#99a8d6",
  "#1a97be",
  "#7e3e52",
  "#f4acbe",
  "#fcecb4",
  "#f9d9e1",
  "#e16836",
  "#0089b2",
  "#91ded5",
  "#bfebe5",
  "#704775",
  "#f5a381",
  "#fcefc1",
  "#f8dfd6",
  "#8797cc",
  "#aae5de",
  "#ef9caf",
  "#f7af90",
  "#e7e6ec",
  "#0078a0",
  "#61514a",
  "#b56742",
  "#dc652f",
  "#c6744d",
  "#c48368",
  "#a69089",
  "#d28969",
  "#cc9077",
  "#e88557",
  "#df8b67",
  "#b09d96",
  "#dc9d83",
  "#ed9972",
  "#d8a692",
  "#f0bfab",
  "#f7cab8",
  "#f4d4c8",
  "#f8ded4",
  "#f5e9e6",
  "#979178",
  "#a29d86",
  "#ada892",
  "#b9b49f",
  "#c4bfac",
  "#d1c585",
  "#d8cb91",
  "#cfcab9",
  "#dfd28d",
  "#dad5c6",
  "#e4d799",
  "#e3d8a8",
  "#e2dabd",
  "#e6dcb8",
  "#eadfb4",
  "#e5e0d3",
  "#f2e49b",
  "#e8e2cd",
  "#f1e4ab",
  "#ebe3c8",
  "#f1e7bd",
  "#f7eab2",
  "#f0ebe0",
  "#f4ecd5",
  "#f8edc3",
  "#7a8bc3",
  "#f9bda1",
  "#f4efe6",
  "#f6f1e9",
  "#f9f2d9",
  "#cc5978",
  "#ea8ca1",
  "#6f7eb9",
  "#aa3b5b",
  "#f2ea98",
  "#f7efb9",
  "#f7f0c2",
  "#f9f2d2",
  "#f8f2da",
  "#f2efe6",
  "#d6e5f0",
  "#606e77",
  "#5c7482",
  "#6c7a83",
  "#517f97",
  "#79868f",
  "#778b98",
  "#6f95aa",
  "#809baa",
  "#649dbc",
  "#939fa6",
  "#8caabd",
  "#a1acb2",
  "#9fafba",
  "#84b1cb",
  "#9cb1bf",
  "#99b6c7",
  "#afb9c0",
  "#a8c0d0",
  "#a2c5da",
  "#bcc8d1",
  "#b6cbd9",
  "#b4cdde",
  "#afcfe2",
  "#c2d8e6",
  "#bdd8e8",
  "#d2d8de",
  "#b9dbf2",
  "#c9dbe8",
  "#c2ddef",
  "#d6dee4",
  "#cbdfec",
  "#297e7c",
  "#4e9593",
  "#5ea19e",
  "#8a9c9b",
  "#97a7a7",
  "#aab7b7",
  "#708973",
  "#66946f",
  "#7d9681",
  "#75a07c",
  "#8ba38f",
  "#83ac8a",
  "#91b897",
  "#a8bdab",
  "#a0c4a6",
  "#bddbc2",
  "#cfe4d2",
  "#cce6d0",
  "#e5ede5",
  "#e0f0e1",
  "#716170",
  "#847083",
  "#8f7c8d",
  "#735156",
  "#af4a61",
  "#946069",
  "#b6566b",
  "#9d6b74",
  "#a6787f",
  "#cf637b",
  "#c86f81",
  "#d37084",
  "#b8858e",
  "#b79097",
  "#df94a1",
  "#d59fa8",
  "#c7a8ae",
  "#e0adb5",
  "#d1b6bb",
  "#d9c2c6",
  "#ecc4cb",
  "#daced0",
  "#e0d0d3",
  "#f5e8ea",
  "#6c4d3c",
  "#895e44",
  "#976a50",
  "#da6d2b",
  "#9b857b",
  "#c89273",
  "#deaa8d",
  "#f0ae8b",
  "#e3b69d",
  "#7c7852",
  "#86825d",
  "#918d69",
  "#a5a066",
  "#afa971",
  "#aba9a0",
  "#b9b7ae",
  "#bbb799",
  "#beb97a",
  "#bfbca8",
  "#c8c73a",
  "#c7c4bc",
  "#cec88f",
  "#d0ce51",
  "#cdc9b6",
  "#d1cdb2",
  "#dad664",
  "#d4d1ca",
  "#d9d5c3",
  "#dcd7be",
  "#dfd9a5",
  "#e3dd77",
  "#e6e180",
  "#e1ded7",
  "#e5e0d1",
  "#eae3aa",
  "#ebe589",
  "#e7e2ca",
  "#ede6a5",
  "#eae4c4",
  "#ede6be",
  "#efebe5",
  "#f0ecde",
  "#f2edd7",
  "#f4eec9",
  "#f6efb4",
  "#f6f2e2",
  "#dee1e5",
  "#a5d2ed",
  "#e26e84",
  "#604245",
  "#f9bfc7",
  "#f7f2d6",
  "#97caec",
  "#edebdd",
  "#f6acb6",
  "#fad0d5",
  "#f4914e",
  "#8cc5e9",
  "#8a6a55",
  "#a7846c",
  "#b8835c",
  "#c4875b",
  "#ca9067",
  "#d59466",
  "#af9f95",
  "#d09a75",
  "#e39867",
  "#d99e74",
  "#bcaca4",
  "#dea681",
  "#e3b08e",
  "#c7b8b2",
  "#f2ad80",
  "#f4b58e",
  "#efbb9c",
  "#f6bd9b",
  "#f3ceb7",
  "#f7ceb7",
  "#f7e1d3",
  "#f39da8",
  "#f2f0e8",
  "#fadadd",
  "#f1efe7",
  "#f79f5d",
  "#efede2",
  "#b43a51",
  "#f1919b",
  "#f3f1d8",
  "#bde6e7",
  "#533c3e",
  "#69b4e3",
  "#e7eab0",
  "#8ed6d9",
  "#1fa4ae",
  "#aae0e3",
  "#d4e086",
  "#dee498",
  "#51a7dd",
  "#c7dbed",
  "#ed818b",
  "#f18e2e",
  "#62628e",
  "#7370a3",
  "#7b78a3",
  "#807bab",
  "#9490ba",
  "#aaa6c9",
  "#b0adbf",
  "#b7b2d1",
  "#c3bed9",
  "#cac6d6",
  "#cdc9e0",
  "#d6d3e2",
  "#e1dee7",
  "#45515b",
  "#4c5d6b",
  "#647481",
  "#5c778d",
  "#698297",
  "#7d8a96",
  "#8c959c",
  "#8995a1",
  "#8399ab",
  "#769dbb",
  "#96a1ac",
  "#84a8c3",
  "#a5abb3",
  "#a2acb6",
  "#92b2cc",
  "#b1bac3",
  "#a0bdd5",
  "#b6c8d8",
  "#afc9df",
  "#cbd2d9",
  "#c7d2de",
  "#c2d3e3",
  "#d9dee4",
  "#d5dee8",
  "#d0deec",
  "#39676b",
  "#617576",
  "#537d80",
  "#6e8283",
  "#47878b",
  "#628a8c",
  "#5c8e91",
  "#1b9299",
  "#7c8e90",
  "#6b9a9c",
  "#649ea1",
  "#7aa6a9",
  "#70aeb2",
  "#5fb3b8",
  "#8cb3b6",
  "#84b6b9",
  "#71bec3",
  "#9bc0c2",
  "#8bc8cb",
  "#aacdcf",
  "#a5cfd1",
  "#a0d1d3",
  "#9cd4d7",
  "#b5dbdc",
  "#b0dddf",
  "#a6e0e3",
  "#cae3e5",
  "#dceeef",
  "#6dbd91",
  "#7dc69c",
  "#87d2a7",
  "#a3e1bd",
  "#b7e6c9",
  "#d8dfdb",
  "#cbe8d6",
  "#c8ead5",
  "#e6ebe7",
  "#d9f1e2",
  "#53454f",
  "#5e4958",
  "#685462",
  "#eadce6",
  "#f2e9ef",
  "#6f5153",
  "#8b4e52",
  "#9f5057",
  "#866063",
  "#a65b61",
  "#b5515d",
  "#906c6e",
  "#c75361",
  "#b4676e",
  "#ca606b",
  "#9a797b",
  "#c36a72",
  "#de6e79",
  "#d77780",
  "#ce8187",
  "#ad9293",
  "#e37983",
  "#b69d9e",
  "#e99197",
  "#eb9aa1",
  "#dca3a7",
  "#e4a5a9",
  "#c9b7b8",
  "#eeb2b6",
  "#d2c4c5",
  "#f0bdbf",
  "#f1c8cb",
  "#dcd0d1",
  "#eed2d4",
  "#f2d3d4",
  "#e7ddde",
  "#ab9484",
  "#b79274",
  "#dc8833",
  "#be9d82",
  "#bfaca0",
  "#eca96e",
  "#e4ad7e",
  "#c9b9ae",
  "#eeb17c",
  "#f1ba8b",
  "#f9b277",
  "#cec3bd",
  "#ebbd99",
  "#f3c299",
  "#dad0cc",
  "#f6d1b5",
  "#e5ddda",
  "#5c5f42",
  "#828562",
  "#8d8f6e",
  "#8f9658",
  "#a2a385",
  "#acae91",
  "#b1b683",
  "#b6b89d",
  "#b6c462",
  "#c2c3a9",
  "#c0c68d",
  "#c5c5bc",
  "#c8d27e",
  "#cdceb6",
  "#d0d4a1",
  "#d3d2ca",
  "#d9d8c2",
  "#e1e2b6",
  "#dde698",
  "#e0ded7",
  "#e3e1d2",
  "#e9eeb7",
  "#eeecdf",
  "#efeed3",
  "#f2d3e7",
  "#853d42",
  "#f8a245",
  "#218fcd",
  "#693c3d",
  "#a93b46",
  "#f8e2e3",
  "#fbc898",
  "#efeeeb",
  "#b7d1eb",
  "#e56971",
  "#f9eae0",
  "#d5d8d9",
  "#bfc3c6",
  "#a9aeb4",
  "#999fa4",
  "#838b92",
  "#6d737a",
  "#575c62",
  "#d3d5cf",
  "#c8cbc8",
  "#bbbcb8",
  "#a7aaa5",
  "#9b9f9a",
  "#919591",
  "#707573",
  "#e0dfdd",
  "#d2d1ce",
  "#c7c6c3",
  "#b9b9b7",
  "#9e9f9e",
  "#7b7a79",
  "#3c3d3d",
  "#dddddb",
  "#cdccca",
  "#a7a7a4",
  "#929290",
  "#80807f",
  "#6f6f6f",
  "#5e5e5d",
  "#d0cfcb",
  "#c3c4be",
  "#babab6",
  "#abaca7",
  "#969795",
  "#7b7c7b",
  "#575958",
  "#f2f0e9",
  "#bebbb1",
  "#afaba3",
  "#a19e98",
  "#94918a",
  "#7d7a75",
  "#dedcd3",
  "#c7c3b9",
  "#b2aea3",
  "#999488",
  "#8a8478",
  "#746e65",
  "#635f5a",
  "#425a65",
  "#657d85",
  "#71898d",
  "#a0aead",
  "#e8e5db",
  "#7c8783",
  "#cdd2c9",
  "#bfc8c3",
  "#48545d",
  "#5c707e",
  "#8398a4",
  "#c3d0d8",
  "#a3aeb4",
  "#b0bcc3",
  "#bdc1c1",
  "#69808b",
  "#bbc6d9",
  "#70777e",
  "#939da9",
  "#808ea1",
  "#667486",
  "#d4dae2",
  "#9daab9",
  "#d4dddd",
  "#cedde7",
  "#cfdce0",
  "#a2b2bd",
  "#a2b5ab",
  "#bcc8ba",
  "#c4d1c6",
  "#2a4b6e",
  "#d1cabe",
  "#c2baad",
  "#b0a99d",
  "#a1978b",
  "#8e8475",
  "#7c7366",
  "#63594b",
  "#f1f2ee",
  "#e3e4e2",
  "#d9dcdb",
  "#acadad",
  "#848585",
  "#5c5d5d",
  "#edebe7",
  "#e6e3df",
  "#d0ccc5",
  "#b9b4b1",
  "#918e8c",
  "#6f6a68",
  "#4b4441",
  "#e1dddb",
  "#d7d2d1",
  "#b8b4b6",
  "#a49f9f",
  "#908b8e",
  "#69656a",
  "#49454b",
  "#dcd8d7",
  "#d1cdca",
  "#c4bdba",
  "#b2aaaa",
  "#8b8283",
  "#645d5e",
  "#50484a",
  "#e5e1de",
  "#d2cfcc",
  "#c2bdba",
  "#b4ada9",
  "#8d847f",
  "#665d59",
  "#4f443f",
  "#b6b0a9",
  "#8b847c",
  "#7b736b",
  "#61584f",
  "#e7e6e0",
  "#cecac1",
  "#bcb7ad",
  "#97928b",
  "#5f5854",
  "#e5e0d2",
  "#cfc9bc",
  "#b2aca2",
  "#a1988b",
  "#8c8578",
  "#746f67",
  "#605c58",
  "#e1e1db",
  "#d1d3cf",
  "#c4c7c4",
  "#b7b9b5",
  "#8e908d",
  "#6a6b65",
  "#4e4f48",
  "#e8e9e4",
  "#d6d7d2",
  "#babdb8",
  "#a4a7a4",
  "#898a86",
  "#595a5c",
  "#e8eae6",
  "#d0d3d3",
  "#afb4b6",
  "#989fa3",
  "#6e7376",
  "#5b5e61",
  "#464544",
  "#e0e5e2",
  "#dce3e2",
  "#d2d9db",
  "#b8bfc2",
  "#8e9598",
  "#6f7678",
  "#434b4f",
  "#e5e7e6",
  "#d9dcdd",
  "#bec0c2",
  "#adb0b4",
  "#828388",
  "#585960",
  "#404149",
  "#eae9e7",
  "#e6e4e4",
  "#c0b2b1",
  "#9b8e8e",
  "#736665",
  "#554747",
  "#f1ece2",
  "#ece4dc",
  "#e6d7cc",
  "#ccb8b3",
  "#a49491",
  "#816f6b",
  "#5e4a47",
  "#ebded7",
  "#e6d5ce",
  "#dcc7c0",
  "#d2bbb2",
  "#b39b94",
  "#8e746c",
  "#664942",
  "#ecdfd8",
  "#d9cac3",
  "#c8bcb7",
  "#b7a9a2",
  "#8d7d77",
  "#796660",
  "#60504b",
  "#ddd5ce",
  "#d4cbc4",
  "#a99f97",
  "#a0928b",
  "#7f726b",
  "#5b4c44",
  "#eae1d6",
  "#d6cbbf",
  "#c6baaf",
  "#a99f96",
  "#91857c",
  "#80736a",
  "#635951",
  "#f1eee4",
  "#e2d8cb",
  "#cec1b5",
  "#a6978a",
  "#847567",
  "#63584c",
  "#e8e3db",
  "#cfc5b6",
  "#bdb0a0",
  "#a99a89",
  "#8c7b6c",
  "#5e5349",
  "#e5e0d5",
  "#cfc6bc",
  "#bdb6ae",
  "#a1968c",
  "#998e83",
  "#746a5e",
  "#5c5042",
  "#e7e3d6",
  "#d9d0c1",
  "#c9bfb2",
  "#9f9484",
  "#827566",
  "#594e40",
  "#e8e4d6",
  "#e1daca",
  "#d8cfbe",
  "#a79d8d",
  "#8a7d6b",
  "#5e5241",
  "#dbd7ce",
  "#d1ccc2",
  "#b1aa9c",
  "#8c8475",
  "#786d5e",
  "#615544",
  "#e1d8bb",
  "#d4c9a6",
  "#beb394",
  "#b2a484",
  "#a29371",
  "#8e8062",
  "#746a51",
  "#dedbcc",
  "#d0cbb6",
  "#beb9a2",
  "#afa78d",
  "#8f876b",
  "#796e54",
  "#5f563f",
  "#e5e7d5",
  "#d1d1bb",
  "#b7b8a5",
  "#a1a18f",
  "#817f6e",
  "#746f5c",
  "#5c5644",
  "#e6e5dc",
  "#dad8c9",
  "#cac8b6",
  "#aead96",
  "#8f8c79",
  "#747261",
  "#656457",
  "#d1d3c0",
  "#c3c7b2",
  "#b1b7a1",
  "#9ca389",
  "#8e9074",
  "#76745d",
  "#686858",
  "#ccccba",
  "#bec0b0",
  "#a6a897",
  "#939581",
  "#84846f",
  "#666556",
  "#5b5a4d",
  "#cdccbe",
  "#bdbbad",
  "#aeab9a",
  "#979381",
  "#84816f",
  "#706d5e",
  "#5e5b4d",
  "#dde2d7",
  "#d9dcd1",
  "#c3c7bd",
  "#89928a",
  "#646c64",
  "#474f43",
  "#e4ece9",
  "#dfebe9",
  "#d5e1e0",
  "#b5c8c9",
  "#8c9fa0",
  "#6b7f81",
  "#3b5257",
  "#cfdfdd",
  "#c6d6d7",
  "#a0b7ba",
  "#89a0a6",
  "#6a8389",
  "#5b6e74",
  "#445055",
  "#e0e4e2",
  "#c9d2d1",
  "#aab5b7",
  "#919fa1",
  "#7a8687",
  "#6e797b",
  "#575e5f",
  "#d5dcdc",
  "#c9d3d3",
  "#a5b2b7",
  "#8fa0a7",
  "#66787e",
  "#535e63",
  "#474c50",
  "#e3e9e8",
  "#dde4e3",
  "#adb6b9",
  "#858f94",
  "#5e686d",
  "#3b484f",
  "#cbd1d0",
  "#b9c0c0",
  "#a8b0b2",
  "#8f989d",
  "#7b8588",
  "#656e72",
  "#445056",
  "#cfd9de",
  "#c0ced6",
  "#b0bec5",
  "#a0aeb8",
  "#8d9ca7",
  "#657682",
  "#525e68",
  "#eaeeec",
  "#dfe6ea",
  "#d8dee3",
  "#bcc5cf",
  "#939fa9",
  "#6b7680",
  "#e4eaed",
  "#e1e6eb",
  "#d4dde2",
  "#abb5c4",
  "#818b9c",
  "#5b6676",
  "#404e61",
  "#e8e9e9",
  "#e1e1e2",
  "#dedfe2",
  "#b1b3be",
  "#8b8d98",
  "#656874",
  "#484b5a",
  "#f1ebea",
  "#eadde1",
  "#e1c8d1",
  "#d6b3c0",
  "#c28ba1",
  "#a5647e",
  "#83455d",
  "#f0eeeb",
  "#ede0e3",
  "#e3d0d5",
  "#ceaebb",
  "#b08693",
  "#986a79",
  "#6d4052",
  "#e9e1df",
  "#e9dbe0",
  "#d8c2ca",
  "#cab7c0",
  "#a38b93",
  "#846c76",
  "#5c4450",
  "#efe6e1",
  "#e5d7d4",
  "#d6c4c1",
  "#d0c1c3",
  "#ab9b9c",
  "#867578",
  "#5a484b",
  "#efeae7",
  "#efdddf",
  "#e2c9ce",
  "#d3b6ba",
  "#a9898d",
  "#8c6c6f",
  "#604046",
  "#f1eeeb",
  "#eedadd",
  "#d6b8bd",
  "#c7a1a9",
  "#aa7982",
  "#8e5b68",
  "#71424a",
  "#f2e7e7",
  "#eaced4",
  "#e1b9c2",
  "#d194a1",
  "#c07281",
  "#a9586c",
  "#953d55",
  "#f2ddd8",
  "#ecc9ca",
  "#e9b3b4",
  "#d99294",
  "#c27277",
  "#ac545e",
  "#903f45",
  "#efe0d7",
  "#f3e2dc",
  "#ddbdba",
  "#c39191",
  "#ad7171",
  "#92555b",
  "#813e45",
  "#f1ede5",
  "#ecd4d2",
  "#e3c7c6",
  "#d7b1b2",
  "#b58e8b",
  "#956a66",
  "#6c403e",
  "#f1e4dc",
  "#f0dcd7",
  "#e6cdca",
  "#d9bebc",
  "#b39997",
  "#8f716e",
  "#674848",
  "#f2ebe6",
  "#f3dbd9",
  "#dbb9b6",
  "#c79d9b",
  "#a97673",
  "#8e5959",
  "#774041",
  "#e8dad6",
  "#e3d2ce",
  "#d9bcb7",
  "#cda09a",
  "#b57770",
  "#9b5b55",
  "#86423e",
  "#eee3dd",
  "#ebd1cd",
  "#e6c1bb",
  "#ca7c74",
  "#b1635e",
  "#a0403e",
  "#f1e0db",
  "#ebcfc9",
  "#e7cac3",
  "#ddb1a8",
  "#c7887f",
  "#ab6057",
  "#9b423f",
  "#eeded8",
  "#e9d2cc",
  "#dac0ba",
  "#c8a6a1",
  "#ad7d76",
  "#7b453e",
  "#ebd9d0",
  "#e3d1cc",
  "#decac5",
  "#cdaea5",
  "#aa8880",
  "#8a5d55",
  "#744034",
  "#efe7df",
  "#eaddd7",
  "#e3cbc0",
  "#c4a295",
  "#b4897d",
  "#976c60",
  "#715145",
  "#efe3d9",
  "#ead6ce",
  "#e3cec6",
  "#d7b1a5",
  "#b98675",
  "#9c6757",
  "#864f3e",
  "#f4e5dd",
  "#f0ded3",
  "#f2d1c4",
  "#d1907c",
  "#9f543e",
  "#f2e4dd",
  "#f4ded9",
  "#f1d2c9",
  "#ecbcb2",
  "#dd9789",
  "#c67363",
  "#a4493d",
  "#f1e2de",
  "#edd8d2",
  "#e9cfc8",
  "#e2bcb3",
  "#c99387",
  "#91493e",
  "#f1e6e0",
  "#f1ddd8",
  "#f1d3ca",
  "#ab6f60",
  "#8c4f42",
  "#ecdbd2",
  "#e8d3c9",
  "#e8cac0",
  "#e0b4a4",
  "#b1715a",
  "#9e6654",
  "#8f4c3a",
  "#efe4da",
  "#ecdfd6",
  "#e3c9be",
  "#d9b19f",
  "#be8973",
  "#a8715a",
  "#915b41",
  "#efdbcd",
  "#ebccb9",
  "#e5bca5",
  "#d3a083",
  "#bc886a",
  "#9f6949",
  "#935f43",
  "#eedacb",
  "#edd5c7",
  "#e7c3ac",
  "#d8a686",
  "#c48d69",
  "#a66e49",
  "#966544",
  "#eadfd2",
  "#ead4c4",
  "#e2c7b6",
  "#dbbba7",
  "#ba947b",
  "#996e5a",
  "#805b48",
  "#f0e8e0",
  "#e9dad2",
  "#d5bfb4",
  "#c3a79a",
  "#a2806f",
  "#896757",
  "#6c483a",
  "#e8d9ce",
  "#e3d1c8",
  "#d0bbb0",
  "#a58f85",
  "#8a7265",
  "#63493e",
  "#eee6db",
  "#eae0d4",
  "#dacbbf",
  "#bda998",
  "#957d6f",
  "#6e564a",
  "#efebe3",
  "#eae3d8",
  "#dfd5c8",
  "#bdada4",
  "#968379",
  "#736157",
  "#604a3f",
  "#eae3db",
  "#e4ded5",
  "#d0c2b4",
  "#b09f8f",
  "#988171",
  "#7d685b",
  "#63554b",
  "#f0e1cf",
  "#ebdac8",
  "#c4ae96",
  "#b19c86",
  "#998069",
  "#816b56",
  "#6c5b4d",
  "#eee9dc",
  "#e8e1d5",
  "#e3ceb8",
  "#a98a6b",
  "#8d725a",
  "#76604e",
  "#ebe3d8",
  "#e8e0d8",
  "#dbc8b6",
  "#c3ac98",
  "#aa8f7a",
  "#8c6e54",
  "#74563d",
  "#eadac6",
  "#e6c8a9",
  "#d8b691",
  "#c9a480",
  "#ba8f68",
  "#a37d5a",
  "#8d6a4a",
  "#f1e6d6",
  "#e6d0b6",
  "#e1c6a8",
  "#d3b191",
  "#b98d68",
  "#9f7250",
  "#936647",
  "#eee2d5",
  "#ead9cb",
  "#e3d0bf",
  "#dfc0a6",
  "#c89b75",
  "#b27d50",
  "#97653c",
  "#f0e8dd",
  "#f2e8db",
  "#eed8c2",
  "#e7ceb5",
  "#d2ad87",
  "#b08a61",
  "#926b43",
  "#efe8dc",
  "#ece2d4",
  "#ddcfbc",
  "#cdb69b",
  "#b19576",
  "#967b5d",
  "#75583d",
  "#eae4d6",
  "#e4d9c5",
  "#dcccb4",
  "#c6b49c",
  "#ab9378",
  "#8f775d",
  "#7a634d",
  "#eeeadd",
  "#eae2d1",
  "#e1cfb2",
  "#d2bc9b",
  "#b89e78",
  "#a68966",
  "#967859",
  "#eee6db",
  "#efe5d9",
  "#ead8c1",
  "#e0ceb7",
  "#d1b088",
  "#ab8659",
  "#977043",
  "#f0e8d9",
  "#eedec7",
  "#ebd5b7",
  "#d8b98c",
  "#c9a375",
  "#ad8458",
  "#9b7448",
  "#f5e7d2",
  "#f6e6cb",
  "#efd7b3",
  "#e2c59c",
  "#c7a06c",
  "#bc9263",
  "#a17b4d",
  "#f4e7ce",
  "#ebd0a4",
  "#dbb881",
  "#d4ae76",
  "#c49e69",
  "#b28959",
  "#9c7647",
  "#f2ebd3",
  "#f1e9cf",
  "#f0ddb8",
  "#e2c392",
  "#d0ab70",
  "#b5905a",
  "#a67e4b",
  "#f2eede",
  "#f2ebd6",
  "#e7d2ad",
  "#d3b78b",
  "#c09c6a",
  "#af8a5b",
  "#97774d",
  "#f2edd7",
  "#cbb489",
  "#b19466",
  "#a48454",
  "#e6ddc6",
  "#e3d3b5",
  "#d9c3a1",
  "#d4bc94",
  "#b8996b",
  "#af9468",
  "#8b714b",
  "#f1e8d8",
  "#efe3d2",
  "#e5d3b9",
  "#d8c39f",
  "#c2a377",
  "#a78658",
  "#886a3f",
  "#ede7d2",
  "#ece3cc",
  "#dccaa8",
  "#ccb896",
  "#b3956c",
  "#a0855c",
  "#7f6640",
  "#e9e5d7",
  "#e4dfd1",
  "#dacfba",
  "#c9bba3",
  "#ac9a7e",
  "#8b795f",
  "#756244",
  "#efe9d9",
  "#e8ddc6",
  "#decfb3",
  "#cdba99",
  "#ad9773",
  "#937b56",
  "#715d3d",
  "#ebe5d2",
  "#e6e0cc",
  "#dbceac",
  "#d0bd94",
  "#af9a73",
  "#9c8866",
  "#877252",
  "#ecda9e",
  "#ead795",
  "#d8c475",
  "#ccbf88",
  "#b1a26a",
  "#9d8a50",
  "#8e824e",
  "#6e6a4c",
  "#dad7ad",
  "#c8cda0",
  "#e4eab7",
  "#b7ad6e",
  "#acb17e",
  "#949b64",
  "#848947",
  "#708054",
  "#9c9273",
  "#b0a584",
  "#c2b79a",
  "#adaa96",
  "#d6dbc0",
  "#808677",
  "#838463",
  "#d0c6a1",
  "#89876a",
  "#afa984",
  "#b3ae87",
  "#afa97d",
  "#9c9369",
  "#f2efe1",
  "#f2ecd9",
  "#dacba9",
  "#b8a47a",
  "#a8946b",
  "#9a845e",
  "#88724d",
  "#eae6d9",
  "#e5ddc8",
  "#cec1a5",
  "#ac9877",
  "#867354",
  "#695f4f",
  "#ebe8db",
  "#e3ddcc",
  "#c4baa1",
  "#b9ab8f",
  "#9f906e",
  "#847451",
  "#665c46",
  "#f0eada",
  "#e5dbc5",
  "#c5b28b",
  "#a58e61",
  "#917747",
  "#77623a",
  "#eee9d9",
  "#ebe5d0",
  "#e7dbbf",
  "#d2c098",
  "#ae996b",
  "#8d794f",
  "#82714d",
  "#f0e9d6",
  "#f0e9d1",
  "#e7d5ad",
  "#bb9f6a",
  "#a78a50",
  "#f5e9ca",
  "#f1d9a5",
  "#e5c382",
  "#e6c26f",
  "#d7ad62",
  "#c09856",
  "#b08843",
  "#f3eecd",
  "#f6eec0",
  "#ede1a8",
  "#ddc073",
  "#cba956",
  "#c39e44",
  "#f4f0d2",
  "#f5eec6",
  "#f0e4b2",
  "#e5d295",
  "#d1b871",
  "#bba262",
  "#ae9550",
  "#ede5bc",
  "#e8ddae",
  "#e2d39b",
  "#d7c275",
  "#c8b165",
  "#b59f55",
  "#a28b36",
  "#ede6b3",
  "#e4d89a",
  "#d2c880",
  "#c6bb68",
  "#a79954",
  "#9f9049",
  "#8c7f3c",
  "#e8e6d9",
  "#e3dec6",
  "#d0c6a1",
  "#bbac7d",
  "#9c8f60",
  "#887647",
  "#75693d",
  "#eae6d7",
  "#e0dbc7",
  "#d4cdb5",
  "#c6bb9c",
  "#b0a582",
  "#9e8f66",
  "#726647",
  "#dddbc5",
  "#d1ceb4",
  "#c5c1a3",
  "#9c946e",
  "#7a744d",
  "#5d583e",
  "#e8e7d7",
  "#dedbc4",
  "#d0cca9",
  "#bcb58a",
  "#a49d70",
  "#8d8752",
  "#797447",
  "#e8ecdb",
  "#e4e5d2",
  "#dbdcc4",
  "#c3c6a4",
  "#9c9f75",
  "#8c8e65",
  "#71714e",
  "#eaecd3",
  "#e0e3c8",
  "#e1e1be",
  "#bab078",
  "#a69a5c",
  "#8c8449",
  "#e9edc0",
  "#e3ebb1",
  "#d4e092",
  "#bacb7c",
  "#adb864",
  "#99a456",
  "#898c4a",
  "#e6e8c5",
  "#dadeb5",
  "#cdd3a3",
  "#bac08a",
  "#a0a667",
  "#888f4f",
  "#757d43",
  "#e9e9d0",
  "#e4e4c5",
  "#dcddb8",
  "#c8cc9e",
  "#b4b780",
  "#9ea26b",
  "#868b53",
  "#eaeede",
  "#e0ead7",
  "#d8e6cb",
  "#c6d4ac",
  "#afc195",
  "#91a673",
  "#6a7d4e",
  "#e3e8d9",
  "#dae1cf",
  "#d0dbc4",
  "#bbc6a4",
  "#9aa77c",
  "#7e8d60",
  "#5f6c3c",
  "#e8e8d7",
  "#dfe3d0",
  "#cfd2b5",
  "#b9bd97",
  "#9da073",
  "#7f8353",
  "#6d7244",
  "#ececdf",
  "#eaeadb",
  "#e0e1d1",
  "#cbccb5",
  "#a4a582",
  "#8b8c6b",
  "#6b6d4e",
  "#e1e5d7",
  "#d8dece",
  "#c7cfbe",
  "#b2b9a5",
  "#92987d",
  "#6d765b",
  "#576049",
  "#e1e1d5",
  "#c8cab5",
  "#acaf95",
  "#909373",
  "#6d6f4f",
  "#57593f",
  "#e9ebde",
  "#e5e6d7",
  "#ddddcc",
  "#bfc3ae",
  "#9da286",
  "#797e65",
  "#676c58",
  "#dde6d7",
  "#d8ddcc",
  "#ced3c1",
  "#abb39e",
  "#81876f",
  "#636653",
  "#5c5f4b",
  "#dadcd3",
  "#cfd2c7",
  "#c5cabe",
  "#bec4b7",
  "#939a89",
  "#737b6c",
  "#525746",
  "#dfe6da",
  "#cad5c8",
  "#cdd4c6",
  "#b4c0af",
  "#8e9b88",
  "#768371",
  "#50594f",
  "#e1e8db",
  "#dce5d8",
  "#d0ddcc",
  "#bad1b5",
  "#91af88",
  "#729067",
  "#4d663e",
  "#e3eee3",
  "#d2e6d3",
  "#c8dfc3",
  "#a2c7a3",
  "#89b386",
  "#658e64",
  "#53734c",
  "#dbe9df",
  "#c6decf",
  "#aad0ba",
  "#86bb9d",
  "#64a281",
  "#478865",
  "#236649",
  "#dde7df",
  "#c8dbce",
  "#bdd0c3",
  "#9db7a5",
  "#7a9682",
  "#56745f",
  "#3f5948",
  "#e6eae0",
  "#e2e8df",
  "#deeae0",
  "#b3c6b9",
  "#899a8b",
  "#6a7b6b",
  "#415241",
  "#e4e8e1",
  "#dee4dc",
  "#d7dfd6",
  "#b3c4ba",
  "#83988c",
  "#728478",
  "#54645c",
  "#e0e9e4",
  "#dee8e3",
  "#d5e3de",
  "#bacbc4",
  "#91a49d",
  "#71847d",
  "#4a5b51",
  "#ecf1ec",
  "#e6f0ea",
  "#dcece7",
  "#adc8c0",
  "#829f96",
  "#637d74",
  "#395648",
  "#d8e5dd",
  "#c4d7cf",
  "#afc7bf",
  "#8caea3",
  "#6d9185",
  "#477266",
  "#3c574e",
  "#d3e5db",
  "#bfd6c8",
  "#a2c2b0",
  "#80aa95",
  "#638f7b",
  "#3d6c54",
  "#305a4a",
  "#d7e7e0",
  "#bbdbd0",
  "#a1cdbf",
  "#7fb6a4",
  "#599c89",
  "#2b7b66",
  "#006a50",
  "#d8e7e1",
  "#c3dcd5",
  "#aed0c9",
  "#89bab2",
  "#609d91",
  "#45867c",
  "#116356",
  "#d6e7e3",
  "#cde2de",
  "#bcd7d4",
  "#9bc2bd",
  "#72a49f",
  "#4d8681",
  "#10605a",
  "#e1ebe5",
  "#c8d7d2",
  "#b7ccc7",
  "#94b1a9",
  "#75978f",
  "#4c726b",
  "#2e5a50",
  "#cbd9d7",
  "#becfcd",
  "#a2b7b5",
  "#7c9793",
  "#56736f",
  "#365955",
  "#e7eee8",
  "#dae6e3",
  "#d6e5e2",
  "#a8bbba",
  "#809391",
  "#576b6b",
  "#3c504f",
  "#dce6e3",
  "#d3e0de",
  "#c7dbd9",
  "#a0c0bf",
  "#6d9a9b",
  "#487a7b",
  "#155e60",
  "#dce6e5",
  "#cfe2e0",
  "#bcdbdb",
  "#8cc3c3",
  "#57a1a0",
  "#247e81",
  "#00686d",
  "#d4e3e2",
  "#d5e2e1",
  "#cadada",
  "#a1bdbf",
  "#7a999c",
  "#4b7378",
  "#2a545c",
  "#dbe4e5",
  "#cedee2",
  "#c2d3d6",
  "#96afb7",
  "#708e95",
  "#4a6871",
  "#2d5360",
  "#d3e4e6",
  "#cee0e3",
  "#b7d7de",
  "#8fbcc4",
  "#4e9aa8",
  "#1b7d8d",
  "#00697c",
  "#d9e4e5",
  "#cbdee2",
  "#b4d0d9",
  "#88b5c4",
  "#5e97a9",
  "#34788c",
  "#04627a",
  "#d9e3e5",
  "#d1dee4",
  "#a8c0ce",
  "#7f9daf",
  "#638496",
  "#365d73",
  "#2b526a",
  "#e8efec",
  "#e3ebea",
  "#d7e0e2",
  "#adbfc8",
  "#7b8f99",
  "#526771",
  "#334b58",
  "#ecf0eb",
  "#d4e2e6",
  "#cddce3",
  "#adc6d3",
  "#819daa",
  "#5d7b89",
  "#2d5367",
  "#e1eaec",
  "#dfebee",
  "#bccedb",
  "#8ea7b9",
  "#607b8e",
  "#2e5169",
  "#dee6e7",
  "#cad7de",
  "#a2bacb",
  "#7595ab",
  "#53778f",
  "#2d5975",
  "#2c4d69",
  "#d7e2e5",
  "#c5d9e3",
  "#abc8d8",
  "#82acc4",
  "#5692b2",
  "#347699",
  "#005e88",
  "#d8e4e8",
  "#c3d9e4",
  "#a4c3d7",
  "#78a7c3",
  "#528bab",
  "#296d93",
  "#185887",
  "#dfe7e8",
  "#c4d3dc",
  "#a3bbcd",
  "#789bb6",
  "#507b9a",
  "#1d5c83",
  "#2b4d68",
  "#dae1e3",
  "#c1ceda",
  "#abbed0",
  "#8da8be",
  "#5a809e",
  "#3a5f7d",
  "#dae3e7",
  "#bed1e1",
  "#a1bed9",
  "#729cc2",
  "#4f84af",
  "#286492",
  "#234e86",
  "#d7e0e7",
  "#c7d3e0",
  "#adc0d6",
  "#7e9ec2",
  "#5d84b1",
  "#326395",
  "#314a76",
  "#dde4e8",
  "#c7d1db",
  "#b6c3d1",
  "#9eafc2",
  "#6c8096",
  "#4c6177",
  "#314d67",
  "#e8ecee",
  "#dae4ee",
  "#d6dfe7",
  "#aebbd0",
  "#8290a6",
  "#627188",
  "#384a66",
  "#dfe2e5",
  "#d0d7df",
  "#bfc7d4",
  "#a4b0c4",
  "#7b8ca8",
  "#556682",
  "#3a405a",
  "#dde2e6",
  "#99aac8",
  "#6d86b6",
  "#4f6997",
  "#374874",
  "#e3e5e8",
  "#dcdfe5",
  "#cbd0dd",
  "#a7b0cc",
  "#818db3",
  "#627099",
  "#465383",
  "#e6e6e7",
  "#dadbdf",
  "#c7ccd8",
  "#a4abbf",
  "#838ba4",
  "#606a88",
  "#3d496d",
  "#e3e4e5",
  "#dbdce2",
  "#d1d2dc",
  "#afb2c4",
  "#898ca3",
  "#6b6d85",
  "#464b6a",
  "#e2e3eb",
  "#dde0ea",
  "#d1d3e0",
  "#b1b3cb",
  "#8e90b4",
  "#686b93",
  "#4d517f",
  "#e5e7e8",
  "#e4e6ea",
  "#dadee6",
  "#b8b9cb",
  "#9090a2",
  "#6e6f82",
  "#464960",
  "#eeedea",
  "#eae8ec",
  "#d4cfd6",
  "#b9b3bf",
  "#928a98",
  "#6a6472",
  "#4a4354",
  "#dfdee5",
  "#e0dee3",
  "#d3d1dc",
  "#bebbc9",
  "#9b95a9",
  "#78738b",
  "#544f66",
  "#e4e1e4",
  "#dad6df",
  "#cdc8d2",
  "#b9b3c2",
  "#9b8fa6",
  "#736a86",
  "#4e4260",
  "#dedbe5",
  "#d3d0dd",
  "#beb8cd",
  "#988eb4",
  "#736993",
  "#534a77",
  "#e6dee6",
  "#e5dde7",
  "#d6cbda",
  "#c2b1c8",
  "#a387ac",
  "#886793",
  "#694878",
  "#e7e3e7",
  "#e0d8df",
  "#d6c7d6",
  "#c2aec3",
  "#a489a3",
  "#7e667f",
  "#5f4561",
  "#e7dfe3",
  "#e5d8e1",
  "#dccad8",
  "#cfb7c9",
  "#af8ea5",
  "#87657e",
  "#654161",
  "#e7e1e3",
  "#e1d9dc",
  "#dbccd3",
  "#ceb9c4",
  "#b495a4",
  "#8e6278",
  "#603e53",
  "#e5dae1",
  "#e6d9e2",
  "#e5cfde",
  "#d8b7cf",
  "#bf91b2",
  "#a16c94",
  "#7f4774",
  "#f3dfe3",
  "#f3d8e0",
  "#f4c8d5",
  "#efa7bf",
  "#e585a5",
  "#da6d91",
  "#c6577c",
  "#efe1e4",
  "#f0d6dd",
  "#eec8d3",
  "#e3a4b8",
  "#d6859f",
  "#c66787",
  "#ab446b",
  "#f0dee0",
  "#f1d3d9",
  "#ecbfc9",
  "#e69dad",
  "#d1768c",
  "#c7607b",
  "#ac3e5f",
  "#f4e4e5",
  "#f5cdd2",
  "#f5b3bc",
  "#f392a0",
  "#e26b81",
  "#d45871",
  "#ca4b65",
  "#f4dbd9",
  "#f7cccd",
  "#f6b5b6",
  "#f3949b",
  "#e66a77",
  "#da5265",
  "#c53a4b",
  "#f2dbdb",
  "#f3cacb",
  "#f1b3b6",
  "#e68e96",
  "#d16d76",
  "#bb4f5c",
  "#a83e4c",
  "#f3d9d6",
  "#f3d2cf",
  "#f2c1c0",
  "#ec9b9d",
  "#d87678",
  "#c3585c",
  "#ac3a3e",
  "#f4e4e0",
  "#f6d8d7",
  "#f7c2bf",
  "#f6a09d",
  "#ec7878",
  "#e15f65",
  "#c6494c",
  "#f5e2de",
  "#f6dbd3",
  "#f7cac1",
  "#f7b1a6",
  "#ee867d",
  "#d1584c",
  "#b44940",
  "#f3e0db",
  "#f2dbd6",
  "#f3c8c2",
  "#eaaaa2",
  "#db8079",
  "#c26157",
  "#aa423a",
  "#f3ece7",
  "#f2e3dc",
  "#efc4bb",
  "#e5a090",
  "#d78775",
  "#c3705f",
  "#af5941",
  "#f3e5dc",
  "#f3e0d8",
  "#f0d1c8",
  "#efc1b5",
  "#e49c86",
  "#d88167",
  "#bf5b3c",
  "#f3e9e0",
  "#f6e2d8",
  "#f7dfd7",
  "#f5c8bb",
  "#f9a48e",
  "#df745b",
  "#c9543a",
  "#f4e8e1",
  "#f5e5dc",
  "#f4ded3",
  "#f0b9a9",
  "#ea9073",
  "#e07757",
  "#bc5339",
  "#f2ebe1",
  "#f4e2d4",
  "#f1d4c4",
  "#f0b599",
  "#f2a37d",
  "#e88a5b",
  "#d86f3c",
  "#f3ddcd",
  "#f4d9c8",
  "#f5d5c2",
  "#f5be9d",
  "#f7a270",
  "#f09056",
  "#e68750",
  "#f2e9de",
  "#f2e1d2",
  "#f6d8be",
  "#f7c5a0",
  "#faac72",
  "#f69a54",
  "#ef924a",
  "#f4decb",
  "#f3d4bf",
  "#f2c6a7",
  "#edaa80",
  "#dc8c59",
  "#ce7639",
  "#c26a35",
  "#f4e2d6",
  "#f3dfd4",
  "#edc7b6",
  "#e4b095",
  "#cf8d6c",
  "#c37c59",
  "#ac5e3a",
  "#f9e4ae",
  "#f0ddbb",
  "#e7c26f",
  "#d4b57f",
  "#f5e4bf",
  "#e2c28d",
  "#efd7ab",
  "#e6b570",
  "#f1e7ce",
  "#f0debb",
  "#e5ca9e",
  "#dcc49b",
  "#e8dbc4",
  "#e1cca6",
  "#c2ae88",
  "#efd7a7",
  "#e0c796",
  "#c1a87c",
  "#ccb88d",
  "#e1cfa5",
  "#cfb989",
  "#ab8f55",
  "#f4e4c6",
  "#e1d0b2",
  "#f0e5c7",
  "#e7d9b9",
  "#e2d0ad",
  "#ceba97",
  "#dfcca6",
  "#e8d7b8",
  "#f3e4d5",
  "#f4d9c5",
  "#f0c3a7",
  "#e6a57f",
  "#cf875e",
  "#c17444",
  "#b66a3c",
  "#f1e4d7",
  "#efdcca",
  "#efcdb4",
  "#e8b793",
  "#d59466",
  "#cc8149",
  "#bc6f37",
  "#f1e9dd",
  "#f3e3d1",
  "#f3dcc6",
  "#eec9aa",
  "#e2ac78",
  "#d09258",
  "#c27f38",
  "#f3ecdc",
  "#f5e9d5",
  "#f4debf",
  "#f9d09f",
  "#fbc17b",
  "#f2ad62",
  "#ed9b44",
  "#f4eedc",
  "#f3ead2",
  "#f9e7bf",
  "#fbdca8",
  "#f9c982",
  "#f7c070",
  "#f7b74e",
  "#f4f0de",
  "#f5efd6",
  "#f8e9c2",
  "#fcdfa4",
  "#fdd792",
  "#ffc863",
  "#ffbc35",
  "#f4f0da",
  "#f6eecd",
  "#f7ecca",
  "#fbe4af",
  "#ffd978",
  "#ffd15c",
  "#ffc632",
  "#f1ede0",
  "#f4e8d1",
  "#f3e2c6",
  "#efcea0",
  "#e1b270",
  "#cc974d",
  "#b98033",
  "#f1eee2",
  "#f3e9cf",
  "#f3dfb6",
  "#ecc481",
  "#dfac59",
  "#ce9844",
  "#bb852f",
  "#f3edd9",
  "#f4e5c5",
  "#f5deae",
  "#f3c775",
  "#edb856",
  "#e1a84b",
  "#c89134",
  "#f4ebd0",
  "#f6e5b9",
  "#f6e0a9",
  "#f6d48d",
  "#ecbe63",
  "#e3b34c",
  "#d6a332",
  "#f3f0d6",
  "#f3efcd",
  "#f9ecb6",
  "#fce79a",
  "#f9d97b",
  "#fbd05c",
  "#ffc943",
  "#f1f0d6",
  "#f4efc3",
  "#f5edb2",
  "#f6eba1",
  "#fdea83",
  "#ffdf38",
  "#ffd637",
  "#f0f0e0",
  "#f2efcd",
  "#f4eeba",
  "#f5edae",
  "#f8eb97",
  "#f6db5d",
  "#efcc44",
  "#f0eddb",
  "#f0ead2",
  "#f7eab9",
  "#f3e4a7",
  "#f6d76e",
  "#e4c14d",
  "#d8ad39",
  "#f1f1e6",
  "#f0edd1",
  "#f0e7a9",
  "#efde75",
  "#e2c74f",
  "#ceb02a",
  "#b8a02a",
  "#eef0d6",
  "#eaefce",
  "#e9edbd",
  "#ebeca7",
  "#ece678",
  "#e6d943",
  "#d9c737",
  "#eff0d3",
  "#eaecb9",
  "#e4e8a7",
  "#d9e6a6",
  "#cfdb8d",
  "#cdd47f",
  "#c9cc4a",
  "#edeec5",
  "#edebb4",
  "#e1dd8e",
  "#d5ce69",
  "#beb755",
  "#a6a23f",
  "#9b983d",
  "#ebf0d6",
  "#e3ebae",
  "#d9e49e",
  "#ccd87a",
  "#bece61",
  "#afbb42",
  "#9aa22b",
  "#ecf0da",
  "#edefcb",
  "#e5ecb7",
  "#deeaaa",
  "#d0e798",
  "#bed565",
  "#a8c74d",
  "#ecf1e2",
  "#ddedbd",
  "#d5ebac",
  "#c1e089",
  "#a5cb66",
  "#98bd3c",
  "#e6ecd6",
  "#e6eccc",
  "#dbe5b9",
  "#cedda2",
  "#aec571",
  "#96af54",
  "#7a973b",
  "#e3ede0",
  "#deead8",
  "#d2e3cc",
  "#bad7ae",
  "#96bf83",
  "#76a55b",
  "#588c3a",
  "#ecf0e5",
  "#e8f0e2",
  "#e4efde",
  "#d7eccd",
  "#bfe5b1",
  "#9ed686",
  "#79be58",
  "#e3efe1",
  "#dceedb",
  "#cdeacd",
  "#bee5be",
  "#92d599",
  "#6bc271",
  "#41a94f",
  "#dae9dc",
  "#d1e6d5",
  "#b9dcc3",
  "#9acda9",
  "#68b082",
  "#529d6e",
  "#027944",
  "#dbeee0",
  "#c4ead5",
  "#a7e0c2",
  "#79d0a7",
  "#47ba87",
  "#31aa74",
  "#00955e",
  "#ddeee2",
  "#c1e5d5",
  "#a2d4bd",
  "#80c4a9",
  "#52a786",
  "#29906d",
  "#007958",
  "#d4ede3",
  "#bde8d8",
  "#98ddc5",
  "#5ecaae",
  "#1db394",
  "#00a483",
  "#008b6d",
  "#d9eae5",
  "#bde1d8",
  "#a5d8cd",
  "#46a795",
  "#007e6b",
  "#e2ebe5",
  "#c5e5e2",
  "#b5deda",
  "#8fcdc7",
  "#5eb2aa",
  "#2b9890",
  "#007c75",
  "#e1ede6",
  "#d4ede6",
  "#abe3de",
  "#80d7cf",
  "#41bfb5",
  "#00a49b",
  "#00938b",
  "#deeeed",
  "#d2ebea",
  "#c3e7e8",
  "#b5e4e4",
  "#70cbce",
  "#3fbabd",
  "#009a9e",
  "#e5f1ee",
  "#d3e7e5",
  "#bfdfdf",
  "#8ecfd0",
  "#4fb3b3",
  "#1a9597",
  "#00787f",
  "#e8efec",
  "#c4dde2",
  "#94c8d2",
  "#55a7b6",
  "#1e8ea1",
  "#007a91",
  "#deeced",
  "#d3e9ec",
  "#c6e4eb",
  "#9cd4e1",
  "#59b9cc",
  "#26a5ba",
  "#0090a8",
  "#e3eded",
  "#cfe4ee",
  "#aed7ea",
  "#80c1e2",
  "#48a8d0",
  "#1993be",
  "#007dac",
  "#dae6e9",
  "#d0e1e8",
  "#add0e0",
  "#7eb6d0",
  "#5397b7",
  "#2282a8",
  "#006a93",
  "#d6e1e4",
  "#ccdfe8",
  "#9fc9e4",
  "#66a9d3",
  "#3e8fbc",
  "#1d78ab",
  "#00619d",
  "#d3e5eb",
  "#cbe3ee",
  "#a3d1eb",
  "#6ab4e0",
  "#3398ce",
  "#1c8ac9",
  "#0072b5",
  "#d9e6ee",
  "#c8ddee",
  "#9bc7ea",
  "#62a5df",
  "#3d8ed0",
  "#1e80c7",
  "#0264ae",
  "#dae3e9",
  "#c2d7e9",
  "#97bee2",
  "#73a3d0",
  "#3c85be",
  "#1c70ad",
  "#1a5897",
  "#e0e8ec",
  "#d3e0ec",
  "#abcaea",
  "#7daee1",
  "#518fd1",
  "#3c7ac2",
  "#2863ad",
  "#dfe6ea",
  "#d0dce8",
  "#a3bcdb",
  "#7ea3d2",
  "#5488c0",
  "#356fad",
  "#1c5798",
  "#dde0e8",
  "#dadee9",
  "#cbd1e1",
  "#abb6d7",
  "#8394c5",
  "#6274ab",
  "#445397",
  "#dee2ec",
  "#d7ddec",
  "#c9d1e9",
  "#adbae3",
  "#8596d2",
  "#7487c6",
  "#5868ae",
  "#e8e6e8",
  "#e4e1ea",
  "#dbd7e4",
  "#c6bedd",
  "#a598c7",
  "#8278ad",
  "#5a4e88",
  "#edecec",
  "#e8e5ec",
  "#e3dfec",
  "#d0c8e6",
  "#ada2ce",
  "#9488be",
  "#76679e",
  "#e9e1e8",
  "#e3d7e5",
  "#dccae0",
  "#c9afd0",
  "#a885b5",
  "#9569a3",
  "#795088",
  "#ebdfea",
  "#e8deea",
  "#dfcae4",
  "#cfb1d8",
  "#b48ac2",
  "#a475b1",
  "#835995",
  "#ebe2e8",
  "#eae0e8",
  "#e8d2e3",
  "#e1bed9",
  "#cc94be",
  "#ad6ea0",
  "#905284",
  "#ede5e8",
  "#eee1eb",
  "#e7c2de",
  "#dba3ce",
  "#c37cb3",
  "#9d5a8f",
  "#91575d",
  "#824e4a",
  "#723f45",
  "#89585d",
  "#72494a",
  "#604344",
  "#6b4d5f",
  "#a34747",
  "#964647",
  "#943e4d",
  "#8f4347",
  "#9c4d52",
  "#a54f5d",
  "#a34a3e",
  "#9d3e3f",
  "#595461",
  "#605258",
  "#7c6b76",
  "#705c79",
  "#a0a0aa",
  "#817c85",
  "#295266",
  "#1c6b75",
  "#455c59",
  "#3a5a55",
  "#4f6450",
  "#4c6b4e",
  "#b4aaa0",
  "#9c8f83",
  "#e0ded8",
  "#bab2ab",
  "#3d4645",
  "#948e82",
  "#e0dbcd",
  "#c0af92",
  "#d9cdb5",
  "#d5d3c3",
  "#eeeada",
  "#a0917e",
  "#c7b8a4",
  "#eae3d6",
  "#efece2",
  "#d7c8b1",
  "#d3bc9e",
  "#e4d5bc",
  "#efe9da",
  "#dfd4c4",
  "#eee8d9",
  "#e9e6dd",
  "#d3d1be",
  "#c8c0aa",
  "#b8ae98",
  "#aaa492",
  "#dad1c6",
  "#e5e1d8",
  "#cec7b8",
  "#bb9b7d",
  "#996f45",
  "#ae8661",
  "#c7a98d",
  "#efebde",
  "#f5f0e2",
  "#e5caa2",
  "#cca571",
  "#baa589",
  "#ae9676",
  "#c8ac89",
  "#c4ad92",
  "#6f5746",
  "#98754e",
  "#6d6053",
  "#a39281",
  "#887b6e",
  "#766859",
  "#625141",
  "#624e45",
  "#544642",
  "#c8bcab",
  "#e5dac8",
  "#cbc1b4",
  "#b7a696",
  "#9d8c7c",
  "#c6b092",
  "#8b7867",
  "#d1ac99",
  "#c79c7c",
  "#c58f68",
  "#b78565",
  "#b88a74",
  "#a27253",
  "#9d6f59",
  "#784c42",
  "#f1e2c6",
  "#d9bc86",
  "#e2b46c",
  "#cd9647",
  "#ac854e",
  "#cc9859",
  "#ac7b44",
  "#a9805d",
  "#bc946d",
  "#cda885",
  "#c68b5a",
  "#ae703b",
  "#b07447",
  "#a76c40",
  "#835842",
  "#574642",
  "#e8cbb4",
  "#c18978",
  "#b7735e",
  "#9a5247",
  "#9b6046",
  "#a15c49",
  "#89483e",
  "#96addc",
  "#5072b1",
  "#314a76",
  "#7e84b5",
  "#816d95",
  "#b08aae",
  "#c86e94",
  "#c25a88",
  "#a54976",
  "#a24041",
  "#d9624e",
  "#fcd766",
  "#f1c96a",
  "#ebb454",
  "#dfb170",
  "#fdae6f",
  "#ef913e",
  "#d07d4d",
  "#d67953",
  "#d5d16b",
  "#aaac32",
  "#b6c876",
  "#729167",
  "#97d4c0",
  "#bce7d1",
  "#86c7bf",
  "#00908d",
  "#f2f0e6",
  "#d8cdc4",
  "#cab8ab",
  "#c3b8b7",
  "#bb9e9b",
  "#c49b9e",
  "#af8f9e",
  "#a18a8d",
  "#ece9dd",
  "#f2e9dc",
  "#f3eae3",
  "#f4e4d9",
  "#eedbce",
  "#dfc4b9",
  "#e3b8a9",
  "#c59687",
  "#ece2e3",
  "#ead7d9",
  "#dab7bb",
  "#b68190",
  "#a37379",
  "#a0666b",
  "#9c6071",
  "#7c3f55",
  "#f4e5d2",
  "#e5ccbd",
  "#e7c3ab",
  "#e3beb0",
  "#c67976",
  "#be727c",
  "#b2656c",
  "#ab5959",
  "#DCDED4",
  "#876B61",
  "#DBDED9",
  "#BFC4CC",
  "#5F696D",
  "#8C8071",
  "#6F6558",
  "#E8E4D9",
  "#78757C",
  "#47464A",
  "#7F9469",
  "#D6EAE2",
  "#9DAEA5",
  "#A77F4F",
  "#454446",
  "#745E4C",
  "#BAB2A9",
  "#CDCAC0",
  "#ECDDCA",
  "#658289",
  "#43474A",
  "#C3D7D1",
  "#1F615B",
  "#8FAEAB",
  "#3A5D48",
  "#63554A",
  "#DACFB9",
  "#DBE5DF",
  "#A8AEAF",
  "#A18569",
  "#AF8A70",
  "#C4C8C7",
  "#D9D5D8",
  "#6A6D6F",
  "#637381",
  "#735245",
  "#C8D0CF",
  "#C7B3A3",
  "#7A5C4E",
  "#E1E5DF",
  "#5F6A6E",
  "#9CA2B2",
  "#82B1B3",
  "#F1DFC7",
  "#ABCAD6",
  "#007783",
  "#DBC8A8",
  "#9E5F56",
  "#747F56",
  "#7D8991",
  "#4A7E83",
  "#697A5A",
  "#BDC8CD",
  "#BEB09F",
  "#96ABB0",
  "#536A71",
  "#6398A6",
  "#625557",
  "#D7C4B1",
  "#62524B",
  "#697178",
  "#BEA58E",
  "#CCB8A9",
  "#B9C2C3",
  "#B0A9A7",
  "#137FA6",
  "#C7B098",
  "#584B4A",
  "#545552",
  "#54595D",
  "#514745",
  "#5B5256",
  "#404547",
  "#3D3E3E",
  "#DAC7B6",
  "#F5DFCB",
  "#A2D5E5",
  "#D8E1D7",
  "#C9D4D9",
  "#BFE7DD",
  "#3E7DA3",
  "#00918B",
  "#006985",
  "#4E778E",
  "#D2E8DD",
  "#5DB7CA",
  "#96B3C1",
  "#007B86",
  "#A6ADB0",
  "#6F8FA7",
  "#3F4D58",
  "#84B0BB",
  "#60676D",
  "#838A8F",
  "#677772",
  "#CFD9DB",
  "#DFE5E2",
  "#A4D7E4",
  "#C7E6E6",
  "#C4DADE",
  "#D7C4BE",
  "#91D1DC",
  "#708EA8",
  "#4F6352",
  "#CCCDB9",
  "#9D7469",
  "#356179",
  "#9AACB7",
  "#D8C7B9",
  "#6B7063",
  "#81704D",
  "#ADCCD1",
  "#5F5A55",
  "#8B6057",
  "#DAC9B0",
  "#885149",
  "#7E6F5D",
  "#D7C6AF",
  "#98806A",
  "#6E5344",
  "#8F7257",
  "#F1E0CA",
  "#B1D8E3",
  "#BFB9A6",
  "#A19A8B",
  "#D7E4D9",
  "#E1C18D",
  "#F1E4CF",
  "#95856F",
  "#92857B",
  "#DACFB8",
  "#89B0C3",
  "#BA8F69",
  "#4FC0AF",
  "#BBC6CF",
  "#A59E84",
  "#4F4D52",
  "#C4AB87",
  "#ABB3B6",
  "#98765C",
  "#95B19E",
  "#E0E9D4",
  "#7A8E9C",
  "#338592",
  "#E8E2CA",
  "#EBDCC6",
  "#88B7BF",
  "#AD8548",
  "#CBA361",
  "#BEB8B6",
  "#8D8979",
  "#DFE3CD",
  "#D9CDC1",
  "#4D4B50",
  "#687365",
  "#8C8270",
  "#8C7E7A",
  "#158A8F",
  "#8B8075",
  "#E5CAAD",
  "#63979B",
  "#755E49",
  "#57A9B3",
  "#ABA69D",
  "#656269",
  "#916947",
  "#C3A598",
  "#A8BBBF",
  "#E3DDCD",
  "#E8D4AD",
  "#D0C191",
  "#C4B088",
  "#F1D4AE",
  "#EDEBE0",
  "#B4CDC8",
  "#BAE1E5",
  "#E9DAC0",
  "#D5A05D",
  "#CBC9CA",
  "#8C8476",
  "#D6EDE8",
  "#CFCACC",
  "#6F92A5",
  "#BDBEB0",
  "#C4B3AD",
  "#836A64",
  "#E3CFA5",
  "#ECD1A6",
  "#D2D7D5",
  "#CC9451",
  "#BDC1C2",
  "#F3E5C9",
  "#DFB495",
  "#C1B093",
  "#ADA296",
  "#A28058",
  "#D6E5E4",
  "#598A85",
  "#BDB8B8",
  "#AFA8AD",
  "#EBCFBA",
  "#90A9BA",
  "#B5B8AB",
  "#E0DCD9",
  "#7D6366",
  "#DFDFCC",
  "#714D47",
  "#686C48",
  "#8E7E81",
  "#E2C294",
  "#E9CFBD",
  "#917B48",
  "#C1BCA7",
  "#D1BB97",
  "#978269",
  "#D6CEC3",
  "#8DAC84",
  "#646F4D",
  "#6A8773",
  "#335851",
  "#68737B",
  "#C7C2CA",
  "#EACCB4",
  "#E6E0D6",
  "#58738A",
  "#E7C79C",
  "#A8A89D",
  "#888785",
  "#A3A997",
  "#579AA3",
  "#DFD3AE",
  "#D3E1C7",
  "#DEE8D3",
  "#B5D6BD",
  "#DDBD93",
  "#B9CDDB",
  "#756D6A",
  "#EEDDCF",
  "#B5E0E5",
  "#9BB295",
  "#B5CBD6",
  "#CFDDE4",
  "#555F54",
  "#D7E9E3",
  "#92867F",
  "#7B7069",
  "#5E604B",
  "#7E706A",
  "#655A4E",
  "#F1D2B0",
  "#678561",
  "#DAE7E2",
  "#A8BEB2",
  "#8E6C5D",
  "#645647",
  "#5F785A",
  "#EBDED2",
  "#E7DAD0",
  "#B2B5AE",
  "#816554",
  "#C58C56",
  "#B79D5F",
  "#D3B187",
  "#BD8546",
  "#DCAE6E",
  "#BF9759",
  "#D0BA85",
  "#C29A68",
  "#C0935C",
  "#E6CEAC",
  "#E2E3DD",
  "#CCC7C5",
  "#A7A4A8",
  "#B4B2B5",
  "#E9D3D0",
  "#838277",
  "#C1B8AB",
  "#EDE6D6",
  "#15715A",
  "#C0CDC3",
  "#96B6A7",
  "#476D50",
  "#ACC3A9",
  "#D8E1CA",
  "#BAA86D",
  "#D4C7BA",
  "#C2B4AB",
  "#006676",
  "#DBDED9",
  "#DFD8CD",
  "#CEC6BD",
  "#CFCAC5",
  "#E2E6D5",
  "#67656A",
  "#AABDBD",
  "#CCBDA2",
  "#CBB786",
  "#AD9775",
  "#A07B48",
  "#E0DCD5",
  "#817F82",
  "#A1D4C8",
  "#CA9C62",
  "#E7D9D6",
  "#8A755D",
  "#CEB5A2",
  "#918959",
  "#DFCABD",
  "#D2C6BD",
  "#B0875B",
  "#CBD1C6",
  "#B78247",
  "#2C5469",
  "#474C49",
  "#89807C",
  "#B9CEDC",
  "#C7B5AA",
  "#405D53",
  "#3D4B50",
  "#9CAEB0",
  "#A7D4DB",
  "#71849A",
  "#D7C9C0",
  "#A1B0C7",
  "#82856B",
  "#D9D9DB",
  "#5AA691",
  "#416F6C",
  "#424446",
  "#ACBBB3",
  "#5B715E",
  "#80928C",
  "#ADB68A",
  "#B0A898",
  "#A2D4CA",
  "#41A5B6",
  "#20879A",
  "#347B89",
  "#5B8DA2",
  "#637677",
  "#3E5875",
  "#E2DED9",
  "#BBC0B5",
  "#515047",
  "#ECE5E3",
  "#F3E2C7",
  "#AECBBD",
  "#DEE6D8",
  "#ADB3A7",
  "#B3C8CF",
  "#DADAD8",
  "#A5AAA1",
  "#E3DBD3",
  "#D1C7C5",
  "#937A7C",
  "#E0D9D2",
  "#EAC28E",
  "#796A6B",
  "#E6DBD2",
  "#C0A98D",
  "#CFCDBE",
  "#D9CED1",
  "#EDE0DA",
  "#49ACB0",
  "#D4DCD3",
  "#70C0C2",
  "#9F955F",
  "#325B7D",
  "#E3DFD0",
  "#6C5D57",
  "#DFE4D3",
  "#CAE0C7",
  "#CDC5B9",
  "#ACC4B5",
  "#625A4E",
  "#B6BAB5",
  "#E8CBB0",
  "#CCE2D0",
  "#DFE7DF",
  "#85A59A",
  "#DFBEBD",
  "#56555F",
  "#D1B8A9",
  "#BBCBCC",
  "#5A6D86",
  "#E8E2D3",
  "#C5DBDC",
  "#CEE7E4",
  "#70726B",
  "#645A49",
  "#9B8071",
  "#B99E9A",
  "#BFAA8C",
  "#8E8675",
  "#C1B3B2",
  "#B0B7B7",
  "#D6C8C0",
  "#D9D8CA",
  "#49545C",
  "#6F7159",
  "#778184",
  "#F0D7B6",
  "#BCA48A",
  "#C4DACE",
  "#C5B6A8",
  "#2E5D8A",
  "#706B6D",
  "#C7E3E7",
  "#CBD8CB",
  "#EEDDCC",
  "#A18161",
  "#C7CAC3",
  "#C2B7AB",
  "#80C1DD",
  "#EFDCD4",
  "#836D4E",
  "#A28F7D",
  "#C0B5B2",
  "#8FA9BF",
  "#969867",
  "#4C5F4E",
  "#69574C",
  "#23677E",
  "#D8E3D6",
  "#489084",
  "#62A0BF",
  "#CDDED3",
  "#E6DED0",
  "#3E6E85",
  "#E7E1D7",
  "#E2DBCD",
  "#E1D7D3",
  "#787A50",
  "#B2AEA9",
  "#E0E0D8",
  "#F5D9B2",
  "#EFDCD9",
  "#E6DCD2",
  "#D0CDB9",
  "#E2B99C",
  "#EACEB4",
  "#E5BC99",
  "#F0E0CF",
  "#DFB79F",
  "#75BBA9",
  "#E3DED4",
  "#9A7F4C",
  "#EBDBC7",
  "#9E7B6B",
  "#F4E2D5",
  "#E0DADC",
  "#EEE0E0",
  "#F0DCD7",
  "#F1DFD3",
  "#F1DCD7",
  "#CCB89B",
  "#DFDCD4",
  "#C4B69D",
  "#D2C6B5",
  "#DDE1E1",
  "#D8DFDB",
  "#82B7D1",
  "#927765",
  "#F0E9D8",
  "#C2E4E3",
  "#D5CCC6",
  "#BFAD84",
  "#EDE1DE",
  "#61665E",
  "#BFB7A6",
  "#E9DDC7",
  "#B2A2A2",
  "#55766D",
  "#635549",
  "#AEA099",
  "#92684F",
  "#7A8B81",
  "#B59F8E",
  "#A67B59",
  "#B7BEBF",
  "#15678C",
  "#A5D1D4",
  "#C6BEB0",
  "#947D6B",
  "#898A87",
  "#CAB39E",
  "#E5DCD1",
  "#E8CDC1",
  "#EBD1CD",
  "#EDDAD4",
  "#B9A398",
  "#EFE1D9",
  "#CAB1AC",
  "#E8CCC6",
  "#927770",
  "#674B49",
  "#A6DCDA",
  "#9DC4C1",
  "#5D5650",
  "#B79071",
  "#925146",
  "#E3DAD0",
  "#884D45",
  "#664941",
  "#B2AD97",
  "#417F91",
  "#B2A392",
  "#656A61",
  "#678B81",
  "#6BAB9F",
  "#BEA797",
  "#B7E7DD",
  "#C2E5E2",
  "#B3CCAB",
  "#958F87",
  "#DDEADB",
  "#80C3CA",
  "#D3E9E8",
  "#007369",
  "#719784",
  "#A9BAC3",
  "#DABAB2",
  "#595C53",
  "#DEDFD9",
  "#464949",
  "#ADA496",
  "#BCB7B2",
  "#826A55",
  "#DFE4E0",
  "#C6CBC9",
  "#DFE1E3",
  "#E0DED5",
  "#DECEB0",
  "#EED9D2",
  "#D5C9B2",
  "#E7DFC4",
  "#DBE6E3",
  "#51544B",
  "#B8BAB5",
  "#DCE7E3",
  "#6F5B4B",
  "#898384",
  "#B2C7D1",
  "#F3D4B1",
  "#E5E4DA",
  "#EEE7DD",
  "#E4E5E3",
  "#F1E0CB",
  "#736765",
  "#B29B65",
  "#7E685A",
  "#10A1A0",
  "#B5AA9E",
  "#A18A54",
  "#B3794B",
  "#BFD1C7",
  "#C6CFA8",
  "#C6D7BF",
  "#A4B690",
  "#E7E1DE",
  "#516B4C",
  "#F5E8D3",
  "#D6AF7D",
  "#939B9F",
  "#9A8462",
  "#9AA8B7",
  "#7D7974",
  "#E4E5DE",
  "#7A6E60",
  "#706960",
  "#EEC795",
  "#DADEDA",
  "#ABAD96",
  "#D7B595",
  "#73696F",
  "#587188",
  "#706F5E",
  "#EFEFE5",
  "#694842",
  "#CABCA4",
  "#B1D6E3",
  "#EEE0C2",
  "#B0AF80",
  "#C9C9C0",
  "#F1E1CE",
  "#EDDBD1",
  "#C3D6DA",
  "#51604D",
  "#C4A697",
  "#E4E3D8",
  "#CDB592",
  "#997C6F",
  "#DDCCA5",
  "#7B6D60",
  "#438E7C",
  "#E2E3E1",
  "#C4927A",
  "#8E7E6E",
  "#D0B6AA",
  "#AFAC9C",
  "#78B9AE",
  "#B1D2D5",
  "#7B7064",
  "#9D8F77",
  "#676E70",
  "#5E4940",
  "#7F8B7B",
  "#718D6D",
  "#D0CCBC",
  "#EDD4D0",
  "#9D834C",
  "#B1ACAC",
  "#C9D7DC",
  "#4D614C",
  "#5B7E6F",
  "#299F95",
  "#3C5575",
  "#E3DCBC",
  "#6F5F4C",
  "#276C6F",
  "#DAE0E5",
  "#E7DCCA",
  "#7F8475",
  "#D9DCD8",
  "#F2DBB8",
  "#E8DFD1",
  "#B59F99",
  "#534F51",
  "#575B59",
  "#AADEE0",
  "#EDDAD0",
  "#E8CBBF",
  "#B4946D",
  "#EEDED4",
  "#C5D0B1",
  "#BFB6A8",
  "#B2C7D4",
  "#D5E5E4",
  "#97754E",
  "#7E7872",
  "#BEC1B2",
  "#B5A596",
  "#A1A8A8",
  "#F2E1C7",
  "#D1CAC7",
  "#C9D8C3",
  "#EAE6E3",
  "#E8DFD2",
  "#EEEADB",
  "#EEDBBF",
  "#DAC6BB",
  "#E8DCCA",
  "#E7E4E1",
  "#E7E0D1",
  "#EBEDE5",
  "#EAE7E3",
  "#E8DBC5",
  "#E0D6D0",
  "#F3ECE3",
  "#DEDDCF",
  "#DDDED5",
  "#E1DFD3",
  "#97765D",
  "#8C9668",
  "#E2DDD6",
  "#CAD0CE",
  "#80D0D0",
  "#D9E1DC",
  "#DCE0DB",
  "#6D7378",
  "#7B7363",
  "#756A5F",
  "#727268",
  "#8E6F55",
  "#C0A58F",
  "#E2DBD3",
  "#aebea6",
  "#b1b695",
  "#94b1a0",
  "#528a9a",
  "#602234",
  "#7c243d",
  "#8d1d30",
  "#87141f",
  "#801522",
  "#711922",
  "#b5001a",
  "#9d101c",
  "#98010d",
  "#ac0000",
  "#940000",
  "#870000",
  "#911f21",
  "#7e191b",
  "#8e3928",
  "#9a4a33",
  "#b7813c",
  "#915f3d",
  "#503629",
  "#3d271d",
  "#3f352b",
  "#2c201a",
  "#424330",
  "#4c4527",
  "#1b5236",
  "#214b2d",
  "#054239",
  "#002f24",
  "#12221d",
  "#005553",
  "#006c7a",
  "#1e454d",
  "#004683",
  "#014e71",
  "#0e1531",
  "#e2d9d7",
  "#dfdcdb",
  "#e1dcda",
  "#e7e1e1",
  "#ebdfdd",
  "#e9dcdb",
  "#efe1dd",
  "#eededb",
  "#efded8",
  "#dfe4d5",
  "#d6e1d8",
  "#d8ebe6",
  "#dfe8e4",
  "#e1e5e3",
  "#dee2e4",
  "#e1e2e4",
  "#e6e4e4",
  "#ebe8e6",
  "#f0e5e5",
  "#f0e2e4",
  "#f0e3e4",
  "#f1dfdf",
  "#f1dede",
  "#f2dedc",
  "#f2dcd7",
  "#f4e1d7",
  "#f4e3d8",
  "#f1e1d7",
  "#f2e1d2",
  "#f2decc",
  "#f4d5b2",
  "#f5c99b",
  "#f0b07a",
  "#e89a61",
  "#dd894f",
  "#d2783a",
  "#f4e3cb",
  "#f2ecca",
  "#e8ecd1",
  "#e3ead6",
  "#e6ebd4",
  "#e0ead8",
  "#dfebdd",
  "#dcede7",
  "#d5eae8",
  "#cfe8e8",
  "#dce9e9",
  "#d5e5e7",
  "#e0e5e6",
  "#dfe2e7",
  "#e8e6e7",
  "#eae5e7",
  "#efe7e7",
  "#eac8da",
  "#e7bcd4",
  "#da9ec5",
  "#cf7ead",
  "#edc9d5",
  "#e3a9c4",
  "#dc89a8",
  "#ce6c91",
  "#eec5d2",
  "#e6a3b9",
  "#db7b97",
  "#f1cad3",
  "#ed9aab",
  "#e47486",
  "#cb3e50",
  "#b1383d",
  "#b13330",
  "#b6363b",
  "#d03e35",
  "#c04641",
  "#f1beb8",
  "#ef9a93",
  "#e5756a",
  "#d54f43",
  "#f1bdb2",
  "#ed9080",
  "#df644e",
  "#d85739",
  "#d34c2a",
  "#f5c795",
  "#f6b064",
  "#f08d2e",
  "#ed8732",
  "#f29312",
  "#f49807",
  "#fac76c",
  "#f9b952",
  "#f9ac34",
  "#ffc401",
  "#f5e6ac",
  "#e4d68c",
  "#d7c65b",
  "#b0ae26",
  "#8ab733",
  "#6ea43c",
  "#b1d99d",
  "#8cbf6f",
  "#61a53f",
  "#c9e7cc",
  "#a3d9ab",
  "#7ec083",
  "#52a550",
  "#b8e7de",
  "#48c2b0",
  "#01a192",
  "#019f9f",
  "#b5e3e2",
  "#7fd3d3",
  "#01a4a5",
  "#018c94",
  "#abdee3",
  "#73ccd8",
  "#017c85",
  "#a7d8e8",
  "#6cc3e0",
  "#01a2c6",
  "#0192b8",
  "#b0d8e7",
  "#bbd0e3",
  "#91b8d9",
  "#5287b9",
  "#4d78ac",
  "#01678d",
  "#9fabcf",
  "#7381b3",
  "#e4d4e2",
  "#a786b4",
  "#9975a5",
  "#e6ccdd",
  "#d3acce",
  "#b883b0",
  "#944f80",
  "#705284",
  "#bfe6d2",
  "#95dabd",
  "#6ccca5",
  "#e8eaea",
  "#f6e9e8",
  "#f6e6e5",
  "#f7e2e2",
  "#f6e7e2",
  "#f7e1dc",
  "#f5eae2",
  "#f7e5db",
  "#f7ece1",
  "#f8e6d7",
  "#f6ecde",
  "#f8e7d4",
  "#f9e9d1",
  "#f7edda",
  "#f8ebd4",
  "#f8ecd1",
  "#f8f0d9",
  "#f9eed0",
  "#f7f0d8",
  "#f9eecd",
  "#eeefe1",
  "#ebedda",
  "#eaf1e4",
  "#e5f1eb",
  "#e1f0ea",
  "#e6efec",
  "#d8ebea",
  "#e5eeee",
  "#dbeaed",
  "#e4e9ed",
  "#dee5ec",
  "#d8e0ea",
  "#e2e2ea",
  "#efeced",
  "#ece7ed",
  "#c69eae",
  "#d7a491",
  "#b63731",
  "#d1ae9a",
  "#e7b89a",
  "#d39a72",
  "#f6f7f2",
  "#dedacd",
  "#e4decf",
  "#f6f2e8",
  "#f6f0e5",
  "#e1d9c6",
  "#ddcfb9",
  "#d7c9ae",
  "#e0d4bd",
  "#c4b9a3",
  "#d8cfba",
  "#cec2aa",
  "#b5a78d",
  "#8c8373",
  "#584e41",
  "#d5cebf",
  "#bbb2a0",
  "#99917c",
  "#544e42",
  "#cdc7b7",
  "#b6ae99",
  "#969281",
  "#797869",
  "#5f5b4d",
  "#bfb397",
  "#a69c81",
  "#908468",
  "#7d6e52",
  "#5c4e2e",
  "#caba97",
  "#beae88",
  "#9e8e6c",
  "#94876e",
  "#665b44",
  "#cab598",
  "#b49d7b",
  "#a18a67",
  "#8d7553",
  "#796040",
  "#ecebe8",
  "#eaebe8",
  "#e2e0dc",
  "#e0ddd8",
  "#cdc8bf",
  "#ccccc5",
  "#d1cfca",
  "#d1ccc6",
  "#d1d0c9",
  "#c7c8c1",
  "#83807a",
  "#696863",
  "#e0e2e0",
  "#c6c7c5",
  "#a0a5a5",
  "#7b8285",
  "#656a6e",
  "#d2d1cb",
  "#c6c5c1",
  "#9e9d99",
  "#74777a",
  "#d6d2ca",
  "#c1bbb0",
  "#a8a298",
  "#8e8a81",
  "#615c55",
  "#dbd9d2",
  "#b4ada6",
  "#aca69f",
  "#726f6c",
  "#59504f",
  "#d8cfc6",
  "#d0c6b8",
  "#afa499",
  "#908379",
  "#eeebe1",
  "#edece7",
  "#e6e2d9",
  "#e3dfd5",
  "#e5e0d7",
  "#d0c7b7",
  "#c8c0b3",
  "#dbd5cb",
  "#dad2c6",
  "#b0a899",
  "#868172",
  "#7e7970",
  "#65635b",
  "#bab3a6",
  "#a8a294",
  "#80796d",
  "#6a655c",
  "#413d3c",
  "#d5cbbe",
  "#c1b2a1",
  "#978e7f",
  "#625346",
  "#453e39",
  "#cec5b6",
  "#9b8f7e",
  "#897d6d",
  "#766859",
  "#57534e",
  "#cabead",
  "#b2a492",
  "#8c8475",
  "#7c7466",
  "#62584b",
  "#d8d0c1",
  "#d0c1ac",
  "#9f8e7a",
  "#8d7e6d",
  "#5b564f",
  "#e0e3e2",
  "#ebebe7",
  "#eef1ec",
  "#e7e9e7",
  "#e4e1d6",
  "#e1e1db",
  "#dcdcd5",
  "#d8d5cc",
  "#cdccc3",
  "#cfd1ca",
  "#dce2df",
  "#ced7d5",
  "#b6c3c4",
  "#82979b",
  "#d5d8d7",
  "#b0b7b7",
  "#a2a8a6",
  "#536168",
  "#434a54",
  "#d4dcdc",
  "#bfc2bf",
  "#a3afac",
  "#768482",
  "#41494b",
  "#c9cabf",
  "#bcbcae",
  "#a7a796",
  "#85877b",
  "#c8cec6",
  "#b8bfb1",
  "#aab4a7",
  "#768078",
  "#5c6a6a",
  "#d0d5cb",
  "#c2cec5",
  "#adbcb4",
  "#94a69d",
  "#ebe0ce",
  "#f5e9cf",
  "#f6deb3",
  "#f5cf92",
  "#f7ce65",
  "#edebdb",
  "#efebd1",
  "#e3deb3",
  "#a4a571",
  "#4e6342",
  "#e9ede7",
  "#d3dccd",
  "#c2ccac",
  "#8b987b",
  "#2a4442",
  "#e7eae3",
  "#d4dcd3",
  "#bdcbbb",
  "#658375",
  "#303636",
  "#dde6e5",
  "#d7e1e5",
  "#dfe0e3",
  "#dcdee0",
  "#a8aab3",
  "#5c5666",
  "#383c49",
  "#e9e3de",
  "#f2e0df",
  "#eecacd",
  "#b85b57",
  "#833337",
  "#eee6de",
  "#f3dfd6",
  "#f0dfcd",
  "#f2a28c",
  "#d16f65",
  "#797a69",
  "#f5f1e6",
  "#221f20",
  "#c2c7bc",
  "#51504d",
  "#d8d0c0",
  "#beb6ab",
  "#fcf3d3",
  "#525f6c",
  "#aeb3a8",
  "#a8aa9f",
  "#844f45",
  "#73858e",
  "#a6aaad",
  "#615f55",
  "#acb1b3",
  "#68707c",
  "#a29c88",
  "#5f554f",
  "#877c69",
  "#3d2a1c",
  "#6e766a",
  "#8f9485",
  "#54331b",
  "#908672",
  "#6a543e",
  "#cac2b0",
  "#7d8689",
  "#aca394",
  "#e2e3e4",
  "#89847f",
  "#637d95",
  "#d2c7a8",
  "#beb59c",
  "#b8b7b0",
  "#848683",
  "#a2b5c5",
  "#e0d4c2",
  "#f3f7f7",
  "#fbf2c6",
];
